webpackJsonp([9],{

/***/ 2301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PointSearch = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends3 = __webpack_require__(13);

var _extends4 = _interopRequireDefault(_extends3);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(85);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _AppConstants = __webpack_require__(6);

var _PointFlow = __webpack_require__(980);

var _PointFlow2 = _interopRequireDefault(_PointFlow);

var _SearchActions = __webpack_require__(426);

var _SearchActions2 = _interopRequireDefault(_SearchActions);

var _JourneyNotificationActions = __webpack_require__(2524);

var _JourneyNotificationActions2 = _interopRequireDefault(_JourneyNotificationActions);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _PreviousSearchesStore = __webpack_require__(621);

var _PreviousSearchesStore2 = _interopRequireDefault(_PreviousSearchesStore);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _TocOnlyStore = __webpack_require__(1014);

var _TocOnlyStore2 = _interopRequireDefault(_TocOnlyStore);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _LeftColumn = __webpack_require__(2699);

var _LeftColumn2 = _interopRequireDefault(_LeftColumn);

var _JourneyDetailsForm = __webpack_require__(2576);

var _JourneyDetailsForm2 = _interopRequireDefault(_JourneyDetailsForm);

var _JourneyNotificationsModal = __webpack_require__(2528);

var _JourneyNotificationsModal2 = _interopRequireDefault(_JourneyNotificationsModal);

var _ResponsiveRender = __webpack_require__(982);

var _ResponsiveRender2 = _interopRequireDefault(_ResponsiveRender);

var _stationFinder = __webpack_require__(2447);

var _stationFinder2 = _interopRequireDefault(_stationFinder);

var _OpenStreetMaps = __webpack_require__(2820);

var _OpenStreetMaps2 = _interopRequireDefault(_OpenStreetMaps);

var _Footer = __webpack_require__(2825);

var _Footer2 = _interopRequireDefault(_Footer);

var _ReferralFrame = __webpack_require__(2624);

var _ReferralFrame2 = _interopRequireDefault(_ReferralFrame);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _serviceUtils = __webpack_require__(2450);

var _serviceUtils2 = _interopRequireDefault(_serviceUtils);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _SearchWithoutMap = __webpack_require__(3073);

var _SearchWithoutMap2 = _interopRequireDefault(_SearchWithoutMap);

var _OrderActions = __webpack_require__(157);

var _OrderActions2 = _interopRequireDefault(_OrderActions);

var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PointSearch = exports.PointSearch = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(PointSearch, _React$PureComponent);

    function PointSearch() {
        var _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PointSearch);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            loading: false,
            search: _this.props.search,
            searchErrors: _this.props.search.getValidationErrors(),
            showJourneyNotificationsModal: false,
            tocOnlyAvailability: false,
            searchAttempted: false
        }, _this._handleSearchChange = function (search) {
            var searchErrors = search.getValidationErrors();
            _this.setState({ search: search, searchErrors: searchErrors });
            _this._checkTocOnlyAvailability(search);
        }, _this._handleStationChange = function (stations) {
            var search = _this.state.search.set('origin', stations.origin).set('destination', stations.destination).set('via', stations.via).set('avoid', stations.avoid);

            _this._handleSearchChange(search);
        }, _this._handleStationFinderChange = function (type, value) {
            var _extends2;

            var stations = (0, _extends4.default)({}, _this._getStations(), (_extends2 = {}, _extends2[type] = value, _extends2));

            _this._handleStationChange(stations);
        }, _this._handleContinueSearch = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var search, _this$props, user, isMobileWidth, currentOrder, hasTicketWithPromo, response;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this._handleJourneyNotificationsModalClose();
                            _JourneyNotificationActions2.default.dismissMessages();

                            search = _this.state.search;
                            _this$props = _this.props, user = _this$props.user, isMobileWidth = _this$props.isMobileWidth, currentOrder = _this$props.currentOrder;


                            _this.setState({ loading: true });

                            _context.prev = 5;

                            search = search.set('realTime', false);
                            if (isMobileWidth) {
                                search = search.setTargetLayout(_AppConstants.JourneyPlannerLayout.LIST);
                            }

                            hasTicketWithPromo = currentOrder && currentOrder.hasPromoCode();


                            search = search.set('orderId', hasTicketWithPromo ? currentOrder.id : null);

                            _context.next = 12;
                            return _SearchActions2.default.search({ search: search, user: user });

                        case 12:
                            response = _context.sent;

                            _PointFlow2.default.moveToNext(_AppConstants.PointStages.SEARCH, { search: search }, _this.context.router).then(function () {
                                _serviceUtils2.default.handleDifferentDaySearchResult({ search: search, response: response });
                            });
                            _context.next = 20;
                            break;

                        case 16:
                            _context.prev = 16;
                            _context.t0 = _context['catch'](5);

                            _this.setState({ loading: false });
                            throw _context.t0;

                        case 20:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[5, 16]]);
        })), _this._handleJourneyNotificationsModalClose = function () {
            if (_this.state.showJourneyNotificationsModal) {
                _this.setState({ showJourneyNotificationsModal: false });
            }
        }, _this._handleSearch = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            var search, searchErrors, _ref3, messages;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            search = _this.state.search;


                            _this.setState({ searchAttempted: true });

                            _TrackingActions2.default.widgetSearchClick({ name: 'search' });

                            searchErrors = search.getValidationErrors();

                            if (searchErrors.isEmpty()) {
                                _context2.next = 7;
                                break;
                            }

                            _this.setState({ searchErrors: searchErrors });
                            return _context2.abrupt('return');

                        case 7:
                            _context2.prev = 7;

                            _this.setState({ loading: true });
                            _context2.next = 11;
                            return _JourneyNotificationActions2.default.fetchMessages(search);

                        case 11:
                            _ref3 = _context2.sent;
                            messages = _ref3.messages;

                            if (messages.size > 0) {
                                _this.setState({ loading: false, showJourneyNotificationsModal: true });
                            } else {
                                _this._handleContinueSearch();
                            }
                            _context2.next = 20;
                            break;

                        case 16:
                            _context2.prev = 16;
                            _context2.t0 = _context2['catch'](7);

                            _this.setState({ loading: false });
                            throw _context2.t0;

                        case 20:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2, [[7, 16]]);
        })), _this._checkTocOnlyAvailability = function (search) {
            if (_this.props.enableTocOnlySearch && search.origin.id && search.destination.id) {
                var tocOnlyAvailability = _TocOnlyStore2.default.getAvailability(search);
                if (!tocOnlyAvailability) {
                    _this.setState({ tocOnlyAvailability: false });
                    _SearchActions2.default.checkTocOnlyRoute(search).then(function (result) {
                        _this.setState({ tocOnlyAvailability: result });
                    });
                } else {
                    _this.setState({ tocOnlyAvailability: tocOnlyAvailability.get('result') });
                }
            }
        }, _this.performSearch = function (url) {
            _this.context.router.push(url);
        }, _this.renderMap = function () {
            var search = _this.state.search;

            var shouldUseOpenStreetMaps = _config2.default.get('enableOpenMaps');

            var MapComponent = shouldUseOpenStreetMaps ? _OpenStreetMaps2.default : _stationFinder2.default;
            return _react2.default.createElement(MapComponent, {
                className: "right-col",
                isMobile: false,
                currentSearch: search,
                onChange: _this._handleStationFinderChange,
                origin: search.origin,
                destination: search.destination
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    PointSearch.prototype.componentDidMount = function componentDidMount() {
        this._checkTocOnlyAvailability(this.props.search);

        if (_urls2.default.getQuery('refreshOrder')) {
            _OrderActions2.default.refreshOrderFromCookieData();
        }
    };

    PointSearch.prototype._getStations = function _getStations() {
        var search = this.state.search;

        return {
            'origin': search.origin,
            'destination': search.destination,
            'via': search.via,
            'avoid': search.avoid
        };
    };

    PointSearch.prototype.render = function render() {
        var _props = this.props,
            smartcard = _props.smartcard,
            user = _props.user,
            hasFooterPoweredByOn = _props.hasFooterPoweredByOn;
        var _state = this.state,
            search = _state.search,
            searchAttempted = _state.searchAttempted,
            searchErrors = _state.searchErrors,
            loading = _state.loading,
            showJourneyNotificationsModal = _state.showJourneyNotificationsModal,
            tocOnlyAvailability = _state.tocOnlyAvailability;

        var smartcardChecked = search.smartcard ? (0, _result3.default)(smartcard, 'canLoadProduct') : true;
        var enableMap = _FeatureFlagStore2.default.get('enableMap');

        return _react2.default.createElement(
            'div',
            null,
            enableMap ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    _LeftColumn2.default,
                    { loading: loading, title: (0, _I18n2.default)('pageTitles.point-search') },
                    _react2.default.createElement(_JourneyDetailsForm2.default, {
                        enableStationFinder: true,
                        search: search,
                        searchAttempted: searchAttempted,
                        user: user,
                        handleSearchChange: this._handleSearchChange,
                        tocSpecificSelectorVisible: tocOnlyAvailability })
                ),
                _react2.default.createElement(
                    _ResponsiveRender2.default,
                    { minWidth: _AppConstants.BreakPoints.TABLET_PORTRAIT_WIDTH },
                    this.renderMap()
                ),
                _react2.default.createElement(_Footer2.default, {
                    disabled: loading || !smartcardChecked || searchAttempted && !searchErrors.isEmpty(),
                    onSearch: this._handleSearch,
                    searchAttempted: searchAttempted,
                    type: 'point',
                    hasFooterPoweredByOn: hasFooterPoweredByOn
                })
            ) : _react2.default.createElement(_SearchWithoutMap2.default, { user: user, performSearch: this.performSearch }),
            _react2.default.createElement(_JourneyNotificationsModal2.default, {
                show: showJourneyNotificationsModal,
                onClose: this._handleJourneyNotificationsModalClose,
                onContinue: this._handleContinueSearch
            }),
            _react2.default.createElement(
                _FeatureFlag2.default,
                { name: 'enableNREHandoffLogging' },
                _react2.default.createElement(_ReferralFrame2.default, { location: location })
            )
        );
    };

    return PointSearch;
}(_react2.default.PureComponent), _class.propTypes = {
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    search: _propTypes2.default.instanceOf(_Search2.default).isRequired,
    isMobileWidth: _propTypes2.default.bool.isRequired,
    location: _PropTypes.locationShape,
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default),
    enableTocOnlySearch: _propTypes2.default.bool.isRequired,
    hasFooterPoweredByOn: _propTypes2.default.bool,
    currentOrder: _propTypes2.default.instanceOf(_Order2.default)
}, _class.defaultProps = {
    smartcard: null,
    location: null
}, _class.contextTypes = {
    router: _PropTypes.routerShape
}, _temp2);


function getStateFromStores(_ref4) {
    var location = _ref4.location;

    var smartcard = _SmartcardStore2.default.get('smartcard');
    var isMobileWidth = _DimensionsStore2.default.isMobileWidth();
    var enableTocOnlySearch = _FeatureFlagStore2.default.get('enableTocOnlySearch');
    var hasFooterPoweredByOn = _FeatureFlagStore2.default.get('hasFooterPoweredByOn');
    var currentOrder = _OrderStore2.default.getCurrent();

    // for some reason when you amend a trip search request pollutes PreviousSearchesStore
    // and isAmending stays true
    var search = _PreviousSearchesStore2.default.get('point').set('tocSpecific', false).refreshDates(smartcard).refreshAmending();

    if (location.query.smartcard && location.query.smartcard === 'yes' && smartcard && smartcard.canSearchForProducts()) {
        search = search.set('smartcard', true);
    }

    return {
        isMobileWidth: isMobileWidth, smartcard: smartcard, search: search, enableTocOnlySearch: enableTocOnlySearch, hasFooterPoweredByOn: hasFooterPoweredByOn, currentOrder: currentOrder
    };
}

exports.default = (0, _connectToStores2.default)([_SmartcardStore2.default, _DimensionsStore2.default, _FeatureFlagStore2.default, _OrderStore2.default], getStateFromStores)(PointSearch);

/***/ }),

/***/ 2395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _immutable = __webpack_require__(5);

var _joi = __webpack_require__(62);

var _joi2 = _interopRequireDefault(_joi);

var _Immutable = __webpack_require__(54);

var _I18n = __webpack_require__(9);

var _validation = __webpack_require__(42);

var _validation2 = _interopRequireDefault(_validation);

var _ValidationMixin = __webpack_require__(34);

var _ValidationMixin2 = _interopRequireDefault(_ValidationMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    adults: 1,
    children: 0,
    railcards: new _immutable.List()
};

var PassengersForm = function (_record) {
    (0, _inherits3.default)(PassengersForm, _record);

    function PassengersForm() {
        (0, _classCallCheck3.default)(this, PassengersForm);
        return (0, _possibleConstructorReturn3.default)(this, _record.apply(this, arguments));
    }

    PassengersForm.prototype.getComputedValues = function getComputedValues() {
        var adults = this.adults,
            children = this.children,
            railcards = this.railcards;

        var total = adults + children;
        var railcardsCount = railcards ? (0, _Immutable.sum)(railcards, 'quantity') : 0;

        return {
            total: total,
            railcards: railcardsCount
        };
    };

    PassengersForm.prototype.getSchema = function getSchema() {
        var passenger = _joi2.default.number().min(0).max(9).required();

        return {
            adults: passenger,
            children: passenger,
            railcards: _validation2.default.railcardsNumber('total'),
            total: _joi2.default.number().min(1).max(9).required().options({
                language: {
                    number: {
                        base: (0, _I18n.translate)('booking.passengers.errors.atLeastOne'),
                        min: (0, _I18n.translate)('booking.passengers.errors.atLeastOne'),
                        max: (0, _I18n.translate)('booking.passengers.errors.upToNine')
                    }
                }
            })
        };
    };

    return PassengersForm;
}((0, _immutable.Record)(defaults));

(0, _assign2.default)(PassengersForm.prototype, _ValidationMixin2.default);

exports.default = PassengersForm;

/***/ }),

/***/ 2396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _MomentPropTypes = __webpack_require__(230);

var _MomentPropTypes2 = _interopRequireDefault(_MomentPropTypes);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _CalendarDropdown = __webpack_require__(2400);

var _CalendarDropdown2 = _interopRequireDefault(_CalendarDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateSelector = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(DateSelector, _PureRenderComponent);

    function DateSelector() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DateSelector);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            showCalendar: false
        }, _this.toggleCalendar = function (e) {
            e.preventDefault();
            _this.setState({
                showCalendar: !_this.state.showCalendar
            }, function () {
                if (_this.state.showCalendar) {
                    var calendarNode = _reactDom2.default.findDOMNode(_this.refs.calendar);
                    calendarNode.scrollIntoView();
                }
            });
        }, _this.closeCalendar = function () {
            _this.setState({
                showCalendar: false
            }, function () {
                _this.button.scrollIntoView();
                _this.button.focus(); // restore focus
            });
        }, _this.handleDateChange = function (date) {
            var _this$props = _this.props,
                datetime = _this$props.datetime,
                onChange = _this$props.onChange;

            var chosenDate = (0, _TrainTime2.default)(date.format('YYYY-MM-DD'));

            if (datetime) {
                chosenDate = chosenDate.set({
                    hour: datetime.hour(),
                    minute: datetime.minute()
                });
            }

            onChange(chosenDate);

            _this.closeCalendar();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    DateSelector.prototype.renderTime = function renderTime() {
        var _props = this.props,
            datetime = _props.datetime,
            datetimeFormats = _props.datetimeFormats,
            srOnly = _props.srOnly;


        var text = datetime.calendar(null, datetimeFormats);

        return _react2.default.createElement(
            'span',
            null,
            srOnly && _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                srOnly
            ),
            _react2.default.createElement(
                'time',
                { className: 'clearfix', dateTime: datetime.format() },
                text
            ),
            srOnly && _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                (0, _I18n2.default)('ariaLabel.clickToChange')
            )
        );
    };

    DateSelector.prototype.render = function render() {
        var _this2 = this;

        var _props2 = this.props,
            datetime = _props2.datetime,
            min = _props2.min,
            max = _props2.max,
            placeholder = _props2.placeholder,
            dropdownPosition = _props2.dropdownPosition,
            initialDatetime = _props2.initialDatetime,
            required = _props2.required;
        var showCalendar = this.state.showCalendar;


        return _react2.default.createElement(
            'div',
            { className: 'calendar-dropdown__button' },
            _react2.default.createElement(
                'button',
                { className: 'btn btn-box',
                    disabled: this.props.disabled,
                    onClick: this.toggleCalendar,
                    ref: function ref(btn) {
                        _this2.button = btn;
                    }
                },
                _react2.default.createElement(_Icon2.default, { className: 'pull-right box__icon', icon: 'calendar' }),
                required && _react2.default.createElement(_Icon2.default, { icon: 'mandatory' }),
                datetime ? this.renderTime() : placeholder
            ),
            _react2.default.createElement(_CalendarDropdown2.default, {
                ref: 'calendar',
                datetime: datetime || initialDatetime,
                onChange: this.handleDateChange,
                onClose: this.closeCalendar,
                min: min,
                max: max,
                dropdownPosition: dropdownPosition,
                disableOnClickOutside: !showCalendar,
                show: showCalendar,
                autoFocus: true })
        );
    };

    return DateSelector;
}(_PureRenderComponent3.default), _class.dropdownPositions = _CalendarDropdown.DROPDOWN_POSITIONS, _class.propTypes = {
    datetime: _MomentPropTypes2.default.isMoment,
    datetimeFormats: _propTypes2.default.object,
    initialDatetime: _MomentPropTypes2.default.isMoment,
    onChange: _propTypes2.default.func,
    min: _MomentPropTypes2.default.isMoment,
    max: _MomentPropTypes2.default.isMoment,
    placeholder: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    required: _propTypes2.default.bool,
    dropdownPosition: _propTypes2.default.oneOf((0, _values2.default)(_CalendarDropdown.DROPDOWN_POSITIONS)),
    srOnly: _propTypes2.default.string
}, _class.defaultProps = {
    datetime: null,
    datetimeFormats: {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'ddd DD MMM',
        lastDay: '[Yesterday]',
        lastWeek: 'ddd DD MMM',
        sameElse: 'ddd DD MMM'
    },
    initialDatetime: (0, _TrainTime2.default)(),
    onChange: _noop3.default,
    min: null,
    max: null,
    placeholder: (0, _I18n2.default)('form.dateSelector.placeholder'),
    disabled: false,
    required: false,
    dropdownPosition: null,
    srOnly: ''
}, _temp2);
exports.default = DateSelector;

/***/ }),

/***/ 2397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getOwnPropertyDescriptor = __webpack_require__(233);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _head2 = __webpack_require__(993);

var _head3 = _interopRequireDefault(_head2);

var _takeRight3 = __webpack_require__(2417);

var _takeRight4 = _interopRequireDefault(_takeRight3);

var _invokeMap2 = __webpack_require__(1003);

var _invokeMap3 = _interopRequireDefault(_invokeMap2);

var _isUndefined2 = __webpack_require__(278);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _desc, _value, _class; /* global google */

var _GoogleMapStyles = __webpack_require__(2418);

var _GoogleMapStyles2 = _interopRequireDefault(_GoogleMapStyles);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

var defaultCenter = { lat: 53, lng: -1.8 };
var defaultZoom = 7;
var zoomOutLimit = 4;

var _pathToLatLngs = function _pathToLatLngs(path) {
    var result = path.map(function (coords) {
        var latitude = coords.latitude,
            longitude = coords.longitude;

        return new google.maps.LatLng(latitude, longitude);
    });

    return (0, _isUndefined3.default)(result.toJS) ? result : result.toJS();
};

/**
 * Decorator that logs any exceptions with console.error instead of throwing them
 * We don't want google maps errors to stop the user from progressing
 */
function errorToLog(target, name, descriptor) {
    var original = descriptor.value;
    descriptor.value = function () {
        try {
            return original.apply(this, arguments);
        } catch (e) {
            console.error("Google Maps Error", e);
            return null;
        }
    };
    return descriptor;
}

var GoogleMapsHelper = (_class = function () {
    function GoogleMapsHelper(domNode, next) {
        var _this = this;

        (0, _classCallCheck3.default)(this, GoogleMapsHelper);

        this.callback = function () {
            window.callback = void 0;
            delete window.callback;
            _this.next(_this.createMap());
        };

        this.map = null;
        this.loaded = false;
        this.domNode = domNode;
        this.next = next;
        this.objects = [];
        this.bounds = null;
        this.loadGoogleMaps();
    }

    GoogleMapsHelper.prototype.addEventListener = function addEventListener(event, callback) {
        if (this.map) {
            window.google.maps.event.addListener(this.map, event, callback);
        }
    };

    GoogleMapsHelper.prototype.refresh = function refresh() {
        this.bounds = new google.maps.LatLngBounds();
        (0, _invokeMap3.default)(this.objects, 'setMap', null);
        this.objects = [];
    };

    GoogleMapsHelper.prototype.resize = function resize() {
        window.google.maps.event.trigger(this.map, 'resize');
    };

    /**
     * Fit bounds zooms in too close to single bounds so zoom out a little
     * by adding extra bounds
     */


    GoogleMapsHelper.prototype.zoomOutSingleBound = function zoomOutSingleBound() {
        var bounds = this.bounds;
        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
            var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
        }
        return this.bounds;
    };

    GoogleMapsHelper.prototype.fitBounds = function fitBounds() {
        var bounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.bounds;

        if (!bounds.isEmpty()) {
            this.map.fitBounds(this.zoomOutSingleBound());
        } else {
            this.map.setCenter(defaultCenter);
            this.map.setZoom(defaultZoom);
        }
    };

    GoogleMapsHelper.prototype.loadGoogleMaps = function loadGoogleMaps() {
        if (!window.google) {

            var existingCallback = window.callback;
            window.callback = this.callback;

            //Avoid loading the script if there is already a pending callback
            if (!existingCallback) {
                var script = document.createElement('script');
                script.setAttribute('src', _config2.default.get('googleMapsSrc') + _config2.default.get('googleMapsApiKey'));
                document.head.appendChild(script);
            }
        } else {
            // Due to async nature of loading/rendering
            setTimeout(this.callback.bind(this), 0);
        }
    };

    GoogleMapsHelper.prototype.createMap = function createMap() {
        this.map = new google.maps.Map(this.domNode, {
            zoom: defaultZoom,
            minZoom: zoomOutLimit,
            draggable: true,
            zoomControl: true,
            scrollwheel: true,
            disableDefaultUI: false,
            disableDoubleClickZoom: false,
            center: defaultCenter,
            styles: _GoogleMapStyles2.default,
            mapTypeControl: false,
            streetViewControl: false
        });

        this.loaded = true;
        return this.map;
    };

    GoogleMapsHelper.prototype.dashedLine = function dashedLine(path) {
        var _this2 = this;

        var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config2.default.get('googleMapPrimaryColour');

        var lineSymbol = {
            path: 'M 0,-1 0,1',
            strokeColor: color,
            strokeOpacity: 1,
            scale: 4
        };

        var dashed = new google.maps.Polyline({
            path: _pathToLatLngs(path),
            strokeOpacity: 0,
            icons: [{ icon: lineSymbol, offset: '0', repeat: '25px' }],
            map: this.map
        });

        path.forEach(function (coords) {
            var marker = document.createElement('div');
            marker.style.background = color;
            marker.className = 'map__calling-point';
            _this2.newLabel(marker, coords);
        });

        this.objects.push(dashed);
    };

    GoogleMapsHelper.prototype.solidLine = function solidLine(path) {
        var _this3 = this;

        var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config2.default.get('googleMapPrimaryColour');

        path = path.map(function (coords) {
            if (!coords.latitude || !coords.longitude) {
                return null;
            }

            var latitude = coords.latitude,
                longitude = coords.longitude;

            var latLng = new google.maps.LatLng(latitude, longitude);
            _this3.bounds.extend(latLng);
            return latLng;
        }).toJS();

        var solid = new google.maps.Polyline({
            map: this.map,
            path: path,
            strokeColor: color,
            strokeOpacity: 1,
            strokeWeight: 4,
            clickable: false,
            editable: false,
            visible: true
        });

        this.objects.push(solid);
    };

    GoogleMapsHelper.prototype.points = function points(path) {
        var _this4 = this;

        var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config2.default.get('googleMapPrimaryColour');

        path.forEach(function (coords) {
            var marker = document.createElement('div');
            marker.style.background = color;
            marker.className = 'map__calling-point';
            _this4.newLabel(marker, coords);
        });
    };

    GoogleMapsHelper.prototype.newLabel = function newLabel(element, coords) {
        if (!coords.latitude || !coords.longitude) {
            return null;
        }

        var latLng = new google.maps.LatLng(coords.latitude, coords.longitude);
        var map = this.map;
        var Overlay = function Overlay() {
            this.setMap(map);
        };
        Overlay.prototype = new google.maps.OverlayView();
        Overlay.prototype.onAdd = function () {
            this.getPanes().floatPane.appendChild(element);
        };
        Overlay.prototype.draw = function () {
            var projection = this.getProjection();
            var pos = projection.fromLatLngToDivPixel(latLng);
            element.style.position = 'absolute';
            element.style.left = pos.x + 'px';
            element.style.top = pos.y + 'px';
        };
        Overlay.prototype.onRemove = function () {
            if (element.parentNode) {
                element.parentNode.removeChild(element);
            }
            element = null;
        };

        var label = new Overlay();

        this.objects.push(label);
        this.bounds.extend(latLng);

        return label;
    };

    GoogleMapsHelper.prototype.getDistance = function getDistance(x, y) {
        return google.maps.geometry.spherical.computeDistanceBetween(x, y);
    };

    GoogleMapsHelper.prototype.getRoutePairs = function getRoutePairs(route) {
        return route.map(function (x, i) {
            return [x, route[i + 1]];
        }).splice(0, route.length - 2); // Remove last one
    };

    GoogleMapsHelper.prototype.getRouteDistance = function getRouteDistance(route) {
        return google.maps.geometry.spherical.computeLength(route);
    };

    GoogleMapsHelper.prototype.getRouteMiddle = function getRouteMiddle(route) {
        var _this5 = this;

        var latLngs = _pathToLatLngs(route),
            roughMiddle = this.getRouteDistance(latLngs) / 2,
            pairs = this.getRoutePairs(latLngs),
            distances = pairs.map(function (xCoord) {
            return _this5.getDistance.apply(_this5, xCoord);
        }),
            runningTotal = 0;

        for (var i = 0; i < distances.length; i++) {
            var curDistance = runningTotal + distances[i];

            if (curDistance >= roughMiddle) {
                var _pairs$i = pairs[i],
                    x = _pairs$i[0],
                    y = _pairs$i[1],
                    p = (roughMiddle - runningTotal) / (curDistance - runningTotal);


                return google.maps.geometry.spherical.interpolate(x, y, p);
            }

            runningTotal = curDistance;
        }

        var _takeRight2 = (0, _takeRight4.default)(latLngs, 2),
            posX = _takeRight2[0],
            posY = _takeRight2[1];

        if (!posX || !posY) {
            return (0, _head3.default)(latLngs);
        }
        return google.maps.geometry.spherical.interpolate(posX, posY, 0.5);
    };

    GoogleMapsHelper.prototype.getZoomLevel = function getZoomLevel() {
        return this.map.getZoom();
    };

    GoogleMapsHelper.prototype.setZoomLevel = function setZoomLevel(level) {
        this.map.setZoom(level);
    };

    GoogleMapsHelper.prototype.setCenter = function setCenter(pos) {
        this.map.setCenter(pos);
    };

    GoogleMapsHelper.prototype.addMarker = function addMarker(_ref) {
        var animation = _ref.animation,
            options = (0, _objectWithoutProperties3.default)(_ref, ['animation']);

        if (animation) {
            animation = google.maps.Animation[animation];
        }
        return new google.maps.Marker((0, _assign2.default)({}, options, { map: this.map, animation: animation }));
    };

    return GoogleMapsHelper;
}(), (_applyDecoratedDescriptor(_class.prototype, 'zoomOutSingleBound', [errorToLog], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'zoomOutSingleBound'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fitBounds', [errorToLog], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'fitBounds'), _class.prototype)), _class);
exports.default = GoogleMapsHelper;

/***/ }),

/***/ 2400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.DROPDOWN_POSITIONS = undefined;

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactOnclickoutside = __webpack_require__(991);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _MomentPropTypes = __webpack_require__(230);

var _MomentPropTypes2 = _interopRequireDefault(_MomentPropTypes);

var _Calendar = __webpack_require__(975);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DROPDOWN_POSITIONS = exports.DROPDOWN_POSITIONS = {
    LEFT: 'calendar-dropdown--left',
    RIGHT: 'calendar-dropdown--right'
};

var CalendarDropdown = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(CalendarDropdown, _PureRenderComponent);

    function CalendarDropdown() {
        (0, _classCallCheck3.default)(this, CalendarDropdown);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    CalendarDropdown.prototype.handleClickOutside = function handleClickOutside() {
        this.props.onClose();
    };

    CalendarDropdown.prototype.render = function render() {
        var _props = this.props,
            datetime = _props.datetime,
            min = _props.min,
            max = _props.max,
            initialMonth = _props.initialMonth,
            show = _props.show,
            autoFocus = _props.autoFocus,
            onChange = _props.onChange,
            dropdownPosition = _props.dropdownPosition;

        var calendarClass = (0, _classnames2.default)('box', 'box--rounded', 'box--padded', 'calendar-dropdown', dropdownPosition, {
            'calendar-dropdown--hidden': !show
        });

        return _react2.default.createElement(
            'div',
            { className: calendarClass },
            _react2.default.createElement(_Calendar2.default, {
                show: show,
                autoFocus: autoFocus,
                selected: datetime,
                onChange: onChange,
                min: min,
                max: max,
                initialMonth: initialMonth
            })
        );
    };

    return CalendarDropdown;
}(_PureRenderComponent3.default), _class.propTypes = {
    datetime: _MomentPropTypes2.default.isMoment,
    onChange: _propTypes2.default.func,
    onClose: _propTypes2.default.func,
    min: _MomentPropTypes2.default.isMoment,
    max: _MomentPropTypes2.default.isMoment,
    initialMonth: _MomentPropTypes2.default.isMoment,
    show: _propTypes2.default.bool,
    autoFocus: _propTypes2.default.bool,
    dropdownPosition: _propTypes2.default.oneOf((0, _values2.default)(DROPDOWN_POSITIONS))
}, _class.defaultProps = {
    datetime: (0, _TrainTime2.default)(),
    onChange: _noop3.default,
    onClose: _noop3.default,
    min: null,
    max: null,
    initialMonth: null,
    show: false,
    autoFocus: false,
    dropdownPosition: DROPDOWN_POSITIONS.LEFT
}, _temp);
exports.default = (0, _reactOnclickoutside2.default)(CalendarDropdown);

/***/ }),

/***/ 2401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _I18n = __webpack_require__(9);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _StationService = __webpack_require__(341);

var _StationService2 = _interopRequireDefault(_StationService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StationFinderActions = {
    findNearest: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref) {
            var latitude = _ref.latitude,
                longitude = _ref.longitude,
                searchInteraction = _ref.searchInteraction;
            var stations;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.STATION_FINDER_SEARCH_STARTED,
                                latitude: latitude,
                                longitude: longitude,
                                searchInteraction: searchInteraction
                            });

                            _context.prev = 1;
                            _context.next = 4;
                            return _StationService2.default.findNearest(latitude, longitude);

                        case 4:
                            stations = _context.sent;

                            if (stations.size) {
                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.STATION_FINDER_SEARCH_COMPLETE,
                                    stations: stations
                                });
                            } else {
                                _AppDispatcher2.default.dispatch({
                                    actionType: _AppConstants.ActionTypes.STATION_FINDER_SEARCH_FAILED,
                                    error: new Error((0, _I18n.translate)('stationFinder.search.error'))
                                });
                                _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.STATION_FINDER_SET_EXPANDED, value: true });
                            }
                            _context.next = 13;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](1);

                            console.error('Error searching for stations', _context.t0);
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.STATION_FINDER_SEARCH_FAILED,
                                error: _context.t0
                            });
                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.STATION_FINDER_SET_EXPANDED, value: true });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 8]]);
        }));

        function findNearest(_x) {
            return _ref2.apply(this, arguments);
        }

        return findNearest;
    }(),
    clearStations: function clearStations() {
        _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.STATION_FINDER_STATIONS_CLEARED });
    },
    clearError: function clearError() {
        _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.STATION_FINDER_ERROR_CLEARED });
    },
    setExpanded: function setExpanded(value) {
        _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.STATION_FINDER_SET_EXPANDED, value: value });
    },
    setStationSelected: function setStationSelected(originDest, station) {
        _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.STATION_FINDER_STATION_SELECTED, originDest: originDest, station: station });
    },
    getTicketOfficeDetails: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(station) {
            var ticketOffice;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _StationService2.default.getTicketOfficeDetails(station);

                        case 2:
                            ticketOffice = _context2.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.STATION_FINDER_TICKET_OFFICE_LOADED,
                                station: station,
                                ticketOffice: ticketOffice
                            });
                            return _context2.abrupt('return', ticketOffice);

                        case 5:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function getTicketOfficeDetails(_x2) {
            return _ref3.apply(this, arguments);
        }

        return getTicketOfficeDetails;
    }()
};

exports.default = StationFinderActions;

/***/ }),

/***/ 2402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _RailcardsService = __webpack_require__(620);

var _RailcardsService2 = _interopRequireDefault(_RailcardsService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RailcardsActions = {
    load: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref) {
            var smartcard = _ref.smartcard;
            var railcards;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.RAILCARDS_LOAD_STARTED });
                            _context.prev = 1;
                            _context.next = 4;
                            return _RailcardsService2.default.getAll({ smartcard: smartcard });

                        case 4:
                            railcards = _context.sent;

                            _AppDispatcher2.default.dispatch({
                                railcards: railcards, smartcard: smartcard,
                                actionType: _AppConstants.ActionTypes.RAILCARDS_LOADED
                            });
                            return _context.abrupt('return', railcards);

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](1);

                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.RAILCARDS_LOAD_FAILED });
                            throw _context.t0;

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 9]]);
        }));

        function load(_x) {
            return _ref2.apply(this, arguments);
        }

        return load;
    }(),
    loadAccountDRC: function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(userId) {
            var railcards;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return _RailcardsService2.default.getAccountDRC(userId);

                        case 3:
                            railcards = _context2.sent;

                            _AppDispatcher2.default.dispatch({
                                railcards: railcards,
                                actionType: _AppConstants.ActionTypes.ACCOUNT_DRC_LOADED
                            });

                            return _context2.abrupt('return', railcards);

                        case 8:
                            _context2.prev = 8;
                            _context2.t0 = _context2['catch'](0);
                            throw _context2.t0;

                        case 11:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[0, 8]]);
        }));

        function loadAccountDRC(_x2) {
            return _ref3.apply(this, arguments);
        }

        return loadAccountDRC;
    }(),
    setFavouriteDRC: function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(userId, railcardId) {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return _RailcardsService2.default.setFavouriteDRC(userId, railcardId);

                        case 3:
                            _AppDispatcher2.default.dispatch({
                                railcardId: railcardId,
                                actionType: _AppConstants.ActionTypes.SET_FAVOURITE_DRC
                            });
                            _context3.next = 9;
                            break;

                        case 6:
                            _context3.prev = 6;
                            _context3.t0 = _context3['catch'](0);
                            throw _context3.t0;

                        case 9:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 6]]);
        }));

        function setFavouriteDRC(_x3, _x4) {
            return _ref4.apply(this, arguments);
        }

        return setFavouriteDRC;
    }(),
    removeDRCDevice: function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(userId, railcardId, body) {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.prev = 0;

                            _RailcardsService2.default.removeDRCDevice(userId, railcardId, body).then(function () {
                                _AppDispatcher2.default.dispatch((0, _extends3.default)({}, body, {
                                    railcardId: railcardId,
                                    actionType: _AppConstants.ActionTypes.REMOVED_DRC_DEVICE
                                }));
                            });
                            _context4.next = 7;
                            break;

                        case 4:
                            _context4.prev = 4;
                            _context4.t0 = _context4['catch'](0);
                            throw _context4.t0;

                        case 7:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this, [[0, 4]]);
        }));

        function removeDRCDevice(_x5, _x6, _x7) {
            return _ref5.apply(this, arguments);
        }

        return removeDRCDevice;
    }()
};

exports.default = RailcardsActions;

/***/ }),

/***/ 2405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _I18n = __webpack_require__(9);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StepperInput = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(StepperInput, _PureRenderComponent);

    function StepperInput() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, StepperInput);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this._makeIncrement = function (_ref) {
            var value = _ref.value,
                min = _ref.min,
                max = _ref.max,
                onChange = _ref.onChange;
            return function () {
                if (value >= min && value < max) {
                    var newValue = value + 1;
                    onChange(newValue);
                }
            };
        }, _this._makeDecrement = function (_ref2) {
            var value = _ref2.value,
                min = _ref2.min,
                max = _ref2.max,
                onChange = _ref2.onChange;
            return function () {
                if (value > min && value <= max) {
                    var newValue = value - 1;
                    onChange(newValue);
                }
            };
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    StepperInput.prototype._renderLabel = function _renderLabel(_ref3) {
        var name = _ref3.name,
            label = _ref3.label;

        if (label) {
            return _react2.default.createElement(
                'label',
                { className: 'sr-only', htmlFor: name },
                label
            );
        }

        return null;
    };

    StepperInput.prototype.render = function render() {
        var _classnames;

        var _props = this.props,
            label = _props.label,
            name = _props.name,
            value = _props.value,
            error = _props.error;


        return _react2.default.createElement(
            'div',
            { className: (0, _classnames3.default)('stepper', (_classnames = {}, _classnames[name] = true, _classnames['stepper--error'] = this.props.error, _classnames)) },
            _react2.default.createElement(
                _Button2.default,
                { className: 'stepper--decrement pull-left', onClick: this._makeDecrement(this.props) },
                _react2.default.createElement(_Icon2.default, { icon: 'remove' }),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    error + '. ',
                    (0, _I18n.translate)('ariaLabel.stepperInput', { label: label, value: value, direction: 'Remove' })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'stepper__faux-input pull-left' },
                _react2.default.createElement(
                    'span',
                    { className: 'stepper__number text-weight--normal' },
                    value
                ),
                ' ',
                label
            ),
            this._renderLabel(this.props),
            _react2.default.createElement(
                _Button2.default,
                { bsStyle: 'default', className: 'stepper--increment pull-left', onClick: this._makeIncrement(this.props) },
                _react2.default.createElement(_Icon2.default, { icon: 'add' }),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    error + '. ',
                    (0, _I18n.translate)('ariaLabel.stepperInput', { label: label, value: value, direction: 'Add' })
                )
            )
        );
    };

    return StepperInput;
}(_PureRenderComponent3.default), _class.propTypes = {
    name: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    labelSide: _propTypes2.default.oneOf(['left', 'right']),
    value: _propTypes2.default.number,
    min: _propTypes2.default.number,
    max: _propTypes2.default.number,
    onChange: _propTypes2.default.func,
    error: _propTypes2.default.string
}, _class.defaultProps = {
    name: '',
    label: '',
    labelSide: 'left',
    value: 0,
    min: 0,
    max: 9,
    onChange: _noop3.default,
    error: ''
}, _temp2);
exports.default = StepperInput;

/***/ }),

/***/ 2406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _class2, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _RailcardsStore = __webpack_require__(608);

var _RailcardsStore2 = _interopRequireDefault(_RailcardsStore);

var _RailcardsActions = __webpack_require__(2402);

var _RailcardsActions2 = _interopRequireDefault(_RailcardsActions);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _Select = __webpack_require__(425);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getStateFromStores(_ref) {
    var smartcard = _ref.smartcard,
        filterOutRailcards = _ref.filterOutRailcards;

    return {
        railcardTypes: filterOutRailcards ? _RailcardsStore2.default.getSome({ smartcard: smartcard, filterOutRailcards: filterOutRailcards }) : _RailcardsStore2.default.getAll({ smartcard: smartcard })
    };
}

var Railcard = (_dec = (0, _connectToStores2.default)([_RailcardsStore2.default], _getStateFromStores), _dec(_class = (_temp2 = _class2 = function (_PureRenderComponent) {
    (0, _inherits3.default)(Railcard, _PureRenderComponent);

    function Railcard() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Railcard);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this._handleChange = function (event) {
            var value = event.target.value;

            var railcard = _RailcardsStore2.default.get(value);
            _this.props.onChange(railcard);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    Railcard.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        var _props = this.props,
            smartcard = _props.smartcard,
            railcardTypes = _props.railcardTypes;

        if (!railcardTypes) {
            (0, _defer3.default)(_RailcardsActions2.default.load, { smartcard: smartcard });
        }
    };

    Railcard.prototype.render = function render() {
        var _props2 = this.props,
            railcardTypes = _props2.railcardTypes,
            error = _props2.error,
            required = _props2.required,
            placeholder = _props2.placeholder,
            className = _props2.className;


        var inputProps = {
            type: 'select',
            id: 'railcards__types',
            value: this.props.value,
            className: (0, _classnames2.default)('railcards__types', { 'input--invalid': error }),
            onChange: this._handleChange,
            disabled: !railcardTypes
        };

        return _react2.default.createElement(
            'span',
            { className: (0, _classnames2.default)('select-container ' + className, { 'input--required': required }) },
            _react2.default.createElement(_Icon2.default, { icon: 'dropdown' }),
            required && _react2.default.createElement(_Icon2.default, { icon: 'mandatory' }),
            _react2.default.createElement(
                'label',
                { className: 'sr-only', htmlFor: 'railcards__types' },
                error + '. ',
                (0, _I18n.translate)('booking.railcards.select')
            ),
            _react2.default.createElement(
                _Select2.default,
                inputProps,
                _react2.default.createElement(
                    'option',
                    { value: '' },
                    placeholder
                ),
                railcardTypes && railcardTypes.map(function (type, key) {
                    var props = { value: type.code, key: key };
                    return _react2.default.createElement(
                        'option',
                        props,
                        type.name
                    );
                })
            )
        );
    };

    return Railcard;
}(_PureRenderComponent3.default), _class2.propTypes = {
    smartcard: _propTypes2.default.bool,
    value: _propTypes2.default.string,
    railcardTypes: _propTypes2.default.instanceOf(_immutable.List),
    onChange: _noop3.default,
    error: _propTypes2.default.string,
    required: _propTypes2.default.bool,
    placeholder: _propTypes2.default.string,
    filterOutRailcards: _propTypes2.default.arrayOf(_propTypes2.default.string),
    className: _propTypes2.default.string
}, _class2.defaultProps = {
    smartcard: false,
    value: '',
    railcardTypes: null,
    onChange: _noop3.default,
    error: '',
    required: false,
    placeholder: (0, _I18n.translate)('booking.railcards.select'),
    filterOutRailcards: [],
    className: ''
}, _temp2)) || _class);
exports.default = Railcard;

/***/ }),

/***/ 2407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _shallowequal = __webpack_require__(1005);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _GoogleMaps = __webpack_require__(2397);

var _GoogleMaps2 = _interopRequireDefault(_GoogleMaps);

var _I18n = __webpack_require__(9);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapComponent = (_temp2 = _class = function (_React$Component) {
    (0, _inherits3.default)(MapComponent, _React$Component);

    function MapComponent() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, MapComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
            loaded: false,
            expandMap: false
        }, _this._onMapLoaded = function () {
            _this.setState({ loaded: true });
        }, _this._toggleMapExpand = function () {
            _this.setState({ expandMap: !_this.state.expandMap }, function () {
                setTimeout(function () {
                    _this.mapsHelper.resize();
                    _this.mapsHelper.fitBounds();
                }, 1);
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    /**
     * Pure render mixin shallow compares, so doesn't know if children change,
     * so we check if the props on the children have changed and if their keys match,
     * so to reduce requests, all children to this component need keys.
     */
    MapComponent.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var nextChildren = [];
        var currentChildren = [];
        _react2.default.Children.forEach(nextProps.children, function (child) {
            return nextChildren.push(child);
        });
        _react2.default.Children.forEach(this.props.children, function (child) {
            return currentChildren.push(child);
        });

        var childrenChanged = nextChildren.reduce(function (out, child) {
            var matched = currentChildren.filter(function (existing) {
                return child.key === existing.key;
            });
            if (!matched || !matched.length) {
                return true;
            }
            return out || !(0, _shallowequal2.default)(matched[0].props, child.props);
        }, false);

        return !(0, _shallowequal2.default)(this.state, nextState) || childrenChanged;
    };

    MapComponent.prototype.componentDidMount = function componentDidMount() {
        this.mapsHelper = new _GoogleMaps2.default(this.refs.map, this._onMapLoaded);
        this.props.onReady(this.mapsHelper);
    };

    MapComponent.prototype.componentDidUpdate = function componentDidUpdate() {
        if (this.state.loaded && !this.props.stationFinderActive) {
            this.mapsHelper.fitBounds();
        }
    };

    MapComponent.prototype._renderChildren = function _renderChildren() {
        var _this2 = this;

        if (!this.state.loaded) {
            return null;
        }

        return _react2.default.Children.map(this.props.children, function (child, index) {
            return _react2.default.cloneElement(child, {
                key: index,
                mapsHelper: _this2.mapsHelper
            });
        });
    };

    MapComponent.prototype.render = function render() {
        var style = { width: '100%', height: '100%' };
        var classNames = (0, _classnames2.default)(this.props.className, { 'right-col--expand-map': this.state.expandMap });
        var allowMapExpand = this.props.allowMapExpand;

        if (this.state.loaded) {
            this.mapsHelper.refresh();
        }

        var buttonClass = (0, _classnames2.default)('map-expander box box--rounded box--padded', {
            'map-expander--active': this.state.expandMap
        });

        return _react2.default.createElement(
            'div',
            { className: classNames, style: this.props.style },
            this._renderChildren(),
            _react2.default.createElement('div', { style: style, ref: 'map' }),
            allowMapExpand && _react2.default.createElement(
                'button',
                {
                    className: buttonClass,
                    type: 'button',
                    'aria-label': (0, _I18n.translate)('ariaLabel.toggleMap'),
                    onClick: this._toggleMapExpand
                },
                _react2.default.createElement(_Icon2.default, { icon: 'arrowback', className: 'otrl-rotate-45' }),
                _react2.default.createElement(_Icon2.default, { icon: 'arrowback', className: 'otrl-rotate-225' })
            )
        );
    };

    return MapComponent;
}(_react2.default.Component), _class.propTypes = {
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    children: _propTypes2.default.any,
    allowMapExpand: _propTypes2.default.bool,
    onReady: _propTypes2.default.func,
    stationFinderActive: _propTypes2.default.bool
}, _class.defaultProps = {
    allowMapExpand: true,
    className: '',
    style: {},
    onReady: _noop3.default,
    stationFinderActive: false
}, _temp2);
exports.default = MapComponent;

/***/ }),

/***/ 2408:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.useMap = exports.boundedElementsReducer = exports.MapContext = exports.BoundedElementsReducerActions = undefined;

var _extends3 = __webpack_require__(13);

var _extends4 = _interopRequireDefault(_extends3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _omit = __webpack_require__(174);

var _omit2 = _interopRequireDefault(_omit);

var _keymirror = __webpack_require__(176);

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BoundedElementsReducerActions = exports.BoundedElementsReducerActions = (0, _keymirror2.default)({
    ADD_ITEM: null,
    REMOVE_ITEM: null
});

var MapContext = exports.MapContext = _react2.default.createContext(null);

var boundedElementsReducer = exports.boundedElementsReducer = function boundedElementsReducer(state, action) {
    var _extends2;

    switch (action.type) {
        case BoundedElementsReducerActions.ADD_ITEM:
            return (0, _extends4.default)({}, state, (_extends2 = {}, _extends2[action.uid] = action.coords, _extends2));
        case BoundedElementsReducerActions.REMOVE_ITEM:
            return (0, _extends4.default)({}, (0, _omit2.default)(state, action.uid));
        default:
            return state;
    }
};

var useMap = exports.useMap = function useMap() {
    return _react2.default.useContext(MapContext);
};

/***/ }),

/***/ 2415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _values2 = __webpack_require__(92);

var _values3 = _interopRequireDefault(_values2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FormControl = __webpack_require__(177);

var _FormControl2 = _interopRequireDefault(_FormControl);

var _AppConstants = __webpack_require__(6);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var changeHandler = function changeHandler(callback) {
    return function (e) {
        return callback(e.target.value);
    };
};

function ArriveDepart(_ref) {
    var arriveDepart = _ref.arriveDepart,
        direction = _ref.direction,
        onChange = _ref.onChange,
        className = _ref.className,
        disabled = _ref.disabled;

    var labelName = direction === _AppConstants.JourneyDirections.INWARD ? 'returnArriveDepart__selector' : 'outboundArriveDepart__selector';

    return _react2.default.createElement(
        'div',
        { className: 'arrive-depart select-container ' + className },
        _react2.default.createElement(_Icon2.default, { icon: 'dropdown' }),
        _react2.default.createElement(
            'label',
            { htmlFor: labelName, className: 'sr-only' },
            (0, _I18n2.default)('booking.dates.arriving'),
            ' / ',
            (0, _I18n2.default)('booking.dates.departing')
        ),
        _react2.default.createElement(
            _FormControl2.default,
            { componentClass: 'select',
                disabled: disabled,
                name: 'arriveDepart',
                id: labelName,
                className: 'arriveDepart__form-control',
                value: arriveDepart,
                onChange: changeHandler(onChange) },
            _react2.default.createElement(
                'option',
                { value: _AppConstants.TimeTypes.DEPART },
                (0, _I18n2.default)('booking.dates.departing')
            ),
            _react2.default.createElement(
                'option',
                { value: _AppConstants.TimeTypes.ARRIVE },
                (0, _I18n2.default)('booking.dates.arriving')
            )
        )
    );
}

ArriveDepart.propTypes = {
    arriveDepart: _propTypes2.default.oneOf((0, _values3.default)(_AppConstants.TimeTypes)),
    direction: _propTypes2.default.oneOf((0, _values3.default)(_AppConstants.JourneyDirections)),
    onChange: _propTypes2.default.func,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    labelName: _propTypes2.default.string
};

ArriveDepart.defaultProps = {
    arriveDepart: _AppConstants.TimeTypes.DEPART,
    direction: _AppConstants.JourneyDirections.OUTWARD,
    onChange: _noop3.default,
    className: '',
    disabled: false
};

exports.default = ArriveDepart;

/***/ }),

/***/ 2417:
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(432),
    toInteger = __webpack_require__(200);

/**
 * Creates a slice of `array` with `n` elements taken from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.takeRight([1, 2, 3]);
 * // => [3]
 *
 * _.takeRight([1, 2, 3], 2);
 * // => [2, 3]
 *
 * _.takeRight([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.takeRight([1, 2, 3], 0);
 * // => []
 */
function takeRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, n < 0 ? 0 : n, length);
}

module.exports = takeRight;


/***/ }),

/***/ 2418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * https://snazzymaps.com/editor
 */
exports.default = [{
    "featureType": "administrative.country",
    "elementType": "all",
    "stylers": [{
        "visibility": "on"
    }]
}, {
    "featureType": "administrative.country",
    "elementType": "labels.text",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "administrative.province",
    "elementType": "labels.text",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "administrative.locality",
    "elementType": "labels.text.fill",
    "stylers": [{
        "lightness": "-100"
    }]
}, {
    "featureType": "administrative.neighborhood",
    "elementType": "labels.text.fill",
    "stylers": [{
        "visibility": "on"
    }, {
        "lightness": "-70"
    }]
}, {
    "featureType": "landscape.natural",
    "elementType": "labels.text.fill",
    "stylers": [{
        "lightness": "-60"
    }]
}, {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [{
        "lightness": "25"
    }]
}, {
    "featureType": "poi",
    "elementType": "labels",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{
        "visibility": "simplified"
    }]
}, {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [{
        "visibility": "simplified"
    }]
}, {
    "featureType": "road",
    "elementType": "labels.text",
    "stylers": [{
        "color": "#8c8c8f"
    }]
}, {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [{
        "visibility": "simplified"
    }, {
        "color": "#ffffff"
    }]
}, {
    "featureType": "road.highway.controlled_access",
    "elementType": "geometry",
    "stylers": [{
        "visibility": "on"
    }]
}, {
    "featureType": "road.local",
    "elementType": "geometry",
    "stylers": [{
        "visibility": "on"
    }]
}, {
    "featureType": "transit.station",
    "elementType": "all",
    "stylers": [{
        "visibility": "on"
    }]
}];

/***/ }),

/***/ 2424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _uniq2 = __webpack_require__(619);

var _uniq3 = _interopRequireDefault(_uniq2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _I18n = __webpack_require__(9);

var _PassengerRailcard = __webpack_require__(269);

var _PassengerRailcard2 = _interopRequireDefault(_PassengerRailcard);

var _PassengersForm = __webpack_require__(2395);

var _PassengersForm2 = _interopRequireDefault(_PassengersForm);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _Railcard = __webpack_require__(2425);

var _Railcard2 = _interopRequireDefault(_Railcard);

var _SectionErrors = __webpack_require__(974);

var _SectionErrors2 = _interopRequireDefault(_SectionErrors);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Railcards = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(Railcards, _PureRenderComponent);

    function Railcards() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Railcards);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this._addRailcard = function () {
            var passengerRailcard = new _PassengerRailcard2.default();
            var railcards = _this.props.railcards.push(passengerRailcard);
            _this.props.onRailcardsChange(railcards);
        }, _this._updateRailcard = function (key) {
            return function (railcard) {
                var railcards = _this.props.railcards.set(key, railcard);
                _this.props.onRailcardsChange(railcards);
            };
        }, _this._removeRailcard = function (key) {
            return function () {
                var railcards = _this.props.railcards;

                _this.props.onRailcardsChange(railcards.delete(key));
            };
        }, _this._removeLastRailcard = function () {
            var railcards = _this.props.railcards.pop();
            _this.props.onRailcardsChange(railcards);
        }, _this._renderRailcardExpiryNotice = function () {
            var _this$props = _this.props,
                hideExpiryNotice = _this$props.hideExpiryNotice,
                railcards = _this$props.railcards;


            return railcards.size > 0 && _react2.default.createElement(
                _FeatureFlag2.default,
                { name: 'showRailcardExpiryInfo', disabled: hideExpiryNotice },
                _react2.default.createElement(
                    _BAlert2.default,
                    { type: _BAlert.bAlertType.INFO, className: 'margin-bottom--sm' },
                    _react2.default.createElement(_Icon2.default, { icon: 'warning b-alert__icon b-alert__icon--multiline' }),
                    (0, _I18n.translate)('boooking.railcards.checkExpiry')
                )
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    Railcards.prototype._validate = function _validate() {
        var _props = this.props,
            railcards = _props.railcards,
            adults = _props.adults,
            children = _props.children;

        var form = new this.props.Form({ railcards: railcards, adults: adults, children: children });

        var error = form.getError('railcards');
        if (error) {
            return [error];
        }
        return [];
    };

    Railcards.prototype._isAddDisabled = function _isAddDisabled() {
        return !!this._validate().length;
    };

    Railcards.prototype._renderRemoveButton = function _renderRemoveButton(_ref) {
        var railcards = _ref.railcards;

        return railcards.size > 0 ? _react2.default.createElement(
            _Button2.default,
            { className: 'btn-sm', onClick: this._removeLastRailcard },
            _react2.default.createElement(_Icon2.default, { icon: 'remove' }),
            (0, _I18n.translate)('booking.railcards.remove')
        ) : null;
    };

    Railcards.prototype.render = function render() {
        var _this2 = this;

        var _props2 = this.props,
            adults = _props2.adults,
            children = _props2.children,
            className = _props2.className,
            enableRemoving = _props2.enableRemoving,
            Form = _props2.Form,
            railcards = _props2.railcards;


        var errors = this._validate();

        return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('railcards', className) },
            _react2.default.createElement(
                _Button2.default,
                { className: 'btn-sm', onClick: this._addRailcard, disabled: this._isAddDisabled() },
                _react2.default.createElement(_Icon2.default, { icon: 'add' }),
                (0, _I18n.translate)('booking.railcards.add')
            ),
            _react2.default.createElement(
                'ul',
                { className: 'list-unstyled railcards__list' },
                railcards.map(function (passengerRailcard, key) {

                    /* constructs an array of relevant errors for each specific railcard: */
                    var railcardSpecificForm = new Form({ adults: adults, children: children, railcards: _immutable.List.of(passengerRailcard) });
                    var railcardSpecificErrors = railcardSpecificForm.getValidationSummaryArray();
                    if (railcards.size > 1 && errors.includes((0, _I18n.translate)('alertmessage.form.moreRailcardsThanPassengers'))) {
                        railcardSpecificErrors.push((0, _I18n.translate)('alertmessage.form.moreRailcardsThanPassengers'));
                    }

                    return _react2.default.createElement(_Railcard2.default, {
                        key: key,
                        code: passengerRailcard.code,
                        enableRemoving: enableRemoving,
                        quantity: passengerRailcard.quantity,
                        onChange: _this2._updateRailcard(key),
                        onDelete: _this2._removeRailcard(key),
                        error: (0, _uniq3.default)(railcardSpecificErrors).join('. ')
                    });
                })
            ),
            this._renderRailcardExpiryNotice(),
            !enableRemoving && this._renderRemoveButton(this.props),
            errors.length > 0 && _react2.default.createElement(_SectionErrors2.default, { errors: errors })
        );
    };

    return Railcards;
}(_PureRenderComponent3.default), _class.propTypes = {
    railcards: _propTypes2.default.instanceOf(_immutable.List).isRequired,
    adults: _propTypes2.default.number.isRequired,
    children: _propTypes2.default.number.isRequired,
    className: _propTypes2.default.string,
    enableRemoving: _propTypes2.default.bool,
    hideExpiryNotice: _propTypes2.default.bool,
    onRailcardsChange: _propTypes2.default.func,
    Form: _propTypes2.default.func
}, _class.defaultProps = {
    className: '',
    enableRemoving: false,
    hideExpiryNotice: false,
    onRailcardsChange: _noop3.default,
    Form: _PassengersForm2.default
}, _temp2);
exports.default = Railcards;

/***/ }),

/***/ 2425:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _PassengerRailcard = __webpack_require__(269);

var _PassengerRailcard2 = _interopRequireDefault(_PassengerRailcard);

var _BinWithCrossIcon = __webpack_require__(2426);

var _BinWithCrossIcon2 = _interopRequireDefault(_BinWithCrossIcon);

var _StepperInput = __webpack_require__(2405);

var _StepperInput2 = _interopRequireDefault(_StepperInput);

var _RailcardTypes = __webpack_require__(2406);

var _RailcardTypes2 = _interopRequireDefault(_RailcardTypes);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Railcard = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(Railcard, _PureRenderComponent);

    function Railcard() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Railcard);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this._onRailcardChange = function () {
            var railcard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var code = railcard.code;
            var quantity = _this.props.quantity;
            var passengerRailcard = new _PassengerRailcard2.default({ code: code, quantity: quantity });
            _this.props.onChange(passengerRailcard);
        }, _this._onQuantityChange = function (quantity) {
            var code = _this.props.code;
            var passengerRailcard = new _PassengerRailcard2.default({ code: code, quantity: quantity });
            _this.props.onChange(passengerRailcard);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    Railcard.prototype.render = function render() {
        var _props = this.props,
            enableRemoving = _props.enableRemoving,
            error = _props.error,
            onDelete = _props.onDelete;

        return _react2.default.createElement(
            'li',
            { className: 'railcards__item' },
            _react2.default.createElement(_StepperInput2.default, {
                name: 'clearfix',
                value: this.props.quantity,
                min: 1,
                max: 9,
                onChange: this._onQuantityChange,
                error: error
            }),
            _react2.default.createElement(_RailcardTypes2.default, {
                value: this.props.code,
                onChange: this._onRailcardChange,
                error: error
            }),
            enableRemoving && _react2.default.createElement(
                'span',
                { className: 'railcards__item__remove', onClick: onDelete },
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    (0, _I18n2.default)('railcard.list.remove')
                ),
                _react2.default.createElement(_BinWithCrossIcon2.default, null)
            )
        );
    };

    return Railcard;
}(_PureRenderComponent3.default), _class.propTypes = {
    code: _propTypes2.default.string,
    quantity: _propTypes2.default.number,
    enableRemoving: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    onDelete: _propTypes2.default.func,
    error: _propTypes2.default.string
}, _class.defaultProps = {
    code: '',
    quantity: 0,
    enableRemoving: false,
    onChange: _noop3.default,
    onDelete: _noop3.default,
    error: ''
}, _temp2);
exports.default = Railcard;

/***/ }),

/***/ 2426:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BinWithCrossIcon(_ref) {
    var _ref$width = _ref.width,
        width = _ref$width === undefined ? 22 : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 28 : _ref$height;

    return _react2.default.createElement(
        'svg',
        { width: width, height: height, viewBox: '0 0 5.048 6.35' },
        _react2.default.createElement('path', { fill: 'currentColor', d: 'M.576 6.262a.683.683 0 01-.197-.22C.31 5.91.309 5.845.309 3.76V1.61h4.43v2.148c0 2.08-.002 2.151-.068 2.282a.709.709 0 01-.197.222l-.128.087-3.642-.004zm1.597-1.655c.172-.175.329-.318.348-.318.02 0 .217.18.438.4l.4.4.21-.199c.115-.11.209-.21.209-.222 0-.013-.17-.195-.378-.405-.208-.21-.378-.41-.378-.443 0-.034.174-.236.386-.449l.386-.387-.214-.214-.214-.214-.404.403c-.223.222-.416.403-.43.403s-.205-.177-.425-.393c-.315-.31-.412-.387-.456-.363-.031.016-.132.11-.223.208l-.166.177.4.401c.219.22.399.416.399.434 0 .018-.181.214-.402.436l-.402.403.426.426.09-.083c.048-.046.229-.226.4-.4zM0 .632V.34h1.55l.16-.156A.855.855 0 011.944.01c.04-.01.334-.013.653-.007l.58.01.331.327h1.541v.584H0z' })
    );
}

BinWithCrossIcon.propTypes = {
    width: _propTypes2.default.number.isRequired,
    height: _propTypes2.default.number.isRequired
};

exports.default = BinWithCrossIcon;

/***/ }),

/***/ 2427:
/***/ (function(module, exports, __webpack_require__) {

/* @preserve
 * Leaflet 1.7.1, a JS library for interactive maps. http://leafletjs.com
 * (c) 2010-2019 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */

(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.L = {})));
}(this, (function (exports) { 'use strict';

  var version = "1.7.1";

  /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */

  // @function extend(dest: Object, src?: Object): Object
  // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
  function extend(dest) {
  	var i, j, len, src;

  	for (j = 1, len = arguments.length; j < len; j++) {
  		src = arguments[j];
  		for (i in src) {
  			dest[i] = src[i];
  		}
  	}
  	return dest;
  }

  // @function create(proto: Object, properties?: Object): Object
  // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
  var create = Object.create || (function () {
  	function F() {}
  	return function (proto) {
  		F.prototype = proto;
  		return new F();
  	};
  })();

  // @function bind(fn: Function, …): Function
  // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
  // Has a `L.bind()` shortcut.
  function bind(fn, obj) {
  	var slice = Array.prototype.slice;

  	if (fn.bind) {
  		return fn.bind.apply(fn, slice.call(arguments, 1));
  	}

  	var args = slice.call(arguments, 2);

  	return function () {
  		return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
  	};
  }

  // @property lastId: Number
  // Last unique ID used by [`stamp()`](#util-stamp)
  var lastId = 0;

  // @function stamp(obj: Object): Number
  // Returns the unique ID of an object, assigning it one if it doesn't have it.
  function stamp(obj) {
  	/*eslint-disable */
  	obj._leaflet_id = obj._leaflet_id || ++lastId;
  	return obj._leaflet_id;
  	/* eslint-enable */
  }

  // @function throttle(fn: Function, time: Number, context: Object): Function
  // Returns a function which executes function `fn` with the given scope `context`
  // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
  // `fn` will be called no more than one time per given amount of `time`. The arguments
  // received by the bound function will be any arguments passed when binding the
  // function, followed by any arguments passed when invoking the bound function.
  // Has an `L.throttle` shortcut.
  function throttle(fn, time, context) {
  	var lock, args, wrapperFn, later;

  	later = function () {
  		// reset lock and call if queued
  		lock = false;
  		if (args) {
  			wrapperFn.apply(context, args);
  			args = false;
  		}
  	};

  	wrapperFn = function () {
  		if (lock) {
  			// called too soon, queue to call later
  			args = arguments;

  		} else {
  			// call and lock until later
  			fn.apply(context, arguments);
  			setTimeout(later, time);
  			lock = true;
  		}
  	};

  	return wrapperFn;
  }

  // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
  // Returns the number `num` modulo `range` in such a way so it lies within
  // `range[0]` and `range[1]`. The returned value will be always smaller than
  // `range[1]` unless `includeMax` is set to `true`.
  function wrapNum(x, range, includeMax) {
  	var max = range[1],
  	    min = range[0],
  	    d = max - min;
  	return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
  }

  // @function falseFn(): Function
  // Returns a function which always returns `false`.
  function falseFn() { return false; }

  // @function formatNum(num: Number, digits?: Number): Number
  // Returns the number `num` rounded to `digits` decimals, or to 6 decimals by default.
  function formatNum(num, digits) {
  	var pow = Math.pow(10, (digits === undefined ? 6 : digits));
  	return Math.round(num * pow) / pow;
  }

  // @function trim(str: String): String
  // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
  function trim(str) {
  	return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
  }

  // @function splitWords(str: String): String[]
  // Trims and splits the string on whitespace and returns the array of parts.
  function splitWords(str) {
  	return trim(str).split(/\s+/);
  }

  // @function setOptions(obj: Object, options: Object): Object
  // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
  function setOptions(obj, options) {
  	if (!Object.prototype.hasOwnProperty.call(obj, 'options')) {
  		obj.options = obj.options ? create(obj.options) : {};
  	}
  	for (var i in options) {
  		obj.options[i] = options[i];
  	}
  	return obj.options;
  }

  // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
  // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
  // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
  // be appended at the end. If `uppercase` is `true`, the parameter names will
  // be uppercased (e.g. `'?A=foo&B=bar'`)
  function getParamString(obj, existingUrl, uppercase) {
  	var params = [];
  	for (var i in obj) {
  		params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
  	}
  	return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
  }

  var templateRe = /\{ *([\w_-]+) *\}/g;

  // @function template(str: String, data: Object): String
  // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
  // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
  // `('Hello foo, bar')`. You can also specify functions instead of strings for
  // data values — they will be evaluated passing `data` as an argument.
  function template(str, data) {
  	return str.replace(templateRe, function (str, key) {
  		var value = data[key];

  		if (value === undefined) {
  			throw new Error('No value provided for variable ' + str);

  		} else if (typeof value === 'function') {
  			value = value(data);
  		}
  		return value;
  	});
  }

  // @function isArray(obj): Boolean
  // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
  var isArray = Array.isArray || function (obj) {
  	return (Object.prototype.toString.call(obj) === '[object Array]');
  };

  // @function indexOf(array: Array, el: Object): Number
  // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
  function indexOf(array, el) {
  	for (var i = 0; i < array.length; i++) {
  		if (array[i] === el) { return i; }
  	}
  	return -1;
  }

  // @property emptyImageUrl: String
  // Data URI string containing a base64-encoded empty GIF image.
  // Used as a hack to free memory from unused images on WebKit-powered
  // mobile devices (by setting image `src` to this string).
  var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';

  // inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/

  function getPrefixed(name) {
  	return window['webkit' + name] || window['moz' + name] || window['ms' + name];
  }

  var lastTime = 0;

  // fallback for IE 7-8
  function timeoutDefer(fn) {
  	var time = +new Date(),
  	    timeToCall = Math.max(0, 16 - (time - lastTime));

  	lastTime = time + timeToCall;
  	return window.setTimeout(fn, timeToCall);
  }

  var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
  var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
  		getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };

  // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
  // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
  // `context` if given. When `immediate` is set, `fn` is called immediately if
  // the browser doesn't have native support for
  // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
  // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
  function requestAnimFrame(fn, context, immediate) {
  	if (immediate && requestFn === timeoutDefer) {
  		fn.call(context);
  	} else {
  		return requestFn.call(window, bind(fn, context));
  	}
  }

  // @function cancelAnimFrame(id: Number): undefined
  // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
  function cancelAnimFrame(id) {
  	if (id) {
  		cancelFn.call(window, id);
  	}
  }

  var Util = ({
    extend: extend,
    create: create,
    bind: bind,
    lastId: lastId,
    stamp: stamp,
    throttle: throttle,
    wrapNum: wrapNum,
    falseFn: falseFn,
    formatNum: formatNum,
    trim: trim,
    splitWords: splitWords,
    setOptions: setOptions,
    getParamString: getParamString,
    template: template,
    isArray: isArray,
    indexOf: indexOf,
    emptyImageUrl: emptyImageUrl,
    requestFn: requestFn,
    cancelFn: cancelFn,
    requestAnimFrame: requestAnimFrame,
    cancelAnimFrame: cancelAnimFrame
  });

  // @class Class
  // @aka L.Class

  // @section
  // @uninheritable

  // Thanks to John Resig and Dean Edwards for inspiration!

  function Class() {}

  Class.extend = function (props) {

  	// @function extend(props: Object): Function
  	// [Extends the current class](#class-inheritance) given the properties to be included.
  	// Returns a Javascript function that is a class constructor (to be called with `new`).
  	var NewClass = function () {

  		// call the constructor
  		if (this.initialize) {
  			this.initialize.apply(this, arguments);
  		}

  		// call all constructor hooks
  		this.callInitHooks();
  	};

  	var parentProto = NewClass.__super__ = this.prototype;

  	var proto = create(parentProto);
  	proto.constructor = NewClass;

  	NewClass.prototype = proto;

  	// inherit parent's statics
  	for (var i in this) {
  		if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') {
  			NewClass[i] = this[i];
  		}
  	}

  	// mix static properties into the class
  	if (props.statics) {
  		extend(NewClass, props.statics);
  		delete props.statics;
  	}

  	// mix includes into the prototype
  	if (props.includes) {
  		checkDeprecatedMixinEvents(props.includes);
  		extend.apply(null, [proto].concat(props.includes));
  		delete props.includes;
  	}

  	// merge options
  	if (proto.options) {
  		props.options = extend(create(proto.options), props.options);
  	}

  	// mix given properties into the prototype
  	extend(proto, props);

  	proto._initHooks = [];

  	// add method for calling all hooks
  	proto.callInitHooks = function () {

  		if (this._initHooksCalled) { return; }

  		if (parentProto.callInitHooks) {
  			parentProto.callInitHooks.call(this);
  		}

  		this._initHooksCalled = true;

  		for (var i = 0, len = proto._initHooks.length; i < len; i++) {
  			proto._initHooks[i].call(this);
  		}
  	};

  	return NewClass;
  };


  // @function include(properties: Object): this
  // [Includes a mixin](#class-includes) into the current class.
  Class.include = function (props) {
  	extend(this.prototype, props);
  	return this;
  };

  // @function mergeOptions(options: Object): this
  // [Merges `options`](#class-options) into the defaults of the class.
  Class.mergeOptions = function (options) {
  	extend(this.prototype.options, options);
  	return this;
  };

  // @function addInitHook(fn: Function): this
  // Adds a [constructor hook](#class-constructor-hooks) to the class.
  Class.addInitHook = function (fn) { // (Function) || (String, args...)
  	var args = Array.prototype.slice.call(arguments, 1);

  	var init = typeof fn === 'function' ? fn : function () {
  		this[fn].apply(this, args);
  	};

  	this.prototype._initHooks = this.prototype._initHooks || [];
  	this.prototype._initHooks.push(init);
  	return this;
  };

  function checkDeprecatedMixinEvents(includes) {
  	if (typeof L === 'undefined' || !L || !L.Mixin) { return; }

  	includes = isArray(includes) ? includes : [includes];

  	for (var i = 0; i < includes.length; i++) {
  		if (includes[i] === L.Mixin.Events) {
  			console.warn('Deprecated include of L.Mixin.Events: ' +
  				'this property will be removed in future releases, ' +
  				'please inherit from L.Evented instead.', new Error().stack);
  		}
  	}
  }

  /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */

  var Events = {
  	/* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */
  	on: function (types, fn, context) {

  		// types can be a map of types/handlers
  		if (typeof types === 'object') {
  			for (var type in types) {
  				// we don't process space-separated events here for performance;
  				// it's a hot path since Layer uses the on(obj) syntax
  				this._on(type, types[type], fn);
  			}

  		} else {
  			// types can be a string of space-separated words
  			types = splitWords(types);

  			for (var i = 0, len = types.length; i < len; i++) {
  				this._on(types[i], fn, context);
  			}
  		}

  		return this;
  	},

  	/* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */
  	off: function (types, fn, context) {

  		if (!types) {
  			// clear all listeners if called without arguments
  			delete this._events;

  		} else if (typeof types === 'object') {
  			for (var type in types) {
  				this._off(type, types[type], fn);
  			}

  		} else {
  			types = splitWords(types);

  			for (var i = 0, len = types.length; i < len; i++) {
  				this._off(types[i], fn, context);
  			}
  		}

  		return this;
  	},

  	// attach listener (without syntactic sugar now)
  	_on: function (type, fn, context) {
  		this._events = this._events || {};

  		/* get/init listeners for type */
  		var typeListeners = this._events[type];
  		if (!typeListeners) {
  			typeListeners = [];
  			this._events[type] = typeListeners;
  		}

  		if (context === this) {
  			// Less memory footprint.
  			context = undefined;
  		}
  		var newListener = {fn: fn, ctx: context},
  		    listeners = typeListeners;

  		// check if fn already there
  		for (var i = 0, len = listeners.length; i < len; i++) {
  			if (listeners[i].fn === fn && listeners[i].ctx === context) {
  				return;
  			}
  		}

  		listeners.push(newListener);
  	},

  	_off: function (type, fn, context) {
  		var listeners,
  		    i,
  		    len;

  		if (!this._events) { return; }

  		listeners = this._events[type];

  		if (!listeners) {
  			return;
  		}

  		if (!fn) {
  			// Set all removed listeners to noop so they are not called if remove happens in fire
  			for (i = 0, len = listeners.length; i < len; i++) {
  				listeners[i].fn = falseFn;
  			}
  			// clear all listeners for a type if function isn't specified
  			delete this._events[type];
  			return;
  		}

  		if (context === this) {
  			context = undefined;
  		}

  		if (listeners) {

  			// find fn and remove it
  			for (i = 0, len = listeners.length; i < len; i++) {
  				var l = listeners[i];
  				if (l.ctx !== context) { continue; }
  				if (l.fn === fn) {

  					// set the removed listener to noop so that's not called if remove happens in fire
  					l.fn = falseFn;

  					if (this._firingCount) {
  						/* copy array in case events are being fired */
  						this._events[type] = listeners = listeners.slice();
  					}
  					listeners.splice(i, 1);

  					return;
  				}
  			}
  		}
  	},

  	// @method fire(type: String, data?: Object, propagate?: Boolean): this
  	// Fires an event of the specified type. You can optionally provide an data
  	// object — the first argument of the listener function will contain its
  	// properties. The event can optionally be propagated to event parents.
  	fire: function (type, data, propagate) {
  		if (!this.listens(type, propagate)) { return this; }

  		var event = extend({}, data, {
  			type: type,
  			target: this,
  			sourceTarget: data && data.sourceTarget || this
  		});

  		if (this._events) {
  			var listeners = this._events[type];

  			if (listeners) {
  				this._firingCount = (this._firingCount + 1) || 1;
  				for (var i = 0, len = listeners.length; i < len; i++) {
  					var l = listeners[i];
  					l.fn.call(l.ctx || this, event);
  				}

  				this._firingCount--;
  			}
  		}

  		if (propagate) {
  			// propagate the event to parents (set with addEventParent)
  			this._propagateEvent(event);
  		}

  		return this;
  	},

  	// @method listens(type: String): Boolean
  	// Returns `true` if a particular event type has any listeners attached to it.
  	listens: function (type, propagate) {
  		var listeners = this._events && this._events[type];
  		if (listeners && listeners.length) { return true; }

  		if (propagate) {
  			// also check parents for listeners if event propagates
  			for (var id in this._eventParents) {
  				if (this._eventParents[id].listens(type, propagate)) { return true; }
  			}
  		}
  		return false;
  	},

  	// @method once(…): this
  	// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
  	once: function (types, fn, context) {

  		if (typeof types === 'object') {
  			for (var type in types) {
  				this.once(type, types[type], fn);
  			}
  			return this;
  		}

  		var handler = bind(function () {
  			this
  			    .off(types, fn, context)
  			    .off(types, handler, context);
  		}, this);

  		// add a listener that's executed once and removed after that
  		return this
  		    .on(types, fn, context)
  		    .on(types, handler, context);
  	},

  	// @method addEventParent(obj: Evented): this
  	// Adds an event parent - an `Evented` that will receive propagated events
  	addEventParent: function (obj) {
  		this._eventParents = this._eventParents || {};
  		this._eventParents[stamp(obj)] = obj;
  		return this;
  	},

  	// @method removeEventParent(obj: Evented): this
  	// Removes an event parent, so it will stop receiving propagated events
  	removeEventParent: function (obj) {
  		if (this._eventParents) {
  			delete this._eventParents[stamp(obj)];
  		}
  		return this;
  	},

  	_propagateEvent: function (e) {
  		for (var id in this._eventParents) {
  			this._eventParents[id].fire(e.type, extend({
  				layer: e.target,
  				propagatedFrom: e.target
  			}, e), true);
  		}
  	}
  };

  // aliases; we should ditch those eventually

  // @method addEventListener(…): this
  // Alias to [`on(…)`](#evented-on)
  Events.addEventListener = Events.on;

  // @method removeEventListener(…): this
  // Alias to [`off(…)`](#evented-off)

  // @method clearAllEventListeners(…): this
  // Alias to [`off()`](#evented-off)
  Events.removeEventListener = Events.clearAllEventListeners = Events.off;

  // @method addOneTimeEventListener(…): this
  // Alias to [`once(…)`](#evented-once)
  Events.addOneTimeEventListener = Events.once;

  // @method fireEvent(…): this
  // Alias to [`fire(…)`](#evented-fire)
  Events.fireEvent = Events.fire;

  // @method hasEventListeners(…): Boolean
  // Alias to [`listens(…)`](#evented-listens)
  Events.hasEventListeners = Events.listens;

  var Evented = Class.extend(Events);

  /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */

  function Point(x, y, round) {
  	// @property x: Number; The `x` coordinate of the point
  	this.x = (round ? Math.round(x) : x);
  	// @property y: Number; The `y` coordinate of the point
  	this.y = (round ? Math.round(y) : y);
  }

  var trunc = Math.trunc || function (v) {
  	return v > 0 ? Math.floor(v) : Math.ceil(v);
  };

  Point.prototype = {

  	// @method clone(): Point
  	// Returns a copy of the current point.
  	clone: function () {
  		return new Point(this.x, this.y);
  	},

  	// @method add(otherPoint: Point): Point
  	// Returns the result of addition of the current and the given points.
  	add: function (point) {
  		// non-destructive, returns a new point
  		return this.clone()._add(toPoint(point));
  	},

  	_add: function (point) {
  		// destructive, used directly for performance in situations where it's safe to modify existing point
  		this.x += point.x;
  		this.y += point.y;
  		return this;
  	},

  	// @method subtract(otherPoint: Point): Point
  	// Returns the result of subtraction of the given point from the current.
  	subtract: function (point) {
  		return this.clone()._subtract(toPoint(point));
  	},

  	_subtract: function (point) {
  		this.x -= point.x;
  		this.y -= point.y;
  		return this;
  	},

  	// @method divideBy(num: Number): Point
  	// Returns the result of division of the current point by the given number.
  	divideBy: function (num) {
  		return this.clone()._divideBy(num);
  	},

  	_divideBy: function (num) {
  		this.x /= num;
  		this.y /= num;
  		return this;
  	},

  	// @method multiplyBy(num: Number): Point
  	// Returns the result of multiplication of the current point by the given number.
  	multiplyBy: function (num) {
  		return this.clone()._multiplyBy(num);
  	},

  	_multiplyBy: function (num) {
  		this.x *= num;
  		this.y *= num;
  		return this;
  	},

  	// @method scaleBy(scale: Point): Point
  	// Multiply each coordinate of the current point by each coordinate of
  	// `scale`. In linear algebra terms, multiply the point by the
  	// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
  	// defined by `scale`.
  	scaleBy: function (point) {
  		return new Point(this.x * point.x, this.y * point.y);
  	},

  	// @method unscaleBy(scale: Point): Point
  	// Inverse of `scaleBy`. Divide each coordinate of the current point by
  	// each coordinate of `scale`.
  	unscaleBy: function (point) {
  		return new Point(this.x / point.x, this.y / point.y);
  	},

  	// @method round(): Point
  	// Returns a copy of the current point with rounded coordinates.
  	round: function () {
  		return this.clone()._round();
  	},

  	_round: function () {
  		this.x = Math.round(this.x);
  		this.y = Math.round(this.y);
  		return this;
  	},

  	// @method floor(): Point
  	// Returns a copy of the current point with floored coordinates (rounded down).
  	floor: function () {
  		return this.clone()._floor();
  	},

  	_floor: function () {
  		this.x = Math.floor(this.x);
  		this.y = Math.floor(this.y);
  		return this;
  	},

  	// @method ceil(): Point
  	// Returns a copy of the current point with ceiled coordinates (rounded up).
  	ceil: function () {
  		return this.clone()._ceil();
  	},

  	_ceil: function () {
  		this.x = Math.ceil(this.x);
  		this.y = Math.ceil(this.y);
  		return this;
  	},

  	// @method trunc(): Point
  	// Returns a copy of the current point with truncated coordinates (rounded towards zero).
  	trunc: function () {
  		return this.clone()._trunc();
  	},

  	_trunc: function () {
  		this.x = trunc(this.x);
  		this.y = trunc(this.y);
  		return this;
  	},

  	// @method distanceTo(otherPoint: Point): Number
  	// Returns the cartesian distance between the current and the given points.
  	distanceTo: function (point) {
  		point = toPoint(point);

  		var x = point.x - this.x,
  		    y = point.y - this.y;

  		return Math.sqrt(x * x + y * y);
  	},

  	// @method equals(otherPoint: Point): Boolean
  	// Returns `true` if the given point has the same coordinates.
  	equals: function (point) {
  		point = toPoint(point);

  		return point.x === this.x &&
  		       point.y === this.y;
  	},

  	// @method contains(otherPoint: Point): Boolean
  	// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
  	contains: function (point) {
  		point = toPoint(point);

  		return Math.abs(point.x) <= Math.abs(this.x) &&
  		       Math.abs(point.y) <= Math.abs(this.y);
  	},

  	// @method toString(): String
  	// Returns a string representation of the point for debugging purposes.
  	toString: function () {
  		return 'Point(' +
  		        formatNum(this.x) + ', ' +
  		        formatNum(this.y) + ')';
  	}
  };

  // @factory L.point(x: Number, y: Number, round?: Boolean)
  // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.

  // @alternative
  // @factory L.point(coords: Number[])
  // Expects an array of the form `[x, y]` instead.

  // @alternative
  // @factory L.point(coords: Object)
  // Expects a plain object of the form `{x: Number, y: Number}` instead.
  function toPoint(x, y, round) {
  	if (x instanceof Point) {
  		return x;
  	}
  	if (isArray(x)) {
  		return new Point(x[0], x[1]);
  	}
  	if (x === undefined || x === null) {
  		return x;
  	}
  	if (typeof x === 'object' && 'x' in x && 'y' in x) {
  		return new Point(x.x, x.y);
  	}
  	return new Point(x, y, round);
  }

  /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */

  function Bounds(a, b) {
  	if (!a) { return; }

  	var points = b ? [a, b] : a;

  	for (var i = 0, len = points.length; i < len; i++) {
  		this.extend(points[i]);
  	}
  }

  Bounds.prototype = {
  	// @method extend(point: Point): this
  	// Extends the bounds to contain the given point.
  	extend: function (point) { // (Point)
  		point = toPoint(point);

  		// @property min: Point
  		// The top left corner of the rectangle.
  		// @property max: Point
  		// The bottom right corner of the rectangle.
  		if (!this.min && !this.max) {
  			this.min = point.clone();
  			this.max = point.clone();
  		} else {
  			this.min.x = Math.min(point.x, this.min.x);
  			this.max.x = Math.max(point.x, this.max.x);
  			this.min.y = Math.min(point.y, this.min.y);
  			this.max.y = Math.max(point.y, this.max.y);
  		}
  		return this;
  	},

  	// @method getCenter(round?: Boolean): Point
  	// Returns the center point of the bounds.
  	getCenter: function (round) {
  		return new Point(
  		        (this.min.x + this.max.x) / 2,
  		        (this.min.y + this.max.y) / 2, round);
  	},

  	// @method getBottomLeft(): Point
  	// Returns the bottom-left point of the bounds.
  	getBottomLeft: function () {
  		return new Point(this.min.x, this.max.y);
  	},

  	// @method getTopRight(): Point
  	// Returns the top-right point of the bounds.
  	getTopRight: function () { // -> Point
  		return new Point(this.max.x, this.min.y);
  	},

  	// @method getTopLeft(): Point
  	// Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
  	getTopLeft: function () {
  		return this.min; // left, top
  	},

  	// @method getBottomRight(): Point
  	// Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
  	getBottomRight: function () {
  		return this.max; // right, bottom
  	},

  	// @method getSize(): Point
  	// Returns the size of the given bounds
  	getSize: function () {
  		return this.max.subtract(this.min);
  	},

  	// @method contains(otherBounds: Bounds): Boolean
  	// Returns `true` if the rectangle contains the given one.
  	// @alternative
  	// @method contains(point: Point): Boolean
  	// Returns `true` if the rectangle contains the given point.
  	contains: function (obj) {
  		var min, max;

  		if (typeof obj[0] === 'number' || obj instanceof Point) {
  			obj = toPoint(obj);
  		} else {
  			obj = toBounds(obj);
  		}

  		if (obj instanceof Bounds) {
  			min = obj.min;
  			max = obj.max;
  		} else {
  			min = max = obj;
  		}

  		return (min.x >= this.min.x) &&
  		       (max.x <= this.max.x) &&
  		       (min.y >= this.min.y) &&
  		       (max.y <= this.max.y);
  	},

  	// @method intersects(otherBounds: Bounds): Boolean
  	// Returns `true` if the rectangle intersects the given bounds. Two bounds
  	// intersect if they have at least one point in common.
  	intersects: function (bounds) { // (Bounds) -> Boolean
  		bounds = toBounds(bounds);

  		var min = this.min,
  		    max = this.max,
  		    min2 = bounds.min,
  		    max2 = bounds.max,
  		    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
  		    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);

  		return xIntersects && yIntersects;
  	},

  	// @method overlaps(otherBounds: Bounds): Boolean
  	// Returns `true` if the rectangle overlaps the given bounds. Two bounds
  	// overlap if their intersection is an area.
  	overlaps: function (bounds) { // (Bounds) -> Boolean
  		bounds = toBounds(bounds);

  		var min = this.min,
  		    max = this.max,
  		    min2 = bounds.min,
  		    max2 = bounds.max,
  		    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
  		    yOverlaps = (max2.y > min.y) && (min2.y < max.y);

  		return xOverlaps && yOverlaps;
  	},

  	isValid: function () {
  		return !!(this.min && this.max);
  	}
  };


  // @factory L.bounds(corner1: Point, corner2: Point)
  // Creates a Bounds object from two corners coordinate pairs.
  // @alternative
  // @factory L.bounds(points: Point[])
  // Creates a Bounds object from the given array of points.
  function toBounds(a, b) {
  	if (!a || a instanceof Bounds) {
  		return a;
  	}
  	return new Bounds(a, b);
  }

  /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */

  function LatLngBounds(corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
  	if (!corner1) { return; }

  	var latlngs = corner2 ? [corner1, corner2] : corner1;

  	for (var i = 0, len = latlngs.length; i < len; i++) {
  		this.extend(latlngs[i]);
  	}
  }

  LatLngBounds.prototype = {

  	// @method extend(latlng: LatLng): this
  	// Extend the bounds to contain the given point

  	// @alternative
  	// @method extend(otherBounds: LatLngBounds): this
  	// Extend the bounds to contain the given bounds
  	extend: function (obj) {
  		var sw = this._southWest,
  		    ne = this._northEast,
  		    sw2, ne2;

  		if (obj instanceof LatLng) {
  			sw2 = obj;
  			ne2 = obj;

  		} else if (obj instanceof LatLngBounds) {
  			sw2 = obj._southWest;
  			ne2 = obj._northEast;

  			if (!sw2 || !ne2) { return this; }

  		} else {
  			return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
  		}

  		if (!sw && !ne) {
  			this._southWest = new LatLng(sw2.lat, sw2.lng);
  			this._northEast = new LatLng(ne2.lat, ne2.lng);
  		} else {
  			sw.lat = Math.min(sw2.lat, sw.lat);
  			sw.lng = Math.min(sw2.lng, sw.lng);
  			ne.lat = Math.max(ne2.lat, ne.lat);
  			ne.lng = Math.max(ne2.lng, ne.lng);
  		}

  		return this;
  	},

  	// @method pad(bufferRatio: Number): LatLngBounds
  	// Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
  	// For example, a ratio of 0.5 extends the bounds by 50% in each direction.
  	// Negative values will retract the bounds.
  	pad: function (bufferRatio) {
  		var sw = this._southWest,
  		    ne = this._northEast,
  		    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
  		    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;

  		return new LatLngBounds(
  		        new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
  		        new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
  	},

  	// @method getCenter(): LatLng
  	// Returns the center point of the bounds.
  	getCenter: function () {
  		return new LatLng(
  		        (this._southWest.lat + this._northEast.lat) / 2,
  		        (this._southWest.lng + this._northEast.lng) / 2);
  	},

  	// @method getSouthWest(): LatLng
  	// Returns the south-west point of the bounds.
  	getSouthWest: function () {
  		return this._southWest;
  	},

  	// @method getNorthEast(): LatLng
  	// Returns the north-east point of the bounds.
  	getNorthEast: function () {
  		return this._northEast;
  	},

  	// @method getNorthWest(): LatLng
  	// Returns the north-west point of the bounds.
  	getNorthWest: function () {
  		return new LatLng(this.getNorth(), this.getWest());
  	},

  	// @method getSouthEast(): LatLng
  	// Returns the south-east point of the bounds.
  	getSouthEast: function () {
  		return new LatLng(this.getSouth(), this.getEast());
  	},

  	// @method getWest(): Number
  	// Returns the west longitude of the bounds
  	getWest: function () {
  		return this._southWest.lng;
  	},

  	// @method getSouth(): Number
  	// Returns the south latitude of the bounds
  	getSouth: function () {
  		return this._southWest.lat;
  	},

  	// @method getEast(): Number
  	// Returns the east longitude of the bounds
  	getEast: function () {
  		return this._northEast.lng;
  	},

  	// @method getNorth(): Number
  	// Returns the north latitude of the bounds
  	getNorth: function () {
  		return this._northEast.lat;
  	},

  	// @method contains(otherBounds: LatLngBounds): Boolean
  	// Returns `true` if the rectangle contains the given one.

  	// @alternative
  	// @method contains (latlng: LatLng): Boolean
  	// Returns `true` if the rectangle contains the given point.
  	contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
  		if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) {
  			obj = toLatLng(obj);
  		} else {
  			obj = toLatLngBounds(obj);
  		}

  		var sw = this._southWest,
  		    ne = this._northEast,
  		    sw2, ne2;

  		if (obj instanceof LatLngBounds) {
  			sw2 = obj.getSouthWest();
  			ne2 = obj.getNorthEast();
  		} else {
  			sw2 = ne2 = obj;
  		}

  		return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
  		       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
  	},

  	// @method intersects(otherBounds: LatLngBounds): Boolean
  	// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
  	intersects: function (bounds) {
  		bounds = toLatLngBounds(bounds);

  		var sw = this._southWest,
  		    ne = this._northEast,
  		    sw2 = bounds.getSouthWest(),
  		    ne2 = bounds.getNorthEast(),

  		    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
  		    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);

  		return latIntersects && lngIntersects;
  	},

  	// @method overlaps(otherBounds: LatLngBounds): Boolean
  	// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
  	overlaps: function (bounds) {
  		bounds = toLatLngBounds(bounds);

  		var sw = this._southWest,
  		    ne = this._northEast,
  		    sw2 = bounds.getSouthWest(),
  		    ne2 = bounds.getNorthEast(),

  		    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
  		    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);

  		return latOverlaps && lngOverlaps;
  	},

  	// @method toBBoxString(): String
  	// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
  	toBBoxString: function () {
  		return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
  	},

  	// @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
  	// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
  	equals: function (bounds, maxMargin) {
  		if (!bounds) { return false; }

  		bounds = toLatLngBounds(bounds);

  		return this._southWest.equals(bounds.getSouthWest(), maxMargin) &&
  		       this._northEast.equals(bounds.getNorthEast(), maxMargin);
  	},

  	// @method isValid(): Boolean
  	// Returns `true` if the bounds are properly initialized.
  	isValid: function () {
  		return !!(this._southWest && this._northEast);
  	}
  };

  // TODO International date line?

  // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
  // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.

  // @alternative
  // @factory L.latLngBounds(latlngs: LatLng[])
  // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
  function toLatLngBounds(a, b) {
  	if (a instanceof LatLngBounds) {
  		return a;
  	}
  	return new LatLngBounds(a, b);
  }

  /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */

  function LatLng(lat, lng, alt) {
  	if (isNaN(lat) || isNaN(lng)) {
  		throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
  	}

  	// @property lat: Number
  	// Latitude in degrees
  	this.lat = +lat;

  	// @property lng: Number
  	// Longitude in degrees
  	this.lng = +lng;

  	// @property alt: Number
  	// Altitude in meters (optional)
  	if (alt !== undefined) {
  		this.alt = +alt;
  	}
  }

  LatLng.prototype = {
  	// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
  	// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
  	equals: function (obj, maxMargin) {
  		if (!obj) { return false; }

  		obj = toLatLng(obj);

  		var margin = Math.max(
  		        Math.abs(this.lat - obj.lat),
  		        Math.abs(this.lng - obj.lng));

  		return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
  	},

  	// @method toString(): String
  	// Returns a string representation of the point (for debugging purposes).
  	toString: function (precision) {
  		return 'LatLng(' +
  		        formatNum(this.lat, precision) + ', ' +
  		        formatNum(this.lng, precision) + ')';
  	},

  	// @method distanceTo(otherLatLng: LatLng): Number
  	// Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
  	distanceTo: function (other) {
  		return Earth.distance(this, toLatLng(other));
  	},

  	// @method wrap(): LatLng
  	// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
  	wrap: function () {
  		return Earth.wrapLatLng(this);
  	},

  	// @method toBounds(sizeInMeters: Number): LatLngBounds
  	// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
  	toBounds: function (sizeInMeters) {
  		var latAccuracy = 180 * sizeInMeters / 40075017,
  		    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);

  		return toLatLngBounds(
  		        [this.lat - latAccuracy, this.lng - lngAccuracy],
  		        [this.lat + latAccuracy, this.lng + lngAccuracy]);
  	},

  	clone: function () {
  		return new LatLng(this.lat, this.lng, this.alt);
  	}
  };



  // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
  // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).

  // @alternative
  // @factory L.latLng(coords: Array): LatLng
  // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.

  // @alternative
  // @factory L.latLng(coords: Object): LatLng
  // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.

  function toLatLng(a, b, c) {
  	if (a instanceof LatLng) {
  		return a;
  	}
  	if (isArray(a) && typeof a[0] !== 'object') {
  		if (a.length === 3) {
  			return new LatLng(a[0], a[1], a[2]);
  		}
  		if (a.length === 2) {
  			return new LatLng(a[0], a[1]);
  		}
  		return null;
  	}
  	if (a === undefined || a === null) {
  		return a;
  	}
  	if (typeof a === 'object' && 'lat' in a) {
  		return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
  	}
  	if (b === undefined) {
  		return null;
  	}
  	return new LatLng(a, b, c);
  }

  /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */

  var CRS = {
  	// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
  	// Projects geographical coordinates into pixel coordinates for a given zoom.
  	latLngToPoint: function (latlng, zoom) {
  		var projectedPoint = this.projection.project(latlng),
  		    scale = this.scale(zoom);

  		return this.transformation._transform(projectedPoint, scale);
  	},

  	// @method pointToLatLng(point: Point, zoom: Number): LatLng
  	// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
  	// zoom into geographical coordinates.
  	pointToLatLng: function (point, zoom) {
  		var scale = this.scale(zoom),
  		    untransformedPoint = this.transformation.untransform(point, scale);

  		return this.projection.unproject(untransformedPoint);
  	},

  	// @method project(latlng: LatLng): Point
  	// Projects geographical coordinates into coordinates in units accepted for
  	// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
  	project: function (latlng) {
  		return this.projection.project(latlng);
  	},

  	// @method unproject(point: Point): LatLng
  	// Given a projected coordinate returns the corresponding LatLng.
  	// The inverse of `project`.
  	unproject: function (point) {
  		return this.projection.unproject(point);
  	},

  	// @method scale(zoom: Number): Number
  	// Returns the scale used when transforming projected coordinates into
  	// pixel coordinates for a particular zoom. For example, it returns
  	// `256 * 2^zoom` for Mercator-based CRS.
  	scale: function (zoom) {
  		return 256 * Math.pow(2, zoom);
  	},

  	// @method zoom(scale: Number): Number
  	// Inverse of `scale()`, returns the zoom level corresponding to a scale
  	// factor of `scale`.
  	zoom: function (scale) {
  		return Math.log(scale / 256) / Math.LN2;
  	},

  	// @method getProjectedBounds(zoom: Number): Bounds
  	// Returns the projection's bounds scaled and transformed for the provided `zoom`.
  	getProjectedBounds: function (zoom) {
  		if (this.infinite) { return null; }

  		var b = this.projection.bounds,
  		    s = this.scale(zoom),
  		    min = this.transformation.transform(b.min, s),
  		    max = this.transformation.transform(b.max, s);

  		return new Bounds(min, max);
  	},

  	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
  	// Returns the distance between two geographical coordinates.

  	// @property code: String
  	// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
  	//
  	// @property wrapLng: Number[]
  	// An array of two numbers defining whether the longitude (horizontal) coordinate
  	// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
  	// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
  	//
  	// @property wrapLat: Number[]
  	// Like `wrapLng`, but for the latitude (vertical) axis.

  	// wrapLng: [min, max],
  	// wrapLat: [min, max],

  	// @property infinite: Boolean
  	// If true, the coordinate space will be unbounded (infinite in both axes)
  	infinite: false,

  	// @method wrapLatLng(latlng: LatLng): LatLng
  	// Returns a `LatLng` where lat and lng has been wrapped according to the
  	// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
  	wrapLatLng: function (latlng) {
  		var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
  		    lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
  		    alt = latlng.alt;

  		return new LatLng(lat, lng, alt);
  	},

  	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
  	// Returns a `LatLngBounds` with the same size as the given one, ensuring
  	// that its center is within the CRS's bounds.
  	// Only accepts actual `L.LatLngBounds` instances, not arrays.
  	wrapLatLngBounds: function (bounds) {
  		var center = bounds.getCenter(),
  		    newCenter = this.wrapLatLng(center),
  		    latShift = center.lat - newCenter.lat,
  		    lngShift = center.lng - newCenter.lng;

  		if (latShift === 0 && lngShift === 0) {
  			return bounds;
  		}

  		var sw = bounds.getSouthWest(),
  		    ne = bounds.getNorthEast(),
  		    newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift),
  		    newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);

  		return new LatLngBounds(newSw, newNe);
  	}
  };

  /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */

  var Earth = extend({}, CRS, {
  	wrapLng: [-180, 180],

  	// Mean Earth Radius, as recommended for use by
  	// the International Union of Geodesy and Geophysics,
  	// see http://rosettacode.org/wiki/Haversine_formula
  	R: 6371000,

  	// distance between two geographical points using spherical law of cosines approximation
  	distance: function (latlng1, latlng2) {
  		var rad = Math.PI / 180,
  		    lat1 = latlng1.lat * rad,
  		    lat2 = latlng2.lat * rad,
  		    sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2),
  		    sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2),
  		    a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon,
  		    c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  		return this.R * c;
  	}
  });

  /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */

  var earthRadius = 6378137;

  var SphericalMercator = {

  	R: earthRadius,
  	MAX_LATITUDE: 85.0511287798,

  	project: function (latlng) {
  		var d = Math.PI / 180,
  		    max = this.MAX_LATITUDE,
  		    lat = Math.max(Math.min(max, latlng.lat), -max),
  		    sin = Math.sin(lat * d);

  		return new Point(
  			this.R * latlng.lng * d,
  			this.R * Math.log((1 + sin) / (1 - sin)) / 2);
  	},

  	unproject: function (point) {
  		var d = 180 / Math.PI;

  		return new LatLng(
  			(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
  			point.x * d / this.R);
  	},

  	bounds: (function () {
  		var d = earthRadius * Math.PI;
  		return new Bounds([-d, -d], [d, d]);
  	})()
  };

  /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */


  // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
  // Creates a `Transformation` object with the given coefficients.
  function Transformation(a, b, c, d) {
  	if (isArray(a)) {
  		// use array properties
  		this._a = a[0];
  		this._b = a[1];
  		this._c = a[2];
  		this._d = a[3];
  		return;
  	}
  	this._a = a;
  	this._b = b;
  	this._c = c;
  	this._d = d;
  }

  Transformation.prototype = {
  	// @method transform(point: Point, scale?: Number): Point
  	// Returns a transformed point, optionally multiplied by the given scale.
  	// Only accepts actual `L.Point` instances, not arrays.
  	transform: function (point, scale) { // (Point, Number) -> Point
  		return this._transform(point.clone(), scale);
  	},

  	// destructive transform (faster)
  	_transform: function (point, scale) {
  		scale = scale || 1;
  		point.x = scale * (this._a * point.x + this._b);
  		point.y = scale * (this._c * point.y + this._d);
  		return point;
  	},

  	// @method untransform(point: Point, scale?: Number): Point
  	// Returns the reverse transformation of the given point, optionally divided
  	// by the given scale. Only accepts actual `L.Point` instances, not arrays.
  	untransform: function (point, scale) {
  		scale = scale || 1;
  		return new Point(
  		        (point.x / scale - this._b) / this._a,
  		        (point.y / scale - this._d) / this._c);
  	}
  };

  // factory L.transformation(a: Number, b: Number, c: Number, d: Number)

  // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
  // Instantiates a Transformation object with the given coefficients.

  // @alternative
  // @factory L.transformation(coefficients: Array): Transformation
  // Expects an coefficients array of the form
  // `[a: Number, b: Number, c: Number, d: Number]`.

  function toTransformation(a, b, c, d) {
  	return new Transformation(a, b, c, d);
  }

  /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */

  var EPSG3857 = extend({}, Earth, {
  	code: 'EPSG:3857',
  	projection: SphericalMercator,

  	transformation: (function () {
  		var scale = 0.5 / (Math.PI * SphericalMercator.R);
  		return toTransformation(scale, 0.5, -scale, 0.5);
  	}())
  });

  var EPSG900913 = extend({}, EPSG3857, {
  	code: 'EPSG:900913'
  });

  // @namespace SVG; @section
  // There are several static functions which can be called without instantiating L.SVG:

  // @function create(name: String): SVGElement
  // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
  // corresponding to the class name passed. For example, using 'line' will return
  // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
  function svgCreate(name) {
  	return document.createElementNS('http://www.w3.org/2000/svg', name);
  }

  // @function pointsToPath(rings: Point[], closed: Boolean): String
  // Generates a SVG path string for multiple rings, with each ring turning
  // into "M..L..L.." instructions
  function pointsToPath(rings, closed) {
  	var str = '',
  	i, j, len, len2, points, p;

  	for (i = 0, len = rings.length; i < len; i++) {
  		points = rings[i];

  		for (j = 0, len2 = points.length; j < len2; j++) {
  			p = points[j];
  			str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
  		}

  		// closes the ring for polygons; "x" is VML syntax
  		str += closed ? (svg ? 'z' : 'x') : '';
  	}

  	// SVG complains about empty path strings
  	return str || 'M0 0';
  }

  /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */

  var style$1 = document.documentElement.style;

  // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
  var ie = 'ActiveXObject' in window;

  // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
  var ielt9 = ie && !document.addEventListener;

  // @property edge: Boolean; `true` for the Edge web browser.
  var edge = 'msLaunchUri' in navigator && !('documentMode' in document);

  // @property webkit: Boolean;
  // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
  var webkit = userAgentContains('webkit');

  // @property android: Boolean
  // `true` for any browser running on an Android platform.
  var android = userAgentContains('android');

  // @property android23: Boolean; `true` for browsers running on Android 2 or Android 3.
  var android23 = userAgentContains('android 2') || userAgentContains('android 3');

  /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */
  var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
  // @property androidStock: Boolean; `true` for the Android stock browser (i.e. not Chrome)
  var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);

  // @property opera: Boolean; `true` for the Opera browser
  var opera = !!window.opera;

  // @property chrome: Boolean; `true` for the Chrome browser.
  var chrome = !edge && userAgentContains('chrome');

  // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
  var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;

  // @property safari: Boolean; `true` for the Safari browser.
  var safari = !chrome && userAgentContains('safari');

  var phantom = userAgentContains('phantom');

  // @property opera12: Boolean
  // `true` for the Opera browser supporting CSS transforms (version 12 or later).
  var opera12 = 'OTransition' in style$1;

  // @property win: Boolean; `true` when the browser is running in a Windows platform
  var win = navigator.platform.indexOf('Win') === 0;

  // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
  var ie3d = ie && ('transition' in style$1);

  // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
  var webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23;

  // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
  var gecko3d = 'MozPerspective' in style$1;

  // @property any3d: Boolean
  // `true` for all browsers supporting CSS transforms.
  var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;

  // @property mobile: Boolean; `true` for all browsers running in a mobile device.
  var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');

  // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
  var mobileWebkit = mobile && webkit;

  // @property mobileWebkit3d: Boolean
  // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
  var mobileWebkit3d = mobile && webkit3d;

  // @property msPointer: Boolean
  // `true` for browsers implementing the Microsoft touch events model (notably IE10).
  var msPointer = !window.PointerEvent && window.MSPointerEvent;

  // @property pointer: Boolean
  // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
  var pointer = !!(window.PointerEvent || msPointer);

  // @property touch: Boolean
  // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
  // This does not necessarily mean that the browser is running in a computer with
  // a touchscreen, it only means that the browser is capable of understanding
  // touch events.
  var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
  		(window.DocumentTouch && document instanceof window.DocumentTouch));

  // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
  var mobileOpera = mobile && opera;

  // @property mobileGecko: Boolean
  // `true` for gecko-based browsers running in a mobile device.
  var mobileGecko = mobile && gecko;

  // @property retina: Boolean
  // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
  var retina = (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1;

  // @property passiveEvents: Boolean
  // `true` for browsers that support passive events.
  var passiveEvents = (function () {
  	var supportsPassiveOption = false;
  	try {
  		var opts = Object.defineProperty({}, 'passive', {
  			get: function () { // eslint-disable-line getter-return
  				supportsPassiveOption = true;
  			}
  		});
  		window.addEventListener('testPassiveEventSupport', falseFn, opts);
  		window.removeEventListener('testPassiveEventSupport', falseFn, opts);
  	} catch (e) {
  		// Errors can safely be ignored since this is only a browser support test.
  	}
  	return supportsPassiveOption;
  }());

  // @property canvas: Boolean
  // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
  var canvas = (function () {
  	return !!document.createElement('canvas').getContext;
  }());

  // @property svg: Boolean
  // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
  var svg = !!(document.createElementNS && svgCreate('svg').createSVGRect);

  // @property vml: Boolean
  // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
  var vml = !svg && (function () {
  	try {
  		var div = document.createElement('div');
  		div.innerHTML = '<v:shape adj="1"/>';

  		var shape = div.firstChild;
  		shape.style.behavior = 'url(#default#VML)';

  		return shape && (typeof shape.adj === 'object');

  	} catch (e) {
  		return false;
  	}
  }());


  function userAgentContains(str) {
  	return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
  }

  var Browser = ({
    ie: ie,
    ielt9: ielt9,
    edge: edge,
    webkit: webkit,
    android: android,
    android23: android23,
    androidStock: androidStock,
    opera: opera,
    chrome: chrome,
    gecko: gecko,
    safari: safari,
    phantom: phantom,
    opera12: opera12,
    win: win,
    ie3d: ie3d,
    webkit3d: webkit3d,
    gecko3d: gecko3d,
    any3d: any3d,
    mobile: mobile,
    mobileWebkit: mobileWebkit,
    mobileWebkit3d: mobileWebkit3d,
    msPointer: msPointer,
    pointer: pointer,
    touch: touch,
    mobileOpera: mobileOpera,
    mobileGecko: mobileGecko,
    retina: retina,
    passiveEvents: passiveEvents,
    canvas: canvas,
    svg: svg,
    vml: vml
  });

  /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */


  var POINTER_DOWN =   msPointer ? 'MSPointerDown'   : 'pointerdown';
  var POINTER_MOVE =   msPointer ? 'MSPointerMove'   : 'pointermove';
  var POINTER_UP =     msPointer ? 'MSPointerUp'     : 'pointerup';
  var POINTER_CANCEL = msPointer ? 'MSPointerCancel' : 'pointercancel';

  var _pointers = {};
  var _pointerDocListener = false;

  // Provides a touch events wrapper for (ms)pointer events.
  // ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890

  function addPointerListener(obj, type, handler, id) {
  	if (type === 'touchstart') {
  		_addPointerStart(obj, handler, id);

  	} else if (type === 'touchmove') {
  		_addPointerMove(obj, handler, id);

  	} else if (type === 'touchend') {
  		_addPointerEnd(obj, handler, id);
  	}

  	return this;
  }

  function removePointerListener(obj, type, id) {
  	var handler = obj['_leaflet_' + type + id];

  	if (type === 'touchstart') {
  		obj.removeEventListener(POINTER_DOWN, handler, false);

  	} else if (type === 'touchmove') {
  		obj.removeEventListener(POINTER_MOVE, handler, false);

  	} else if (type === 'touchend') {
  		obj.removeEventListener(POINTER_UP, handler, false);
  		obj.removeEventListener(POINTER_CANCEL, handler, false);
  	}

  	return this;
  }

  function _addPointerStart(obj, handler, id) {
  	var onDown = bind(function (e) {
  		// IE10 specific: MsTouch needs preventDefault. See #2000
  		if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) {
  			preventDefault(e);
  		}

  		_handlePointer(e, handler);
  	});

  	obj['_leaflet_touchstart' + id] = onDown;
  	obj.addEventListener(POINTER_DOWN, onDown, false);

  	// need to keep track of what pointers and how many are active to provide e.touches emulation
  	if (!_pointerDocListener) {
  		// we listen document as any drags that end by moving the touch off the screen get fired there
  		document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
  		document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
  		document.addEventListener(POINTER_UP, _globalPointerUp, true);
  		document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);

  		_pointerDocListener = true;
  	}
  }

  function _globalPointerDown(e) {
  	_pointers[e.pointerId] = e;
  }

  function _globalPointerMove(e) {
  	if (_pointers[e.pointerId]) {
  		_pointers[e.pointerId] = e;
  	}
  }

  function _globalPointerUp(e) {
  	delete _pointers[e.pointerId];
  }

  function _handlePointer(e, handler) {
  	e.touches = [];
  	for (var i in _pointers) {
  		e.touches.push(_pointers[i]);
  	}
  	e.changedTouches = [e];

  	handler(e);
  }

  function _addPointerMove(obj, handler, id) {
  	var onMove = function (e) {
  		// don't fire touch moves when mouse isn't down
  		if ((e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) && e.buttons === 0) {
  			return;
  		}

  		_handlePointer(e, handler);
  	};

  	obj['_leaflet_touchmove' + id] = onMove;
  	obj.addEventListener(POINTER_MOVE, onMove, false);
  }

  function _addPointerEnd(obj, handler, id) {
  	var onUp = function (e) {
  		_handlePointer(e, handler);
  	};

  	obj['_leaflet_touchend' + id] = onUp;
  	obj.addEventListener(POINTER_UP, onUp, false);
  	obj.addEventListener(POINTER_CANCEL, onUp, false);
  }

  /*
   * Extends the event handling code with double tap support for mobile browsers.
   */

  var _touchstart = msPointer ? 'MSPointerDown' : pointer ? 'pointerdown' : 'touchstart';
  var _touchend = msPointer ? 'MSPointerUp' : pointer ? 'pointerup' : 'touchend';
  var _pre = '_leaflet_';

  // inspired by Zepto touch code by Thomas Fuchs
  function addDoubleTapListener(obj, handler, id) {
  	var last, touch$$1,
  	    doubleTap = false,
  	    delay = 250;

  	function onTouchStart(e) {

  		if (pointer) {
  			if (!e.isPrimary) { return; }
  			if (e.pointerType === 'mouse') { return; } // mouse fires native dblclick
  		} else if (e.touches.length > 1) {
  			return;
  		}

  		var now = Date.now(),
  		    delta = now - (last || now);

  		touch$$1 = e.touches ? e.touches[0] : e;
  		doubleTap = (delta > 0 && delta <= delay);
  		last = now;
  	}

  	function onTouchEnd(e) {
  		if (doubleTap && !touch$$1.cancelBubble) {
  			if (pointer) {
  				if (e.pointerType === 'mouse') { return; }
  				// work around .type being readonly with MSPointer* events
  				var newTouch = {},
  				    prop, i;

  				for (i in touch$$1) {
  					prop = touch$$1[i];
  					newTouch[i] = prop && prop.bind ? prop.bind(touch$$1) : prop;
  				}
  				touch$$1 = newTouch;
  			}
  			touch$$1.type = 'dblclick';
  			touch$$1.button = 0;
  			handler(touch$$1);
  			last = null;
  		}
  	}

  	obj[_pre + _touchstart + id] = onTouchStart;
  	obj[_pre + _touchend + id] = onTouchEnd;
  	obj[_pre + 'dblclick' + id] = handler;

  	obj.addEventListener(_touchstart, onTouchStart, passiveEvents ? {passive: false} : false);
  	obj.addEventListener(_touchend, onTouchEnd, passiveEvents ? {passive: false} : false);

  	// On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
  	// the browser doesn't fire touchend/pointerup events but does fire
  	// native dblclicks. See #4127.
  	// Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
  	obj.addEventListener('dblclick', handler, false);

  	return this;
  }

  function removeDoubleTapListener(obj, id) {
  	var touchstart = obj[_pre + _touchstart + id],
  	    touchend = obj[_pre + _touchend + id],
  	    dblclick = obj[_pre + 'dblclick' + id];

  	obj.removeEventListener(_touchstart, touchstart, passiveEvents ? {passive: false} : false);
  	obj.removeEventListener(_touchend, touchend, passiveEvents ? {passive: false} : false);
  	obj.removeEventListener('dblclick', dblclick, false);

  	return this;
  }

  /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */


  // @property TRANSFORM: String
  // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
  var TRANSFORM = testProp(
  	['transform', 'webkitTransform', 'OTransform', 'MozTransform', 'msTransform']);

  // webkitTransition comes first because some browser versions that drop vendor prefix don't do
  // the same for the transitionend event, in particular the Android 4.1 stock browser

  // @property TRANSITION: String
  // Vendor-prefixed transition style name.
  var TRANSITION = testProp(
  	['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);

  // @property TRANSITION_END: String
  // Vendor-prefixed transitionend event name.
  var TRANSITION_END =
  	TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';


  // @function get(id: String|HTMLElement): HTMLElement
  // Returns an element given its DOM id, or returns the element itself
  // if it was passed directly.
  function get(id) {
  	return typeof id === 'string' ? document.getElementById(id) : id;
  }

  // @function getStyle(el: HTMLElement, styleAttrib: String): String
  // Returns the value for a certain style attribute on an element,
  // including computed values or values set through CSS.
  function getStyle(el, style) {
  	var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);

  	if ((!value || value === 'auto') && document.defaultView) {
  		var css = document.defaultView.getComputedStyle(el, null);
  		value = css ? css[style] : null;
  	}
  	return value === 'auto' ? null : value;
  }

  // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
  // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
  function create$1(tagName, className, container) {
  	var el = document.createElement(tagName);
  	el.className = className || '';

  	if (container) {
  		container.appendChild(el);
  	}
  	return el;
  }

  // @function remove(el: HTMLElement)
  // Removes `el` from its parent element
  function remove(el) {
  	var parent = el.parentNode;
  	if (parent) {
  		parent.removeChild(el);
  	}
  }

  // @function empty(el: HTMLElement)
  // Removes all of `el`'s children elements from `el`
  function empty(el) {
  	while (el.firstChild) {
  		el.removeChild(el.firstChild);
  	}
  }

  // @function toFront(el: HTMLElement)
  // Makes `el` the last child of its parent, so it renders in front of the other children.
  function toFront(el) {
  	var parent = el.parentNode;
  	if (parent && parent.lastChild !== el) {
  		parent.appendChild(el);
  	}
  }

  // @function toBack(el: HTMLElement)
  // Makes `el` the first child of its parent, so it renders behind the other children.
  function toBack(el) {
  	var parent = el.parentNode;
  	if (parent && parent.firstChild !== el) {
  		parent.insertBefore(el, parent.firstChild);
  	}
  }

  // @function hasClass(el: HTMLElement, name: String): Boolean
  // Returns `true` if the element's class attribute contains `name`.
  function hasClass(el, name) {
  	if (el.classList !== undefined) {
  		return el.classList.contains(name);
  	}
  	var className = getClass(el);
  	return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
  }

  // @function addClass(el: HTMLElement, name: String)
  // Adds `name` to the element's class attribute.
  function addClass(el, name) {
  	if (el.classList !== undefined) {
  		var classes = splitWords(name);
  		for (var i = 0, len = classes.length; i < len; i++) {
  			el.classList.add(classes[i]);
  		}
  	} else if (!hasClass(el, name)) {
  		var className = getClass(el);
  		setClass(el, (className ? className + ' ' : '') + name);
  	}
  }

  // @function removeClass(el: HTMLElement, name: String)
  // Removes `name` from the element's class attribute.
  function removeClass(el, name) {
  	if (el.classList !== undefined) {
  		el.classList.remove(name);
  	} else {
  		setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
  	}
  }

  // @function setClass(el: HTMLElement, name: String)
  // Sets the element's class.
  function setClass(el, name) {
  	if (el.className.baseVal === undefined) {
  		el.className = name;
  	} else {
  		// in case of SVG element
  		el.className.baseVal = name;
  	}
  }

  // @function getClass(el: HTMLElement): String
  // Returns the element's class.
  function getClass(el) {
  	// Check if the element is an SVGElementInstance and use the correspondingElement instead
  	// (Required for linked SVG elements in IE11.)
  	if (el.correspondingElement) {
  		el = el.correspondingElement;
  	}
  	return el.className.baseVal === undefined ? el.className : el.className.baseVal;
  }

  // @function setOpacity(el: HTMLElement, opacity: Number)
  // Set the opacity of an element (including old IE support).
  // `opacity` must be a number from `0` to `1`.
  function setOpacity(el, value) {
  	if ('opacity' in el.style) {
  		el.style.opacity = value;
  	} else if ('filter' in el.style) {
  		_setOpacityIE(el, value);
  	}
  }

  function _setOpacityIE(el, value) {
  	var filter = false,
  	    filterName = 'DXImageTransform.Microsoft.Alpha';

  	// filters collection throws an error if we try to retrieve a filter that doesn't exist
  	try {
  		filter = el.filters.item(filterName);
  	} catch (e) {
  		// don't set opacity to 1 if we haven't already set an opacity,
  		// it isn't needed and breaks transparent pngs.
  		if (value === 1) { return; }
  	}

  	value = Math.round(value * 100);

  	if (filter) {
  		filter.Enabled = (value !== 100);
  		filter.Opacity = value;
  	} else {
  		el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
  	}
  }

  // @function testProp(props: String[]): String|false
  // Goes through the array of style names and returns the first name
  // that is a valid style name for an element. If no such name is found,
  // it returns false. Useful for vendor-prefixed styles like `transform`.
  function testProp(props) {
  	var style = document.documentElement.style;

  	for (var i = 0; i < props.length; i++) {
  		if (props[i] in style) {
  			return props[i];
  		}
  	}
  	return false;
  }

  // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
  // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
  // and optionally scaled by `scale`. Does not have an effect if the
  // browser doesn't support 3D CSS transforms.
  function setTransform(el, offset, scale) {
  	var pos = offset || new Point(0, 0);

  	el.style[TRANSFORM] =
  		(ie3d ?
  			'translate(' + pos.x + 'px,' + pos.y + 'px)' :
  			'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
  		(scale ? ' scale(' + scale + ')' : '');
  }

  // @function setPosition(el: HTMLElement, position: Point)
  // Sets the position of `el` to coordinates specified by `position`,
  // using CSS translate or top/left positioning depending on the browser
  // (used by Leaflet internally to position its layers).
  function setPosition(el, point) {

  	/*eslint-disable */
  	el._leaflet_pos = point;
  	/* eslint-enable */

  	if (any3d) {
  		setTransform(el, point);
  	} else {
  		el.style.left = point.x + 'px';
  		el.style.top = point.y + 'px';
  	}
  }

  // @function getPosition(el: HTMLElement): Point
  // Returns the coordinates of an element previously positioned with setPosition.
  function getPosition(el) {
  	// this method is only used for elements previously positioned using setPosition,
  	// so it's safe to cache the position for performance

  	return el._leaflet_pos || new Point(0, 0);
  }

  // @function disableTextSelection()
  // Prevents the user from generating `selectstart` DOM events, usually generated
  // when the user drags the mouse through a page with text. Used internally
  // by Leaflet to override the behaviour of any click-and-drag interaction on
  // the map. Affects drag interactions on the whole document.

  // @function enableTextSelection()
  // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
  var disableTextSelection;
  var enableTextSelection;
  var _userSelect;
  if ('onselectstart' in document) {
  	disableTextSelection = function () {
  		on(window, 'selectstart', preventDefault);
  	};
  	enableTextSelection = function () {
  		off(window, 'selectstart', preventDefault);
  	};
  } else {
  	var userSelectProperty = testProp(
  		['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);

  	disableTextSelection = function () {
  		if (userSelectProperty) {
  			var style = document.documentElement.style;
  			_userSelect = style[userSelectProperty];
  			style[userSelectProperty] = 'none';
  		}
  	};
  	enableTextSelection = function () {
  		if (userSelectProperty) {
  			document.documentElement.style[userSelectProperty] = _userSelect;
  			_userSelect = undefined;
  		}
  	};
  }

  // @function disableImageDrag()
  // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
  // for `dragstart` DOM events, usually generated when the user drags an image.
  function disableImageDrag() {
  	on(window, 'dragstart', preventDefault);
  }

  // @function enableImageDrag()
  // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
  function enableImageDrag() {
  	off(window, 'dragstart', preventDefault);
  }

  var _outlineElement, _outlineStyle;
  // @function preventOutline(el: HTMLElement)
  // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
  // of the element `el` invisible. Used internally by Leaflet to prevent
  // focusable elements from displaying an outline when the user performs a
  // drag interaction on them.
  function preventOutline(element) {
  	while (element.tabIndex === -1) {
  		element = element.parentNode;
  	}
  	if (!element.style) { return; }
  	restoreOutline();
  	_outlineElement = element;
  	_outlineStyle = element.style.outline;
  	element.style.outline = 'none';
  	on(window, 'keydown', restoreOutline);
  }

  // @function restoreOutline()
  // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
  function restoreOutline() {
  	if (!_outlineElement) { return; }
  	_outlineElement.style.outline = _outlineStyle;
  	_outlineElement = undefined;
  	_outlineStyle = undefined;
  	off(window, 'keydown', restoreOutline);
  }

  // @function getSizedParentNode(el: HTMLElement): HTMLElement
  // Finds the closest parent node which size (width and height) is not null.
  function getSizedParentNode(element) {
  	do {
  		element = element.parentNode;
  	} while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
  	return element;
  }

  // @function getScale(el: HTMLElement): Object
  // Computes the CSS scale currently applied on the element.
  // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
  // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
  function getScale(element) {
  	var rect = element.getBoundingClientRect(); // Read-only in old browsers.

  	return {
  		x: rect.width / element.offsetWidth || 1,
  		y: rect.height / element.offsetHeight || 1,
  		boundingClientRect: rect
  	};
  }

  var DomUtil = ({
    TRANSFORM: TRANSFORM,
    TRANSITION: TRANSITION,
    TRANSITION_END: TRANSITION_END,
    get: get,
    getStyle: getStyle,
    create: create$1,
    remove: remove,
    empty: empty,
    toFront: toFront,
    toBack: toBack,
    hasClass: hasClass,
    addClass: addClass,
    removeClass: removeClass,
    setClass: setClass,
    getClass: getClass,
    setOpacity: setOpacity,
    testProp: testProp,
    setTransform: setTransform,
    setPosition: setPosition,
    getPosition: getPosition,
    disableTextSelection: disableTextSelection,
    enableTextSelection: enableTextSelection,
    disableImageDrag: disableImageDrag,
    enableImageDrag: enableImageDrag,
    preventOutline: preventOutline,
    restoreOutline: restoreOutline,
    getSizedParentNode: getSizedParentNode,
    getScale: getScale
  });

  /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */

  // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.

  // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
  // Adds a listener function (`fn`) to a particular DOM event type of the
  // element `el`. You can optionally specify the context of the listener
  // (object the `this` keyword will point to). You can also pass several
  // space-separated types (e.g. `'click dblclick'`).

  // @alternative
  // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
  // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  function on(obj, types, fn, context) {

  	if (typeof types === 'object') {
  		for (var type in types) {
  			addOne(obj, type, types[type], fn);
  		}
  	} else {
  		types = splitWords(types);

  		for (var i = 0, len = types.length; i < len; i++) {
  			addOne(obj, types[i], fn, context);
  		}
  	}

  	return this;
  }

  var eventsKey = '_leaflet_events';

  // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
  // Removes a previously added listener function.
  // Note that if you passed a custom context to on, you must pass the same
  // context to `off` in order to remove the listener.

  // @alternative
  // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
  // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  function off(obj, types, fn, context) {

  	if (typeof types === 'object') {
  		for (var type in types) {
  			removeOne(obj, type, types[type], fn);
  		}
  	} else if (types) {
  		types = splitWords(types);

  		for (var i = 0, len = types.length; i < len; i++) {
  			removeOne(obj, types[i], fn, context);
  		}
  	} else {
  		for (var j in obj[eventsKey]) {
  			removeOne(obj, j, obj[eventsKey][j]);
  		}
  		delete obj[eventsKey];
  	}

  	return this;
  }

  function browserFiresNativeDblClick() {
  	// See https://github.com/w3c/pointerevents/issues/171
  	if (pointer) {
  		return !(edge || safari);
  	}
  }

  var mouseSubst = {
  	mouseenter: 'mouseover',
  	mouseleave: 'mouseout',
  	wheel: !('onwheel' in window) && 'mousewheel'
  };

  function addOne(obj, type, fn, context) {
  	var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');

  	if (obj[eventsKey] && obj[eventsKey][id]) { return this; }

  	var handler = function (e) {
  		return fn.call(context || obj, e || window.event);
  	};

  	var originalHandler = handler;

  	if (pointer && type.indexOf('touch') === 0) {
  		// Needs DomEvent.Pointer.js
  		addPointerListener(obj, type, handler, id);

  	} else if (touch && (type === 'dblclick') && !browserFiresNativeDblClick()) {
  		addDoubleTapListener(obj, handler, id);

  	} else if ('addEventListener' in obj) {

  		if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' ||  type === 'mousewheel') {
  			obj.addEventListener(mouseSubst[type] || type, handler, passiveEvents ? {passive: false} : false);

  		} else if (type === 'mouseenter' || type === 'mouseleave') {
  			handler = function (e) {
  				e = e || window.event;
  				if (isExternalTarget(obj, e)) {
  					originalHandler(e);
  				}
  			};
  			obj.addEventListener(mouseSubst[type], handler, false);

  		} else {
  			obj.addEventListener(type, originalHandler, false);
  		}

  	} else if ('attachEvent' in obj) {
  		obj.attachEvent('on' + type, handler);
  	}

  	obj[eventsKey] = obj[eventsKey] || {};
  	obj[eventsKey][id] = handler;
  }

  function removeOne(obj, type, fn, context) {

  	var id = type + stamp(fn) + (context ? '_' + stamp(context) : ''),
  	    handler = obj[eventsKey] && obj[eventsKey][id];

  	if (!handler) { return this; }

  	if (pointer && type.indexOf('touch') === 0) {
  		removePointerListener(obj, type, id);

  	} else if (touch && (type === 'dblclick') && !browserFiresNativeDblClick()) {
  		removeDoubleTapListener(obj, id);

  	} else if ('removeEventListener' in obj) {

  		obj.removeEventListener(mouseSubst[type] || type, handler, false);

  	} else if ('detachEvent' in obj) {
  		obj.detachEvent('on' + type, handler);
  	}

  	obj[eventsKey][id] = null;
  }

  // @function stopPropagation(ev: DOMEvent): this
  // Stop the given event from propagation to parent elements. Used inside the listener functions:
  // ```js
  // L.DomEvent.on(div, 'click', function (ev) {
  // 	L.DomEvent.stopPropagation(ev);
  // });
  // ```
  function stopPropagation(e) {

  	if (e.stopPropagation) {
  		e.stopPropagation();
  	} else if (e.originalEvent) {  // In case of Leaflet event.
  		e.originalEvent._stopped = true;
  	} else {
  		e.cancelBubble = true;
  	}
  	skipped(e);

  	return this;
  }

  // @function disableScrollPropagation(el: HTMLElement): this
  // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
  function disableScrollPropagation(el) {
  	addOne(el, 'wheel', stopPropagation);
  	return this;
  }

  // @function disableClickPropagation(el: HTMLElement): this
  // Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
  // `'mousedown'` and `'touchstart'` events (plus browser variants).
  function disableClickPropagation(el) {
  	on(el, 'mousedown touchstart dblclick', stopPropagation);
  	addOne(el, 'click', fakeStop);
  	return this;
  }

  // @function preventDefault(ev: DOMEvent): this
  // Prevents the default action of the DOM Event `ev` from happening (such as
  // following a link in the href of the a element, or doing a POST request
  // with page reload when a `<form>` is submitted).
  // Use it inside listener functions.
  function preventDefault(e) {
  	if (e.preventDefault) {
  		e.preventDefault();
  	} else {
  		e.returnValue = false;
  	}
  	return this;
  }

  // @function stop(ev: DOMEvent): this
  // Does `stopPropagation` and `preventDefault` at the same time.
  function stop(e) {
  	preventDefault(e);
  	stopPropagation(e);
  	return this;
  }

  // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
  // Gets normalized mouse position from a DOM event relative to the
  // `container` (border excluded) or to the whole page if not specified.
  function getMousePosition(e, container) {
  	if (!container) {
  		return new Point(e.clientX, e.clientY);
  	}

  	var scale = getScale(container),
  	    offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)

  	return new Point(
  		// offset.left/top values are in page scale (like clientX/Y),
  		// whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
  		(e.clientX - offset.left) / scale.x - container.clientLeft,
  		(e.clientY - offset.top) / scale.y - container.clientTop
  	);
  }

  // Chrome on Win scrolls double the pixels as in other platforms (see #4538),
  // and Firefox scrolls device pixels, not CSS pixels
  var wheelPxFactor =
  	(win && chrome) ? 2 * window.devicePixelRatio :
  	gecko ? window.devicePixelRatio : 1;

  // @function getWheelDelta(ev: DOMEvent): Number
  // Gets normalized wheel delta from a wheel DOM event, in vertical
  // pixels scrolled (negative if scrolling down).
  // Events from pointing devices without precise scrolling are mapped to
  // a best guess of 60 pixels.
  function getWheelDelta(e) {
  	return (edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
  	       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / wheelPxFactor : // Pixels
  	       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
  	       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
  	       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
  	       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
  	       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
  	       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
  	       0;
  }

  var skipEvents = {};

  function fakeStop(e) {
  	// fakes stopPropagation by setting a special event flag, checked/reset with skipped(e)
  	skipEvents[e.type] = true;
  }

  function skipped(e) {
  	var events = skipEvents[e.type];
  	// reset when checking, as it's only used in map container and propagates outside of the map
  	skipEvents[e.type] = false;
  	return events;
  }

  // check if element really left/entered the event target (for mouseenter/mouseleave)
  function isExternalTarget(el, e) {

  	var related = e.relatedTarget;

  	if (!related) { return true; }

  	try {
  		while (related && (related !== el)) {
  			related = related.parentNode;
  		}
  	} catch (err) {
  		return false;
  	}
  	return (related !== el);
  }

  var DomEvent = ({
    on: on,
    off: off,
    stopPropagation: stopPropagation,
    disableScrollPropagation: disableScrollPropagation,
    disableClickPropagation: disableClickPropagation,
    preventDefault: preventDefault,
    stop: stop,
    getMousePosition: getMousePosition,
    getWheelDelta: getWheelDelta,
    fakeStop: fakeStop,
    skipped: skipped,
    isExternalTarget: isExternalTarget,
    addListener: on,
    removeListener: off
  });

  /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var fx = new L.PosAnimation();
   * fx.run(el, [300, 500], 0.5);
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */

  var PosAnimation = Evented.extend({

  	// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
  	// Run an animation of a given element to a new position, optionally setting
  	// duration in seconds (`0.25` by default) and easing linearity factor (3rd
  	// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
  	// `0.5` by default).
  	run: function (el, newPos, duration, easeLinearity) {
  		this.stop();

  		this._el = el;
  		this._inProgress = true;
  		this._duration = duration || 0.25;
  		this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);

  		this._startPos = getPosition(el);
  		this._offset = newPos.subtract(this._startPos);
  		this._startTime = +new Date();

  		// @event start: Event
  		// Fired when the animation starts
  		this.fire('start');

  		this._animate();
  	},

  	// @method stop()
  	// Stops the animation (if currently running).
  	stop: function () {
  		if (!this._inProgress) { return; }

  		this._step(true);
  		this._complete();
  	},

  	_animate: function () {
  		// animation loop
  		this._animId = requestAnimFrame(this._animate, this);
  		this._step();
  	},

  	_step: function (round) {
  		var elapsed = (+new Date()) - this._startTime,
  		    duration = this._duration * 1000;

  		if (elapsed < duration) {
  			this._runFrame(this._easeOut(elapsed / duration), round);
  		} else {
  			this._runFrame(1);
  			this._complete();
  		}
  	},

  	_runFrame: function (progress, round) {
  		var pos = this._startPos.add(this._offset.multiplyBy(progress));
  		if (round) {
  			pos._round();
  		}
  		setPosition(this._el, pos);

  		// @event step: Event
  		// Fired continuously during the animation.
  		this.fire('step');
  	},

  	_complete: function () {
  		cancelAnimFrame(this._animId);

  		this._inProgress = false;
  		// @event end: Event
  		// Fired when the animation ends.
  		this.fire('end');
  	},

  	_easeOut: function (t) {
  		return 1 - Math.pow(1 - t, this._easeOutPower);
  	}
  });

  /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */

  var Map = Evented.extend({

  	options: {
  		// @section Map State Options
  		// @option crs: CRS = L.CRS.EPSG3857
  		// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
  		// sure what it means.
  		crs: EPSG3857,

  		// @option center: LatLng = undefined
  		// Initial geographic center of the map
  		center: undefined,

  		// @option zoom: Number = undefined
  		// Initial map zoom level
  		zoom: undefined,

  		// @option minZoom: Number = *
  		// Minimum zoom level of the map.
  		// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
  		// the lowest of their `minZoom` options will be used instead.
  		minZoom: undefined,

  		// @option maxZoom: Number = *
  		// Maximum zoom level of the map.
  		// If not specified and at least one `GridLayer` or `TileLayer` is in the map,
  		// the highest of their `maxZoom` options will be used instead.
  		maxZoom: undefined,

  		// @option layers: Layer[] = []
  		// Array of layers that will be added to the map initially
  		layers: [],

  		// @option maxBounds: LatLngBounds = null
  		// When this option is set, the map restricts the view to the given
  		// geographical bounds, bouncing the user back if the user tries to pan
  		// outside the view. To set the restriction dynamically, use
  		// [`setMaxBounds`](#map-setmaxbounds) method.
  		maxBounds: undefined,

  		// @option renderer: Renderer = *
  		// The default method for drawing vector layers on the map. `L.SVG`
  		// or `L.Canvas` by default depending on browser support.
  		renderer: undefined,


  		// @section Animation Options
  		// @option zoomAnimation: Boolean = true
  		// Whether the map zoom animation is enabled. By default it's enabled
  		// in all browsers that support CSS3 Transitions except Android.
  		zoomAnimation: true,

  		// @option zoomAnimationThreshold: Number = 4
  		// Won't animate zoom if the zoom difference exceeds this value.
  		zoomAnimationThreshold: 4,

  		// @option fadeAnimation: Boolean = true
  		// Whether the tile fade animation is enabled. By default it's enabled
  		// in all browsers that support CSS3 Transitions except Android.
  		fadeAnimation: true,

  		// @option markerZoomAnimation: Boolean = true
  		// Whether markers animate their zoom with the zoom animation, if disabled
  		// they will disappear for the length of the animation. By default it's
  		// enabled in all browsers that support CSS3 Transitions except Android.
  		markerZoomAnimation: true,

  		// @option transform3DLimit: Number = 2^23
  		// Defines the maximum size of a CSS translation transform. The default
  		// value should not be changed unless a web browser positions layers in
  		// the wrong place after doing a large `panBy`.
  		transform3DLimit: 8388608, // Precision limit of a 32-bit float

  		// @section Interaction Options
  		// @option zoomSnap: Number = 1
  		// Forces the map's zoom level to always be a multiple of this, particularly
  		// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
  		// By default, the zoom level snaps to the nearest integer; lower values
  		// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
  		// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
  		zoomSnap: 1,

  		// @option zoomDelta: Number = 1
  		// Controls how much the map's zoom level will change after a
  		// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
  		// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
  		// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
  		zoomDelta: 1,

  		// @option trackResize: Boolean = true
  		// Whether the map automatically handles browser window resize to update itself.
  		trackResize: true
  	},

  	initialize: function (id, options) { // (HTMLElement or String, Object)
  		options = setOptions(this, options);

  		// Make sure to assign internal flags at the beginning,
  		// to avoid inconsistent state in some edge cases.
  		this._handlers = [];
  		this._layers = {};
  		this._zoomBoundLayers = {};
  		this._sizeChanged = true;

  		this._initContainer(id);
  		this._initLayout();

  		// hack for https://github.com/Leaflet/Leaflet/issues/1980
  		this._onResize = bind(this._onResize, this);

  		this._initEvents();

  		if (options.maxBounds) {
  			this.setMaxBounds(options.maxBounds);
  		}

  		if (options.zoom !== undefined) {
  			this._zoom = this._limitZoom(options.zoom);
  		}

  		if (options.center && options.zoom !== undefined) {
  			this.setView(toLatLng(options.center), options.zoom, {reset: true});
  		}

  		this.callInitHooks();

  		// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
  		this._zoomAnimated = TRANSITION && any3d && !mobileOpera &&
  				this.options.zoomAnimation;

  		// zoom transitions run with the same duration for all layers, so if one of transitionend events
  		// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
  		if (this._zoomAnimated) {
  			this._createAnimProxy();
  			on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
  		}

  		this._addLayers(this.options.layers);
  	},


  	// @section Methods for modifying map state

  	// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
  	// Sets the view of the map (geographical center and zoom) with the given
  	// animation options.
  	setView: function (center, zoom, options) {

  		zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
  		center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
  		options = options || {};

  		this._stop();

  		if (this._loaded && !options.reset && options !== true) {

  			if (options.animate !== undefined) {
  				options.zoom = extend({animate: options.animate}, options.zoom);
  				options.pan = extend({animate: options.animate, duration: options.duration}, options.pan);
  			}

  			// try animating pan or zoom
  			var moved = (this._zoom !== zoom) ?
  				this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
  				this._tryAnimatedPan(center, options.pan);

  			if (moved) {
  				// prevent resize handler call, the view will refresh after animation anyway
  				clearTimeout(this._sizeTimer);
  				return this;
  			}
  		}

  		// animation didn't start, just reset the map view
  		this._resetView(center, zoom);

  		return this;
  	},

  	// @method setZoom(zoom: Number, options?: Zoom/pan options): this
  	// Sets the zoom of the map.
  	setZoom: function (zoom, options) {
  		if (!this._loaded) {
  			this._zoom = zoom;
  			return this;
  		}
  		return this.setView(this.getCenter(), zoom, {zoom: options});
  	},

  	// @method zoomIn(delta?: Number, options?: Zoom options): this
  	// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
  	zoomIn: function (delta, options) {
  		delta = delta || (any3d ? this.options.zoomDelta : 1);
  		return this.setZoom(this._zoom + delta, options);
  	},

  	// @method zoomOut(delta?: Number, options?: Zoom options): this
  	// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
  	zoomOut: function (delta, options) {
  		delta = delta || (any3d ? this.options.zoomDelta : 1);
  		return this.setZoom(this._zoom - delta, options);
  	},

  	// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
  	// Zooms the map while keeping a specified geographical point on the map
  	// stationary (e.g. used internally for scroll zoom and double-click zoom).
  	// @alternative
  	// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
  	// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
  	setZoomAround: function (latlng, zoom, options) {
  		var scale = this.getZoomScale(zoom),
  		    viewHalf = this.getSize().divideBy(2),
  		    containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng),

  		    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
  		    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));

  		return this.setView(newCenter, zoom, {zoom: options});
  	},

  	_getBoundsCenterZoom: function (bounds, options) {

  		options = options || {};
  		bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);

  		var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
  		    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),

  		    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));

  		zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;

  		if (zoom === Infinity) {
  			return {
  				center: bounds.getCenter(),
  				zoom: zoom
  			};
  		}

  		var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),

  		    swPoint = this.project(bounds.getSouthWest(), zoom),
  		    nePoint = this.project(bounds.getNorthEast(), zoom),
  		    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);

  		return {
  			center: center,
  			zoom: zoom
  		};
  	},

  	// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
  	// Sets a map view that contains the given geographical bounds with the
  	// maximum zoom level possible.
  	fitBounds: function (bounds, options) {

  		bounds = toLatLngBounds(bounds);

  		if (!bounds.isValid()) {
  			throw new Error('Bounds are not valid.');
  		}

  		var target = this._getBoundsCenterZoom(bounds, options);
  		return this.setView(target.center, target.zoom, options);
  	},

  	// @method fitWorld(options?: fitBounds options): this
  	// Sets a map view that mostly contains the whole world with the maximum
  	// zoom level possible.
  	fitWorld: function (options) {
  		return this.fitBounds([[-90, -180], [90, 180]], options);
  	},

  	// @method panTo(latlng: LatLng, options?: Pan options): this
  	// Pans the map to a given center.
  	panTo: function (center, options) { // (LatLng)
  		return this.setView(center, this._zoom, {pan: options});
  	},

  	// @method panBy(offset: Point, options?: Pan options): this
  	// Pans the map by a given number of pixels (animated).
  	panBy: function (offset, options) {
  		offset = toPoint(offset).round();
  		options = options || {};

  		if (!offset.x && !offset.y) {
  			return this.fire('moveend');
  		}
  		// If we pan too far, Chrome gets issues with tiles
  		// and makes them disappear or appear in the wrong place (slightly offset) #2602
  		if (options.animate !== true && !this.getSize().contains(offset)) {
  			this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
  			return this;
  		}

  		if (!this._panAnim) {
  			this._panAnim = new PosAnimation();

  			this._panAnim.on({
  				'step': this._onPanTransitionStep,
  				'end': this._onPanTransitionEnd
  			}, this);
  		}

  		// don't fire movestart if animating inertia
  		if (!options.noMoveStart) {
  			this.fire('movestart');
  		}

  		// animate pan unless animate: false specified
  		if (options.animate !== false) {
  			addClass(this._mapPane, 'leaflet-pan-anim');

  			var newPos = this._getMapPanePos().subtract(offset).round();
  			this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
  		} else {
  			this._rawPanBy(offset);
  			this.fire('move').fire('moveend');
  		}

  		return this;
  	},

  	// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
  	// Sets the view of the map (geographical center and zoom) performing a smooth
  	// pan-zoom animation.
  	flyTo: function (targetCenter, targetZoom, options) {

  		options = options || {};
  		if (options.animate === false || !any3d) {
  			return this.setView(targetCenter, targetZoom, options);
  		}

  		this._stop();

  		var from = this.project(this.getCenter()),
  		    to = this.project(targetCenter),
  		    size = this.getSize(),
  		    startZoom = this._zoom;

  		targetCenter = toLatLng(targetCenter);
  		targetZoom = targetZoom === undefined ? startZoom : targetZoom;

  		var w0 = Math.max(size.x, size.y),
  		    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
  		    u1 = (to.distanceTo(from)) || 1,
  		    rho = 1.42,
  		    rho2 = rho * rho;

  		function r(i) {
  			var s1 = i ? -1 : 1,
  			    s2 = i ? w1 : w0,
  			    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
  			    b1 = 2 * s2 * rho2 * u1,
  			    b = t1 / b1,
  			    sq = Math.sqrt(b * b + 1) - b;

  			    // workaround for floating point precision bug when sq = 0, log = -Infinite,
  			    // thus triggering an infinite loop in flyTo
  			    var log = sq < 0.000000001 ? -18 : Math.log(sq);

  			return log;
  		}

  		function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
  		function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
  		function tanh(n) { return sinh(n) / cosh(n); }

  		var r0 = r(0);

  		function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
  		function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }

  		function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }

  		var start = Date.now(),
  		    S = (r(1) - r0) / rho,
  		    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;

  		function frame() {
  			var t = (Date.now() - start) / duration,
  			    s = easeOut(t) * S;

  			if (t <= 1) {
  				this._flyToFrame = requestAnimFrame(frame, this);

  				this._move(
  					this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
  					this.getScaleZoom(w0 / w(s), startZoom),
  					{flyTo: true});

  			} else {
  				this
  					._move(targetCenter, targetZoom)
  					._moveEnd(true);
  			}
  		}

  		this._moveStart(true, options.noMoveStart);

  		frame.call(this);
  		return this;
  	},

  	// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
  	// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
  	// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
  	flyToBounds: function (bounds, options) {
  		var target = this._getBoundsCenterZoom(bounds, options);
  		return this.flyTo(target.center, target.zoom, options);
  	},

  	// @method setMaxBounds(bounds: LatLngBounds): this
  	// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
  	setMaxBounds: function (bounds) {
  		bounds = toLatLngBounds(bounds);

  		if (!bounds.isValid()) {
  			this.options.maxBounds = null;
  			return this.off('moveend', this._panInsideMaxBounds);
  		} else if (this.options.maxBounds) {
  			this.off('moveend', this._panInsideMaxBounds);
  		}

  		this.options.maxBounds = bounds;

  		if (this._loaded) {
  			this._panInsideMaxBounds();
  		}

  		return this.on('moveend', this._panInsideMaxBounds);
  	},

  	// @method setMinZoom(zoom: Number): this
  	// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
  	setMinZoom: function (zoom) {
  		var oldZoom = this.options.minZoom;
  		this.options.minZoom = zoom;

  		if (this._loaded && oldZoom !== zoom) {
  			this.fire('zoomlevelschange');

  			if (this.getZoom() < this.options.minZoom) {
  				return this.setZoom(zoom);
  			}
  		}

  		return this;
  	},

  	// @method setMaxZoom(zoom: Number): this
  	// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
  	setMaxZoom: function (zoom) {
  		var oldZoom = this.options.maxZoom;
  		this.options.maxZoom = zoom;

  		if (this._loaded && oldZoom !== zoom) {
  			this.fire('zoomlevelschange');

  			if (this.getZoom() > this.options.maxZoom) {
  				return this.setZoom(zoom);
  			}
  		}

  		return this;
  	},

  	// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
  	// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
  	panInsideBounds: function (bounds, options) {
  		this._enforcingBounds = true;
  		var center = this.getCenter(),
  		    newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));

  		if (!center.equals(newCenter)) {
  			this.panTo(newCenter, options);
  		}

  		this._enforcingBounds = false;
  		return this;
  	},

  	// @method panInside(latlng: LatLng, options?: options): this
  	// Pans the map the minimum amount to make the `latlng` visible. Use
  	// `padding`, `paddingTopLeft` and `paddingTopRight` options to fit
  	// the display to more restricted bounds, like [`fitBounds`](#map-fitbounds).
  	// If `latlng` is already within the (optionally padded) display bounds,
  	// the map will not be panned.
  	panInside: function (latlng, options) {
  		options = options || {};

  		var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]),
  		    paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]),
  		    center = this.getCenter(),
  		    pixelCenter = this.project(center),
  		    pixelPoint = this.project(latlng),
  		    pixelBounds = this.getPixelBounds(),
  		    halfPixelBounds = pixelBounds.getSize().divideBy(2),
  		    paddedBounds = toBounds([pixelBounds.min.add(paddingTL), pixelBounds.max.subtract(paddingBR)]);

  		if (!paddedBounds.contains(pixelPoint)) {
  			this._enforcingBounds = true;
  			var diff = pixelCenter.subtract(pixelPoint),
  			    newCenter = toPoint(pixelPoint.x + diff.x, pixelPoint.y + diff.y);

  			if (pixelPoint.x < paddedBounds.min.x || pixelPoint.x > paddedBounds.max.x) {
  				newCenter.x = pixelCenter.x - diff.x;
  				if (diff.x > 0) {
  					newCenter.x += halfPixelBounds.x - paddingTL.x;
  				} else {
  					newCenter.x -= halfPixelBounds.x - paddingBR.x;
  				}
  			}
  			if (pixelPoint.y < paddedBounds.min.y || pixelPoint.y > paddedBounds.max.y) {
  				newCenter.y = pixelCenter.y - diff.y;
  				if (diff.y > 0) {
  					newCenter.y += halfPixelBounds.y - paddingTL.y;
  				} else {
  					newCenter.y -= halfPixelBounds.y - paddingBR.y;
  				}
  			}
  			this.panTo(this.unproject(newCenter), options);
  			this._enforcingBounds = false;
  		}
  		return this;
  	},

  	// @method invalidateSize(options: Zoom/pan options): this
  	// Checks if the map container size changed and updates the map if so —
  	// call it after you've changed the map size dynamically, also animating
  	// pan by default. If `options.pan` is `false`, panning will not occur.
  	// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
  	// that it doesn't happen often even if the method is called many
  	// times in a row.

  	// @alternative
  	// @method invalidateSize(animate: Boolean): this
  	// Checks if the map container size changed and updates the map if so —
  	// call it after you've changed the map size dynamically, also animating
  	// pan by default.
  	invalidateSize: function (options) {
  		if (!this._loaded) { return this; }

  		options = extend({
  			animate: false,
  			pan: true
  		}, options === true ? {animate: true} : options);

  		var oldSize = this.getSize();
  		this._sizeChanged = true;
  		this._lastCenter = null;

  		var newSize = this.getSize(),
  		    oldCenter = oldSize.divideBy(2).round(),
  		    newCenter = newSize.divideBy(2).round(),
  		    offset = oldCenter.subtract(newCenter);

  		if (!offset.x && !offset.y) { return this; }

  		if (options.animate && options.pan) {
  			this.panBy(offset);

  		} else {
  			if (options.pan) {
  				this._rawPanBy(offset);
  			}

  			this.fire('move');

  			if (options.debounceMoveend) {
  				clearTimeout(this._sizeTimer);
  				this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
  			} else {
  				this.fire('moveend');
  			}
  		}

  		// @section Map state change events
  		// @event resize: ResizeEvent
  		// Fired when the map is resized.
  		return this.fire('resize', {
  			oldSize: oldSize,
  			newSize: newSize
  		});
  	},

  	// @section Methods for modifying map state
  	// @method stop(): this
  	// Stops the currently running `panTo` or `flyTo` animation, if any.
  	stop: function () {
  		this.setZoom(this._limitZoom(this._zoom));
  		if (!this.options.zoomSnap) {
  			this.fire('viewreset');
  		}
  		return this._stop();
  	},

  	// @section Geolocation methods
  	// @method locate(options?: Locate options): this
  	// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
  	// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
  	// and optionally sets the map view to the user's location with respect to
  	// detection accuracy (or to the world view if geolocation failed).
  	// Note that, if your page doesn't use HTTPS, this method will fail in
  	// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
  	// See `Locate options` for more details.
  	locate: function (options) {

  		options = this._locateOptions = extend({
  			timeout: 10000,
  			watch: false
  			// setView: false
  			// maxZoom: <Number>
  			// maximumAge: 0
  			// enableHighAccuracy: false
  		}, options);

  		if (!('geolocation' in navigator)) {
  			this._handleGeolocationError({
  				code: 0,
  				message: 'Geolocation not supported.'
  			});
  			return this;
  		}

  		var onResponse = bind(this._handleGeolocationResponse, this),
  		    onError = bind(this._handleGeolocationError, this);

  		if (options.watch) {
  			this._locationWatchId =
  			        navigator.geolocation.watchPosition(onResponse, onError, options);
  		} else {
  			navigator.geolocation.getCurrentPosition(onResponse, onError, options);
  		}
  		return this;
  	},

  	// @method stopLocate(): this
  	// Stops watching location previously initiated by `map.locate({watch: true})`
  	// and aborts resetting the map view if map.locate was called with
  	// `{setView: true}`.
  	stopLocate: function () {
  		if (navigator.geolocation && navigator.geolocation.clearWatch) {
  			navigator.geolocation.clearWatch(this._locationWatchId);
  		}
  		if (this._locateOptions) {
  			this._locateOptions.setView = false;
  		}
  		return this;
  	},

  	_handleGeolocationError: function (error) {
  		var c = error.code,
  		    message = error.message ||
  		            (c === 1 ? 'permission denied' :
  		            (c === 2 ? 'position unavailable' : 'timeout'));

  		if (this._locateOptions.setView && !this._loaded) {
  			this.fitWorld();
  		}

  		// @section Location events
  		// @event locationerror: ErrorEvent
  		// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
  		this.fire('locationerror', {
  			code: c,
  			message: 'Geolocation error: ' + message + '.'
  		});
  	},

  	_handleGeolocationResponse: function (pos) {
  		var lat = pos.coords.latitude,
  		    lng = pos.coords.longitude,
  		    latlng = new LatLng(lat, lng),
  		    bounds = latlng.toBounds(pos.coords.accuracy * 2),
  		    options = this._locateOptions;

  		if (options.setView) {
  			var zoom = this.getBoundsZoom(bounds);
  			this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
  		}

  		var data = {
  			latlng: latlng,
  			bounds: bounds,
  			timestamp: pos.timestamp
  		};

  		for (var i in pos.coords) {
  			if (typeof pos.coords[i] === 'number') {
  				data[i] = pos.coords[i];
  			}
  		}

  		// @event locationfound: LocationEvent
  		// Fired when geolocation (using the [`locate`](#map-locate) method)
  		// went successfully.
  		this.fire('locationfound', data);
  	},

  	// TODO Appropriate docs section?
  	// @section Other Methods
  	// @method addHandler(name: String, HandlerClass: Function): this
  	// Adds a new `Handler` to the map, given its name and constructor function.
  	addHandler: function (name, HandlerClass) {
  		if (!HandlerClass) { return this; }

  		var handler = this[name] = new HandlerClass(this);

  		this._handlers.push(handler);

  		if (this.options[name]) {
  			handler.enable();
  		}

  		return this;
  	},

  	// @method remove(): this
  	// Destroys the map and clears all related event listeners.
  	remove: function () {

  		this._initEvents(true);
  		this.off('moveend', this._panInsideMaxBounds);

  		if (this._containerId !== this._container._leaflet_id) {
  			throw new Error('Map container is being reused by another instance');
  		}

  		try {
  			// throws error in IE6-8
  			delete this._container._leaflet_id;
  			delete this._containerId;
  		} catch (e) {
  			/*eslint-disable */
  			this._container._leaflet_id = undefined;
  			/* eslint-enable */
  			this._containerId = undefined;
  		}

  		if (this._locationWatchId !== undefined) {
  			this.stopLocate();
  		}

  		this._stop();

  		remove(this._mapPane);

  		if (this._clearControlPos) {
  			this._clearControlPos();
  		}
  		if (this._resizeRequest) {
  			cancelAnimFrame(this._resizeRequest);
  			this._resizeRequest = null;
  		}

  		this._clearHandlers();

  		if (this._loaded) {
  			// @section Map state change events
  			// @event unload: Event
  			// Fired when the map is destroyed with [remove](#map-remove) method.
  			this.fire('unload');
  		}

  		var i;
  		for (i in this._layers) {
  			this._layers[i].remove();
  		}
  		for (i in this._panes) {
  			remove(this._panes[i]);
  		}

  		this._layers = [];
  		this._panes = [];
  		delete this._mapPane;
  		delete this._renderer;

  		return this;
  	},

  	// @section Other Methods
  	// @method createPane(name: String, container?: HTMLElement): HTMLElement
  	// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
  	// then returns it. The pane is created as a child of `container`, or
  	// as a child of the main map pane if not set.
  	createPane: function (name, container) {
  		var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
  		    pane = create$1('div', className, container || this._mapPane);

  		if (name) {
  			this._panes[name] = pane;
  		}
  		return pane;
  	},

  	// @section Methods for Getting Map State

  	// @method getCenter(): LatLng
  	// Returns the geographical center of the map view
  	getCenter: function () {
  		this._checkIfLoaded();

  		if (this._lastCenter && !this._moved()) {
  			return this._lastCenter;
  		}
  		return this.layerPointToLatLng(this._getCenterLayerPoint());
  	},

  	// @method getZoom(): Number
  	// Returns the current zoom level of the map view
  	getZoom: function () {
  		return this._zoom;
  	},

  	// @method getBounds(): LatLngBounds
  	// Returns the geographical bounds visible in the current map view
  	getBounds: function () {
  		var bounds = this.getPixelBounds(),
  		    sw = this.unproject(bounds.getBottomLeft()),
  		    ne = this.unproject(bounds.getTopRight());

  		return new LatLngBounds(sw, ne);
  	},

  	// @method getMinZoom(): Number
  	// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
  	getMinZoom: function () {
  		return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
  	},

  	// @method getMaxZoom(): Number
  	// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
  	getMaxZoom: function () {
  		return this.options.maxZoom === undefined ?
  			(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
  			this.options.maxZoom;
  	},

  	// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
  	// Returns the maximum zoom level on which the given bounds fit to the map
  	// view in its entirety. If `inside` (optional) is set to `true`, the method
  	// instead returns the minimum zoom level on which the map view fits into
  	// the given bounds in its entirety.
  	getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
  		bounds = toLatLngBounds(bounds);
  		padding = toPoint(padding || [0, 0]);

  		var zoom = this.getZoom() || 0,
  		    min = this.getMinZoom(),
  		    max = this.getMaxZoom(),
  		    nw = bounds.getNorthWest(),
  		    se = bounds.getSouthEast(),
  		    size = this.getSize().subtract(padding),
  		    boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
  		    snap = any3d ? this.options.zoomSnap : 1,
  		    scalex = size.x / boundsSize.x,
  		    scaley = size.y / boundsSize.y,
  		    scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);

  		zoom = this.getScaleZoom(scale, zoom);

  		if (snap) {
  			zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
  			zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
  		}

  		return Math.max(min, Math.min(max, zoom));
  	},

  	// @method getSize(): Point
  	// Returns the current size of the map container (in pixels).
  	getSize: function () {
  		if (!this._size || this._sizeChanged) {
  			this._size = new Point(
  				this._container.clientWidth || 0,
  				this._container.clientHeight || 0);

  			this._sizeChanged = false;
  		}
  		return this._size.clone();
  	},

  	// @method getPixelBounds(): Bounds
  	// Returns the bounds of the current map view in projected pixel
  	// coordinates (sometimes useful in layer and overlay implementations).
  	getPixelBounds: function (center, zoom) {
  		var topLeftPoint = this._getTopLeftPoint(center, zoom);
  		return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
  	},

  	// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
  	// the map pane? "left point of the map layer" can be confusing, specially
  	// since there can be negative offsets.
  	// @method getPixelOrigin(): Point
  	// Returns the projected pixel coordinates of the top left point of
  	// the map layer (useful in custom layer and overlay implementations).
  	getPixelOrigin: function () {
  		this._checkIfLoaded();
  		return this._pixelOrigin;
  	},

  	// @method getPixelWorldBounds(zoom?: Number): Bounds
  	// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
  	// If `zoom` is omitted, the map's current zoom level is used.
  	getPixelWorldBounds: function (zoom) {
  		return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
  	},

  	// @section Other Methods

  	// @method getPane(pane: String|HTMLElement): HTMLElement
  	// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
  	getPane: function (pane) {
  		return typeof pane === 'string' ? this._panes[pane] : pane;
  	},

  	// @method getPanes(): Object
  	// Returns a plain object containing the names of all [panes](#map-pane) as keys and
  	// the panes as values.
  	getPanes: function () {
  		return this._panes;
  	},

  	// @method getContainer: HTMLElement
  	// Returns the HTML element that contains the map.
  	getContainer: function () {
  		return this._container;
  	},


  	// @section Conversion Methods

  	// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
  	// Returns the scale factor to be applied to a map transition from zoom level
  	// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
  	getZoomScale: function (toZoom, fromZoom) {
  		// TODO replace with universal implementation after refactoring projections
  		var crs = this.options.crs;
  		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
  		return crs.scale(toZoom) / crs.scale(fromZoom);
  	},

  	// @method getScaleZoom(scale: Number, fromZoom: Number): Number
  	// Returns the zoom level that the map would end up at, if it is at `fromZoom`
  	// level and everything is scaled by a factor of `scale`. Inverse of
  	// [`getZoomScale`](#map-getZoomScale).
  	getScaleZoom: function (scale, fromZoom) {
  		var crs = this.options.crs;
  		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
  		var zoom = crs.zoom(scale * crs.scale(fromZoom));
  		return isNaN(zoom) ? Infinity : zoom;
  	},

  	// @method project(latlng: LatLng, zoom: Number): Point
  	// Projects a geographical coordinate `LatLng` according to the projection
  	// of the map's CRS, then scales it according to `zoom` and the CRS's
  	// `Transformation`. The result is pixel coordinate relative to
  	// the CRS origin.
  	project: function (latlng, zoom) {
  		zoom = zoom === undefined ? this._zoom : zoom;
  		return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
  	},

  	// @method unproject(point: Point, zoom: Number): LatLng
  	// Inverse of [`project`](#map-project).
  	unproject: function (point, zoom) {
  		zoom = zoom === undefined ? this._zoom : zoom;
  		return this.options.crs.pointToLatLng(toPoint(point), zoom);
  	},

  	// @method layerPointToLatLng(point: Point): LatLng
  	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
  	// returns the corresponding geographical coordinate (for the current zoom level).
  	layerPointToLatLng: function (point) {
  		var projectedPoint = toPoint(point).add(this.getPixelOrigin());
  		return this.unproject(projectedPoint);
  	},

  	// @method latLngToLayerPoint(latlng: LatLng): Point
  	// Given a geographical coordinate, returns the corresponding pixel coordinate
  	// relative to the [origin pixel](#map-getpixelorigin).
  	latLngToLayerPoint: function (latlng) {
  		var projectedPoint = this.project(toLatLng(latlng))._round();
  		return projectedPoint._subtract(this.getPixelOrigin());
  	},

  	// @method wrapLatLng(latlng: LatLng): LatLng
  	// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
  	// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
  	// CRS's bounds.
  	// By default this means longitude is wrapped around the dateline so its
  	// value is between -180 and +180 degrees.
  	wrapLatLng: function (latlng) {
  		return this.options.crs.wrapLatLng(toLatLng(latlng));
  	},

  	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
  	// Returns a `LatLngBounds` with the same size as the given one, ensuring that
  	// its center is within the CRS's bounds.
  	// By default this means the center longitude is wrapped around the dateline so its
  	// value is between -180 and +180 degrees, and the majority of the bounds
  	// overlaps the CRS's bounds.
  	wrapLatLngBounds: function (latlng) {
  		return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
  	},

  	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
  	// Returns the distance between two geographical coordinates according to
  	// the map's CRS. By default this measures distance in meters.
  	distance: function (latlng1, latlng2) {
  		return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
  	},

  	// @method containerPointToLayerPoint(point: Point): Point
  	// Given a pixel coordinate relative to the map container, returns the corresponding
  	// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
  	containerPointToLayerPoint: function (point) { // (Point)
  		return toPoint(point).subtract(this._getMapPanePos());
  	},

  	// @method layerPointToContainerPoint(point: Point): Point
  	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
  	// returns the corresponding pixel coordinate relative to the map container.
  	layerPointToContainerPoint: function (point) { // (Point)
  		return toPoint(point).add(this._getMapPanePos());
  	},

  	// @method containerPointToLatLng(point: Point): LatLng
  	// Given a pixel coordinate relative to the map container, returns
  	// the corresponding geographical coordinate (for the current zoom level).
  	containerPointToLatLng: function (point) {
  		var layerPoint = this.containerPointToLayerPoint(toPoint(point));
  		return this.layerPointToLatLng(layerPoint);
  	},

  	// @method latLngToContainerPoint(latlng: LatLng): Point
  	// Given a geographical coordinate, returns the corresponding pixel coordinate
  	// relative to the map container.
  	latLngToContainerPoint: function (latlng) {
  		return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
  	},

  	// @method mouseEventToContainerPoint(ev: MouseEvent): Point
  	// Given a MouseEvent object, returns the pixel coordinate relative to the
  	// map container where the event took place.
  	mouseEventToContainerPoint: function (e) {
  		return getMousePosition(e, this._container);
  	},

  	// @method mouseEventToLayerPoint(ev: MouseEvent): Point
  	// Given a MouseEvent object, returns the pixel coordinate relative to
  	// the [origin pixel](#map-getpixelorigin) where the event took place.
  	mouseEventToLayerPoint: function (e) {
  		return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
  	},

  	// @method mouseEventToLatLng(ev: MouseEvent): LatLng
  	// Given a MouseEvent object, returns geographical coordinate where the
  	// event took place.
  	mouseEventToLatLng: function (e) { // (MouseEvent)
  		return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
  	},


  	// map initialization methods

  	_initContainer: function (id) {
  		var container = this._container = get(id);

  		if (!container) {
  			throw new Error('Map container not found.');
  		} else if (container._leaflet_id) {
  			throw new Error('Map container is already initialized.');
  		}

  		on(container, 'scroll', this._onScroll, this);
  		this._containerId = stamp(container);
  	},

  	_initLayout: function () {
  		var container = this._container;

  		this._fadeAnimated = this.options.fadeAnimation && any3d;

  		addClass(container, 'leaflet-container' +
  			(touch ? ' leaflet-touch' : '') +
  			(retina ? ' leaflet-retina' : '') +
  			(ielt9 ? ' leaflet-oldie' : '') +
  			(safari ? ' leaflet-safari' : '') +
  			(this._fadeAnimated ? ' leaflet-fade-anim' : ''));

  		var position = getStyle(container, 'position');

  		if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
  			container.style.position = 'relative';
  		}

  		this._initPanes();

  		if (this._initControlPos) {
  			this._initControlPos();
  		}
  	},

  	_initPanes: function () {
  		var panes = this._panes = {};
  		this._paneRenderers = {};

  		// @section
  		//
  		// Panes are DOM elements used to control the ordering of layers on the map. You
  		// can access panes with [`map.getPane`](#map-getpane) or
  		// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
  		// [`map.createPane`](#map-createpane) method.
  		//
  		// Every map has the following default panes that differ only in zIndex.
  		//
  		// @pane mapPane: HTMLElement = 'auto'
  		// Pane that contains all other map panes

  		this._mapPane = this.createPane('mapPane', this._container);
  		setPosition(this._mapPane, new Point(0, 0));

  		// @pane tilePane: HTMLElement = 200
  		// Pane for `GridLayer`s and `TileLayer`s
  		this.createPane('tilePane');
  		// @pane overlayPane: HTMLElement = 400
  		// Pane for overlay shadows (e.g. `Marker` shadows)
  		this.createPane('shadowPane');
  		// @pane shadowPane: HTMLElement = 500
  		// Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
  		this.createPane('overlayPane');
  		// @pane markerPane: HTMLElement = 600
  		// Pane for `Icon`s of `Marker`s
  		this.createPane('markerPane');
  		// @pane tooltipPane: HTMLElement = 650
  		// Pane for `Tooltip`s.
  		this.createPane('tooltipPane');
  		// @pane popupPane: HTMLElement = 700
  		// Pane for `Popup`s.
  		this.createPane('popupPane');

  		if (!this.options.markerZoomAnimation) {
  			addClass(panes.markerPane, 'leaflet-zoom-hide');
  			addClass(panes.shadowPane, 'leaflet-zoom-hide');
  		}
  	},


  	// private methods that modify map state

  	// @section Map state change events
  	_resetView: function (center, zoom) {
  		setPosition(this._mapPane, new Point(0, 0));

  		var loading = !this._loaded;
  		this._loaded = true;
  		zoom = this._limitZoom(zoom);

  		this.fire('viewprereset');

  		var zoomChanged = this._zoom !== zoom;
  		this
  			._moveStart(zoomChanged, false)
  			._move(center, zoom)
  			._moveEnd(zoomChanged);

  		// @event viewreset: Event
  		// Fired when the map needs to redraw its content (this usually happens
  		// on map zoom or load). Very useful for creating custom overlays.
  		this.fire('viewreset');

  		// @event load: Event
  		// Fired when the map is initialized (when its center and zoom are set
  		// for the first time).
  		if (loading) {
  			this.fire('load');
  		}
  	},

  	_moveStart: function (zoomChanged, noMoveStart) {
  		// @event zoomstart: Event
  		// Fired when the map zoom is about to change (e.g. before zoom animation).
  		// @event movestart: Event
  		// Fired when the view of the map starts changing (e.g. user starts dragging the map).
  		if (zoomChanged) {
  			this.fire('zoomstart');
  		}
  		if (!noMoveStart) {
  			this.fire('movestart');
  		}
  		return this;
  	},

  	_move: function (center, zoom, data) {
  		if (zoom === undefined) {
  			zoom = this._zoom;
  		}
  		var zoomChanged = this._zoom !== zoom;

  		this._zoom = zoom;
  		this._lastCenter = center;
  		this._pixelOrigin = this._getNewPixelOrigin(center);

  		// @event zoom: Event
  		// Fired repeatedly during any change in zoom level, including zoom
  		// and fly animations.
  		if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
  			this.fire('zoom', data);
  		}

  		// @event move: Event
  		// Fired repeatedly during any movement of the map, including pan and
  		// fly animations.
  		return this.fire('move', data);
  	},

  	_moveEnd: function (zoomChanged) {
  		// @event zoomend: Event
  		// Fired when the map has changed, after any animations.
  		if (zoomChanged) {
  			this.fire('zoomend');
  		}

  		// @event moveend: Event
  		// Fired when the center of the map stops changing (e.g. user stopped
  		// dragging the map).
  		return this.fire('moveend');
  	},

  	_stop: function () {
  		cancelAnimFrame(this._flyToFrame);
  		if (this._panAnim) {
  			this._panAnim.stop();
  		}
  		return this;
  	},

  	_rawPanBy: function (offset) {
  		setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
  	},

  	_getZoomSpan: function () {
  		return this.getMaxZoom() - this.getMinZoom();
  	},

  	_panInsideMaxBounds: function () {
  		if (!this._enforcingBounds) {
  			this.panInsideBounds(this.options.maxBounds);
  		}
  	},

  	_checkIfLoaded: function () {
  		if (!this._loaded) {
  			throw new Error('Set map center and zoom first.');
  		}
  	},

  	// DOM event handling

  	// @section Interaction events
  	_initEvents: function (remove$$1) {
  		this._targets = {};
  		this._targets[stamp(this._container)] = this;

  		var onOff = remove$$1 ? off : on;

  		// @event click: MouseEvent
  		// Fired when the user clicks (or taps) the map.
  		// @event dblclick: MouseEvent
  		// Fired when the user double-clicks (or double-taps) the map.
  		// @event mousedown: MouseEvent
  		// Fired when the user pushes the mouse button on the map.
  		// @event mouseup: MouseEvent
  		// Fired when the user releases the mouse button on the map.
  		// @event mouseover: MouseEvent
  		// Fired when the mouse enters the map.
  		// @event mouseout: MouseEvent
  		// Fired when the mouse leaves the map.
  		// @event mousemove: MouseEvent
  		// Fired while the mouse moves over the map.
  		// @event contextmenu: MouseEvent
  		// Fired when the user pushes the right mouse button on the map, prevents
  		// default browser context menu from showing if there are listeners on
  		// this event. Also fired on mobile when the user holds a single touch
  		// for a second (also called long press).
  		// @event keypress: KeyboardEvent
  		// Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
  		// @event keydown: KeyboardEvent
  		// Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
  		// the `keydown` event is fired for keys that produce a character value and for keys
  		// that do not produce a character value.
  		// @event keyup: KeyboardEvent
  		// Fired when the user releases a key from the keyboard while the map is focused.
  		onOff(this._container, 'click dblclick mousedown mouseup ' +
  			'mouseover mouseout mousemove contextmenu keypress keydown keyup', this._handleDOMEvent, this);

  		if (this.options.trackResize) {
  			onOff(window, 'resize', this._onResize, this);
  		}

  		if (any3d && this.options.transform3DLimit) {
  			(remove$$1 ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
  		}
  	},

  	_onResize: function () {
  		cancelAnimFrame(this._resizeRequest);
  		this._resizeRequest = requestAnimFrame(
  		        function () { this.invalidateSize({debounceMoveend: true}); }, this);
  	},

  	_onScroll: function () {
  		this._container.scrollTop  = 0;
  		this._container.scrollLeft = 0;
  	},

  	_onMoveEnd: function () {
  		var pos = this._getMapPanePos();
  		if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
  			// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
  			// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
  			this._resetView(this.getCenter(), this.getZoom());
  		}
  	},

  	_findEventTargets: function (e, type) {
  		var targets = [],
  		    target,
  		    isHover = type === 'mouseout' || type === 'mouseover',
  		    src = e.target || e.srcElement,
  		    dragging = false;

  		while (src) {
  			target = this._targets[stamp(src)];
  			if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
  				// Prevent firing click after you just dragged an object.
  				dragging = true;
  				break;
  			}
  			if (target && target.listens(type, true)) {
  				if (isHover && !isExternalTarget(src, e)) { break; }
  				targets.push(target);
  				if (isHover) { break; }
  			}
  			if (src === this._container) { break; }
  			src = src.parentNode;
  		}
  		if (!targets.length && !dragging && !isHover && isExternalTarget(src, e)) {
  			targets = [this];
  		}
  		return targets;
  	},

  	_handleDOMEvent: function (e) {
  		if (!this._loaded || skipped(e)) { return; }

  		var type = e.type;

  		if (type === 'mousedown' || type === 'keypress' || type === 'keyup' || type === 'keydown') {
  			// prevents outline when clicking on keyboard-focusable element
  			preventOutline(e.target || e.srcElement);
  		}

  		this._fireDOMEvent(e, type);
  	},

  	_mouseEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu'],

  	_fireDOMEvent: function (e, type, targets) {

  		if (e.type === 'click') {
  			// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
  			// @event preclick: MouseEvent
  			// Fired before mouse click on the map (sometimes useful when you
  			// want something to happen on click before any existing click
  			// handlers start running).
  			var synth = extend({}, e);
  			synth.type = 'preclick';
  			this._fireDOMEvent(synth, synth.type, targets);
  		}

  		if (e._stopped) { return; }

  		// Find the layer the event is propagating from and its parents.
  		targets = (targets || []).concat(this._findEventTargets(e, type));

  		if (!targets.length) { return; }

  		var target = targets[0];
  		if (type === 'contextmenu' && target.listens(type, true)) {
  			preventDefault(e);
  		}

  		var data = {
  			originalEvent: e
  		};

  		if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
  			var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
  			data.containerPoint = isMarker ?
  				this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
  			data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
  			data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
  		}

  		for (var i = 0; i < targets.length; i++) {
  			targets[i].fire(type, data, true);
  			if (data.originalEvent._stopped ||
  				(targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1)) { return; }
  		}
  	},

  	_draggableMoved: function (obj) {
  		obj = obj.dragging && obj.dragging.enabled() ? obj : this;
  		return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
  	},

  	_clearHandlers: function () {
  		for (var i = 0, len = this._handlers.length; i < len; i++) {
  			this._handlers[i].disable();
  		}
  	},

  	// @section Other Methods

  	// @method whenReady(fn: Function, context?: Object): this
  	// Runs the given function `fn` when the map gets initialized with
  	// a view (center and zoom) and at least one layer, or immediately
  	// if it's already initialized, optionally passing a function context.
  	whenReady: function (callback, context) {
  		if (this._loaded) {
  			callback.call(context || this, {target: this});
  		} else {
  			this.on('load', callback, context);
  		}
  		return this;
  	},


  	// private methods for getting map state

  	_getMapPanePos: function () {
  		return getPosition(this._mapPane) || new Point(0, 0);
  	},

  	_moved: function () {
  		var pos = this._getMapPanePos();
  		return pos && !pos.equals([0, 0]);
  	},

  	_getTopLeftPoint: function (center, zoom) {
  		var pixelOrigin = center && zoom !== undefined ?
  			this._getNewPixelOrigin(center, zoom) :
  			this.getPixelOrigin();
  		return pixelOrigin.subtract(this._getMapPanePos());
  	},

  	_getNewPixelOrigin: function (center, zoom) {
  		var viewHalf = this.getSize()._divideBy(2);
  		return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
  	},

  	_latLngToNewLayerPoint: function (latlng, zoom, center) {
  		var topLeft = this._getNewPixelOrigin(center, zoom);
  		return this.project(latlng, zoom)._subtract(topLeft);
  	},

  	_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
  		var topLeft = this._getNewPixelOrigin(center, zoom);
  		return toBounds([
  			this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
  			this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
  			this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
  			this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
  		]);
  	},

  	// layer point of the current center
  	_getCenterLayerPoint: function () {
  		return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
  	},

  	// offset of the specified place to the current center in pixels
  	_getCenterOffset: function (latlng) {
  		return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
  	},

  	// adjust center for view to get inside bounds
  	_limitCenter: function (center, zoom, bounds) {

  		if (!bounds) { return center; }

  		var centerPoint = this.project(center, zoom),
  		    viewHalf = this.getSize().divideBy(2),
  		    viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
  		    offset = this._getBoundsOffset(viewBounds, bounds, zoom);

  		// If offset is less than a pixel, ignore.
  		// This prevents unstable projections from getting into
  		// an infinite loop of tiny offsets.
  		if (offset.round().equals([0, 0])) {
  			return center;
  		}

  		return this.unproject(centerPoint.add(offset), zoom);
  	},

  	// adjust offset for view to get inside bounds
  	_limitOffset: function (offset, bounds) {
  		if (!bounds) { return offset; }

  		var viewBounds = this.getPixelBounds(),
  		    newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));

  		return offset.add(this._getBoundsOffset(newBounds, bounds));
  	},

  	// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
  	_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
  		var projectedMaxBounds = toBounds(
  		        this.project(maxBounds.getNorthEast(), zoom),
  		        this.project(maxBounds.getSouthWest(), zoom)
  		    ),
  		    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
  		    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),

  		    dx = this._rebound(minOffset.x, -maxOffset.x),
  		    dy = this._rebound(minOffset.y, -maxOffset.y);

  		return new Point(dx, dy);
  	},

  	_rebound: function (left, right) {
  		return left + right > 0 ?
  			Math.round(left - right) / 2 :
  			Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
  	},

  	_limitZoom: function (zoom) {
  		var min = this.getMinZoom(),
  		    max = this.getMaxZoom(),
  		    snap = any3d ? this.options.zoomSnap : 1;
  		if (snap) {
  			zoom = Math.round(zoom / snap) * snap;
  		}
  		return Math.max(min, Math.min(max, zoom));
  	},

  	_onPanTransitionStep: function () {
  		this.fire('move');
  	},

  	_onPanTransitionEnd: function () {
  		removeClass(this._mapPane, 'leaflet-pan-anim');
  		this.fire('moveend');
  	},

  	_tryAnimatedPan: function (center, options) {
  		// difference between the new and current centers in pixels
  		var offset = this._getCenterOffset(center)._trunc();

  		// don't animate too far unless animate: true specified in options
  		if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }

  		this.panBy(offset, options);

  		return true;
  	},

  	_createAnimProxy: function () {

  		var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
  		this._panes.mapPane.appendChild(proxy);

  		this.on('zoomanim', function (e) {
  			var prop = TRANSFORM,
  			    transform = this._proxy.style[prop];

  			setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));

  			// workaround for case when transform is the same and so transitionend event is not fired
  			if (transform === this._proxy.style[prop] && this._animatingZoom) {
  				this._onZoomTransitionEnd();
  			}
  		}, this);

  		this.on('load moveend', this._animMoveEnd, this);

  		this._on('unload', this._destroyAnimProxy, this);
  	},

  	_destroyAnimProxy: function () {
  		remove(this._proxy);
  		this.off('load moveend', this._animMoveEnd, this);
  		delete this._proxy;
  	},

  	_animMoveEnd: function () {
  		var c = this.getCenter(),
  		    z = this.getZoom();
  		setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
  	},

  	_catchTransitionEnd: function (e) {
  		if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
  			this._onZoomTransitionEnd();
  		}
  	},

  	_nothingToAnimate: function () {
  		return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
  	},

  	_tryAnimatedZoom: function (center, zoom, options) {

  		if (this._animatingZoom) { return true; }

  		options = options || {};

  		// don't animate if disabled, not supported or zoom difference is too large
  		if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
  		        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }

  		// offset is the pixel coords of the zoom origin relative to the current center
  		var scale = this.getZoomScale(zoom),
  		    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);

  		// don't animate if the zoom origin isn't within one screen from the current center, unless forced
  		if (options.animate !== true && !this.getSize().contains(offset)) { return false; }

  		requestAnimFrame(function () {
  			this
  			    ._moveStart(true, false)
  			    ._animateZoom(center, zoom, true);
  		}, this);

  		return true;
  	},

  	_animateZoom: function (center, zoom, startAnim, noUpdate) {
  		if (!this._mapPane) { return; }

  		if (startAnim) {
  			this._animatingZoom = true;

  			// remember what center/zoom to set after animation
  			this._animateToCenter = center;
  			this._animateToZoom = zoom;

  			addClass(this._mapPane, 'leaflet-zoom-anim');
  		}

  		// @section Other Events
  		// @event zoomanim: ZoomAnimEvent
  		// Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
  		this.fire('zoomanim', {
  			center: center,
  			zoom: zoom,
  			noUpdate: noUpdate
  		});

  		// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
  		setTimeout(bind(this._onZoomTransitionEnd, this), 250);
  	},

  	_onZoomTransitionEnd: function () {
  		if (!this._animatingZoom) { return; }

  		if (this._mapPane) {
  			removeClass(this._mapPane, 'leaflet-zoom-anim');
  		}

  		this._animatingZoom = false;

  		this._move(this._animateToCenter, this._animateToZoom);

  		// This anim frame should prevent an obscure iOS webkit tile loading race condition.
  		requestAnimFrame(function () {
  			this._moveEnd(true);
  		}, this);
  	}
  });

  // @section

  // @factory L.map(id: String, options?: Map options)
  // Instantiates a map object given the DOM ID of a `<div>` element
  // and optionally an object literal with `Map options`.
  //
  // @alternative
  // @factory L.map(el: HTMLElement, options?: Map options)
  // Instantiates a map object given an instance of a `<div>` HTML element
  // and optionally an object literal with `Map options`.
  function createMap(id, options) {
  	return new Map(id, options);
  }

  /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */

  var Control = Class.extend({
  	// @section
  	// @aka Control options
  	options: {
  		// @option position: String = 'topright'
  		// The position of the control (one of the map corners). Possible values are `'topleft'`,
  		// `'topright'`, `'bottomleft'` or `'bottomright'`
  		position: 'topright'
  	},

  	initialize: function (options) {
  		setOptions(this, options);
  	},

  	/* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */
  	getPosition: function () {
  		return this.options.position;
  	},

  	// @method setPosition(position: string): this
  	// Sets the position of the control.
  	setPosition: function (position) {
  		var map = this._map;

  		if (map) {
  			map.removeControl(this);
  		}

  		this.options.position = position;

  		if (map) {
  			map.addControl(this);
  		}

  		return this;
  	},

  	// @method getContainer: HTMLElement
  	// Returns the HTMLElement that contains the control.
  	getContainer: function () {
  		return this._container;
  	},

  	// @method addTo(map: Map): this
  	// Adds the control to the given map.
  	addTo: function (map) {
  		this.remove();
  		this._map = map;

  		var container = this._container = this.onAdd(map),
  		    pos = this.getPosition(),
  		    corner = map._controlCorners[pos];

  		addClass(container, 'leaflet-control');

  		if (pos.indexOf('bottom') !== -1) {
  			corner.insertBefore(container, corner.firstChild);
  		} else {
  			corner.appendChild(container);
  		}

  		this._map.on('unload', this.remove, this);

  		return this;
  	},

  	// @method remove: this
  	// Removes the control from the map it is currently active on.
  	remove: function () {
  		if (!this._map) {
  			return this;
  		}

  		remove(this._container);

  		if (this.onRemove) {
  			this.onRemove(this._map);
  		}

  		this._map.off('unload', this.remove, this);
  		this._map = null;

  		return this;
  	},

  	_refocusOnMap: function (e) {
  		// if map exists and event is not a keyboard event
  		if (this._map && e && e.screenX > 0 && e.screenY > 0) {
  			this._map.getContainer().focus();
  		}
  	}
  });

  var control = function (options) {
  	return new Control(options);
  };

  /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */

  /* @namespace Map
   * @section Methods for Layers and Controls
   */
  Map.include({
  	// @method addControl(control: Control): this
  	// Adds the given control to the map
  	addControl: function (control) {
  		control.addTo(this);
  		return this;
  	},

  	// @method removeControl(control: Control): this
  	// Removes the given control from the map
  	removeControl: function (control) {
  		control.remove();
  		return this;
  	},

  	_initControlPos: function () {
  		var corners = this._controlCorners = {},
  		    l = 'leaflet-',
  		    container = this._controlContainer =
  		            create$1('div', l + 'control-container', this._container);

  		function createCorner(vSide, hSide) {
  			var className = l + vSide + ' ' + l + hSide;

  			corners[vSide + hSide] = create$1('div', className, container);
  		}

  		createCorner('top', 'left');
  		createCorner('top', 'right');
  		createCorner('bottom', 'left');
  		createCorner('bottom', 'right');
  	},

  	_clearControlPos: function () {
  		for (var i in this._controlCorners) {
  			remove(this._controlCorners[i]);
  		}
  		remove(this._controlContainer);
  		delete this._controlCorners;
  		delete this._controlContainer;
  	}
  });

  /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */

  var Layers = Control.extend({
  	// @section
  	// @aka Control.Layers options
  	options: {
  		// @option collapsed: Boolean = true
  		// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
  		collapsed: true,
  		position: 'topright',

  		// @option autoZIndex: Boolean = true
  		// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
  		autoZIndex: true,

  		// @option hideSingleBase: Boolean = false
  		// If `true`, the base layers in the control will be hidden when there is only one.
  		hideSingleBase: false,

  		// @option sortLayers: Boolean = false
  		// Whether to sort the layers. When `false`, layers will keep the order
  		// in which they were added to the control.
  		sortLayers: false,

  		// @option sortFunction: Function = *
  		// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
  		// that will be used for sorting the layers, when `sortLayers` is `true`.
  		// The function receives both the `L.Layer` instances and their names, as in
  		// `sortFunction(layerA, layerB, nameA, nameB)`.
  		// By default, it sorts layers alphabetically by their name.
  		sortFunction: function (layerA, layerB, nameA, nameB) {
  			return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
  		}
  	},

  	initialize: function (baseLayers, overlays, options) {
  		setOptions(this, options);

  		this._layerControlInputs = [];
  		this._layers = [];
  		this._lastZIndex = 0;
  		this._handlingClick = false;

  		for (var i in baseLayers) {
  			this._addLayer(baseLayers[i], i);
  		}

  		for (i in overlays) {
  			this._addLayer(overlays[i], i, true);
  		}
  	},

  	onAdd: function (map) {
  		this._initLayout();
  		this._update();

  		this._map = map;
  		map.on('zoomend', this._checkDisabledLayers, this);

  		for (var i = 0; i < this._layers.length; i++) {
  			this._layers[i].layer.on('add remove', this._onLayerChange, this);
  		}

  		return this._container;
  	},

  	addTo: function (map) {
  		Control.prototype.addTo.call(this, map);
  		// Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
  		return this._expandIfNotCollapsed();
  	},

  	onRemove: function () {
  		this._map.off('zoomend', this._checkDisabledLayers, this);

  		for (var i = 0; i < this._layers.length; i++) {
  			this._layers[i].layer.off('add remove', this._onLayerChange, this);
  		}
  	},

  	// @method addBaseLayer(layer: Layer, name: String): this
  	// Adds a base layer (radio button entry) with the given name to the control.
  	addBaseLayer: function (layer, name) {
  		this._addLayer(layer, name);
  		return (this._map) ? this._update() : this;
  	},

  	// @method addOverlay(layer: Layer, name: String): this
  	// Adds an overlay (checkbox entry) with the given name to the control.
  	addOverlay: function (layer, name) {
  		this._addLayer(layer, name, true);
  		return (this._map) ? this._update() : this;
  	},

  	// @method removeLayer(layer: Layer): this
  	// Remove the given layer from the control.
  	removeLayer: function (layer) {
  		layer.off('add remove', this._onLayerChange, this);

  		var obj = this._getLayer(stamp(layer));
  		if (obj) {
  			this._layers.splice(this._layers.indexOf(obj), 1);
  		}
  		return (this._map) ? this._update() : this;
  	},

  	// @method expand(): this
  	// Expand the control container if collapsed.
  	expand: function () {
  		addClass(this._container, 'leaflet-control-layers-expanded');
  		this._section.style.height = null;
  		var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
  		if (acceptableHeight < this._section.clientHeight) {
  			addClass(this._section, 'leaflet-control-layers-scrollbar');
  			this._section.style.height = acceptableHeight + 'px';
  		} else {
  			removeClass(this._section, 'leaflet-control-layers-scrollbar');
  		}
  		this._checkDisabledLayers();
  		return this;
  	},

  	// @method collapse(): this
  	// Collapse the control container if expanded.
  	collapse: function () {
  		removeClass(this._container, 'leaflet-control-layers-expanded');
  		return this;
  	},

  	_initLayout: function () {
  		var className = 'leaflet-control-layers',
  		    container = this._container = create$1('div', className),
  		    collapsed = this.options.collapsed;

  		// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
  		container.setAttribute('aria-haspopup', true);

  		disableClickPropagation(container);
  		disableScrollPropagation(container);

  		var section = this._section = create$1('section', className + '-list');

  		if (collapsed) {
  			this._map.on('click', this.collapse, this);

  			if (!android) {
  				on(container, {
  					mouseenter: this.expand,
  					mouseleave: this.collapse
  				}, this);
  			}
  		}

  		var link = this._layersLink = create$1('a', className + '-toggle', container);
  		link.href = '#';
  		link.title = 'Layers';

  		if (touch) {
  			on(link, 'click', stop);
  			on(link, 'click', this.expand, this);
  		} else {
  			on(link, 'focus', this.expand, this);
  		}

  		if (!collapsed) {
  			this.expand();
  		}

  		this._baseLayersList = create$1('div', className + '-base', section);
  		this._separator = create$1('div', className + '-separator', section);
  		this._overlaysList = create$1('div', className + '-overlays', section);

  		container.appendChild(section);
  	},

  	_getLayer: function (id) {
  		for (var i = 0; i < this._layers.length; i++) {

  			if (this._layers[i] && stamp(this._layers[i].layer) === id) {
  				return this._layers[i];
  			}
  		}
  	},

  	_addLayer: function (layer, name, overlay) {
  		if (this._map) {
  			layer.on('add remove', this._onLayerChange, this);
  		}

  		this._layers.push({
  			layer: layer,
  			name: name,
  			overlay: overlay
  		});

  		if (this.options.sortLayers) {
  			this._layers.sort(bind(function (a, b) {
  				return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
  			}, this));
  		}

  		if (this.options.autoZIndex && layer.setZIndex) {
  			this._lastZIndex++;
  			layer.setZIndex(this._lastZIndex);
  		}

  		this._expandIfNotCollapsed();
  	},

  	_update: function () {
  		if (!this._container) { return this; }

  		empty(this._baseLayersList);
  		empty(this._overlaysList);

  		this._layerControlInputs = [];
  		var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;

  		for (i = 0; i < this._layers.length; i++) {
  			obj = this._layers[i];
  			this._addItem(obj);
  			overlaysPresent = overlaysPresent || obj.overlay;
  			baseLayersPresent = baseLayersPresent || !obj.overlay;
  			baseLayersCount += !obj.overlay ? 1 : 0;
  		}

  		// Hide base layers section if there's only one layer.
  		if (this.options.hideSingleBase) {
  			baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
  			this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
  		}

  		this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';

  		return this;
  	},

  	_onLayerChange: function (e) {
  		if (!this._handlingClick) {
  			this._update();
  		}

  		var obj = this._getLayer(stamp(e.target));

  		// @namespace Map
  		// @section Layer events
  		// @event baselayerchange: LayersControlEvent
  		// Fired when the base layer is changed through the [layers control](#control-layers).
  		// @event overlayadd: LayersControlEvent
  		// Fired when an overlay is selected through the [layers control](#control-layers).
  		// @event overlayremove: LayersControlEvent
  		// Fired when an overlay is deselected through the [layers control](#control-layers).
  		// @namespace Control.Layers
  		var type = obj.overlay ?
  			(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
  			(e.type === 'add' ? 'baselayerchange' : null);

  		if (type) {
  			this._map.fire(type, obj);
  		}
  	},

  	// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
  	_createRadioElement: function (name, checked) {

  		var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
  				name + '"' + (checked ? ' checked="checked"' : '') + '/>';

  		var radioFragment = document.createElement('div');
  		radioFragment.innerHTML = radioHtml;

  		return radioFragment.firstChild;
  	},

  	_addItem: function (obj) {
  		var label = document.createElement('label'),
  		    checked = this._map.hasLayer(obj.layer),
  		    input;

  		if (obj.overlay) {
  			input = document.createElement('input');
  			input.type = 'checkbox';
  			input.className = 'leaflet-control-layers-selector';
  			input.defaultChecked = checked;
  		} else {
  			input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
  		}

  		this._layerControlInputs.push(input);
  		input.layerId = stamp(obj.layer);

  		on(input, 'click', this._onInputClick, this);

  		var name = document.createElement('span');
  		name.innerHTML = ' ' + obj.name;

  		// Helps from preventing layer control flicker when checkboxes are disabled
  		// https://github.com/Leaflet/Leaflet/issues/2771
  		var holder = document.createElement('div');

  		label.appendChild(holder);
  		holder.appendChild(input);
  		holder.appendChild(name);

  		var container = obj.overlay ? this._overlaysList : this._baseLayersList;
  		container.appendChild(label);

  		this._checkDisabledLayers();
  		return label;
  	},

  	_onInputClick: function () {
  		var inputs = this._layerControlInputs,
  		    input, layer;
  		var addedLayers = [],
  		    removedLayers = [];

  		this._handlingClick = true;

  		for (var i = inputs.length - 1; i >= 0; i--) {
  			input = inputs[i];
  			layer = this._getLayer(input.layerId).layer;

  			if (input.checked) {
  				addedLayers.push(layer);
  			} else if (!input.checked) {
  				removedLayers.push(layer);
  			}
  		}

  		// Bugfix issue 2318: Should remove all old layers before readding new ones
  		for (i = 0; i < removedLayers.length; i++) {
  			if (this._map.hasLayer(removedLayers[i])) {
  				this._map.removeLayer(removedLayers[i]);
  			}
  		}
  		for (i = 0; i < addedLayers.length; i++) {
  			if (!this._map.hasLayer(addedLayers[i])) {
  				this._map.addLayer(addedLayers[i]);
  			}
  		}

  		this._handlingClick = false;

  		this._refocusOnMap();
  	},

  	_checkDisabledLayers: function () {
  		var inputs = this._layerControlInputs,
  		    input,
  		    layer,
  		    zoom = this._map.getZoom();

  		for (var i = inputs.length - 1; i >= 0; i--) {
  			input = inputs[i];
  			layer = this._getLayer(input.layerId).layer;
  			input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
  			                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);

  		}
  	},

  	_expandIfNotCollapsed: function () {
  		if (this._map && !this.options.collapsed) {
  			this.expand();
  		}
  		return this;
  	},

  	_expand: function () {
  		// Backward compatibility, remove me in 1.1.
  		return this.expand();
  	},

  	_collapse: function () {
  		// Backward compatibility, remove me in 1.1.
  		return this.collapse();
  	}

  });


  // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
  // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
  var layers = function (baseLayers, overlays, options) {
  	return new Layers(baseLayers, overlays, options);
  };

  /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */

  var Zoom = Control.extend({
  	// @section
  	// @aka Control.Zoom options
  	options: {
  		position: 'topleft',

  		// @option zoomInText: String = '+'
  		// The text set on the 'zoom in' button.
  		zoomInText: '+',

  		// @option zoomInTitle: String = 'Zoom in'
  		// The title set on the 'zoom in' button.
  		zoomInTitle: 'Zoom in',

  		// @option zoomOutText: String = '&#x2212;'
  		// The text set on the 'zoom out' button.
  		zoomOutText: '&#x2212;',

  		// @option zoomOutTitle: String = 'Zoom out'
  		// The title set on the 'zoom out' button.
  		zoomOutTitle: 'Zoom out'
  	},

  	onAdd: function (map) {
  		var zoomName = 'leaflet-control-zoom',
  		    container = create$1('div', zoomName + ' leaflet-bar'),
  		    options = this.options;

  		this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
  		        zoomName + '-in',  container, this._zoomIn);
  		this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
  		        zoomName + '-out', container, this._zoomOut);

  		this._updateDisabled();
  		map.on('zoomend zoomlevelschange', this._updateDisabled, this);

  		return container;
  	},

  	onRemove: function (map) {
  		map.off('zoomend zoomlevelschange', this._updateDisabled, this);
  	},

  	disable: function () {
  		this._disabled = true;
  		this._updateDisabled();
  		return this;
  	},

  	enable: function () {
  		this._disabled = false;
  		this._updateDisabled();
  		return this;
  	},

  	_zoomIn: function (e) {
  		if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
  			this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
  		}
  	},

  	_zoomOut: function (e) {
  		if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
  			this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
  		}
  	},

  	_createButton: function (html, title, className, container, fn) {
  		var link = create$1('a', className, container);
  		link.innerHTML = html;
  		link.href = '#';
  		link.title = title;

  		/*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */
  		link.setAttribute('role', 'button');
  		link.setAttribute('aria-label', title);

  		disableClickPropagation(link);
  		on(link, 'click', stop);
  		on(link, 'click', fn, this);
  		on(link, 'click', this._refocusOnMap, this);

  		return link;
  	},

  	_updateDisabled: function () {
  		var map = this._map,
  		    className = 'leaflet-disabled';

  		removeClass(this._zoomInButton, className);
  		removeClass(this._zoomOutButton, className);

  		if (this._disabled || map._zoom === map.getMinZoom()) {
  			addClass(this._zoomOutButton, className);
  		}
  		if (this._disabled || map._zoom === map.getMaxZoom()) {
  			addClass(this._zoomInButton, className);
  		}
  	}
  });

  // @namespace Map
  // @section Control options
  // @option zoomControl: Boolean = true
  // Whether a [zoom control](#control-zoom) is added to the map by default.
  Map.mergeOptions({
  	zoomControl: true
  });

  Map.addInitHook(function () {
  	if (this.options.zoomControl) {
  		// @section Controls
  		// @property zoomControl: Control.Zoom
  		// The default zoom control (only available if the
  		// [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
  		this.zoomControl = new Zoom();
  		this.addControl(this.zoomControl);
  	}
  });

  // @namespace Control.Zoom
  // @factory L.control.zoom(options: Control.Zoom options)
  // Creates a zoom control
  var zoom = function (options) {
  	return new Zoom(options);
  };

  /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */

  var Scale = Control.extend({
  	// @section
  	// @aka Control.Scale options
  	options: {
  		position: 'bottomleft',

  		// @option maxWidth: Number = 100
  		// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
  		maxWidth: 100,

  		// @option metric: Boolean = True
  		// Whether to show the metric scale line (m/km).
  		metric: true,

  		// @option imperial: Boolean = True
  		// Whether to show the imperial scale line (mi/ft).
  		imperial: true

  		// @option updateWhenIdle: Boolean = false
  		// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
  	},

  	onAdd: function (map) {
  		var className = 'leaflet-control-scale',
  		    container = create$1('div', className),
  		    options = this.options;

  		this._addScales(options, className + '-line', container);

  		map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
  		map.whenReady(this._update, this);

  		return container;
  	},

  	onRemove: function (map) {
  		map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
  	},

  	_addScales: function (options, className, container) {
  		if (options.metric) {
  			this._mScale = create$1('div', className, container);
  		}
  		if (options.imperial) {
  			this._iScale = create$1('div', className, container);
  		}
  	},

  	_update: function () {
  		var map = this._map,
  		    y = map.getSize().y / 2;

  		var maxMeters = map.distance(
  			map.containerPointToLatLng([0, y]),
  			map.containerPointToLatLng([this.options.maxWidth, y]));

  		this._updateScales(maxMeters);
  	},

  	_updateScales: function (maxMeters) {
  		if (this.options.metric && maxMeters) {
  			this._updateMetric(maxMeters);
  		}
  		if (this.options.imperial && maxMeters) {
  			this._updateImperial(maxMeters);
  		}
  	},

  	_updateMetric: function (maxMeters) {
  		var meters = this._getRoundNum(maxMeters),
  		    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';

  		this._updateScale(this._mScale, label, meters / maxMeters);
  	},

  	_updateImperial: function (maxMeters) {
  		var maxFeet = maxMeters * 3.2808399,
  		    maxMiles, miles, feet;

  		if (maxFeet > 5280) {
  			maxMiles = maxFeet / 5280;
  			miles = this._getRoundNum(maxMiles);
  			this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);

  		} else {
  			feet = this._getRoundNum(maxFeet);
  			this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
  		}
  	},

  	_updateScale: function (scale, text, ratio) {
  		scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
  		scale.innerHTML = text;
  	},

  	_getRoundNum: function (num) {
  		var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
  		    d = num / pow10;

  		d = d >= 10 ? 10 :
  		    d >= 5 ? 5 :
  		    d >= 3 ? 3 :
  		    d >= 2 ? 2 : 1;

  		return pow10 * d;
  	}
  });


  // @factory L.control.scale(options?: Control.Scale options)
  // Creates an scale control with the given options.
  var scale = function (options) {
  	return new Scale(options);
  };

  /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */

  var Attribution = Control.extend({
  	// @section
  	// @aka Control.Attribution options
  	options: {
  		position: 'bottomright',

  		// @option prefix: String = 'Leaflet'
  		// The HTML text shown before the attributions. Pass `false` to disable.
  		prefix: '<a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
  	},

  	initialize: function (options) {
  		setOptions(this, options);

  		this._attributions = {};
  	},

  	onAdd: function (map) {
  		map.attributionControl = this;
  		this._container = create$1('div', 'leaflet-control-attribution');
  		disableClickPropagation(this._container);

  		// TODO ugly, refactor
  		for (var i in map._layers) {
  			if (map._layers[i].getAttribution) {
  				this.addAttribution(map._layers[i].getAttribution());
  			}
  		}

  		this._update();

  		return this._container;
  	},

  	// @method setPrefix(prefix: String): this
  	// Sets the text before the attributions.
  	setPrefix: function (prefix) {
  		this.options.prefix = prefix;
  		this._update();
  		return this;
  	},

  	// @method addAttribution(text: String): this
  	// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
  	addAttribution: function (text) {
  		if (!text) { return this; }

  		if (!this._attributions[text]) {
  			this._attributions[text] = 0;
  		}
  		this._attributions[text]++;

  		this._update();

  		return this;
  	},

  	// @method removeAttribution(text: String): this
  	// Removes an attribution text.
  	removeAttribution: function (text) {
  		if (!text) { return this; }

  		if (this._attributions[text]) {
  			this._attributions[text]--;
  			this._update();
  		}

  		return this;
  	},

  	_update: function () {
  		if (!this._map) { return; }

  		var attribs = [];

  		for (var i in this._attributions) {
  			if (this._attributions[i]) {
  				attribs.push(i);
  			}
  		}

  		var prefixAndAttribs = [];

  		if (this.options.prefix) {
  			prefixAndAttribs.push(this.options.prefix);
  		}
  		if (attribs.length) {
  			prefixAndAttribs.push(attribs.join(', '));
  		}

  		this._container.innerHTML = prefixAndAttribs.join(' | ');
  	}
  });

  // @namespace Map
  // @section Control options
  // @option attributionControl: Boolean = true
  // Whether a [attribution control](#control-attribution) is added to the map by default.
  Map.mergeOptions({
  	attributionControl: true
  });

  Map.addInitHook(function () {
  	if (this.options.attributionControl) {
  		new Attribution().addTo(this);
  	}
  });

  // @namespace Control.Attribution
  // @factory L.control.attribution(options: Control.Attribution options)
  // Creates an attribution control.
  var attribution = function (options) {
  	return new Attribution(options);
  };

  Control.Layers = Layers;
  Control.Zoom = Zoom;
  Control.Scale = Scale;
  Control.Attribution = Attribution;

  control.layers = layers;
  control.zoom = zoom;
  control.scale = scale;
  control.attribution = attribution;

  /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */

  // @class Handler
  // @aka L.Handler
  // Abstract class for map interaction handlers

  var Handler = Class.extend({
  	initialize: function (map) {
  		this._map = map;
  	},

  	// @method enable(): this
  	// Enables the handler
  	enable: function () {
  		if (this._enabled) { return this; }

  		this._enabled = true;
  		this.addHooks();
  		return this;
  	},

  	// @method disable(): this
  	// Disables the handler
  	disable: function () {
  		if (!this._enabled) { return this; }

  		this._enabled = false;
  		this.removeHooks();
  		return this;
  	},

  	// @method enabled(): Boolean
  	// Returns `true` if the handler is enabled
  	enabled: function () {
  		return !!this._enabled;
  	}

  	// @section Extension methods
  	// Classes inheriting from `Handler` must implement the two following methods:
  	// @method addHooks()
  	// Called when the handler is enabled, should add event hooks.
  	// @method removeHooks()
  	// Called when the handler is disabled, should remove the event hooks added previously.
  });

  // @section There is static function which can be called without instantiating L.Handler:
  // @function addTo(map: Map, name: String): this
  // Adds a new Handler to the given map with the given name.
  Handler.addTo = function (map, name) {
  	map.addHandler(name, this);
  	return this;
  };

  var Mixin = {Events: Events};

  /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */

  var START = touch ? 'touchstart mousedown' : 'mousedown';
  var END = {
  	mousedown: 'mouseup',
  	touchstart: 'touchend',
  	pointerdown: 'touchend',
  	MSPointerDown: 'touchend'
  };
  var MOVE = {
  	mousedown: 'mousemove',
  	touchstart: 'touchmove',
  	pointerdown: 'touchmove',
  	MSPointerDown: 'touchmove'
  };


  var Draggable = Evented.extend({

  	options: {
  		// @section
  		// @aka Draggable options
  		// @option clickTolerance: Number = 3
  		// The max number of pixels a user can shift the mouse pointer during a click
  		// for it to be considered a valid click (as opposed to a mouse drag).
  		clickTolerance: 3
  	},

  	// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
  	// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
  	initialize: function (element, dragStartTarget, preventOutline$$1, options) {
  		setOptions(this, options);

  		this._element = element;
  		this._dragStartTarget = dragStartTarget || element;
  		this._preventOutline = preventOutline$$1;
  	},

  	// @method enable()
  	// Enables the dragging ability
  	enable: function () {
  		if (this._enabled) { return; }

  		on(this._dragStartTarget, START, this._onDown, this);

  		this._enabled = true;
  	},

  	// @method disable()
  	// Disables the dragging ability
  	disable: function () {
  		if (!this._enabled) { return; }

  		// If we're currently dragging this draggable,
  		// disabling it counts as first ending the drag.
  		if (Draggable._dragging === this) {
  			this.finishDrag();
  		}

  		off(this._dragStartTarget, START, this._onDown, this);

  		this._enabled = false;
  		this._moved = false;
  	},

  	_onDown: function (e) {
  		// Ignore simulated events, since we handle both touch and
  		// mouse explicitly; otherwise we risk getting duplicates of
  		// touch events, see #4315.
  		// Also ignore the event if disabled; this happens in IE11
  		// under some circumstances, see #3666.
  		if (e._simulated || !this._enabled) { return; }

  		this._moved = false;

  		if (hasClass(this._element, 'leaflet-zoom-anim')) { return; }

  		if (Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
  		Draggable._dragging = this;  // Prevent dragging multiple objects at once.

  		if (this._preventOutline) {
  			preventOutline(this._element);
  		}

  		disableImageDrag();
  		disableTextSelection();

  		if (this._moving) { return; }

  		// @event down: Event
  		// Fired when a drag is about to start.
  		this.fire('down');

  		var first = e.touches ? e.touches[0] : e,
  		    sizedParent = getSizedParentNode(this._element);

  		this._startPoint = new Point(first.clientX, first.clientY);

  		// Cache the scale, so that we can continuously compensate for it during drag (_onMove).
  		this._parentScale = getScale(sizedParent);

  		on(document, MOVE[e.type], this._onMove, this);
  		on(document, END[e.type], this._onUp, this);
  	},

  	_onMove: function (e) {
  		// Ignore simulated events, since we handle both touch and
  		// mouse explicitly; otherwise we risk getting duplicates of
  		// touch events, see #4315.
  		// Also ignore the event if disabled; this happens in IE11
  		// under some circumstances, see #3666.
  		if (e._simulated || !this._enabled) { return; }

  		if (e.touches && e.touches.length > 1) {
  			this._moved = true;
  			return;
  		}

  		var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
  		    offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);

  		if (!offset.x && !offset.y) { return; }
  		if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }

  		// We assume that the parent container's position, border and scale do not change for the duration of the drag.
  		// Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
  		// and we can use the cached value for the scale.
  		offset.x /= this._parentScale.x;
  		offset.y /= this._parentScale.y;

  		preventDefault(e);

  		if (!this._moved) {
  			// @event dragstart: Event
  			// Fired when a drag starts
  			this.fire('dragstart');

  			this._moved = true;
  			this._startPos = getPosition(this._element).subtract(offset);

  			addClass(document.body, 'leaflet-dragging');

  			this._lastTarget = e.target || e.srcElement;
  			// IE and Edge do not give the <use> element, so fetch it
  			// if necessary
  			if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) {
  				this._lastTarget = this._lastTarget.correspondingUseElement;
  			}
  			addClass(this._lastTarget, 'leaflet-drag-target');
  		}

  		this._newPos = this._startPos.add(offset);
  		this._moving = true;

  		cancelAnimFrame(this._animRequest);
  		this._lastEvent = e;
  		this._animRequest = requestAnimFrame(this._updatePosition, this, true);
  	},

  	_updatePosition: function () {
  		var e = {originalEvent: this._lastEvent};

  		// @event predrag: Event
  		// Fired continuously during dragging *before* each corresponding
  		// update of the element's position.
  		this.fire('predrag', e);
  		setPosition(this._element, this._newPos);

  		// @event drag: Event
  		// Fired continuously during dragging.
  		this.fire('drag', e);
  	},

  	_onUp: function (e) {
  		// Ignore simulated events, since we handle both touch and
  		// mouse explicitly; otherwise we risk getting duplicates of
  		// touch events, see #4315.
  		// Also ignore the event if disabled; this happens in IE11
  		// under some circumstances, see #3666.
  		if (e._simulated || !this._enabled) { return; }
  		this.finishDrag();
  	},

  	finishDrag: function () {
  		removeClass(document.body, 'leaflet-dragging');

  		if (this._lastTarget) {
  			removeClass(this._lastTarget, 'leaflet-drag-target');
  			this._lastTarget = null;
  		}

  		for (var i in MOVE) {
  			off(document, MOVE[i], this._onMove, this);
  			off(document, END[i], this._onUp, this);
  		}

  		enableImageDrag();
  		enableTextSelection();

  		if (this._moved && this._moving) {
  			// ensure drag is not fired after dragend
  			cancelAnimFrame(this._animRequest);

  			// @event dragend: DragEndEvent
  			// Fired when the drag ends.
  			this.fire('dragend', {
  				distance: this._newPos.distanceTo(this._startPos)
  			});
  		}

  		this._moving = false;
  		Draggable._dragging = false;
  	}

  });

  /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */

  // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
  // Improves rendering performance dramatically by lessening the number of points to draw.

  // @function simplify(points: Point[], tolerance: Number): Point[]
  // Dramatically reduces the number of points in a polyline while retaining
  // its shape and returns a new array of simplified points, using the
  // [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
  // Used for a huge performance boost when processing/displaying Leaflet polylines for
  // each zoom level and also reducing visual noise. tolerance affects the amount of
  // simplification (lesser value means higher quality but slower and with more points).
  // Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
  function simplify(points, tolerance) {
  	if (!tolerance || !points.length) {
  		return points.slice();
  	}

  	var sqTolerance = tolerance * tolerance;

  	    // stage 1: vertex reduction
  	    points = _reducePoints(points, sqTolerance);

  	    // stage 2: Douglas-Peucker simplification
  	    points = _simplifyDP(points, sqTolerance);

  	return points;
  }

  // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
  // Returns the distance between point `p` and segment `p1` to `p2`.
  function pointToSegmentDistance(p, p1, p2) {
  	return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
  }

  // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
  // Returns the closest point from a point `p` on a segment `p1` to `p2`.
  function closestPointOnSegment(p, p1, p2) {
  	return _sqClosestPointOnSegment(p, p1, p2);
  }

  // Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
  function _simplifyDP(points, sqTolerance) {

  	var len = points.length,
  	    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
  	    markers = new ArrayConstructor(len);

  	    markers[0] = markers[len - 1] = 1;

  	_simplifyDPStep(points, markers, sqTolerance, 0, len - 1);

  	var i,
  	    newPoints = [];

  	for (i = 0; i < len; i++) {
  		if (markers[i]) {
  			newPoints.push(points[i]);
  		}
  	}

  	return newPoints;
  }

  function _simplifyDPStep(points, markers, sqTolerance, first, last) {

  	var maxSqDist = 0,
  	index, i, sqDist;

  	for (i = first + 1; i <= last - 1; i++) {
  		sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);

  		if (sqDist > maxSqDist) {
  			index = i;
  			maxSqDist = sqDist;
  		}
  	}

  	if (maxSqDist > sqTolerance) {
  		markers[index] = 1;

  		_simplifyDPStep(points, markers, sqTolerance, first, index);
  		_simplifyDPStep(points, markers, sqTolerance, index, last);
  	}
  }

  // reduce points that are too close to each other to a single point
  function _reducePoints(points, sqTolerance) {
  	var reducedPoints = [points[0]];

  	for (var i = 1, prev = 0, len = points.length; i < len; i++) {
  		if (_sqDist(points[i], points[prev]) > sqTolerance) {
  			reducedPoints.push(points[i]);
  			prev = i;
  		}
  	}
  	if (prev < len - 1) {
  		reducedPoints.push(points[len - 1]);
  	}
  	return reducedPoints;
  }

  var _lastCode;

  // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
  // Clips the segment a to b by rectangular bounds with the
  // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
  // (modifying the segment points directly!). Used by Leaflet to only show polyline
  // points that are on the screen or near, increasing performance.
  function clipSegment(a, b, bounds, useLastCode, round) {
  	var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds),
  	    codeB = _getBitCode(b, bounds),

  	    codeOut, p, newCode;

  	    // save 2nd code to avoid calculating it on the next segment
  	    _lastCode = codeB;

  	while (true) {
  		// if a,b is inside the clip window (trivial accept)
  		if (!(codeA | codeB)) {
  			return [a, b];
  		}

  		// if a,b is outside the clip window (trivial reject)
  		if (codeA & codeB) {
  			return false;
  		}

  		// other cases
  		codeOut = codeA || codeB;
  		p = _getEdgeIntersection(a, b, codeOut, bounds, round);
  		newCode = _getBitCode(p, bounds);

  		if (codeOut === codeA) {
  			a = p;
  			codeA = newCode;
  		} else {
  			b = p;
  			codeB = newCode;
  		}
  	}
  }

  function _getEdgeIntersection(a, b, code, bounds, round) {
  	var dx = b.x - a.x,
  	    dy = b.y - a.y,
  	    min = bounds.min,
  	    max = bounds.max,
  	    x, y;

  	if (code & 8) { // top
  		x = a.x + dx * (max.y - a.y) / dy;
  		y = max.y;

  	} else if (code & 4) { // bottom
  		x = a.x + dx * (min.y - a.y) / dy;
  		y = min.y;

  	} else if (code & 2) { // right
  		x = max.x;
  		y = a.y + dy * (max.x - a.x) / dx;

  	} else if (code & 1) { // left
  		x = min.x;
  		y = a.y + dy * (min.x - a.x) / dx;
  	}

  	return new Point(x, y, round);
  }

  function _getBitCode(p, bounds) {
  	var code = 0;

  	if (p.x < bounds.min.x) { // left
  		code |= 1;
  	} else if (p.x > bounds.max.x) { // right
  		code |= 2;
  	}

  	if (p.y < bounds.min.y) { // bottom
  		code |= 4;
  	} else if (p.y > bounds.max.y) { // top
  		code |= 8;
  	}

  	return code;
  }

  // square distance (to avoid unnecessary Math.sqrt calls)
  function _sqDist(p1, p2) {
  	var dx = p2.x - p1.x,
  	    dy = p2.y - p1.y;
  	return dx * dx + dy * dy;
  }

  // return closest point on segment or distance to that point
  function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
  	var x = p1.x,
  	    y = p1.y,
  	    dx = p2.x - x,
  	    dy = p2.y - y,
  	    dot = dx * dx + dy * dy,
  	    t;

  	if (dot > 0) {
  		t = ((p.x - x) * dx + (p.y - y) * dy) / dot;

  		if (t > 1) {
  			x = p2.x;
  			y = p2.y;
  		} else if (t > 0) {
  			x += dx * t;
  			y += dy * t;
  		}
  	}

  	dx = p.x - x;
  	dy = p.y - y;

  	return sqDist ? dx * dx + dy * dy : new Point(x, y);
  }


  // @function isFlat(latlngs: LatLng[]): Boolean
  // Returns true if `latlngs` is a flat array, false is nested.
  function isFlat(latlngs) {
  	return !isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
  }

  function _flat(latlngs) {
  	console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
  	return isFlat(latlngs);
  }

  var LineUtil = ({
    simplify: simplify,
    pointToSegmentDistance: pointToSegmentDistance,
    closestPointOnSegment: closestPointOnSegment,
    clipSegment: clipSegment,
    _getEdgeIntersection: _getEdgeIntersection,
    _getBitCode: _getBitCode,
    _sqClosestPointOnSegment: _sqClosestPointOnSegment,
    isFlat: isFlat,
    _flat: _flat
  });

  /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */

  /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */
  function clipPolygon(points, bounds, round) {
  	var clippedPoints,
  	    edges = [1, 4, 2, 8],
  	    i, j, k,
  	    a, b,
  	    len, edge, p;

  	for (i = 0, len = points.length; i < len; i++) {
  		points[i]._code = _getBitCode(points[i], bounds);
  	}

  	// for each edge (left, bottom, right, top)
  	for (k = 0; k < 4; k++) {
  		edge = edges[k];
  		clippedPoints = [];

  		for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
  			a = points[i];
  			b = points[j];

  			// if a is inside the clip window
  			if (!(a._code & edge)) {
  				// if b is outside the clip window (a->b goes out of screen)
  				if (b._code & edge) {
  					p = _getEdgeIntersection(b, a, edge, bounds, round);
  					p._code = _getBitCode(p, bounds);
  					clippedPoints.push(p);
  				}
  				clippedPoints.push(a);

  			// else if b is inside the clip window (a->b enters the screen)
  			} else if (!(b._code & edge)) {
  				p = _getEdgeIntersection(b, a, edge, bounds, round);
  				p._code = _getBitCode(p, bounds);
  				clippedPoints.push(p);
  			}
  		}
  		points = clippedPoints;
  	}

  	return points;
  }

  var PolyUtil = ({
    clipPolygon: clipPolygon
  });

  /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */

  var LonLat = {
  	project: function (latlng) {
  		return new Point(latlng.lng, latlng.lat);
  	},

  	unproject: function (point) {
  		return new LatLng(point.y, point.x);
  	},

  	bounds: new Bounds([-180, -90], [180, 90])
  };

  /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */

  var Mercator = {
  	R: 6378137,
  	R_MINOR: 6356752.314245179,

  	bounds: new Bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),

  	project: function (latlng) {
  		var d = Math.PI / 180,
  		    r = this.R,
  		    y = latlng.lat * d,
  		    tmp = this.R_MINOR / r,
  		    e = Math.sqrt(1 - tmp * tmp),
  		    con = e * Math.sin(y);

  		var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
  		y = -r * Math.log(Math.max(ts, 1E-10));

  		return new Point(latlng.lng * d * r, y);
  	},

  	unproject: function (point) {
  		var d = 180 / Math.PI,
  		    r = this.R,
  		    tmp = this.R_MINOR / r,
  		    e = Math.sqrt(1 - tmp * tmp),
  		    ts = Math.exp(-point.y / r),
  		    phi = Math.PI / 2 - 2 * Math.atan(ts);

  		for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
  			con = e * Math.sin(phi);
  			con = Math.pow((1 - con) / (1 + con), e / 2);
  			dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
  			phi += dphi;
  		}

  		return new LatLng(phi * d, point.x * d / r);
  	}
  };

  /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](http://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */

  var index = ({
    LonLat: LonLat,
    Mercator: Mercator,
    SphericalMercator: SphericalMercator
  });

  /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */
  var EPSG3395 = extend({}, Earth, {
  	code: 'EPSG:3395',
  	projection: Mercator,

  	transformation: (function () {
  		var scale = 0.5 / (Math.PI * Mercator.R);
  		return toTransformation(scale, 0.5, -scale, 0.5);
  	}())
  });

  /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */

  var EPSG4326 = extend({}, Earth, {
  	code: 'EPSG:4326',
  	projection: LonLat,
  	transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
  });

  /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */

  var Simple = extend({}, CRS, {
  	projection: LonLat,
  	transformation: toTransformation(1, 0, -1, 0),

  	scale: function (zoom) {
  		return Math.pow(2, zoom);
  	},

  	zoom: function (scale) {
  		return Math.log(scale) / Math.LN2;
  	},

  	distance: function (latlng1, latlng2) {
  		var dx = latlng2.lng - latlng1.lng,
  		    dy = latlng2.lat - latlng1.lat;

  		return Math.sqrt(dx * dx + dy * dy);
  	},

  	infinite: true
  });

  CRS.Earth = Earth;
  CRS.EPSG3395 = EPSG3395;
  CRS.EPSG3857 = EPSG3857;
  CRS.EPSG900913 = EPSG900913;
  CRS.EPSG4326 = EPSG4326;
  CRS.Simple = Simple;

  /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */


  var Layer = Evented.extend({

  	// Classes extending `L.Layer` will inherit the following options:
  	options: {
  		// @option pane: String = 'overlayPane'
  		// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
  		pane: 'overlayPane',

  		// @option attribution: String = null
  		// String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
  		attribution: null,

  		bubblingMouseEvents: true
  	},

  	/* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */
  	addTo: function (map) {
  		map.addLayer(this);
  		return this;
  	},

  	// @method remove: this
  	// Removes the layer from the map it is currently active on.
  	remove: function () {
  		return this.removeFrom(this._map || this._mapToAdd);
  	},

  	// @method removeFrom(map: Map): this
  	// Removes the layer from the given map
  	//
  	// @alternative
  	// @method removeFrom(group: LayerGroup): this
  	// Removes the layer from the given `LayerGroup`
  	removeFrom: function (obj) {
  		if (obj) {
  			obj.removeLayer(this);
  		}
  		return this;
  	},

  	// @method getPane(name? : String): HTMLElement
  	// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
  	getPane: function (name) {
  		return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
  	},

  	addInteractiveTarget: function (targetEl) {
  		this._map._targets[stamp(targetEl)] = this;
  		return this;
  	},

  	removeInteractiveTarget: function (targetEl) {
  		delete this._map._targets[stamp(targetEl)];
  		return this;
  	},

  	// @method getAttribution: String
  	// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
  	getAttribution: function () {
  		return this.options.attribution;
  	},

  	_layerAdd: function (e) {
  		var map = e.target;

  		// check in case layer gets added and then removed before the map is ready
  		if (!map.hasLayer(this)) { return; }

  		this._map = map;
  		this._zoomAnimated = map._zoomAnimated;

  		if (this.getEvents) {
  			var events = this.getEvents();
  			map.on(events, this);
  			this.once('remove', function () {
  				map.off(events, this);
  			}, this);
  		}

  		this.onAdd(map);

  		if (this.getAttribution && map.attributionControl) {
  			map.attributionControl.addAttribution(this.getAttribution());
  		}

  		this.fire('add');
  		map.fire('layeradd', {layer: this});
  	}
  });

  /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */


  /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */
  Map.include({
  	// @method addLayer(layer: Layer): this
  	// Adds the given layer to the map
  	addLayer: function (layer) {
  		if (!layer._layerAdd) {
  			throw new Error('The provided object is not a Layer.');
  		}

  		var id = stamp(layer);
  		if (this._layers[id]) { return this; }
  		this._layers[id] = layer;

  		layer._mapToAdd = this;

  		if (layer.beforeAdd) {
  			layer.beforeAdd(this);
  		}

  		this.whenReady(layer._layerAdd, layer);

  		return this;
  	},

  	// @method removeLayer(layer: Layer): this
  	// Removes the given layer from the map.
  	removeLayer: function (layer) {
  		var id = stamp(layer);

  		if (!this._layers[id]) { return this; }

  		if (this._loaded) {
  			layer.onRemove(this);
  		}

  		if (layer.getAttribution && this.attributionControl) {
  			this.attributionControl.removeAttribution(layer.getAttribution());
  		}

  		delete this._layers[id];

  		if (this._loaded) {
  			this.fire('layerremove', {layer: layer});
  			layer.fire('remove');
  		}

  		layer._map = layer._mapToAdd = null;

  		return this;
  	},

  	// @method hasLayer(layer: Layer): Boolean
  	// Returns `true` if the given layer is currently added to the map
  	hasLayer: function (layer) {
  		return !!layer && (stamp(layer) in this._layers);
  	},

  	/* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */
  	eachLayer: function (method, context) {
  		for (var i in this._layers) {
  			method.call(context, this._layers[i]);
  		}
  		return this;
  	},

  	_addLayers: function (layers) {
  		layers = layers ? (isArray(layers) ? layers : [layers]) : [];

  		for (var i = 0, len = layers.length; i < len; i++) {
  			this.addLayer(layers[i]);
  		}
  	},

  	_addZoomLimit: function (layer) {
  		if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
  			this._zoomBoundLayers[stamp(layer)] = layer;
  			this._updateZoomLevels();
  		}
  	},

  	_removeZoomLimit: function (layer) {
  		var id = stamp(layer);

  		if (this._zoomBoundLayers[id]) {
  			delete this._zoomBoundLayers[id];
  			this._updateZoomLevels();
  		}
  	},

  	_updateZoomLevels: function () {
  		var minZoom = Infinity,
  		    maxZoom = -Infinity,
  		    oldZoomSpan = this._getZoomSpan();

  		for (var i in this._zoomBoundLayers) {
  			var options = this._zoomBoundLayers[i].options;

  			minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
  			maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
  		}

  		this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
  		this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;

  		// @section Map state change events
  		// @event zoomlevelschange: Event
  		// Fired when the number of zoomlevels on the map is changed due
  		// to adding or removing a layer.
  		if (oldZoomSpan !== this._getZoomSpan()) {
  			this.fire('zoomlevelschange');
  		}

  		if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
  			this.setZoom(this._layersMaxZoom);
  		}
  		if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
  			this.setZoom(this._layersMinZoom);
  		}
  	}
  });

  /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */

  var LayerGroup = Layer.extend({

  	initialize: function (layers, options) {
  		setOptions(this, options);

  		this._layers = {};

  		var i, len;

  		if (layers) {
  			for (i = 0, len = layers.length; i < len; i++) {
  				this.addLayer(layers[i]);
  			}
  		}
  	},

  	// @method addLayer(layer: Layer): this
  	// Adds the given layer to the group.
  	addLayer: function (layer) {
  		var id = this.getLayerId(layer);

  		this._layers[id] = layer;

  		if (this._map) {
  			this._map.addLayer(layer);
  		}

  		return this;
  	},

  	// @method removeLayer(layer: Layer): this
  	// Removes the given layer from the group.
  	// @alternative
  	// @method removeLayer(id: Number): this
  	// Removes the layer with the given internal ID from the group.
  	removeLayer: function (layer) {
  		var id = layer in this._layers ? layer : this.getLayerId(layer);

  		if (this._map && this._layers[id]) {
  			this._map.removeLayer(this._layers[id]);
  		}

  		delete this._layers[id];

  		return this;
  	},

  	// @method hasLayer(layer: Layer): Boolean
  	// Returns `true` if the given layer is currently added to the group.
  	// @alternative
  	// @method hasLayer(id: Number): Boolean
  	// Returns `true` if the given internal ID is currently added to the group.
  	hasLayer: function (layer) {
  		if (!layer) { return false; }
  		var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
  		return layerId in this._layers;
  	},

  	// @method clearLayers(): this
  	// Removes all the layers from the group.
  	clearLayers: function () {
  		return this.eachLayer(this.removeLayer, this);
  	},

  	// @method invoke(methodName: String, …): this
  	// Calls `methodName` on every layer contained in this group, passing any
  	// additional parameters. Has no effect if the layers contained do not
  	// implement `methodName`.
  	invoke: function (methodName) {
  		var args = Array.prototype.slice.call(arguments, 1),
  		    i, layer;

  		for (i in this._layers) {
  			layer = this._layers[i];

  			if (layer[methodName]) {
  				layer[methodName].apply(layer, args);
  			}
  		}

  		return this;
  	},

  	onAdd: function (map) {
  		this.eachLayer(map.addLayer, map);
  	},

  	onRemove: function (map) {
  		this.eachLayer(map.removeLayer, map);
  	},

  	// @method eachLayer(fn: Function, context?: Object): this
  	// Iterates over the layers of the group, optionally specifying context of the iterator function.
  	// ```js
  	// group.eachLayer(function (layer) {
  	// 	layer.bindPopup('Hello');
  	// });
  	// ```
  	eachLayer: function (method, context) {
  		for (var i in this._layers) {
  			method.call(context, this._layers[i]);
  		}
  		return this;
  	},

  	// @method getLayer(id: Number): Layer
  	// Returns the layer with the given internal ID.
  	getLayer: function (id) {
  		return this._layers[id];
  	},

  	// @method getLayers(): Layer[]
  	// Returns an array of all the layers added to the group.
  	getLayers: function () {
  		var layers = [];
  		this.eachLayer(layers.push, layers);
  		return layers;
  	},

  	// @method setZIndex(zIndex: Number): this
  	// Calls `setZIndex` on every layer contained in this group, passing the z-index.
  	setZIndex: function (zIndex) {
  		return this.invoke('setZIndex', zIndex);
  	},

  	// @method getLayerId(layer: Layer): Number
  	// Returns the internal ID for a layer
  	getLayerId: function (layer) {
  		return stamp(layer);
  	}
  });


  // @factory L.layerGroup(layers?: Layer[], options?: Object)
  // Create a layer group, optionally given an initial set of layers and an `options` object.
  var layerGroup = function (layers, options) {
  	return new LayerGroup(layers, options);
  };

  /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */

  var FeatureGroup = LayerGroup.extend({

  	addLayer: function (layer) {
  		if (this.hasLayer(layer)) {
  			return this;
  		}

  		layer.addEventParent(this);

  		LayerGroup.prototype.addLayer.call(this, layer);

  		// @event layeradd: LayerEvent
  		// Fired when a layer is added to this `FeatureGroup`
  		return this.fire('layeradd', {layer: layer});
  	},

  	removeLayer: function (layer) {
  		if (!this.hasLayer(layer)) {
  			return this;
  		}
  		if (layer in this._layers) {
  			layer = this._layers[layer];
  		}

  		layer.removeEventParent(this);

  		LayerGroup.prototype.removeLayer.call(this, layer);

  		// @event layerremove: LayerEvent
  		// Fired when a layer is removed from this `FeatureGroup`
  		return this.fire('layerremove', {layer: layer});
  	},

  	// @method setStyle(style: Path options): this
  	// Sets the given path options to each layer of the group that has a `setStyle` method.
  	setStyle: function (style) {
  		return this.invoke('setStyle', style);
  	},

  	// @method bringToFront(): this
  	// Brings the layer group to the top of all other layers
  	bringToFront: function () {
  		return this.invoke('bringToFront');
  	},

  	// @method bringToBack(): this
  	// Brings the layer group to the back of all other layers
  	bringToBack: function () {
  		return this.invoke('bringToBack');
  	},

  	// @method getBounds(): LatLngBounds
  	// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
  	getBounds: function () {
  		var bounds = new LatLngBounds();

  		for (var id in this._layers) {
  			var layer = this._layers[id];
  			bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
  		}
  		return bounds;
  	}
  });

  // @factory L.featureGroup(layers?: Layer[], options?: Object)
  // Create a feature group, optionally given an initial set of layers and an `options` object.
  var featureGroup = function (layers, options) {
  	return new FeatureGroup(layers, options);
  };

  /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */

  var Icon = Class.extend({

  	/* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */

  	options: {
  		popupAnchor: [0, 0],
  		tooltipAnchor: [0, 0]
  	},

  	initialize: function (options) {
  		setOptions(this, options);
  	},

  	// @method createIcon(oldIcon?: HTMLElement): HTMLElement
  	// Called internally when the icon has to be shown, returns a `<img>` HTML element
  	// styled according to the options.
  	createIcon: function (oldIcon) {
  		return this._createIcon('icon', oldIcon);
  	},

  	// @method createShadow(oldIcon?: HTMLElement): HTMLElement
  	// As `createIcon`, but for the shadow beneath it.
  	createShadow: function (oldIcon) {
  		return this._createIcon('shadow', oldIcon);
  	},

  	_createIcon: function (name, oldIcon) {
  		var src = this._getIconUrl(name);

  		if (!src) {
  			if (name === 'icon') {
  				throw new Error('iconUrl not set in Icon options (see the docs).');
  			}
  			return null;
  		}

  		var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
  		this._setIconStyles(img, name);

  		return img;
  	},

  	_setIconStyles: function (img, name) {
  		var options = this.options;
  		var sizeOption = options[name + 'Size'];

  		if (typeof sizeOption === 'number') {
  			sizeOption = [sizeOption, sizeOption];
  		}

  		var size = toPoint(sizeOption),
  		    anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
  		            size && size.divideBy(2, true));

  		img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');

  		if (anchor) {
  			img.style.marginLeft = (-anchor.x) + 'px';
  			img.style.marginTop  = (-anchor.y) + 'px';
  		}

  		if (size) {
  			img.style.width  = size.x + 'px';
  			img.style.height = size.y + 'px';
  		}
  	},

  	_createImg: function (src, el) {
  		el = el || document.createElement('img');
  		el.src = src;
  		return el;
  	},

  	_getIconUrl: function (name) {
  		return retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
  	}
  });


  // @factory L.icon(options: Icon options)
  // Creates an icon instance with the given options.
  function icon(options) {
  	return new Icon(options);
  }

  /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */

  var IconDefault = Icon.extend({

  	options: {
  		iconUrl:       'marker-icon.png',
  		iconRetinaUrl: 'marker-icon-2x.png',
  		shadowUrl:     'marker-shadow.png',
  		iconSize:    [25, 41],
  		iconAnchor:  [12, 41],
  		popupAnchor: [1, -34],
  		tooltipAnchor: [16, -28],
  		shadowSize:  [41, 41]
  	},

  	_getIconUrl: function (name) {
  		if (!IconDefault.imagePath) {	// Deprecated, backwards-compatibility only
  			IconDefault.imagePath = this._detectIconPath();
  		}

  		// @option imagePath: String
  		// `Icon.Default` will try to auto-detect the location of the
  		// blue icon images. If you are placing these images in a non-standard
  		// way, set this option to point to the right path.
  		return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
  	},

  	_detectIconPath: function () {
  		var el = create$1('div',  'leaflet-default-icon-path', document.body);
  		var path = getStyle(el, 'background-image') ||
  		           getStyle(el, 'backgroundImage');	// IE8

  		document.body.removeChild(el);

  		if (path === null || path.indexOf('url') !== 0) {
  			path = '';
  		} else {
  			path = path.replace(/^url\(["']?/, '').replace(/marker-icon\.png["']?\)$/, '');
  		}

  		return path;
  	}
  });

  /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */


  /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */

  var MarkerDrag = Handler.extend({
  	initialize: function (marker) {
  		this._marker = marker;
  	},

  	addHooks: function () {
  		var icon = this._marker._icon;

  		if (!this._draggable) {
  			this._draggable = new Draggable(icon, icon, true);
  		}

  		this._draggable.on({
  			dragstart: this._onDragStart,
  			predrag: this._onPreDrag,
  			drag: this._onDrag,
  			dragend: this._onDragEnd
  		}, this).enable();

  		addClass(icon, 'leaflet-marker-draggable');
  	},

  	removeHooks: function () {
  		this._draggable.off({
  			dragstart: this._onDragStart,
  			predrag: this._onPreDrag,
  			drag: this._onDrag,
  			dragend: this._onDragEnd
  		}, this).disable();

  		if (this._marker._icon) {
  			removeClass(this._marker._icon, 'leaflet-marker-draggable');
  		}
  	},

  	moved: function () {
  		return this._draggable && this._draggable._moved;
  	},

  	_adjustPan: function (e) {
  		var marker = this._marker,
  		    map = marker._map,
  		    speed = this._marker.options.autoPanSpeed,
  		    padding = this._marker.options.autoPanPadding,
  		    iconPos = getPosition(marker._icon),
  		    bounds = map.getPixelBounds(),
  		    origin = map.getPixelOrigin();

  		var panBounds = toBounds(
  			bounds.min._subtract(origin).add(padding),
  			bounds.max._subtract(origin).subtract(padding)
  		);

  		if (!panBounds.contains(iconPos)) {
  			// Compute incremental movement
  			var movement = toPoint(
  				(Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) -
  				(Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x),

  				(Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) -
  				(Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)
  			).multiplyBy(speed);

  			map.panBy(movement, {animate: false});

  			this._draggable._newPos._add(movement);
  			this._draggable._startPos._add(movement);

  			setPosition(marker._icon, this._draggable._newPos);
  			this._onDrag(e);

  			this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
  		}
  	},

  	_onDragStart: function () {
  		// @section Dragging events
  		// @event dragstart: Event
  		// Fired when the user starts dragging the marker.

  		// @event movestart: Event
  		// Fired when the marker starts moving (because of dragging).

  		this._oldLatLng = this._marker.getLatLng();

  		// When using ES6 imports it could not be set when `Popup` was not imported as well
  		this._marker.closePopup && this._marker.closePopup();

  		this._marker
  			.fire('movestart')
  			.fire('dragstart');
  	},

  	_onPreDrag: function (e) {
  		if (this._marker.options.autoPan) {
  			cancelAnimFrame(this._panRequest);
  			this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
  		}
  	},

  	_onDrag: function (e) {
  		var marker = this._marker,
  		    shadow = marker._shadow,
  		    iconPos = getPosition(marker._icon),
  		    latlng = marker._map.layerPointToLatLng(iconPos);

  		// update shadow position
  		if (shadow) {
  			setPosition(shadow, iconPos);
  		}

  		marker._latlng = latlng;
  		e.latlng = latlng;
  		e.oldLatLng = this._oldLatLng;

  		// @event drag: Event
  		// Fired repeatedly while the user drags the marker.
  		marker
  		    .fire('move', e)
  		    .fire('drag', e);
  	},

  	_onDragEnd: function (e) {
  		// @event dragend: DragEndEvent
  		// Fired when the user stops dragging the marker.

  		 cancelAnimFrame(this._panRequest);

  		// @event moveend: Event
  		// Fired when the marker stops moving (because of dragging).
  		delete this._oldLatLng;
  		this._marker
  		    .fire('moveend')
  		    .fire('dragend', e);
  	}
  });

  /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */

  var Marker = Layer.extend({

  	// @section
  	// @aka Marker options
  	options: {
  		// @option icon: Icon = *
  		// Icon instance to use for rendering the marker.
  		// See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
  		// If not specified, a common instance of `L.Icon.Default` is used.
  		icon: new IconDefault(),

  		// Option inherited from "Interactive layer" abstract class
  		interactive: true,

  		// @option keyboard: Boolean = true
  		// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
  		keyboard: true,

  		// @option title: String = ''
  		// Text for the browser tooltip that appear on marker hover (no tooltip by default).
  		title: '',

  		// @option alt: String = ''
  		// Text for the `alt` attribute of the icon image (useful for accessibility).
  		alt: '',

  		// @option zIndexOffset: Number = 0
  		// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
  		zIndexOffset: 0,

  		// @option opacity: Number = 1.0
  		// The opacity of the marker.
  		opacity: 1,

  		// @option riseOnHover: Boolean = false
  		// If `true`, the marker will get on top of others when you hover the mouse over it.
  		riseOnHover: false,

  		// @option riseOffset: Number = 250
  		// The z-index offset used for the `riseOnHover` feature.
  		riseOffset: 250,

  		// @option pane: String = 'markerPane'
  		// `Map pane` where the markers icon will be added.
  		pane: 'markerPane',

  		// @option shadowPane: String = 'shadowPane'
  		// `Map pane` where the markers shadow will be added.
  		shadowPane: 'shadowPane',

  		// @option bubblingMouseEvents: Boolean = false
  		// When `true`, a mouse event on this marker will trigger the same event on the map
  		// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
  		bubblingMouseEvents: false,

  		// @section Draggable marker options
  		// @option draggable: Boolean = false
  		// Whether the marker is draggable with mouse/touch or not.
  		draggable: false,

  		// @option autoPan: Boolean = false
  		// Whether to pan the map when dragging this marker near its edge or not.
  		autoPan: false,

  		// @option autoPanPadding: Point = Point(50, 50)
  		// Distance (in pixels to the left/right and to the top/bottom) of the
  		// map edge to start panning the map.
  		autoPanPadding: [50, 50],

  		// @option autoPanSpeed: Number = 10
  		// Number of pixels the map should pan by.
  		autoPanSpeed: 10
  	},

  	/* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */

  	initialize: function (latlng, options) {
  		setOptions(this, options);
  		this._latlng = toLatLng(latlng);
  	},

  	onAdd: function (map) {
  		this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;

  		if (this._zoomAnimated) {
  			map.on('zoomanim', this._animateZoom, this);
  		}

  		this._initIcon();
  		this.update();
  	},

  	onRemove: function (map) {
  		if (this.dragging && this.dragging.enabled()) {
  			this.options.draggable = true;
  			this.dragging.removeHooks();
  		}
  		delete this.dragging;

  		if (this._zoomAnimated) {
  			map.off('zoomanim', this._animateZoom, this);
  		}

  		this._removeIcon();
  		this._removeShadow();
  	},

  	getEvents: function () {
  		return {
  			zoom: this.update,
  			viewreset: this.update
  		};
  	},

  	// @method getLatLng: LatLng
  	// Returns the current geographical position of the marker.
  	getLatLng: function () {
  		return this._latlng;
  	},

  	// @method setLatLng(latlng: LatLng): this
  	// Changes the marker position to the given point.
  	setLatLng: function (latlng) {
  		var oldLatLng = this._latlng;
  		this._latlng = toLatLng(latlng);
  		this.update();

  		// @event move: Event
  		// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
  		return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
  	},

  	// @method setZIndexOffset(offset: Number): this
  	// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
  	setZIndexOffset: function (offset) {
  		this.options.zIndexOffset = offset;
  		return this.update();
  	},

  	// @method getIcon: Icon
  	// Returns the current icon used by the marker
  	getIcon: function () {
  		return this.options.icon;
  	},

  	// @method setIcon(icon: Icon): this
  	// Changes the marker icon.
  	setIcon: function (icon) {

  		this.options.icon = icon;

  		if (this._map) {
  			this._initIcon();
  			this.update();
  		}

  		if (this._popup) {
  			this.bindPopup(this._popup, this._popup.options);
  		}

  		return this;
  	},

  	getElement: function () {
  		return this._icon;
  	},

  	update: function () {

  		if (this._icon && this._map) {
  			var pos = this._map.latLngToLayerPoint(this._latlng).round();
  			this._setPos(pos);
  		}

  		return this;
  	},

  	_initIcon: function () {
  		var options = this.options,
  		    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');

  		var icon = options.icon.createIcon(this._icon),
  		    addIcon = false;

  		// if we're not reusing the icon, remove the old one and init new one
  		if (icon !== this._icon) {
  			if (this._icon) {
  				this._removeIcon();
  			}
  			addIcon = true;

  			if (options.title) {
  				icon.title = options.title;
  			}

  			if (icon.tagName === 'IMG') {
  				icon.alt = options.alt || '';
  			}
  		}

  		addClass(icon, classToAdd);

  		if (options.keyboard) {
  			icon.tabIndex = '0';
  		}

  		this._icon = icon;

  		if (options.riseOnHover) {
  			this.on({
  				mouseover: this._bringToFront,
  				mouseout: this._resetZIndex
  			});
  		}

  		var newShadow = options.icon.createShadow(this._shadow),
  		    addShadow = false;

  		if (newShadow !== this._shadow) {
  			this._removeShadow();
  			addShadow = true;
  		}

  		if (newShadow) {
  			addClass(newShadow, classToAdd);
  			newShadow.alt = '';
  		}
  		this._shadow = newShadow;


  		if (options.opacity < 1) {
  			this._updateOpacity();
  		}


  		if (addIcon) {
  			this.getPane().appendChild(this._icon);
  		}
  		this._initInteraction();
  		if (newShadow && addShadow) {
  			this.getPane(options.shadowPane).appendChild(this._shadow);
  		}
  	},

  	_removeIcon: function () {
  		if (this.options.riseOnHover) {
  			this.off({
  				mouseover: this._bringToFront,
  				mouseout: this._resetZIndex
  			});
  		}

  		remove(this._icon);
  		this.removeInteractiveTarget(this._icon);

  		this._icon = null;
  	},

  	_removeShadow: function () {
  		if (this._shadow) {
  			remove(this._shadow);
  		}
  		this._shadow = null;
  	},

  	_setPos: function (pos) {

  		if (this._icon) {
  			setPosition(this._icon, pos);
  		}

  		if (this._shadow) {
  			setPosition(this._shadow, pos);
  		}

  		this._zIndex = pos.y + this.options.zIndexOffset;

  		this._resetZIndex();
  	},

  	_updateZIndex: function (offset) {
  		if (this._icon) {
  			this._icon.style.zIndex = this._zIndex + offset;
  		}
  	},

  	_animateZoom: function (opt) {
  		var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();

  		this._setPos(pos);
  	},

  	_initInteraction: function () {

  		if (!this.options.interactive) { return; }

  		addClass(this._icon, 'leaflet-interactive');

  		this.addInteractiveTarget(this._icon);

  		if (MarkerDrag) {
  			var draggable = this.options.draggable;
  			if (this.dragging) {
  				draggable = this.dragging.enabled();
  				this.dragging.disable();
  			}

  			this.dragging = new MarkerDrag(this);

  			if (draggable) {
  				this.dragging.enable();
  			}
  		}
  	},

  	// @method setOpacity(opacity: Number): this
  	// Changes the opacity of the marker.
  	setOpacity: function (opacity) {
  		this.options.opacity = opacity;
  		if (this._map) {
  			this._updateOpacity();
  		}

  		return this;
  	},

  	_updateOpacity: function () {
  		var opacity = this.options.opacity;

  		if (this._icon) {
  			setOpacity(this._icon, opacity);
  		}

  		if (this._shadow) {
  			setOpacity(this._shadow, opacity);
  		}
  	},

  	_bringToFront: function () {
  		this._updateZIndex(this.options.riseOffset);
  	},

  	_resetZIndex: function () {
  		this._updateZIndex(0);
  	},

  	_getPopupAnchor: function () {
  		return this.options.icon.options.popupAnchor;
  	},

  	_getTooltipAnchor: function () {
  		return this.options.icon.options.tooltipAnchor;
  	}
  });


  // factory L.marker(latlng: LatLng, options? : Marker options)

  // @factory L.marker(latlng: LatLng, options? : Marker options)
  // Instantiates a Marker object given a geographical point and optionally an options object.
  function marker(latlng, options) {
  	return new Marker(latlng, options);
  }

  /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */

  var Path = Layer.extend({

  	// @section
  	// @aka Path options
  	options: {
  		// @option stroke: Boolean = true
  		// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
  		stroke: true,

  		// @option color: String = '#3388ff'
  		// Stroke color
  		color: '#3388ff',

  		// @option weight: Number = 3
  		// Stroke width in pixels
  		weight: 3,

  		// @option opacity: Number = 1.0
  		// Stroke opacity
  		opacity: 1,

  		// @option lineCap: String= 'round'
  		// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
  		lineCap: 'round',

  		// @option lineJoin: String = 'round'
  		// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
  		lineJoin: 'round',

  		// @option dashArray: String = null
  		// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
  		dashArray: null,

  		// @option dashOffset: String = null
  		// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
  		dashOffset: null,

  		// @option fill: Boolean = depends
  		// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
  		fill: false,

  		// @option fillColor: String = *
  		// Fill color. Defaults to the value of the [`color`](#path-color) option
  		fillColor: null,

  		// @option fillOpacity: Number = 0.2
  		// Fill opacity.
  		fillOpacity: 0.2,

  		// @option fillRule: String = 'evenodd'
  		// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
  		fillRule: 'evenodd',

  		// className: '',

  		// Option inherited from "Interactive layer" abstract class
  		interactive: true,

  		// @option bubblingMouseEvents: Boolean = true
  		// When `true`, a mouse event on this path will trigger the same event on the map
  		// (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
  		bubblingMouseEvents: true
  	},

  	beforeAdd: function (map) {
  		// Renderer is set here because we need to call renderer.getEvents
  		// before this.getEvents.
  		this._renderer = map.getRenderer(this);
  	},

  	onAdd: function () {
  		this._renderer._initPath(this);
  		this._reset();
  		this._renderer._addPath(this);
  	},

  	onRemove: function () {
  		this._renderer._removePath(this);
  	},

  	// @method redraw(): this
  	// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
  	redraw: function () {
  		if (this._map) {
  			this._renderer._updatePath(this);
  		}
  		return this;
  	},

  	// @method setStyle(style: Path options): this
  	// Changes the appearance of a Path based on the options in the `Path options` object.
  	setStyle: function (style) {
  		setOptions(this, style);
  		if (this._renderer) {
  			this._renderer._updateStyle(this);
  			if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) {
  				this._updateBounds();
  			}
  		}
  		return this;
  	},

  	// @method bringToFront(): this
  	// Brings the layer to the top of all path layers.
  	bringToFront: function () {
  		if (this._renderer) {
  			this._renderer._bringToFront(this);
  		}
  		return this;
  	},

  	// @method bringToBack(): this
  	// Brings the layer to the bottom of all path layers.
  	bringToBack: function () {
  		if (this._renderer) {
  			this._renderer._bringToBack(this);
  		}
  		return this;
  	},

  	getElement: function () {
  		return this._path;
  	},

  	_reset: function () {
  		// defined in child classes
  		this._project();
  		this._update();
  	},

  	_clickTolerance: function () {
  		// used when doing hit detection for Canvas layers
  		return (this.options.stroke ? this.options.weight / 2 : 0) + this._renderer.options.tolerance;
  	}
  });

  /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */

  var CircleMarker = Path.extend({

  	// @section
  	// @aka CircleMarker options
  	options: {
  		fill: true,

  		// @option radius: Number = 10
  		// Radius of the circle marker, in pixels
  		radius: 10
  	},

  	initialize: function (latlng, options) {
  		setOptions(this, options);
  		this._latlng = toLatLng(latlng);
  		this._radius = this.options.radius;
  	},

  	// @method setLatLng(latLng: LatLng): this
  	// Sets the position of a circle marker to a new location.
  	setLatLng: function (latlng) {
  		var oldLatLng = this._latlng;
  		this._latlng = toLatLng(latlng);
  		this.redraw();

  		// @event move: Event
  		// Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
  		return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
  	},

  	// @method getLatLng(): LatLng
  	// Returns the current geographical position of the circle marker
  	getLatLng: function () {
  		return this._latlng;
  	},

  	// @method setRadius(radius: Number): this
  	// Sets the radius of a circle marker. Units are in pixels.
  	setRadius: function (radius) {
  		this.options.radius = this._radius = radius;
  		return this.redraw();
  	},

  	// @method getRadius(): Number
  	// Returns the current radius of the circle
  	getRadius: function () {
  		return this._radius;
  	},

  	setStyle : function (options) {
  		var radius = options && options.radius || this._radius;
  		Path.prototype.setStyle.call(this, options);
  		this.setRadius(radius);
  		return this;
  	},

  	_project: function () {
  		this._point = this._map.latLngToLayerPoint(this._latlng);
  		this._updateBounds();
  	},

  	_updateBounds: function () {
  		var r = this._radius,
  		    r2 = this._radiusY || r,
  		    w = this._clickTolerance(),
  		    p = [r + w, r2 + w];
  		this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
  	},

  	_update: function () {
  		if (this._map) {
  			this._updatePath();
  		}
  	},

  	_updatePath: function () {
  		this._renderer._updateCircle(this);
  	},

  	_empty: function () {
  		return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
  	},

  	// Needed by the `Canvas` renderer for interactivity
  	_containsPoint: function (p) {
  		return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
  	}
  });


  // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
  // Instantiates a circle marker object given a geographical point, and an optional options object.
  function circleMarker(latlng, options) {
  	return new CircleMarker(latlng, options);
  }

  /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */

  var Circle = CircleMarker.extend({

  	initialize: function (latlng, options, legacyOptions) {
  		if (typeof options === 'number') {
  			// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
  			options = extend({}, legacyOptions, {radius: options});
  		}
  		setOptions(this, options);
  		this._latlng = toLatLng(latlng);

  		if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }

  		// @section
  		// @aka Circle options
  		// @option radius: Number; Radius of the circle, in meters.
  		this._mRadius = this.options.radius;
  	},

  	// @method setRadius(radius: Number): this
  	// Sets the radius of a circle. Units are in meters.
  	setRadius: function (radius) {
  		this._mRadius = radius;
  		return this.redraw();
  	},

  	// @method getRadius(): Number
  	// Returns the current radius of a circle. Units are in meters.
  	getRadius: function () {
  		return this._mRadius;
  	},

  	// @method getBounds(): LatLngBounds
  	// Returns the `LatLngBounds` of the path.
  	getBounds: function () {
  		var half = [this._radius, this._radiusY || this._radius];

  		return new LatLngBounds(
  			this._map.layerPointToLatLng(this._point.subtract(half)),
  			this._map.layerPointToLatLng(this._point.add(half)));
  	},

  	setStyle: Path.prototype.setStyle,

  	_project: function () {

  		var lng = this._latlng.lng,
  		    lat = this._latlng.lat,
  		    map = this._map,
  		    crs = map.options.crs;

  		if (crs.distance === Earth.distance) {
  			var d = Math.PI / 180,
  			    latR = (this._mRadius / Earth.R) / d,
  			    top = map.project([lat + latR, lng]),
  			    bottom = map.project([lat - latR, lng]),
  			    p = top.add(bottom).divideBy(2),
  			    lat2 = map.unproject(p).lat,
  			    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
  			            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;

  			if (isNaN(lngR) || lngR === 0) {
  				lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
  			}

  			this._point = p.subtract(map.getPixelOrigin());
  			this._radius = isNaN(lngR) ? 0 : p.x - map.project([lat2, lng - lngR]).x;
  			this._radiusY = p.y - top.y;

  		} else {
  			var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));

  			this._point = map.latLngToLayerPoint(this._latlng);
  			this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
  		}

  		this._updateBounds();
  	}
  });

  // @factory L.circle(latlng: LatLng, options?: Circle options)
  // Instantiates a circle object given a geographical point, and an options object
  // which contains the circle radius.
  // @alternative
  // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
  // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
  // Do not use in new applications or plugins.
  function circle(latlng, options, legacyOptions) {
  	return new Circle(latlng, options, legacyOptions);
  }

  /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */


  var Polyline = Path.extend({

  	// @section
  	// @aka Polyline options
  	options: {
  		// @option smoothFactor: Number = 1.0
  		// How much to simplify the polyline on each zoom level. More means
  		// better performance and smoother look, and less means more accurate representation.
  		smoothFactor: 1.0,

  		// @option noClip: Boolean = false
  		// Disable polyline clipping.
  		noClip: false
  	},

  	initialize: function (latlngs, options) {
  		setOptions(this, options);
  		this._setLatLngs(latlngs);
  	},

  	// @method getLatLngs(): LatLng[]
  	// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
  	getLatLngs: function () {
  		return this._latlngs;
  	},

  	// @method setLatLngs(latlngs: LatLng[]): this
  	// Replaces all the points in the polyline with the given array of geographical points.
  	setLatLngs: function (latlngs) {
  		this._setLatLngs(latlngs);
  		return this.redraw();
  	},

  	// @method isEmpty(): Boolean
  	// Returns `true` if the Polyline has no LatLngs.
  	isEmpty: function () {
  		return !this._latlngs.length;
  	},

  	// @method closestLayerPoint(p: Point): Point
  	// Returns the point closest to `p` on the Polyline.
  	closestLayerPoint: function (p) {
  		var minDistance = Infinity,
  		    minPoint = null,
  		    closest = _sqClosestPointOnSegment,
  		    p1, p2;

  		for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
  			var points = this._parts[j];

  			for (var i = 1, len = points.length; i < len; i++) {
  				p1 = points[i - 1];
  				p2 = points[i];

  				var sqDist = closest(p, p1, p2, true);

  				if (sqDist < minDistance) {
  					minDistance = sqDist;
  					minPoint = closest(p, p1, p2);
  				}
  			}
  		}
  		if (minPoint) {
  			minPoint.distance = Math.sqrt(minDistance);
  		}
  		return minPoint;
  	},

  	// @method getCenter(): LatLng
  	// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
  	getCenter: function () {
  		// throws error when not yet added to map as this center calculation requires projected coordinates
  		if (!this._map) {
  			throw new Error('Must add layer to map before using getCenter()');
  		}

  		var i, halfDist, segDist, dist, p1, p2, ratio,
  		    points = this._rings[0],
  		    len = points.length;

  		if (!len) { return null; }

  		// polyline centroid algorithm; only uses the first ring if there are multiple

  		for (i = 0, halfDist = 0; i < len - 1; i++) {
  			halfDist += points[i].distanceTo(points[i + 1]) / 2;
  		}

  		// The line is so small in the current view that all points are on the same pixel.
  		if (halfDist === 0) {
  			return this._map.layerPointToLatLng(points[0]);
  		}

  		for (i = 0, dist = 0; i < len - 1; i++) {
  			p1 = points[i];
  			p2 = points[i + 1];
  			segDist = p1.distanceTo(p2);
  			dist += segDist;

  			if (dist > halfDist) {
  				ratio = (dist - halfDist) / segDist;
  				return this._map.layerPointToLatLng([
  					p2.x - ratio * (p2.x - p1.x),
  					p2.y - ratio * (p2.y - p1.y)
  				]);
  			}
  		}
  	},

  	// @method getBounds(): LatLngBounds
  	// Returns the `LatLngBounds` of the path.
  	getBounds: function () {
  		return this._bounds;
  	},

  	// @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
  	// Adds a given point to the polyline. By default, adds to the first ring of
  	// the polyline in case of a multi-polyline, but can be overridden by passing
  	// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
  	addLatLng: function (latlng, latlngs) {
  		latlngs = latlngs || this._defaultShape();
  		latlng = toLatLng(latlng);
  		latlngs.push(latlng);
  		this._bounds.extend(latlng);
  		return this.redraw();
  	},

  	_setLatLngs: function (latlngs) {
  		this._bounds = new LatLngBounds();
  		this._latlngs = this._convertLatLngs(latlngs);
  	},

  	_defaultShape: function () {
  		return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
  	},

  	// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
  	_convertLatLngs: function (latlngs) {
  		var result = [],
  		    flat = isFlat(latlngs);

  		for (var i = 0, len = latlngs.length; i < len; i++) {
  			if (flat) {
  				result[i] = toLatLng(latlngs[i]);
  				this._bounds.extend(result[i]);
  			} else {
  				result[i] = this._convertLatLngs(latlngs[i]);
  			}
  		}

  		return result;
  	},

  	_project: function () {
  		var pxBounds = new Bounds();
  		this._rings = [];
  		this._projectLatlngs(this._latlngs, this._rings, pxBounds);

  		if (this._bounds.isValid() && pxBounds.isValid()) {
  			this._rawPxBounds = pxBounds;
  			this._updateBounds();
  		}
  	},

  	_updateBounds: function () {
  		var w = this._clickTolerance(),
  		    p = new Point(w, w);
  		this._pxBounds = new Bounds([
  			this._rawPxBounds.min.subtract(p),
  			this._rawPxBounds.max.add(p)
  		]);
  	},

  	// recursively turns latlngs into a set of rings with projected coordinates
  	_projectLatlngs: function (latlngs, result, projectedBounds) {
  		var flat = latlngs[0] instanceof LatLng,
  		    len = latlngs.length,
  		    i, ring;

  		if (flat) {
  			ring = [];
  			for (i = 0; i < len; i++) {
  				ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
  				projectedBounds.extend(ring[i]);
  			}
  			result.push(ring);
  		} else {
  			for (i = 0; i < len; i++) {
  				this._projectLatlngs(latlngs[i], result, projectedBounds);
  			}
  		}
  	},

  	// clip polyline by renderer bounds so that we have less to render for performance
  	_clipPoints: function () {
  		var bounds = this._renderer._bounds;

  		this._parts = [];
  		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
  			return;
  		}

  		if (this.options.noClip) {
  			this._parts = this._rings;
  			return;
  		}

  		var parts = this._parts,
  		    i, j, k, len, len2, segment, points;

  		for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
  			points = this._rings[i];

  			for (j = 0, len2 = points.length; j < len2 - 1; j++) {
  				segment = clipSegment(points[j], points[j + 1], bounds, j, true);

  				if (!segment) { continue; }

  				parts[k] = parts[k] || [];
  				parts[k].push(segment[0]);

  				// if segment goes out of screen, or it's the last one, it's the end of the line part
  				if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
  					parts[k].push(segment[1]);
  					k++;
  				}
  			}
  		}
  	},

  	// simplify each clipped part of the polyline for performance
  	_simplifyPoints: function () {
  		var parts = this._parts,
  		    tolerance = this.options.smoothFactor;

  		for (var i = 0, len = parts.length; i < len; i++) {
  			parts[i] = simplify(parts[i], tolerance);
  		}
  	},

  	_update: function () {
  		if (!this._map) { return; }

  		this._clipPoints();
  		this._simplifyPoints();
  		this._updatePath();
  	},

  	_updatePath: function () {
  		this._renderer._updatePoly(this);
  	},

  	// Needed by the `Canvas` renderer for interactivity
  	_containsPoint: function (p, closed) {
  		var i, j, k, len, len2, part,
  		    w = this._clickTolerance();

  		if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }

  		// hit detection for polylines
  		for (i = 0, len = this._parts.length; i < len; i++) {
  			part = this._parts[i];

  			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
  				if (!closed && (j === 0)) { continue; }

  				if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
  					return true;
  				}
  			}
  		}
  		return false;
  	}
  });

  // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
  // Instantiates a polyline object given an array of geographical points and
  // optionally an options object. You can create a `Polyline` object with
  // multiple separate lines (`MultiPolyline`) by passing an array of arrays
  // of geographic points.
  function polyline(latlngs, options) {
  	return new Polyline(latlngs, options);
  }

  // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
  Polyline._flat = _flat;

  /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */

  var Polygon = Polyline.extend({

  	options: {
  		fill: true
  	},

  	isEmpty: function () {
  		return !this._latlngs.length || !this._latlngs[0].length;
  	},

  	getCenter: function () {
  		// throws error when not yet added to map as this center calculation requires projected coordinates
  		if (!this._map) {
  			throw new Error('Must add layer to map before using getCenter()');
  		}

  		var i, j, p1, p2, f, area, x, y, center,
  		    points = this._rings[0],
  		    len = points.length;

  		if (!len) { return null; }

  		// polygon centroid algorithm; only uses the first ring if there are multiple

  		area = x = y = 0;

  		for (i = 0, j = len - 1; i < len; j = i++) {
  			p1 = points[i];
  			p2 = points[j];

  			f = p1.y * p2.x - p2.y * p1.x;
  			x += (p1.x + p2.x) * f;
  			y += (p1.y + p2.y) * f;
  			area += f * 3;
  		}

  		if (area === 0) {
  			// Polygon is so small that all points are on same pixel.
  			center = points[0];
  		} else {
  			center = [x / area, y / area];
  		}
  		return this._map.layerPointToLatLng(center);
  	},

  	_convertLatLngs: function (latlngs) {
  		var result = Polyline.prototype._convertLatLngs.call(this, latlngs),
  		    len = result.length;

  		// remove last point if it equals first one
  		if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) {
  			result.pop();
  		}
  		return result;
  	},

  	_setLatLngs: function (latlngs) {
  		Polyline.prototype._setLatLngs.call(this, latlngs);
  		if (isFlat(this._latlngs)) {
  			this._latlngs = [this._latlngs];
  		}
  	},

  	_defaultShape: function () {
  		return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
  	},

  	_clipPoints: function () {
  		// polygons need a different clipping algorithm so we redefine that

  		var bounds = this._renderer._bounds,
  		    w = this.options.weight,
  		    p = new Point(w, w);

  		// increase clip padding by stroke width to avoid stroke on clip edges
  		bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));

  		this._parts = [];
  		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
  			return;
  		}

  		if (this.options.noClip) {
  			this._parts = this._rings;
  			return;
  		}

  		for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
  			clipped = clipPolygon(this._rings[i], bounds, true);
  			if (clipped.length) {
  				this._parts.push(clipped);
  			}
  		}
  	},

  	_updatePath: function () {
  		this._renderer._updatePoly(this, true);
  	},

  	// Needed by the `Canvas` renderer for interactivity
  	_containsPoint: function (p) {
  		var inside = false,
  		    part, p1, p2, i, j, k, len, len2;

  		if (!this._pxBounds || !this._pxBounds.contains(p)) { return false; }

  		// ray casting algorithm for detecting if point is in polygon
  		for (i = 0, len = this._parts.length; i < len; i++) {
  			part = this._parts[i];

  			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
  				p1 = part[j];
  				p2 = part[k];

  				if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
  					inside = !inside;
  				}
  			}
  		}

  		// also check if it's on polygon stroke
  		return inside || Polyline.prototype._containsPoint.call(this, p, true);
  	}

  });


  // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
  function polygon(latlngs, options) {
  	return new Polygon(latlngs, options);
  }

  /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */

  var GeoJSON = FeatureGroup.extend({

  	/* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */

  	initialize: function (geojson, options) {
  		setOptions(this, options);

  		this._layers = {};

  		if (geojson) {
  			this.addData(geojson);
  		}
  	},

  	// @method addData( <GeoJSON> data ): this
  	// Adds a GeoJSON object to the layer.
  	addData: function (geojson) {
  		var features = isArray(geojson) ? geojson : geojson.features,
  		    i, len, feature;

  		if (features) {
  			for (i = 0, len = features.length; i < len; i++) {
  				// only add this if geometry or geometries are set and not null
  				feature = features[i];
  				if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
  					this.addData(feature);
  				}
  			}
  			return this;
  		}

  		var options = this.options;

  		if (options.filter && !options.filter(geojson)) { return this; }

  		var layer = geometryToLayer(geojson, options);
  		if (!layer) {
  			return this;
  		}
  		layer.feature = asFeature(geojson);

  		layer.defaultOptions = layer.options;
  		this.resetStyle(layer);

  		if (options.onEachFeature) {
  			options.onEachFeature(geojson, layer);
  		}

  		return this.addLayer(layer);
  	},

  	// @method resetStyle( <Path> layer? ): this
  	// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
  	// If `layer` is omitted, the style of all features in the current layer is reset.
  	resetStyle: function (layer) {
  		if (layer === undefined) {
  			return this.eachLayer(this.resetStyle, this);
  		}
  		// reset any custom styles
  		layer.options = extend({}, layer.defaultOptions);
  		this._setLayerStyle(layer, this.options.style);
  		return this;
  	},

  	// @method setStyle( <Function> style ): this
  	// Changes styles of GeoJSON vector layers with the given style function.
  	setStyle: function (style) {
  		return this.eachLayer(function (layer) {
  			this._setLayerStyle(layer, style);
  		}, this);
  	},

  	_setLayerStyle: function (layer, style) {
  		if (layer.setStyle) {
  			if (typeof style === 'function') {
  				style = style(layer.feature);
  			}
  			layer.setStyle(style);
  		}
  	}
  });

  // @section
  // There are several static functions which can be called without instantiating L.GeoJSON:

  // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
  // Creates a `Layer` from a given GeoJSON feature. Can use a custom
  // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
  // functions if provided as options.
  function geometryToLayer(geojson, options) {

  	var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
  	    coords = geometry ? geometry.coordinates : null,
  	    layers = [],
  	    pointToLayer = options && options.pointToLayer,
  	    _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng,
  	    latlng, latlngs, i, len;

  	if (!coords && !geometry) {
  		return null;
  	}

  	switch (geometry.type) {
  	case 'Point':
  		latlng = _coordsToLatLng(coords);
  		return _pointToLayer(pointToLayer, geojson, latlng, options);

  	case 'MultiPoint':
  		for (i = 0, len = coords.length; i < len; i++) {
  			latlng = _coordsToLatLng(coords[i]);
  			layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
  		}
  		return new FeatureGroup(layers);

  	case 'LineString':
  	case 'MultiLineString':
  		latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
  		return new Polyline(latlngs, options);

  	case 'Polygon':
  	case 'MultiPolygon':
  		latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
  		return new Polygon(latlngs, options);

  	case 'GeometryCollection':
  		for (i = 0, len = geometry.geometries.length; i < len; i++) {
  			var layer = geometryToLayer({
  				geometry: geometry.geometries[i],
  				type: 'Feature',
  				properties: geojson.properties
  			}, options);

  			if (layer) {
  				layers.push(layer);
  			}
  		}
  		return new FeatureGroup(layers);

  	default:
  		throw new Error('Invalid GeoJSON object.');
  	}
  }

  function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
  	return pointToLayerFn ?
  		pointToLayerFn(geojson, latlng) :
  		new Marker(latlng, options && options.markersInheritOptions && options);
  }

  // @function coordsToLatLng(coords: Array): LatLng
  // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
  // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
  function coordsToLatLng(coords) {
  	return new LatLng(coords[1], coords[0], coords[2]);
  }

  // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
  // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
  // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
  // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
  function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
  	var latlngs = [];

  	for (var i = 0, len = coords.length, latlng; i < len; i++) {
  		latlng = levelsDeep ?
  			coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) :
  			(_coordsToLatLng || coordsToLatLng)(coords[i]);

  		latlngs.push(latlng);
  	}

  	return latlngs;
  }

  // @function latLngToCoords(latlng: LatLng, precision?: Number): Array
  // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
  function latLngToCoords(latlng, precision) {
  	precision = typeof precision === 'number' ? precision : 6;
  	return latlng.alt !== undefined ?
  		[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] :
  		[formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
  }

  // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
  // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
  // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
  function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
  	var coords = [];

  	for (var i = 0, len = latlngs.length; i < len; i++) {
  		coords.push(levelsDeep ?
  			latLngsToCoords(latlngs[i], levelsDeep - 1, closed, precision) :
  			latLngToCoords(latlngs[i], precision));
  	}

  	if (!levelsDeep && closed) {
  		coords.push(coords[0]);
  	}

  	return coords;
  }

  function getFeature(layer, newGeometry) {
  	return layer.feature ?
  		extend({}, layer.feature, {geometry: newGeometry}) :
  		asFeature(newGeometry);
  }

  // @function asFeature(geojson: Object): Object
  // Normalize GeoJSON geometries/features into GeoJSON features.
  function asFeature(geojson) {
  	if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
  		return geojson;
  	}

  	return {
  		type: 'Feature',
  		properties: {},
  		geometry: geojson
  	};
  }

  var PointToGeoJSON = {
  	toGeoJSON: function (precision) {
  		return getFeature(this, {
  			type: 'Point',
  			coordinates: latLngToCoords(this.getLatLng(), precision)
  		});
  	}
  };

  // @namespace Marker
  // @section Other methods
  // @method toGeoJSON(precision?: Number): Object
  // `precision` is the number of decimal places for coordinates.
  // The default value is 6 places.
  // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
  Marker.include(PointToGeoJSON);

  // @namespace CircleMarker
  // @method toGeoJSON(precision?: Number): Object
  // `precision` is the number of decimal places for coordinates.
  // The default value is 6 places.
  // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
  Circle.include(PointToGeoJSON);
  CircleMarker.include(PointToGeoJSON);


  // @namespace Polyline
  // @method toGeoJSON(precision?: Number): Object
  // `precision` is the number of decimal places for coordinates.
  // The default value is 6 places.
  // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
  Polyline.include({
  	toGeoJSON: function (precision) {
  		var multi = !isFlat(this._latlngs);

  		var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);

  		return getFeature(this, {
  			type: (multi ? 'Multi' : '') + 'LineString',
  			coordinates: coords
  		});
  	}
  });

  // @namespace Polygon
  // @method toGeoJSON(precision?: Number): Object
  // `precision` is the number of decimal places for coordinates.
  // The default value is 6 places.
  // Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
  Polygon.include({
  	toGeoJSON: function (precision) {
  		var holes = !isFlat(this._latlngs),
  		    multi = holes && !isFlat(this._latlngs[0]);

  		var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);

  		if (!holes) {
  			coords = [coords];
  		}

  		return getFeature(this, {
  			type: (multi ? 'Multi' : '') + 'Polygon',
  			coordinates: coords
  		});
  	}
  });


  // @namespace LayerGroup
  LayerGroup.include({
  	toMultiPoint: function (precision) {
  		var coords = [];

  		this.eachLayer(function (layer) {
  			coords.push(layer.toGeoJSON(precision).geometry.coordinates);
  		});

  		return getFeature(this, {
  			type: 'MultiPoint',
  			coordinates: coords
  		});
  	},

  	// @method toGeoJSON(precision?: Number): Object
  	// `precision` is the number of decimal places for coordinates.
  	// The default value is 6 places.
  	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
  	toGeoJSON: function (precision) {

  		var type = this.feature && this.feature.geometry && this.feature.geometry.type;

  		if (type === 'MultiPoint') {
  			return this.toMultiPoint(precision);
  		}

  		var isGeometryCollection = type === 'GeometryCollection',
  		    jsons = [];

  		this.eachLayer(function (layer) {
  			if (layer.toGeoJSON) {
  				var json = layer.toGeoJSON(precision);
  				if (isGeometryCollection) {
  					jsons.push(json.geometry);
  				} else {
  					var feature = asFeature(json);
  					// Squash nested feature collections
  					if (feature.type === 'FeatureCollection') {
  						jsons.push.apply(jsons, feature.features);
  					} else {
  						jsons.push(feature);
  					}
  				}
  			}
  		});

  		if (isGeometryCollection) {
  			return getFeature(this, {
  				geometries: jsons,
  				type: 'GeometryCollection'
  			});
  		}

  		return {
  			type: 'FeatureCollection',
  			features: jsons
  		};
  	}
  });

  // @namespace GeoJSON
  // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
  // Creates a GeoJSON layer. Optionally accepts an object in
  // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
  // (you can alternatively add it later with `addData` method) and an `options` object.
  function geoJSON(geojson, options) {
  	return new GeoJSON(geojson, options);
  }

  // Backward compatibility.
  var geoJson = geoJSON;

  /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */

  var ImageOverlay = Layer.extend({

  	// @section
  	// @aka ImageOverlay options
  	options: {
  		// @option opacity: Number = 1.0
  		// The opacity of the image overlay.
  		opacity: 1,

  		// @option alt: String = ''
  		// Text for the `alt` attribute of the image (useful for accessibility).
  		alt: '',

  		// @option interactive: Boolean = false
  		// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
  		interactive: false,

  		// @option crossOrigin: Boolean|String = false
  		// Whether the crossOrigin attribute will be added to the image.
  		// If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
  		// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
  		crossOrigin: false,

  		// @option errorOverlayUrl: String = ''
  		// URL to the overlay image to show in place of the overlay that failed to load.
  		errorOverlayUrl: '',

  		// @option zIndex: Number = 1
  		// The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
  		zIndex: 1,

  		// @option className: String = ''
  		// A custom class name to assign to the image. Empty by default.
  		className: ''
  	},

  	initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
  		this._url = url;
  		this._bounds = toLatLngBounds(bounds);

  		setOptions(this, options);
  	},

  	onAdd: function () {
  		if (!this._image) {
  			this._initImage();

  			if (this.options.opacity < 1) {
  				this._updateOpacity();
  			}
  		}

  		if (this.options.interactive) {
  			addClass(this._image, 'leaflet-interactive');
  			this.addInteractiveTarget(this._image);
  		}

  		this.getPane().appendChild(this._image);
  		this._reset();
  	},

  	onRemove: function () {
  		remove(this._image);
  		if (this.options.interactive) {
  			this.removeInteractiveTarget(this._image);
  		}
  	},

  	// @method setOpacity(opacity: Number): this
  	// Sets the opacity of the overlay.
  	setOpacity: function (opacity) {
  		this.options.opacity = opacity;

  		if (this._image) {
  			this._updateOpacity();
  		}
  		return this;
  	},

  	setStyle: function (styleOpts) {
  		if (styleOpts.opacity) {
  			this.setOpacity(styleOpts.opacity);
  		}
  		return this;
  	},

  	// @method bringToFront(): this
  	// Brings the layer to the top of all overlays.
  	bringToFront: function () {
  		if (this._map) {
  			toFront(this._image);
  		}
  		return this;
  	},

  	// @method bringToBack(): this
  	// Brings the layer to the bottom of all overlays.
  	bringToBack: function () {
  		if (this._map) {
  			toBack(this._image);
  		}
  		return this;
  	},

  	// @method setUrl(url: String): this
  	// Changes the URL of the image.
  	setUrl: function (url) {
  		this._url = url;

  		if (this._image) {
  			this._image.src = url;
  		}
  		return this;
  	},

  	// @method setBounds(bounds: LatLngBounds): this
  	// Update the bounds that this ImageOverlay covers
  	setBounds: function (bounds) {
  		this._bounds = toLatLngBounds(bounds);

  		if (this._map) {
  			this._reset();
  		}
  		return this;
  	},

  	getEvents: function () {
  		var events = {
  			zoom: this._reset,
  			viewreset: this._reset
  		};

  		if (this._zoomAnimated) {
  			events.zoomanim = this._animateZoom;
  		}

  		return events;
  	},

  	// @method setZIndex(value: Number): this
  	// Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
  	setZIndex: function (value) {
  		this.options.zIndex = value;
  		this._updateZIndex();
  		return this;
  	},

  	// @method getBounds(): LatLngBounds
  	// Get the bounds that this ImageOverlay covers
  	getBounds: function () {
  		return this._bounds;
  	},

  	// @method getElement(): HTMLElement
  	// Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
  	// used by this overlay.
  	getElement: function () {
  		return this._image;
  	},

  	_initImage: function () {
  		var wasElementSupplied = this._url.tagName === 'IMG';
  		var img = this._image = wasElementSupplied ? this._url : create$1('img');

  		addClass(img, 'leaflet-image-layer');
  		if (this._zoomAnimated) { addClass(img, 'leaflet-zoom-animated'); }
  		if (this.options.className) { addClass(img, this.options.className); }

  		img.onselectstart = falseFn;
  		img.onmousemove = falseFn;

  		// @event load: Event
  		// Fired when the ImageOverlay layer has loaded its image
  		img.onload = bind(this.fire, this, 'load');
  		img.onerror = bind(this._overlayOnError, this, 'error');

  		if (this.options.crossOrigin || this.options.crossOrigin === '') {
  			img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
  		}

  		if (this.options.zIndex) {
  			this._updateZIndex();
  		}

  		if (wasElementSupplied) {
  			this._url = img.src;
  			return;
  		}

  		img.src = this._url;
  		img.alt = this.options.alt;
  	},

  	_animateZoom: function (e) {
  		var scale = this._map.getZoomScale(e.zoom),
  		    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;

  		setTransform(this._image, offset, scale);
  	},

  	_reset: function () {
  		var image = this._image,
  		    bounds = new Bounds(
  		        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
  		        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
  		    size = bounds.getSize();

  		setPosition(image, bounds.min);

  		image.style.width  = size.x + 'px';
  		image.style.height = size.y + 'px';
  	},

  	_updateOpacity: function () {
  		setOpacity(this._image, this.options.opacity);
  	},

  	_updateZIndex: function () {
  		if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) {
  			this._image.style.zIndex = this.options.zIndex;
  		}
  	},

  	_overlayOnError: function () {
  		// @event error: Event
  		// Fired when the ImageOverlay layer fails to load its image
  		this.fire('error');

  		var errorUrl = this.options.errorOverlayUrl;
  		if (errorUrl && this._url !== errorUrl) {
  			this._url = errorUrl;
  			this._image.src = errorUrl;
  		}
  	}
  });

  // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
  // Instantiates an image overlay object given the URL of the image and the
  // geographical bounds it is tied to.
  var imageOverlay = function (url, bounds, options) {
  	return new ImageOverlay(url, bounds, options);
  };

  /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */

  var VideoOverlay = ImageOverlay.extend({

  	// @section
  	// @aka VideoOverlay options
  	options: {
  		// @option autoplay: Boolean = true
  		// Whether the video starts playing automatically when loaded.
  		autoplay: true,

  		// @option loop: Boolean = true
  		// Whether the video will loop back to the beginning when played.
  		loop: true,

  		// @option keepAspectRatio: Boolean = true
  		// Whether the video will save aspect ratio after the projection.
  		// Relevant for supported browsers. Browser compatibility- https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit
  		keepAspectRatio: true,

  		// @option muted: Boolean = false
  		// Whether the video starts on mute when loaded.
  		muted: false
  	},

  	_initImage: function () {
  		var wasElementSupplied = this._url.tagName === 'VIDEO';
  		var vid = this._image = wasElementSupplied ? this._url : create$1('video');

  		addClass(vid, 'leaflet-image-layer');
  		if (this._zoomAnimated) { addClass(vid, 'leaflet-zoom-animated'); }
  		if (this.options.className) { addClass(vid, this.options.className); }

  		vid.onselectstart = falseFn;
  		vid.onmousemove = falseFn;

  		// @event load: Event
  		// Fired when the video has finished loading the first frame
  		vid.onloadeddata = bind(this.fire, this, 'load');

  		if (wasElementSupplied) {
  			var sourceElements = vid.getElementsByTagName('source');
  			var sources = [];
  			for (var j = 0; j < sourceElements.length; j++) {
  				sources.push(sourceElements[j].src);
  			}

  			this._url = (sourceElements.length > 0) ? sources : [vid.src];
  			return;
  		}

  		if (!isArray(this._url)) { this._url = [this._url]; }

  		if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) {
  			vid.style['objectFit'] = 'fill';
  		}
  		vid.autoplay = !!this.options.autoplay;
  		vid.loop = !!this.options.loop;
  		vid.muted = !!this.options.muted;
  		for (var i = 0; i < this._url.length; i++) {
  			var source = create$1('source');
  			source.src = this._url[i];
  			vid.appendChild(source);
  		}
  	}

  	// @method getElement(): HTMLVideoElement
  	// Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
  	// used by this overlay.
  });


  // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
  // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
  // geographical bounds it is tied to.

  function videoOverlay(video, bounds, options) {
  	return new VideoOverlay(video, bounds, options);
  }

  /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */

  var SVGOverlay = ImageOverlay.extend({
  	_initImage: function () {
  		var el = this._image = this._url;

  		addClass(el, 'leaflet-image-layer');
  		if (this._zoomAnimated) { addClass(el, 'leaflet-zoom-animated'); }
  		if (this.options.className) { addClass(el, this.options.className); }

  		el.onselectstart = falseFn;
  		el.onmousemove = falseFn;
  	}

  	// @method getElement(): SVGElement
  	// Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
  	// used by this overlay.
  });


  // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
  // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
  // A viewBox attribute is required on the SVG element to zoom in and out properly.

  function svgOverlay(el, bounds, options) {
  	return new SVGOverlay(el, bounds, options);
  }

  /*
   * @class DivOverlay
   * @inherits Layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
   */

  // @namespace DivOverlay
  var DivOverlay = Layer.extend({

  	// @section
  	// @aka DivOverlay options
  	options: {
  		// @option offset: Point = Point(0, 7)
  		// The offset of the popup position. Useful to control the anchor
  		// of the popup when opening it on some overlays.
  		offset: [0, 7],

  		// @option className: String = ''
  		// A custom CSS class name to assign to the popup.
  		className: '',

  		// @option pane: String = 'popupPane'
  		// `Map pane` where the popup will be added.
  		pane: 'popupPane'
  	},

  	initialize: function (options, source) {
  		setOptions(this, options);

  		this._source = source;
  	},

  	onAdd: function (map) {
  		this._zoomAnimated = map._zoomAnimated;

  		if (!this._container) {
  			this._initLayout();
  		}

  		if (map._fadeAnimated) {
  			setOpacity(this._container, 0);
  		}

  		clearTimeout(this._removeTimeout);
  		this.getPane().appendChild(this._container);
  		this.update();

  		if (map._fadeAnimated) {
  			setOpacity(this._container, 1);
  		}

  		this.bringToFront();
  	},

  	onRemove: function (map) {
  		if (map._fadeAnimated) {
  			setOpacity(this._container, 0);
  			this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
  		} else {
  			remove(this._container);
  		}
  	},

  	// @namespace Popup
  	// @method getLatLng: LatLng
  	// Returns the geographical point of popup.
  	getLatLng: function () {
  		return this._latlng;
  	},

  	// @method setLatLng(latlng: LatLng): this
  	// Sets the geographical point where the popup will open.
  	setLatLng: function (latlng) {
  		this._latlng = toLatLng(latlng);
  		if (this._map) {
  			this._updatePosition();
  			this._adjustPan();
  		}
  		return this;
  	},

  	// @method getContent: String|HTMLElement
  	// Returns the content of the popup.
  	getContent: function () {
  		return this._content;
  	},

  	// @method setContent(htmlContent: String|HTMLElement|Function): this
  	// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
  	setContent: function (content) {
  		this._content = content;
  		this.update();
  		return this;
  	},

  	// @method getElement: String|HTMLElement
  	// Returns the HTML container of the popup.
  	getElement: function () {
  		return this._container;
  	},

  	// @method update: null
  	// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
  	update: function () {
  		if (!this._map) { return; }

  		this._container.style.visibility = 'hidden';

  		this._updateContent();
  		this._updateLayout();
  		this._updatePosition();

  		this._container.style.visibility = '';

  		this._adjustPan();
  	},

  	getEvents: function () {
  		var events = {
  			zoom: this._updatePosition,
  			viewreset: this._updatePosition
  		};

  		if (this._zoomAnimated) {
  			events.zoomanim = this._animateZoom;
  		}
  		return events;
  	},

  	// @method isOpen: Boolean
  	// Returns `true` when the popup is visible on the map.
  	isOpen: function () {
  		return !!this._map && this._map.hasLayer(this);
  	},

  	// @method bringToFront: this
  	// Brings this popup in front of other popups (in the same map pane).
  	bringToFront: function () {
  		if (this._map) {
  			toFront(this._container);
  		}
  		return this;
  	},

  	// @method bringToBack: this
  	// Brings this popup to the back of other popups (in the same map pane).
  	bringToBack: function () {
  		if (this._map) {
  			toBack(this._container);
  		}
  		return this;
  	},

  	_prepareOpen: function (parent, layer, latlng) {
  		if (!(layer instanceof Layer)) {
  			latlng = layer;
  			layer = parent;
  		}

  		if (layer instanceof FeatureGroup) {
  			for (var id in parent._layers) {
  				layer = parent._layers[id];
  				break;
  			}
  		}

  		if (!latlng) {
  			if (layer.getCenter) {
  				latlng = layer.getCenter();
  			} else if (layer.getLatLng) {
  				latlng = layer.getLatLng();
  			} else {
  				throw new Error('Unable to get source layer LatLng.');
  			}
  		}

  		// set overlay source to this layer
  		this._source = layer;

  		// update the overlay (content, layout, ect...)
  		this.update();

  		return latlng;
  	},

  	_updateContent: function () {
  		if (!this._content) { return; }

  		var node = this._contentNode;
  		var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;

  		if (typeof content === 'string') {
  			node.innerHTML = content;
  		} else {
  			while (node.hasChildNodes()) {
  				node.removeChild(node.firstChild);
  			}
  			node.appendChild(content);
  		}
  		this.fire('contentupdate');
  	},

  	_updatePosition: function () {
  		if (!this._map) { return; }

  		var pos = this._map.latLngToLayerPoint(this._latlng),
  		    offset = toPoint(this.options.offset),
  		    anchor = this._getAnchor();

  		if (this._zoomAnimated) {
  			setPosition(this._container, pos.add(anchor));
  		} else {
  			offset = offset.add(pos).add(anchor);
  		}

  		var bottom = this._containerBottom = -offset.y,
  		    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;

  		// bottom position the popup in case the height of the popup changes (images loading etc)
  		this._container.style.bottom = bottom + 'px';
  		this._container.style.left = left + 'px';
  	},

  	_getAnchor: function () {
  		return [0, 0];
  	}

  });

  /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   * Here's a more complicated way to open a popup on a map:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */


  // @namespace Popup
  var Popup = DivOverlay.extend({

  	// @section
  	// @aka Popup options
  	options: {
  		// @option maxWidth: Number = 300
  		// Max width of the popup, in pixels.
  		maxWidth: 300,

  		// @option minWidth: Number = 50
  		// Min width of the popup, in pixels.
  		minWidth: 50,

  		// @option maxHeight: Number = null
  		// If set, creates a scrollable container of the given height
  		// inside a popup if its content exceeds it.
  		maxHeight: null,

  		// @option autoPan: Boolean = true
  		// Set it to `false` if you don't want the map to do panning animation
  		// to fit the opened popup.
  		autoPan: true,

  		// @option autoPanPaddingTopLeft: Point = null
  		// The margin between the popup and the top left corner of the map
  		// view after autopanning was performed.
  		autoPanPaddingTopLeft: null,

  		// @option autoPanPaddingBottomRight: Point = null
  		// The margin between the popup and the bottom right corner of the map
  		// view after autopanning was performed.
  		autoPanPaddingBottomRight: null,

  		// @option autoPanPadding: Point = Point(5, 5)
  		// Equivalent of setting both top left and bottom right autopan padding to the same value.
  		autoPanPadding: [5, 5],

  		// @option keepInView: Boolean = false
  		// Set it to `true` if you want to prevent users from panning the popup
  		// off of the screen while it is open.
  		keepInView: false,

  		// @option closeButton: Boolean = true
  		// Controls the presence of a close button in the popup.
  		closeButton: true,

  		// @option autoClose: Boolean = true
  		// Set it to `false` if you want to override the default behavior of
  		// the popup closing when another popup is opened.
  		autoClose: true,

  		// @option closeOnEscapeKey: Boolean = true
  		// Set it to `false` if you want to override the default behavior of
  		// the ESC key for closing of the popup.
  		closeOnEscapeKey: true,

  		// @option closeOnClick: Boolean = *
  		// Set it if you want to override the default behavior of the popup closing when user clicks
  		// on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.

  		// @option className: String = ''
  		// A custom CSS class name to assign to the popup.
  		className: ''
  	},

  	// @namespace Popup
  	// @method openOn(map: Map): this
  	// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
  	openOn: function (map) {
  		map.openPopup(this);
  		return this;
  	},

  	onAdd: function (map) {
  		DivOverlay.prototype.onAdd.call(this, map);

  		// @namespace Map
  		// @section Popup events
  		// @event popupopen: PopupEvent
  		// Fired when a popup is opened in the map
  		map.fire('popupopen', {popup: this});

  		if (this._source) {
  			// @namespace Layer
  			// @section Popup events
  			// @event popupopen: PopupEvent
  			// Fired when a popup bound to this layer is opened
  			this._source.fire('popupopen', {popup: this}, true);
  			// For non-path layers, we toggle the popup when clicking
  			// again the layer, so prevent the map to reopen it.
  			if (!(this._source instanceof Path)) {
  				this._source.on('preclick', stopPropagation);
  			}
  		}
  	},

  	onRemove: function (map) {
  		DivOverlay.prototype.onRemove.call(this, map);

  		// @namespace Map
  		// @section Popup events
  		// @event popupclose: PopupEvent
  		// Fired when a popup in the map is closed
  		map.fire('popupclose', {popup: this});

  		if (this._source) {
  			// @namespace Layer
  			// @section Popup events
  			// @event popupclose: PopupEvent
  			// Fired when a popup bound to this layer is closed
  			this._source.fire('popupclose', {popup: this}, true);
  			if (!(this._source instanceof Path)) {
  				this._source.off('preclick', stopPropagation);
  			}
  		}
  	},

  	getEvents: function () {
  		var events = DivOverlay.prototype.getEvents.call(this);

  		if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
  			events.preclick = this._close;
  		}

  		if (this.options.keepInView) {
  			events.moveend = this._adjustPan;
  		}

  		return events;
  	},

  	_close: function () {
  		if (this._map) {
  			this._map.closePopup(this);
  		}
  	},

  	_initLayout: function () {
  		var prefix = 'leaflet-popup',
  		    container = this._container = create$1('div',
  			prefix + ' ' + (this.options.className || '') +
  			' leaflet-zoom-animated');

  		var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
  		this._contentNode = create$1('div', prefix + '-content', wrapper);

  		disableClickPropagation(container);
  		disableScrollPropagation(this._contentNode);
  		on(container, 'contextmenu', stopPropagation);

  		this._tipContainer = create$1('div', prefix + '-tip-container', container);
  		this._tip = create$1('div', prefix + '-tip', this._tipContainer);

  		if (this.options.closeButton) {
  			var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
  			closeButton.href = '#close';
  			closeButton.innerHTML = '&#215;';

  			on(closeButton, 'click', this._onCloseButtonClick, this);
  		}
  	},

  	_updateLayout: function () {
  		var container = this._contentNode,
  		    style = container.style;

  		style.width = '';
  		style.whiteSpace = 'nowrap';

  		var width = container.offsetWidth;
  		width = Math.min(width, this.options.maxWidth);
  		width = Math.max(width, this.options.minWidth);

  		style.width = (width + 1) + 'px';
  		style.whiteSpace = '';

  		style.height = '';

  		var height = container.offsetHeight,
  		    maxHeight = this.options.maxHeight,
  		    scrolledClass = 'leaflet-popup-scrolled';

  		if (maxHeight && height > maxHeight) {
  			style.height = maxHeight + 'px';
  			addClass(container, scrolledClass);
  		} else {
  			removeClass(container, scrolledClass);
  		}

  		this._containerWidth = this._container.offsetWidth;
  	},

  	_animateZoom: function (e) {
  		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
  		    anchor = this._getAnchor();
  		setPosition(this._container, pos.add(anchor));
  	},

  	_adjustPan: function () {
  		if (!this.options.autoPan) { return; }
  		if (this._map._panAnim) { this._map._panAnim.stop(); }

  		var map = this._map,
  		    marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0,
  		    containerHeight = this._container.offsetHeight + marginBottom,
  		    containerWidth = this._containerWidth,
  		    layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);

  		layerPos._add(getPosition(this._container));

  		var containerPos = map.layerPointToContainerPoint(layerPos),
  		    padding = toPoint(this.options.autoPanPadding),
  		    paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding),
  		    paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding),
  		    size = map.getSize(),
  		    dx = 0,
  		    dy = 0;

  		if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
  			dx = containerPos.x + containerWidth - size.x + paddingBR.x;
  		}
  		if (containerPos.x - dx - paddingTL.x < 0) { // left
  			dx = containerPos.x - paddingTL.x;
  		}
  		if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
  			dy = containerPos.y + containerHeight - size.y + paddingBR.y;
  		}
  		if (containerPos.y - dy - paddingTL.y < 0) { // top
  			dy = containerPos.y - paddingTL.y;
  		}

  		// @namespace Map
  		// @section Popup events
  		// @event autopanstart: Event
  		// Fired when the map starts autopanning when opening a popup.
  		if (dx || dy) {
  			map
  			    .fire('autopanstart')
  			    .panBy([dx, dy]);
  		}
  	},

  	_onCloseButtonClick: function (e) {
  		this._close();
  		stop(e);
  	},

  	_getAnchor: function () {
  		// Where should we anchor the popup on the source layer?
  		return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
  	}

  });

  // @namespace Popup
  // @factory L.popup(options?: Popup options, source?: Layer)
  // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
  var popup = function (options, source) {
  	return new Popup(options, source);
  };


  /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */
  Map.mergeOptions({
  	closePopupOnClick: true
  });


  // @namespace Map
  // @section Methods for Layers and Controls
  Map.include({
  	// @method openPopup(popup: Popup): this
  	// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
  	// @alternative
  	// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
  	// Creates a popup with the specified content and options and opens it in the given point on a map.
  	openPopup: function (popup, latlng, options) {
  		if (!(popup instanceof Popup)) {
  			popup = new Popup(options).setContent(popup);
  		}

  		if (latlng) {
  			popup.setLatLng(latlng);
  		}

  		if (this.hasLayer(popup)) {
  			return this;
  		}

  		if (this._popup && this._popup.options.autoClose) {
  			this.closePopup();
  		}

  		this._popup = popup;
  		return this.addLayer(popup);
  	},

  	// @method closePopup(popup?: Popup): this
  	// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
  	closePopup: function (popup) {
  		if (!popup || popup === this._popup) {
  			popup = this._popup;
  			this._popup = null;
  		}
  		if (popup) {
  			this.removeLayer(popup);
  		}
  		return this;
  	}
  });

  /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */

  // @section Popup methods
  Layer.include({

  	// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
  	// Binds a popup to the layer with the passed `content` and sets up the
  	// necessary event listeners. If a `Function` is passed it will receive
  	// the layer as the first argument and should return a `String` or `HTMLElement`.
  	bindPopup: function (content, options) {

  		if (content instanceof Popup) {
  			setOptions(content, options);
  			this._popup = content;
  			content._source = this;
  		} else {
  			if (!this._popup || options) {
  				this._popup = new Popup(options, this);
  			}
  			this._popup.setContent(content);
  		}

  		if (!this._popupHandlersAdded) {
  			this.on({
  				click: this._openPopup,
  				keypress: this._onKeyPress,
  				remove: this.closePopup,
  				move: this._movePopup
  			});
  			this._popupHandlersAdded = true;
  		}

  		return this;
  	},

  	// @method unbindPopup(): this
  	// Removes the popup previously bound with `bindPopup`.
  	unbindPopup: function () {
  		if (this._popup) {
  			this.off({
  				click: this._openPopup,
  				keypress: this._onKeyPress,
  				remove: this.closePopup,
  				move: this._movePopup
  			});
  			this._popupHandlersAdded = false;
  			this._popup = null;
  		}
  		return this;
  	},

  	// @method openPopup(latlng?: LatLng): this
  	// Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
  	openPopup: function (layer, latlng) {
  		if (this._popup && this._map) {
  			latlng = this._popup._prepareOpen(this, layer, latlng);

  			// open the popup on the map
  			this._map.openPopup(this._popup, latlng);
  		}

  		return this;
  	},

  	// @method closePopup(): this
  	// Closes the popup bound to this layer if it is open.
  	closePopup: function () {
  		if (this._popup) {
  			this._popup._close();
  		}
  		return this;
  	},

  	// @method togglePopup(): this
  	// Opens or closes the popup bound to this layer depending on its current state.
  	togglePopup: function (target) {
  		if (this._popup) {
  			if (this._popup._map) {
  				this.closePopup();
  			} else {
  				this.openPopup(target);
  			}
  		}
  		return this;
  	},

  	// @method isPopupOpen(): boolean
  	// Returns `true` if the popup bound to this layer is currently open.
  	isPopupOpen: function () {
  		return (this._popup ? this._popup.isOpen() : false);
  	},

  	// @method setPopupContent(content: String|HTMLElement|Popup): this
  	// Sets the content of the popup bound to this layer.
  	setPopupContent: function (content) {
  		if (this._popup) {
  			this._popup.setContent(content);
  		}
  		return this;
  	},

  	// @method getPopup(): Popup
  	// Returns the popup bound to this layer.
  	getPopup: function () {
  		return this._popup;
  	},

  	_openPopup: function (e) {
  		var layer = e.layer || e.target;

  		if (!this._popup) {
  			return;
  		}

  		if (!this._map) {
  			return;
  		}

  		// prevent map click
  		stop(e);

  		// if this inherits from Path its a vector and we can just
  		// open the popup at the new location
  		if (layer instanceof Path) {
  			this.openPopup(e.layer || e.target, e.latlng);
  			return;
  		}

  		// otherwise treat it like a marker and figure out
  		// if we should toggle it open/closed
  		if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
  			this.closePopup();
  		} else {
  			this.openPopup(layer, e.latlng);
  		}
  	},

  	_movePopup: function (e) {
  		this._popup.setLatLng(e.latlng);
  	},

  	_onKeyPress: function (e) {
  		if (e.originalEvent.keyCode === 13) {
  			this._openPopup(e);
  		}
  	}
  });

  /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */


  // @namespace Tooltip
  var Tooltip = DivOverlay.extend({

  	// @section
  	// @aka Tooltip options
  	options: {
  		// @option pane: String = 'tooltipPane'
  		// `Map pane` where the tooltip will be added.
  		pane: 'tooltipPane',

  		// @option offset: Point = Point(0, 0)
  		// Optional offset of the tooltip position.
  		offset: [0, 0],

  		// @option direction: String = 'auto'
  		// Direction where to open the tooltip. Possible values are: `right`, `left`,
  		// `top`, `bottom`, `center`, `auto`.
  		// `auto` will dynamically switch between `right` and `left` according to the tooltip
  		// position on the map.
  		direction: 'auto',

  		// @option permanent: Boolean = false
  		// Whether to open the tooltip permanently or only on mouseover.
  		permanent: false,

  		// @option sticky: Boolean = false
  		// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
  		sticky: false,

  		// @option interactive: Boolean = false
  		// If true, the tooltip will listen to the feature events.
  		interactive: false,

  		// @option opacity: Number = 0.9
  		// Tooltip container opacity.
  		opacity: 0.9
  	},

  	onAdd: function (map) {
  		DivOverlay.prototype.onAdd.call(this, map);
  		this.setOpacity(this.options.opacity);

  		// @namespace Map
  		// @section Tooltip events
  		// @event tooltipopen: TooltipEvent
  		// Fired when a tooltip is opened in the map.
  		map.fire('tooltipopen', {tooltip: this});

  		if (this._source) {
  			// @namespace Layer
  			// @section Tooltip events
  			// @event tooltipopen: TooltipEvent
  			// Fired when a tooltip bound to this layer is opened.
  			this._source.fire('tooltipopen', {tooltip: this}, true);
  		}
  	},

  	onRemove: function (map) {
  		DivOverlay.prototype.onRemove.call(this, map);

  		// @namespace Map
  		// @section Tooltip events
  		// @event tooltipclose: TooltipEvent
  		// Fired when a tooltip in the map is closed.
  		map.fire('tooltipclose', {tooltip: this});

  		if (this._source) {
  			// @namespace Layer
  			// @section Tooltip events
  			// @event tooltipclose: TooltipEvent
  			// Fired when a tooltip bound to this layer is closed.
  			this._source.fire('tooltipclose', {tooltip: this}, true);
  		}
  	},

  	getEvents: function () {
  		var events = DivOverlay.prototype.getEvents.call(this);

  		if (touch && !this.options.permanent) {
  			events.preclick = this._close;
  		}

  		return events;
  	},

  	_close: function () {
  		if (this._map) {
  			this._map.closeTooltip(this);
  		}
  	},

  	_initLayout: function () {
  		var prefix = 'leaflet-tooltip',
  		    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');

  		this._contentNode = this._container = create$1('div', className);
  	},

  	_updateLayout: function () {},

  	_adjustPan: function () {},

  	_setPosition: function (pos) {
  		var subX, subY,
  		    map = this._map,
  		    container = this._container,
  		    centerPoint = map.latLngToContainerPoint(map.getCenter()),
  		    tooltipPoint = map.layerPointToContainerPoint(pos),
  		    direction = this.options.direction,
  		    tooltipWidth = container.offsetWidth,
  		    tooltipHeight = container.offsetHeight,
  		    offset = toPoint(this.options.offset),
  		    anchor = this._getAnchor();

  		if (direction === 'top') {
  			subX = tooltipWidth / 2;
  			subY = tooltipHeight;
  		} else if (direction === 'bottom') {
  			subX = tooltipWidth / 2;
  			subY = 0;
  		} else if (direction === 'center') {
  			subX = tooltipWidth / 2;
  			subY = tooltipHeight / 2;
  		} else if (direction === 'right') {
  			subX = 0;
  			subY = tooltipHeight / 2;
  		} else if (direction === 'left') {
  			subX = tooltipWidth;
  			subY = tooltipHeight / 2;
  		} else if (tooltipPoint.x < centerPoint.x) {
  			direction = 'right';
  			subX = 0;
  			subY = tooltipHeight / 2;
  		} else {
  			direction = 'left';
  			subX = tooltipWidth + (offset.x + anchor.x) * 2;
  			subY = tooltipHeight / 2;
  		}

  		pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);

  		removeClass(container, 'leaflet-tooltip-right');
  		removeClass(container, 'leaflet-tooltip-left');
  		removeClass(container, 'leaflet-tooltip-top');
  		removeClass(container, 'leaflet-tooltip-bottom');
  		addClass(container, 'leaflet-tooltip-' + direction);
  		setPosition(container, pos);
  	},

  	_updatePosition: function () {
  		var pos = this._map.latLngToLayerPoint(this._latlng);
  		this._setPosition(pos);
  	},

  	setOpacity: function (opacity) {
  		this.options.opacity = opacity;

  		if (this._container) {
  			setOpacity(this._container, opacity);
  		}
  	},

  	_animateZoom: function (e) {
  		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
  		this._setPosition(pos);
  	},

  	_getAnchor: function () {
  		// Where should we anchor the tooltip on the source layer?
  		return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
  	}

  });

  // @namespace Tooltip
  // @factory L.tooltip(options?: Tooltip options, source?: Layer)
  // Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
  var tooltip = function (options, source) {
  	return new Tooltip(options, source);
  };

  // @namespace Map
  // @section Methods for Layers and Controls
  Map.include({

  	// @method openTooltip(tooltip: Tooltip): this
  	// Opens the specified tooltip.
  	// @alternative
  	// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
  	// Creates a tooltip with the specified content and options and open it.
  	openTooltip: function (tooltip, latlng, options) {
  		if (!(tooltip instanceof Tooltip)) {
  			tooltip = new Tooltip(options).setContent(tooltip);
  		}

  		if (latlng) {
  			tooltip.setLatLng(latlng);
  		}

  		if (this.hasLayer(tooltip)) {
  			return this;
  		}

  		return this.addLayer(tooltip);
  	},

  	// @method closeTooltip(tooltip?: Tooltip): this
  	// Closes the tooltip given as parameter.
  	closeTooltip: function (tooltip) {
  		if (tooltip) {
  			this.removeLayer(tooltip);
  		}
  		return this;
  	}

  });

  /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */

  // @section Tooltip methods
  Layer.include({

  	// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
  	// Binds a tooltip to the layer with the passed `content` and sets up the
  	// necessary event listeners. If a `Function` is passed it will receive
  	// the layer as the first argument and should return a `String` or `HTMLElement`.
  	bindTooltip: function (content, options) {

  		if (content instanceof Tooltip) {
  			setOptions(content, options);
  			this._tooltip = content;
  			content._source = this;
  		} else {
  			if (!this._tooltip || options) {
  				this._tooltip = new Tooltip(options, this);
  			}
  			this._tooltip.setContent(content);

  		}

  		this._initTooltipInteractions();

  		if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
  			this.openTooltip();
  		}

  		return this;
  	},

  	// @method unbindTooltip(): this
  	// Removes the tooltip previously bound with `bindTooltip`.
  	unbindTooltip: function () {
  		if (this._tooltip) {
  			this._initTooltipInteractions(true);
  			this.closeTooltip();
  			this._tooltip = null;
  		}
  		return this;
  	},

  	_initTooltipInteractions: function (remove$$1) {
  		if (!remove$$1 && this._tooltipHandlersAdded) { return; }
  		var onOff = remove$$1 ? 'off' : 'on',
  		    events = {
  			remove: this.closeTooltip,
  			move: this._moveTooltip
  		    };
  		if (!this._tooltip.options.permanent) {
  			events.mouseover = this._openTooltip;
  			events.mouseout = this.closeTooltip;
  			if (this._tooltip.options.sticky) {
  				events.mousemove = this._moveTooltip;
  			}
  			if (touch) {
  				events.click = this._openTooltip;
  			}
  		} else {
  			events.add = this._openTooltip;
  		}
  		this[onOff](events);
  		this._tooltipHandlersAdded = !remove$$1;
  	},

  	// @method openTooltip(latlng?: LatLng): this
  	// Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
  	openTooltip: function (layer, latlng) {
  		if (this._tooltip && this._map) {
  			latlng = this._tooltip._prepareOpen(this, layer, latlng);

  			// open the tooltip on the map
  			this._map.openTooltip(this._tooltip, latlng);

  			// Tooltip container may not be defined if not permanent and never
  			// opened.
  			if (this._tooltip.options.interactive && this._tooltip._container) {
  				addClass(this._tooltip._container, 'leaflet-clickable');
  				this.addInteractiveTarget(this._tooltip._container);
  			}
  		}

  		return this;
  	},

  	// @method closeTooltip(): this
  	// Closes the tooltip bound to this layer if it is open.
  	closeTooltip: function () {
  		if (this._tooltip) {
  			this._tooltip._close();
  			if (this._tooltip.options.interactive && this._tooltip._container) {
  				removeClass(this._tooltip._container, 'leaflet-clickable');
  				this.removeInteractiveTarget(this._tooltip._container);
  			}
  		}
  		return this;
  	},

  	// @method toggleTooltip(): this
  	// Opens or closes the tooltip bound to this layer depending on its current state.
  	toggleTooltip: function (target) {
  		if (this._tooltip) {
  			if (this._tooltip._map) {
  				this.closeTooltip();
  			} else {
  				this.openTooltip(target);
  			}
  		}
  		return this;
  	},

  	// @method isTooltipOpen(): boolean
  	// Returns `true` if the tooltip bound to this layer is currently open.
  	isTooltipOpen: function () {
  		return this._tooltip.isOpen();
  	},

  	// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
  	// Sets the content of the tooltip bound to this layer.
  	setTooltipContent: function (content) {
  		if (this._tooltip) {
  			this._tooltip.setContent(content);
  		}
  		return this;
  	},

  	// @method getTooltip(): Tooltip
  	// Returns the tooltip bound to this layer.
  	getTooltip: function () {
  		return this._tooltip;
  	},

  	_openTooltip: function (e) {
  		var layer = e.layer || e.target;

  		if (!this._tooltip || !this._map) {
  			return;
  		}
  		this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
  	},

  	_moveTooltip: function (e) {
  		var latlng = e.latlng, containerPoint, layerPoint;
  		if (this._tooltip.options.sticky && e.originalEvent) {
  			containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
  			layerPoint = this._map.containerPointToLayerPoint(containerPoint);
  			latlng = this._map.layerPointToLatLng(layerPoint);
  		}
  		this._tooltip.setLatLng(latlng);
  	}
  });

  /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */

  var DivIcon = Icon.extend({
  	options: {
  		// @section
  		// @aka DivIcon options
  		iconSize: [12, 12], // also can be set through CSS

  		// iconAnchor: (Point),
  		// popupAnchor: (Point),

  		// @option html: String|HTMLElement = ''
  		// Custom HTML code to put inside the div element, empty by default. Alternatively,
  		// an instance of `HTMLElement`.
  		html: false,

  		// @option bgPos: Point = [0, 0]
  		// Optional relative position of the background, in pixels
  		bgPos: null,

  		className: 'leaflet-div-icon'
  	},

  	createIcon: function (oldIcon) {
  		var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
  		    options = this.options;

  		if (options.html instanceof Element) {
  			empty(div);
  			div.appendChild(options.html);
  		} else {
  			div.innerHTML = options.html !== false ? options.html : '';
  		}

  		if (options.bgPos) {
  			var bgPos = toPoint(options.bgPos);
  			div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
  		}
  		this._setIconStyles(div, 'icon');

  		return div;
  	},

  	createShadow: function () {
  		return null;
  	}
  });

  // @factory L.divIcon(options: DivIcon options)
  // Creates a `DivIcon` instance with the given options.
  function divIcon(options) {
  	return new DivIcon(options);
  }

  Icon.Default = IconDefault;

  /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */


  var GridLayer = Layer.extend({

  	// @section
  	// @aka GridLayer options
  	options: {
  		// @option tileSize: Number|Point = 256
  		// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
  		tileSize: 256,

  		// @option opacity: Number = 1.0
  		// Opacity of the tiles. Can be used in the `createTile()` function.
  		opacity: 1,

  		// @option updateWhenIdle: Boolean = (depends)
  		// Load new tiles only when panning ends.
  		// `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
  		// `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
  		// [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
  		updateWhenIdle: mobile,

  		// @option updateWhenZooming: Boolean = true
  		// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
  		updateWhenZooming: true,

  		// @option updateInterval: Number = 200
  		// Tiles will not update more than once every `updateInterval` milliseconds when panning.
  		updateInterval: 200,

  		// @option zIndex: Number = 1
  		// The explicit zIndex of the tile layer.
  		zIndex: 1,

  		// @option bounds: LatLngBounds = undefined
  		// If set, tiles will only be loaded inside the set `LatLngBounds`.
  		bounds: null,

  		// @option minZoom: Number = 0
  		// The minimum zoom level down to which this layer will be displayed (inclusive).
  		minZoom: 0,

  		// @option maxZoom: Number = undefined
  		// The maximum zoom level up to which this layer will be displayed (inclusive).
  		maxZoom: undefined,

  		// @option maxNativeZoom: Number = undefined
  		// Maximum zoom number the tile source has available. If it is specified,
  		// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
  		// from `maxNativeZoom` level and auto-scaled.
  		maxNativeZoom: undefined,

  		// @option minNativeZoom: Number = undefined
  		// Minimum zoom number the tile source has available. If it is specified,
  		// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
  		// from `minNativeZoom` level and auto-scaled.
  		minNativeZoom: undefined,

  		// @option noWrap: Boolean = false
  		// Whether the layer is wrapped around the antimeridian. If `true`, the
  		// GridLayer will only be displayed once at low zoom levels. Has no
  		// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
  		// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
  		// tiles outside the CRS limits.
  		noWrap: false,

  		// @option pane: String = 'tilePane'
  		// `Map pane` where the grid layer will be added.
  		pane: 'tilePane',

  		// @option className: String = ''
  		// A custom class name to assign to the tile layer. Empty by default.
  		className: '',

  		// @option keepBuffer: Number = 2
  		// When panning the map, keep this many rows and columns of tiles before unloading them.
  		keepBuffer: 2
  	},

  	initialize: function (options) {
  		setOptions(this, options);
  	},

  	onAdd: function () {
  		this._initContainer();

  		this._levels = {};
  		this._tiles = {};

  		this._resetView();
  		this._update();
  	},

  	beforeAdd: function (map) {
  		map._addZoomLimit(this);
  	},

  	onRemove: function (map) {
  		this._removeAllTiles();
  		remove(this._container);
  		map._removeZoomLimit(this);
  		this._container = null;
  		this._tileZoom = undefined;
  	},

  	// @method bringToFront: this
  	// Brings the tile layer to the top of all tile layers.
  	bringToFront: function () {
  		if (this._map) {
  			toFront(this._container);
  			this._setAutoZIndex(Math.max);
  		}
  		return this;
  	},

  	// @method bringToBack: this
  	// Brings the tile layer to the bottom of all tile layers.
  	bringToBack: function () {
  		if (this._map) {
  			toBack(this._container);
  			this._setAutoZIndex(Math.min);
  		}
  		return this;
  	},

  	// @method getContainer: HTMLElement
  	// Returns the HTML element that contains the tiles for this layer.
  	getContainer: function () {
  		return this._container;
  	},

  	// @method setOpacity(opacity: Number): this
  	// Changes the [opacity](#gridlayer-opacity) of the grid layer.
  	setOpacity: function (opacity) {
  		this.options.opacity = opacity;
  		this._updateOpacity();
  		return this;
  	},

  	// @method setZIndex(zIndex: Number): this
  	// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
  	setZIndex: function (zIndex) {
  		this.options.zIndex = zIndex;
  		this._updateZIndex();

  		return this;
  	},

  	// @method isLoading: Boolean
  	// Returns `true` if any tile in the grid layer has not finished loading.
  	isLoading: function () {
  		return this._loading;
  	},

  	// @method redraw: this
  	// Causes the layer to clear all the tiles and request them again.
  	redraw: function () {
  		if (this._map) {
  			this._removeAllTiles();
  			this._update();
  		}
  		return this;
  	},

  	getEvents: function () {
  		var events = {
  			viewprereset: this._invalidateAll,
  			viewreset: this._resetView,
  			zoom: this._resetView,
  			moveend: this._onMoveEnd
  		};

  		if (!this.options.updateWhenIdle) {
  			// update tiles on move, but not more often than once per given interval
  			if (!this._onMove) {
  				this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
  			}

  			events.move = this._onMove;
  		}

  		if (this._zoomAnimated) {
  			events.zoomanim = this._animateZoom;
  		}

  		return events;
  	},

  	// @section Extension methods
  	// Layers extending `GridLayer` shall reimplement the following method.
  	// @method createTile(coords: Object, done?: Function): HTMLElement
  	// Called only internally, must be overridden by classes extending `GridLayer`.
  	// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
  	// is specified, it must be called when the tile has finished loading and drawing.
  	createTile: function () {
  		return document.createElement('div');
  	},

  	// @section
  	// @method getTileSize: Point
  	// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
  	getTileSize: function () {
  		var s = this.options.tileSize;
  		return s instanceof Point ? s : new Point(s, s);
  	},

  	_updateZIndex: function () {
  		if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
  			this._container.style.zIndex = this.options.zIndex;
  		}
  	},

  	_setAutoZIndex: function (compare) {
  		// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)

  		var layers = this.getPane().children,
  		    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min

  		for (var i = 0, len = layers.length, zIndex; i < len; i++) {

  			zIndex = layers[i].style.zIndex;

  			if (layers[i] !== this._container && zIndex) {
  				edgeZIndex = compare(edgeZIndex, +zIndex);
  			}
  		}

  		if (isFinite(edgeZIndex)) {
  			this.options.zIndex = edgeZIndex + compare(-1, 1);
  			this._updateZIndex();
  		}
  	},

  	_updateOpacity: function () {
  		if (!this._map) { return; }

  		// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
  		if (ielt9) { return; }

  		setOpacity(this._container, this.options.opacity);

  		var now = +new Date(),
  		    nextFrame = false,
  		    willPrune = false;

  		for (var key in this._tiles) {
  			var tile = this._tiles[key];
  			if (!tile.current || !tile.loaded) { continue; }

  			var fade = Math.min(1, (now - tile.loaded) / 200);

  			setOpacity(tile.el, fade);
  			if (fade < 1) {
  				nextFrame = true;
  			} else {
  				if (tile.active) {
  					willPrune = true;
  				} else {
  					this._onOpaqueTile(tile);
  				}
  				tile.active = true;
  			}
  		}

  		if (willPrune && !this._noPrune) { this._pruneTiles(); }

  		if (nextFrame) {
  			cancelAnimFrame(this._fadeFrame);
  			this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
  		}
  	},

  	_onOpaqueTile: falseFn,

  	_initContainer: function () {
  		if (this._container) { return; }

  		this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
  		this._updateZIndex();

  		if (this.options.opacity < 1) {
  			this._updateOpacity();
  		}

  		this.getPane().appendChild(this._container);
  	},

  	_updateLevels: function () {

  		var zoom = this._tileZoom,
  		    maxZoom = this.options.maxZoom;

  		if (zoom === undefined) { return undefined; }

  		for (var z in this._levels) {
  			z = Number(z);
  			if (this._levels[z].el.children.length || z === zoom) {
  				this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
  				this._onUpdateLevel(z);
  			} else {
  				remove(this._levels[z].el);
  				this._removeTilesAtZoom(z);
  				this._onRemoveLevel(z);
  				delete this._levels[z];
  			}
  		}

  		var level = this._levels[zoom],
  		    map = this._map;

  		if (!level) {
  			level = this._levels[zoom] = {};

  			level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
  			level.el.style.zIndex = maxZoom;

  			level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
  			level.zoom = zoom;

  			this._setZoomTransform(level, map.getCenter(), map.getZoom());

  			// force the browser to consider the newly added element for transition
  			falseFn(level.el.offsetWidth);

  			this._onCreateLevel(level);
  		}

  		this._level = level;

  		return level;
  	},

  	_onUpdateLevel: falseFn,

  	_onRemoveLevel: falseFn,

  	_onCreateLevel: falseFn,

  	_pruneTiles: function () {
  		if (!this._map) {
  			return;
  		}

  		var key, tile;

  		var zoom = this._map.getZoom();
  		if (zoom > this.options.maxZoom ||
  			zoom < this.options.minZoom) {
  			this._removeAllTiles();
  			return;
  		}

  		for (key in this._tiles) {
  			tile = this._tiles[key];
  			tile.retain = tile.current;
  		}

  		for (key in this._tiles) {
  			tile = this._tiles[key];
  			if (tile.current && !tile.active) {
  				var coords = tile.coords;
  				if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
  					this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
  				}
  			}
  		}

  		for (key in this._tiles) {
  			if (!this._tiles[key].retain) {
  				this._removeTile(key);
  			}
  		}
  	},

  	_removeTilesAtZoom: function (zoom) {
  		for (var key in this._tiles) {
  			if (this._tiles[key].coords.z !== zoom) {
  				continue;
  			}
  			this._removeTile(key);
  		}
  	},

  	_removeAllTiles: function () {
  		for (var key in this._tiles) {
  			this._removeTile(key);
  		}
  	},

  	_invalidateAll: function () {
  		for (var z in this._levels) {
  			remove(this._levels[z].el);
  			this._onRemoveLevel(Number(z));
  			delete this._levels[z];
  		}
  		this._removeAllTiles();

  		this._tileZoom = undefined;
  	},

  	_retainParent: function (x, y, z, minZoom) {
  		var x2 = Math.floor(x / 2),
  		    y2 = Math.floor(y / 2),
  		    z2 = z - 1,
  		    coords2 = new Point(+x2, +y2);
  		coords2.z = +z2;

  		var key = this._tileCoordsToKey(coords2),
  		    tile = this._tiles[key];

  		if (tile && tile.active) {
  			tile.retain = true;
  			return true;

  		} else if (tile && tile.loaded) {
  			tile.retain = true;
  		}

  		if (z2 > minZoom) {
  			return this._retainParent(x2, y2, z2, minZoom);
  		}

  		return false;
  	},

  	_retainChildren: function (x, y, z, maxZoom) {

  		for (var i = 2 * x; i < 2 * x + 2; i++) {
  			for (var j = 2 * y; j < 2 * y + 2; j++) {

  				var coords = new Point(i, j);
  				coords.z = z + 1;

  				var key = this._tileCoordsToKey(coords),
  				    tile = this._tiles[key];

  				if (tile && tile.active) {
  					tile.retain = true;
  					continue;

  				} else if (tile && tile.loaded) {
  					tile.retain = true;
  				}

  				if (z + 1 < maxZoom) {
  					this._retainChildren(i, j, z + 1, maxZoom);
  				}
  			}
  		}
  	},

  	_resetView: function (e) {
  		var animating = e && (e.pinch || e.flyTo);
  		this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
  	},

  	_animateZoom: function (e) {
  		this._setView(e.center, e.zoom, true, e.noUpdate);
  	},

  	_clampZoom: function (zoom) {
  		var options = this.options;

  		if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) {
  			return options.minNativeZoom;
  		}

  		if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) {
  			return options.maxNativeZoom;
  		}

  		return zoom;
  	},

  	_setView: function (center, zoom, noPrune, noUpdate) {
  		var tileZoom = Math.round(zoom);
  		if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
  		    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
  			tileZoom = undefined;
  		} else {
  			tileZoom = this._clampZoom(tileZoom);
  		}

  		var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);

  		if (!noUpdate || tileZoomChanged) {

  			this._tileZoom = tileZoom;

  			if (this._abortLoading) {
  				this._abortLoading();
  			}

  			this._updateLevels();
  			this._resetGrid();

  			if (tileZoom !== undefined) {
  				this._update(center);
  			}

  			if (!noPrune) {
  				this._pruneTiles();
  			}

  			// Flag to prevent _updateOpacity from pruning tiles during
  			// a zoom anim or a pinch gesture
  			this._noPrune = !!noPrune;
  		}

  		this._setZoomTransforms(center, zoom);
  	},

  	_setZoomTransforms: function (center, zoom) {
  		for (var i in this._levels) {
  			this._setZoomTransform(this._levels[i], center, zoom);
  		}
  	},

  	_setZoomTransform: function (level, center, zoom) {
  		var scale = this._map.getZoomScale(zoom, level.zoom),
  		    translate = level.origin.multiplyBy(scale)
  		        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();

  		if (any3d) {
  			setTransform(level.el, translate, scale);
  		} else {
  			setPosition(level.el, translate);
  		}
  	},

  	_resetGrid: function () {
  		var map = this._map,
  		    crs = map.options.crs,
  		    tileSize = this._tileSize = this.getTileSize(),
  		    tileZoom = this._tileZoom;

  		var bounds = this._map.getPixelWorldBounds(this._tileZoom);
  		if (bounds) {
  			this._globalTileRange = this._pxBoundsToTileRange(bounds);
  		}

  		this._wrapX = crs.wrapLng && !this.options.noWrap && [
  			Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
  			Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
  		];
  		this._wrapY = crs.wrapLat && !this.options.noWrap && [
  			Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
  			Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
  		];
  	},

  	_onMoveEnd: function () {
  		if (!this._map || this._map._animatingZoom) { return; }

  		this._update();
  	},

  	_getTiledPixelBounds: function (center) {
  		var map = this._map,
  		    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
  		    scale = map.getZoomScale(mapZoom, this._tileZoom),
  		    pixelCenter = map.project(center, this._tileZoom).floor(),
  		    halfSize = map.getSize().divideBy(scale * 2);

  		return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
  	},

  	// Private method to load tiles in the grid's active zoom level according to map bounds
  	_update: function (center) {
  		var map = this._map;
  		if (!map) { return; }
  		var zoom = this._clampZoom(map.getZoom());

  		if (center === undefined) { center = map.getCenter(); }
  		if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom

  		var pixelBounds = this._getTiledPixelBounds(center),
  		    tileRange = this._pxBoundsToTileRange(pixelBounds),
  		    tileCenter = tileRange.getCenter(),
  		    queue = [],
  		    margin = this.options.keepBuffer,
  		    noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
  		                              tileRange.getTopRight().add([margin, -margin]));

  		// Sanity check: panic if the tile range contains Infinity somewhere.
  		if (!(isFinite(tileRange.min.x) &&
  		      isFinite(tileRange.min.y) &&
  		      isFinite(tileRange.max.x) &&
  		      isFinite(tileRange.max.y))) { throw new Error('Attempted to load an infinite number of tiles'); }

  		for (var key in this._tiles) {
  			var c = this._tiles[key].coords;
  			if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
  				this._tiles[key].current = false;
  			}
  		}

  		// _update just loads more tiles. If the tile zoom level differs too much
  		// from the map's, let _setView reset levels and prune old tiles.
  		if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }

  		// create a queue of coordinates to load tiles from
  		for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
  			for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
  				var coords = new Point(i, j);
  				coords.z = this._tileZoom;

  				if (!this._isValidTile(coords)) { continue; }

  				var tile = this._tiles[this._tileCoordsToKey(coords)];
  				if (tile) {
  					tile.current = true;
  				} else {
  					queue.push(coords);
  				}
  			}
  		}

  		// sort tile queue to load tiles in order of their distance to center
  		queue.sort(function (a, b) {
  			return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
  		});

  		if (queue.length !== 0) {
  			// if it's the first batch of tiles to load
  			if (!this._loading) {
  				this._loading = true;
  				// @event loading: Event
  				// Fired when the grid layer starts loading tiles.
  				this.fire('loading');
  			}

  			// create DOM fragment to append tiles in one batch
  			var fragment = document.createDocumentFragment();

  			for (i = 0; i < queue.length; i++) {
  				this._addTile(queue[i], fragment);
  			}

  			this._level.el.appendChild(fragment);
  		}
  	},

  	_isValidTile: function (coords) {
  		var crs = this._map.options.crs;

  		if (!crs.infinite) {
  			// don't load tile if it's out of bounds and not wrapped
  			var bounds = this._globalTileRange;
  			if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
  			    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
  		}

  		if (!this.options.bounds) { return true; }

  		// don't load tile if it doesn't intersect the bounds in options
  		var tileBounds = this._tileCoordsToBounds(coords);
  		return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
  	},

  	_keyToBounds: function (key) {
  		return this._tileCoordsToBounds(this._keyToTileCoords(key));
  	},

  	_tileCoordsToNwSe: function (coords) {
  		var map = this._map,
  		    tileSize = this.getTileSize(),
  		    nwPoint = coords.scaleBy(tileSize),
  		    sePoint = nwPoint.add(tileSize),
  		    nw = map.unproject(nwPoint, coords.z),
  		    se = map.unproject(sePoint, coords.z);
  		return [nw, se];
  	},

  	// converts tile coordinates to its geographical bounds
  	_tileCoordsToBounds: function (coords) {
  		var bp = this._tileCoordsToNwSe(coords),
  		    bounds = new LatLngBounds(bp[0], bp[1]);

  		if (!this.options.noWrap) {
  			bounds = this._map.wrapLatLngBounds(bounds);
  		}
  		return bounds;
  	},
  	// converts tile coordinates to key for the tile cache
  	_tileCoordsToKey: function (coords) {
  		return coords.x + ':' + coords.y + ':' + coords.z;
  	},

  	// converts tile cache key to coordinates
  	_keyToTileCoords: function (key) {
  		var k = key.split(':'),
  		    coords = new Point(+k[0], +k[1]);
  		coords.z = +k[2];
  		return coords;
  	},

  	_removeTile: function (key) {
  		var tile = this._tiles[key];
  		if (!tile) { return; }

  		remove(tile.el);

  		delete this._tiles[key];

  		// @event tileunload: TileEvent
  		// Fired when a tile is removed (e.g. when a tile goes off the screen).
  		this.fire('tileunload', {
  			tile: tile.el,
  			coords: this._keyToTileCoords(key)
  		});
  	},

  	_initTile: function (tile) {
  		addClass(tile, 'leaflet-tile');

  		var tileSize = this.getTileSize();
  		tile.style.width = tileSize.x + 'px';
  		tile.style.height = tileSize.y + 'px';

  		tile.onselectstart = falseFn;
  		tile.onmousemove = falseFn;

  		// update opacity on tiles in IE7-8 because of filter inheritance problems
  		if (ielt9 && this.options.opacity < 1) {
  			setOpacity(tile, this.options.opacity);
  		}

  		// without this hack, tiles disappear after zoom on Chrome for Android
  		// https://github.com/Leaflet/Leaflet/issues/2078
  		if (android && !android23) {
  			tile.style.WebkitBackfaceVisibility = 'hidden';
  		}
  	},

  	_addTile: function (coords, container) {
  		var tilePos = this._getTilePos(coords),
  		    key = this._tileCoordsToKey(coords);

  		var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));

  		this._initTile(tile);

  		// if createTile is defined with a second argument ("done" callback),
  		// we know that tile is async and will be ready later; otherwise
  		if (this.createTile.length < 2) {
  			// mark tile as ready, but delay one frame for opacity animation to happen
  			requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
  		}

  		setPosition(tile, tilePos);

  		// save tile in cache
  		this._tiles[key] = {
  			el: tile,
  			coords: coords,
  			current: true
  		};

  		container.appendChild(tile);
  		// @event tileloadstart: TileEvent
  		// Fired when a tile is requested and starts loading.
  		this.fire('tileloadstart', {
  			tile: tile,
  			coords: coords
  		});
  	},

  	_tileReady: function (coords, err, tile) {
  		if (err) {
  			// @event tileerror: TileErrorEvent
  			// Fired when there is an error loading a tile.
  			this.fire('tileerror', {
  				error: err,
  				tile: tile,
  				coords: coords
  			});
  		}

  		var key = this._tileCoordsToKey(coords);

  		tile = this._tiles[key];
  		if (!tile) { return; }

  		tile.loaded = +new Date();
  		if (this._map._fadeAnimated) {
  			setOpacity(tile.el, 0);
  			cancelAnimFrame(this._fadeFrame);
  			this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
  		} else {
  			tile.active = true;
  			this._pruneTiles();
  		}

  		if (!err) {
  			addClass(tile.el, 'leaflet-tile-loaded');

  			// @event tileload: TileEvent
  			// Fired when a tile loads.
  			this.fire('tileload', {
  				tile: tile.el,
  				coords: coords
  			});
  		}

  		if (this._noTilesToLoad()) {
  			this._loading = false;
  			// @event load: Event
  			// Fired when the grid layer loaded all visible tiles.
  			this.fire('load');

  			if (ielt9 || !this._map._fadeAnimated) {
  				requestAnimFrame(this._pruneTiles, this);
  			} else {
  				// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
  				// to trigger a pruning.
  				setTimeout(bind(this._pruneTiles, this), 250);
  			}
  		}
  	},

  	_getTilePos: function (coords) {
  		return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
  	},

  	_wrapCoords: function (coords) {
  		var newCoords = new Point(
  			this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x,
  			this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
  		newCoords.z = coords.z;
  		return newCoords;
  	},

  	_pxBoundsToTileRange: function (bounds) {
  		var tileSize = this.getTileSize();
  		return new Bounds(
  			bounds.min.unscaleBy(tileSize).floor(),
  			bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
  	},

  	_noTilesToLoad: function () {
  		for (var key in this._tiles) {
  			if (!this._tiles[key].loaded) { return false; }
  		}
  		return true;
  	}
  });

  // @factory L.gridLayer(options?: GridLayer options)
  // Creates a new instance of GridLayer with the supplied options.
  function gridLayer(options) {
  	return new GridLayer(options);
  }

  /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */


  var TileLayer = GridLayer.extend({

  	// @section
  	// @aka TileLayer options
  	options: {
  		// @option minZoom: Number = 0
  		// The minimum zoom level down to which this layer will be displayed (inclusive).
  		minZoom: 0,

  		// @option maxZoom: Number = 18
  		// The maximum zoom level up to which this layer will be displayed (inclusive).
  		maxZoom: 18,

  		// @option subdomains: String|String[] = 'abc'
  		// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
  		subdomains: 'abc',

  		// @option errorTileUrl: String = ''
  		// URL to the tile image to show in place of the tile that failed to load.
  		errorTileUrl: '',

  		// @option zoomOffset: Number = 0
  		// The zoom number used in tile URLs will be offset with this value.
  		zoomOffset: 0,

  		// @option tms: Boolean = false
  		// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
  		tms: false,

  		// @option zoomReverse: Boolean = false
  		// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
  		zoomReverse: false,

  		// @option detectRetina: Boolean = false
  		// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
  		detectRetina: false,

  		// @option crossOrigin: Boolean|String = false
  		// Whether the crossOrigin attribute will be added to the tiles.
  		// If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
  		// Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
  		crossOrigin: false
  	},

  	initialize: function (url, options) {

  		this._url = url;

  		options = setOptions(this, options);

  		// detecting retina displays, adjusting tileSize and zoom levels
  		if (options.detectRetina && retina && options.maxZoom > 0) {

  			options.tileSize = Math.floor(options.tileSize / 2);

  			if (!options.zoomReverse) {
  				options.zoomOffset++;
  				options.maxZoom--;
  			} else {
  				options.zoomOffset--;
  				options.minZoom++;
  			}

  			options.minZoom = Math.max(0, options.minZoom);
  		}

  		if (typeof options.subdomains === 'string') {
  			options.subdomains = options.subdomains.split('');
  		}

  		// for https://github.com/Leaflet/Leaflet/issues/137
  		if (!android) {
  			this.on('tileunload', this._onTileRemove);
  		}
  	},

  	// @method setUrl(url: String, noRedraw?: Boolean): this
  	// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
  	// If the URL does not change, the layer will not be redrawn unless
  	// the noRedraw parameter is set to false.
  	setUrl: function (url, noRedraw) {
  		if (this._url === url && noRedraw === undefined) {
  			noRedraw = true;
  		}

  		this._url = url;

  		if (!noRedraw) {
  			this.redraw();
  		}
  		return this;
  	},

  	// @method createTile(coords: Object, done?: Function): HTMLElement
  	// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
  	// to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
  	// callback is called when the tile has been loaded.
  	createTile: function (coords, done) {
  		var tile = document.createElement('img');

  		on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
  		on(tile, 'error', bind(this._tileOnError, this, done, tile));

  		if (this.options.crossOrigin || this.options.crossOrigin === '') {
  			tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
  		}

  		/*
  		 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
  		 http://www.w3.org/TR/WCAG20-TECHS/H67
  		*/
  		tile.alt = '';

  		/*
  		 Set role="presentation" to force screen readers to ignore this
  		 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
  		*/
  		tile.setAttribute('role', 'presentation');

  		tile.src = this.getTileUrl(coords);

  		return tile;
  	},

  	// @section Extension methods
  	// @uninheritable
  	// Layers extending `TileLayer` might reimplement the following method.
  	// @method getTileUrl(coords: Object): String
  	// Called only internally, returns the URL for a tile given its coordinates.
  	// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
  	getTileUrl: function (coords) {
  		var data = {
  			r: retina ? '@2x' : '',
  			s: this._getSubdomain(coords),
  			x: coords.x,
  			y: coords.y,
  			z: this._getZoomForUrl()
  		};
  		if (this._map && !this._map.options.crs.infinite) {
  			var invertedY = this._globalTileRange.max.y - coords.y;
  			if (this.options.tms) {
  				data['y'] = invertedY;
  			}
  			data['-y'] = invertedY;
  		}

  		return template(this._url, extend(data, this.options));
  	},

  	_tileOnLoad: function (done, tile) {
  		// For https://github.com/Leaflet/Leaflet/issues/3332
  		if (ielt9) {
  			setTimeout(bind(done, this, null, tile), 0);
  		} else {
  			done(null, tile);
  		}
  	},

  	_tileOnError: function (done, tile, e) {
  		var errorUrl = this.options.errorTileUrl;
  		if (errorUrl && tile.getAttribute('src') !== errorUrl) {
  			tile.src = errorUrl;
  		}
  		done(e, tile);
  	},

  	_onTileRemove: function (e) {
  		e.tile.onload = null;
  	},

  	_getZoomForUrl: function () {
  		var zoom = this._tileZoom,
  		maxZoom = this.options.maxZoom,
  		zoomReverse = this.options.zoomReverse,
  		zoomOffset = this.options.zoomOffset;

  		if (zoomReverse) {
  			zoom = maxZoom - zoom;
  		}

  		return zoom + zoomOffset;
  	},

  	_getSubdomain: function (tilePoint) {
  		var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
  		return this.options.subdomains[index];
  	},

  	// stops loading all tiles in the background layer
  	_abortLoading: function () {
  		var i, tile;
  		for (i in this._tiles) {
  			if (this._tiles[i].coords.z !== this._tileZoom) {
  				tile = this._tiles[i].el;

  				tile.onload = falseFn;
  				tile.onerror = falseFn;

  				if (!tile.complete) {
  					tile.src = emptyImageUrl;
  					remove(tile);
  					delete this._tiles[i];
  				}
  			}
  		}
  	},

  	_removeTile: function (key) {
  		var tile = this._tiles[key];
  		if (!tile) { return; }

  		// Cancels any pending http requests associated with the tile
  		// unless we're on Android's stock browser,
  		// see https://github.com/Leaflet/Leaflet/issues/137
  		if (!androidStock) {
  			tile.el.setAttribute('src', emptyImageUrl);
  		}

  		return GridLayer.prototype._removeTile.call(this, key);
  	},

  	_tileReady: function (coords, err, tile) {
  		if (!this._map || (tile && tile.getAttribute('src') === emptyImageUrl)) {
  			return;
  		}

  		return GridLayer.prototype._tileReady.call(this, coords, err, tile);
  	}
  });


  // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
  // Instantiates a tile layer object given a `URL template` and optionally an options object.

  function tileLayer(url, options) {
  	return new TileLayer(url, options);
  }

  /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */

  var TileLayerWMS = TileLayer.extend({

  	// @section
  	// @aka TileLayer.WMS options
  	// If any custom options not documented here are used, they will be sent to the
  	// WMS server as extra parameters in each request URL. This can be useful for
  	// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
  	defaultWmsParams: {
  		service: 'WMS',
  		request: 'GetMap',

  		// @option layers: String = ''
  		// **(required)** Comma-separated list of WMS layers to show.
  		layers: '',

  		// @option styles: String = ''
  		// Comma-separated list of WMS styles.
  		styles: '',

  		// @option format: String = 'image/jpeg'
  		// WMS image format (use `'image/png'` for layers with transparency).
  		format: 'image/jpeg',

  		// @option transparent: Boolean = false
  		// If `true`, the WMS service will return images with transparency.
  		transparent: false,

  		// @option version: String = '1.1.1'
  		// Version of the WMS service to use
  		version: '1.1.1'
  	},

  	options: {
  		// @option crs: CRS = null
  		// Coordinate Reference System to use for the WMS requests, defaults to
  		// map CRS. Don't change this if you're not sure what it means.
  		crs: null,

  		// @option uppercase: Boolean = false
  		// If `true`, WMS request parameter keys will be uppercase.
  		uppercase: false
  	},

  	initialize: function (url, options) {

  		this._url = url;

  		var wmsParams = extend({}, this.defaultWmsParams);

  		// all keys that are not TileLayer options go to WMS params
  		for (var i in options) {
  			if (!(i in this.options)) {
  				wmsParams[i] = options[i];
  			}
  		}

  		options = setOptions(this, options);

  		var realRetina = options.detectRetina && retina ? 2 : 1;
  		var tileSize = this.getTileSize();
  		wmsParams.width = tileSize.x * realRetina;
  		wmsParams.height = tileSize.y * realRetina;

  		this.wmsParams = wmsParams;
  	},

  	onAdd: function (map) {

  		this._crs = this.options.crs || map.options.crs;
  		this._wmsVersion = parseFloat(this.wmsParams.version);

  		var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
  		this.wmsParams[projectionKey] = this._crs.code;

  		TileLayer.prototype.onAdd.call(this, map);
  	},

  	getTileUrl: function (coords) {

  		var tileBounds = this._tileCoordsToNwSe(coords),
  		    crs = this._crs,
  		    bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])),
  		    min = bounds.min,
  		    max = bounds.max,
  		    bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ?
  		    [min.y, min.x, max.y, max.x] :
  		    [min.x, min.y, max.x, max.y]).join(','),
  		    url = TileLayer.prototype.getTileUrl.call(this, coords);
  		return url +
  			getParamString(this.wmsParams, url, this.options.uppercase) +
  			(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
  	},

  	// @method setParams(params: Object, noRedraw?: Boolean): this
  	// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
  	setParams: function (params, noRedraw) {

  		extend(this.wmsParams, params);

  		if (!noRedraw) {
  			this.redraw();
  		}

  		return this;
  	}
  });


  // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
  // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
  function tileLayerWMS(url, options) {
  	return new TileLayerWMS(url, options);
  }

  TileLayer.WMS = TileLayerWMS;
  tileLayer.wms = tileLayerWMS;

  /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */

  var Renderer = Layer.extend({

  	// @section
  	// @aka Renderer options
  	options: {
  		// @option padding: Number = 0.1
  		// How much to extend the clip area around the map view (relative to its size)
  		// e.g. 0.1 would be 10% of map view in each direction
  		padding: 0.1,

  		// @option tolerance: Number = 0
  		// How much to extend click tolerance round a path/object on the map
  		tolerance : 0
  	},

  	initialize: function (options) {
  		setOptions(this, options);
  		stamp(this);
  		this._layers = this._layers || {};
  	},

  	onAdd: function () {
  		if (!this._container) {
  			this._initContainer(); // defined by renderer implementations

  			if (this._zoomAnimated) {
  				addClass(this._container, 'leaflet-zoom-animated');
  			}
  		}

  		this.getPane().appendChild(this._container);
  		this._update();
  		this.on('update', this._updatePaths, this);
  	},

  	onRemove: function () {
  		this.off('update', this._updatePaths, this);
  		this._destroyContainer();
  	},

  	getEvents: function () {
  		var events = {
  			viewreset: this._reset,
  			zoom: this._onZoom,
  			moveend: this._update,
  			zoomend: this._onZoomEnd
  		};
  		if (this._zoomAnimated) {
  			events.zoomanim = this._onAnimZoom;
  		}
  		return events;
  	},

  	_onAnimZoom: function (ev) {
  		this._updateTransform(ev.center, ev.zoom);
  	},

  	_onZoom: function () {
  		this._updateTransform(this._map.getCenter(), this._map.getZoom());
  	},

  	_updateTransform: function (center, zoom) {
  		var scale = this._map.getZoomScale(zoom, this._zoom),
  		    position = getPosition(this._container),
  		    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
  		    currentCenterPoint = this._map.project(this._center, zoom),
  		    destCenterPoint = this._map.project(center, zoom),
  		    centerOffset = destCenterPoint.subtract(currentCenterPoint),

  		    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);

  		if (any3d) {
  			setTransform(this._container, topLeftOffset, scale);
  		} else {
  			setPosition(this._container, topLeftOffset);
  		}
  	},

  	_reset: function () {
  		this._update();
  		this._updateTransform(this._center, this._zoom);

  		for (var id in this._layers) {
  			this._layers[id]._reset();
  		}
  	},

  	_onZoomEnd: function () {
  		for (var id in this._layers) {
  			this._layers[id]._project();
  		}
  	},

  	_updatePaths: function () {
  		for (var id in this._layers) {
  			this._layers[id]._update();
  		}
  	},

  	_update: function () {
  		// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
  		// Subclasses are responsible of firing the 'update' event.
  		var p = this.options.padding,
  		    size = this._map.getSize(),
  		    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();

  		this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());

  		this._center = this._map.getCenter();
  		this._zoom = this._map.getZoom();
  	}
  });

  /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */

  var Canvas = Renderer.extend({
  	getEvents: function () {
  		var events = Renderer.prototype.getEvents.call(this);
  		events.viewprereset = this._onViewPreReset;
  		return events;
  	},

  	_onViewPreReset: function () {
  		// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
  		this._postponeUpdatePaths = true;
  	},

  	onAdd: function () {
  		Renderer.prototype.onAdd.call(this);

  		// Redraw vectors since canvas is cleared upon removal,
  		// in case of removing the renderer itself from the map.
  		this._draw();
  	},

  	_initContainer: function () {
  		var container = this._container = document.createElement('canvas');

  		on(container, 'mousemove', this._onMouseMove, this);
  		on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
  		on(container, 'mouseout', this._handleMouseOut, this);

  		this._ctx = container.getContext('2d');
  	},

  	_destroyContainer: function () {
  		cancelAnimFrame(this._redrawRequest);
  		delete this._ctx;
  		remove(this._container);
  		off(this._container);
  		delete this._container;
  	},

  	_updatePaths: function () {
  		if (this._postponeUpdatePaths) { return; }

  		var layer;
  		this._redrawBounds = null;
  		for (var id in this._layers) {
  			layer = this._layers[id];
  			layer._update();
  		}
  		this._redraw();
  	},

  	_update: function () {
  		if (this._map._animatingZoom && this._bounds) { return; }

  		Renderer.prototype._update.call(this);

  		var b = this._bounds,
  		    container = this._container,
  		    size = b.getSize(),
  		    m = retina ? 2 : 1;

  		setPosition(container, b.min);

  		// set canvas size (also clearing it); use double size on retina
  		container.width = m * size.x;
  		container.height = m * size.y;
  		container.style.width = size.x + 'px';
  		container.style.height = size.y + 'px';

  		if (retina) {
  			this._ctx.scale(2, 2);
  		}

  		// translate so we use the same path coordinates after canvas element moves
  		this._ctx.translate(-b.min.x, -b.min.y);

  		// Tell paths to redraw themselves
  		this.fire('update');
  	},

  	_reset: function () {
  		Renderer.prototype._reset.call(this);

  		if (this._postponeUpdatePaths) {
  			this._postponeUpdatePaths = false;
  			this._updatePaths();
  		}
  	},

  	_initPath: function (layer) {
  		this._updateDashArray(layer);
  		this._layers[stamp(layer)] = layer;

  		var order = layer._order = {
  			layer: layer,
  			prev: this._drawLast,
  			next: null
  		};
  		if (this._drawLast) { this._drawLast.next = order; }
  		this._drawLast = order;
  		this._drawFirst = this._drawFirst || this._drawLast;
  	},

  	_addPath: function (layer) {
  		this._requestRedraw(layer);
  	},

  	_removePath: function (layer) {
  		var order = layer._order;
  		var next = order.next;
  		var prev = order.prev;

  		if (next) {
  			next.prev = prev;
  		} else {
  			this._drawLast = prev;
  		}
  		if (prev) {
  			prev.next = next;
  		} else {
  			this._drawFirst = next;
  		}

  		delete layer._order;

  		delete this._layers[stamp(layer)];

  		this._requestRedraw(layer);
  	},

  	_updatePath: function (layer) {
  		// Redraw the union of the layer's old pixel
  		// bounds and the new pixel bounds.
  		this._extendRedrawBounds(layer);
  		layer._project();
  		layer._update();
  		// The redraw will extend the redraw bounds
  		// with the new pixel bounds.
  		this._requestRedraw(layer);
  	},

  	_updateStyle: function (layer) {
  		this._updateDashArray(layer);
  		this._requestRedraw(layer);
  	},

  	_updateDashArray: function (layer) {
  		if (typeof layer.options.dashArray === 'string') {
  			var parts = layer.options.dashArray.split(/[, ]+/),
  			    dashArray = [],
  			    dashValue,
  			    i;
  			for (i = 0; i < parts.length; i++) {
  				dashValue = Number(parts[i]);
  				// Ignore dash array containing invalid lengths
  				if (isNaN(dashValue)) { return; }
  				dashArray.push(dashValue);
  			}
  			layer.options._dashArray = dashArray;
  		} else {
  			layer.options._dashArray = layer.options.dashArray;
  		}
  	},

  	_requestRedraw: function (layer) {
  		if (!this._map) { return; }

  		this._extendRedrawBounds(layer);
  		this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
  	},

  	_extendRedrawBounds: function (layer) {
  		if (layer._pxBounds) {
  			var padding = (layer.options.weight || 0) + 1;
  			this._redrawBounds = this._redrawBounds || new Bounds();
  			this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
  			this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
  		}
  	},

  	_redraw: function () {
  		this._redrawRequest = null;

  		if (this._redrawBounds) {
  			this._redrawBounds.min._floor();
  			this._redrawBounds.max._ceil();
  		}

  		this._clear(); // clear layers in redraw bounds
  		this._draw(); // draw layers

  		this._redrawBounds = null;
  	},

  	_clear: function () {
  		var bounds = this._redrawBounds;
  		if (bounds) {
  			var size = bounds.getSize();
  			this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
  		} else {
  			this._ctx.save();
  			this._ctx.setTransform(1, 0, 0, 1, 0, 0);
  			this._ctx.clearRect(0, 0, this._container.width, this._container.height);
  			this._ctx.restore();
  		}
  	},

  	_draw: function () {
  		var layer, bounds = this._redrawBounds;
  		this._ctx.save();
  		if (bounds) {
  			var size = bounds.getSize();
  			this._ctx.beginPath();
  			this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
  			this._ctx.clip();
  		}

  		this._drawing = true;

  		for (var order = this._drawFirst; order; order = order.next) {
  			layer = order.layer;
  			if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
  				layer._updatePath();
  			}
  		}

  		this._drawing = false;

  		this._ctx.restore();  // Restore state before clipping.
  	},

  	_updatePoly: function (layer, closed) {
  		if (!this._drawing) { return; }

  		var i, j, len2, p,
  		    parts = layer._parts,
  		    len = parts.length,
  		    ctx = this._ctx;

  		if (!len) { return; }

  		ctx.beginPath();

  		for (i = 0; i < len; i++) {
  			for (j = 0, len2 = parts[i].length; j < len2; j++) {
  				p = parts[i][j];
  				ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
  			}
  			if (closed) {
  				ctx.closePath();
  			}
  		}

  		this._fillStroke(ctx, layer);

  		// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
  	},

  	_updateCircle: function (layer) {

  		if (!this._drawing || layer._empty()) { return; }

  		var p = layer._point,
  		    ctx = this._ctx,
  		    r = Math.max(Math.round(layer._radius), 1),
  		    s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;

  		if (s !== 1) {
  			ctx.save();
  			ctx.scale(1, s);
  		}

  		ctx.beginPath();
  		ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);

  		if (s !== 1) {
  			ctx.restore();
  		}

  		this._fillStroke(ctx, layer);
  	},

  	_fillStroke: function (ctx, layer) {
  		var options = layer.options;

  		if (options.fill) {
  			ctx.globalAlpha = options.fillOpacity;
  			ctx.fillStyle = options.fillColor || options.color;
  			ctx.fill(options.fillRule || 'evenodd');
  		}

  		if (options.stroke && options.weight !== 0) {
  			if (ctx.setLineDash) {
  				ctx.setLineDash(layer.options && layer.options._dashArray || []);
  			}
  			ctx.globalAlpha = options.opacity;
  			ctx.lineWidth = options.weight;
  			ctx.strokeStyle = options.color;
  			ctx.lineCap = options.lineCap;
  			ctx.lineJoin = options.lineJoin;
  			ctx.stroke();
  		}
  	},

  	// Canvas obviously doesn't have mouse events for individual drawn objects,
  	// so we emulate that by calculating what's under the mouse on mousemove/click manually

  	_onClick: function (e) {
  		var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;

  		for (var order = this._drawFirst; order; order = order.next) {
  			layer = order.layer;
  			if (layer.options.interactive && layer._containsPoint(point)) {
  				if (!(e.type === 'click' || e.type !== 'preclick') || !this._map._draggableMoved(layer)) {
  					clickedLayer = layer;
  				}
  			}
  		}
  		if (clickedLayer)  {
  			fakeStop(e);
  			this._fireEvent([clickedLayer], e);
  		}
  	},

  	_onMouseMove: function (e) {
  		if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }

  		var point = this._map.mouseEventToLayerPoint(e);
  		this._handleMouseHover(e, point);
  	},


  	_handleMouseOut: function (e) {
  		var layer = this._hoveredLayer;
  		if (layer) {
  			// if we're leaving the layer, fire mouseout
  			removeClass(this._container, 'leaflet-interactive');
  			this._fireEvent([layer], e, 'mouseout');
  			this._hoveredLayer = null;
  			this._mouseHoverThrottled = false;
  		}
  	},

  	_handleMouseHover: function (e, point) {
  		if (this._mouseHoverThrottled) {
  			return;
  		}

  		var layer, candidateHoveredLayer;

  		for (var order = this._drawFirst; order; order = order.next) {
  			layer = order.layer;
  			if (layer.options.interactive && layer._containsPoint(point)) {
  				candidateHoveredLayer = layer;
  			}
  		}

  		if (candidateHoveredLayer !== this._hoveredLayer) {
  			this._handleMouseOut(e);

  			if (candidateHoveredLayer) {
  				addClass(this._container, 'leaflet-interactive'); // change cursor
  				this._fireEvent([candidateHoveredLayer], e, 'mouseover');
  				this._hoveredLayer = candidateHoveredLayer;
  			}
  		}

  		if (this._hoveredLayer) {
  			this._fireEvent([this._hoveredLayer], e);
  		}

  		this._mouseHoverThrottled = true;
  		setTimeout(bind(function () {
  			this._mouseHoverThrottled = false;
  		}, this), 32);
  	},

  	_fireEvent: function (layers, e, type) {
  		this._map._fireDOMEvent(e, type || e.type, layers);
  	},

  	_bringToFront: function (layer) {
  		var order = layer._order;

  		if (!order) { return; }

  		var next = order.next;
  		var prev = order.prev;

  		if (next) {
  			next.prev = prev;
  		} else {
  			// Already last
  			return;
  		}
  		if (prev) {
  			prev.next = next;
  		} else if (next) {
  			// Update first entry unless this is the
  			// single entry
  			this._drawFirst = next;
  		}

  		order.prev = this._drawLast;
  		this._drawLast.next = order;

  		order.next = null;
  		this._drawLast = order;

  		this._requestRedraw(layer);
  	},

  	_bringToBack: function (layer) {
  		var order = layer._order;

  		if (!order) { return; }

  		var next = order.next;
  		var prev = order.prev;

  		if (prev) {
  			prev.next = next;
  		} else {
  			// Already first
  			return;
  		}
  		if (next) {
  			next.prev = prev;
  		} else if (prev) {
  			// Update last entry unless this is the
  			// single entry
  			this._drawLast = prev;
  		}

  		order.prev = null;

  		order.next = this._drawFirst;
  		this._drawFirst.prev = order;
  		this._drawFirst = order;

  		this._requestRedraw(layer);
  	}
  });

  // @factory L.canvas(options?: Renderer options)
  // Creates a Canvas renderer with the given options.
  function canvas$1(options) {
  	return canvas ? new Canvas(options) : null;
  }

  /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */


  var vmlCreate = (function () {
  	try {
  		document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
  		return function (name) {
  			return document.createElement('<lvml:' + name + ' class="lvml">');
  		};
  	} catch (e) {
  		return function (name) {
  			return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
  		};
  	}
  })();


  /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */

  // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
  var vmlMixin = {

  	_initContainer: function () {
  		this._container = create$1('div', 'leaflet-vml-container');
  	},

  	_update: function () {
  		if (this._map._animatingZoom) { return; }
  		Renderer.prototype._update.call(this);
  		this.fire('update');
  	},

  	_initPath: function (layer) {
  		var container = layer._container = vmlCreate('shape');

  		addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));

  		container.coordsize = '1 1';

  		layer._path = vmlCreate('path');
  		container.appendChild(layer._path);

  		this._updateStyle(layer);
  		this._layers[stamp(layer)] = layer;
  	},

  	_addPath: function (layer) {
  		var container = layer._container;
  		this._container.appendChild(container);

  		if (layer.options.interactive) {
  			layer.addInteractiveTarget(container);
  		}
  	},

  	_removePath: function (layer) {
  		var container = layer._container;
  		remove(container);
  		layer.removeInteractiveTarget(container);
  		delete this._layers[stamp(layer)];
  	},

  	_updateStyle: function (layer) {
  		var stroke = layer._stroke,
  		    fill = layer._fill,
  		    options = layer.options,
  		    container = layer._container;

  		container.stroked = !!options.stroke;
  		container.filled = !!options.fill;

  		if (options.stroke) {
  			if (!stroke) {
  				stroke = layer._stroke = vmlCreate('stroke');
  			}
  			container.appendChild(stroke);
  			stroke.weight = options.weight + 'px';
  			stroke.color = options.color;
  			stroke.opacity = options.opacity;

  			if (options.dashArray) {
  				stroke.dashStyle = isArray(options.dashArray) ?
  				    options.dashArray.join(' ') :
  				    options.dashArray.replace(/( *, *)/g, ' ');
  			} else {
  				stroke.dashStyle = '';
  			}
  			stroke.endcap = options.lineCap.replace('butt', 'flat');
  			stroke.joinstyle = options.lineJoin;

  		} else if (stroke) {
  			container.removeChild(stroke);
  			layer._stroke = null;
  		}

  		if (options.fill) {
  			if (!fill) {
  				fill = layer._fill = vmlCreate('fill');
  			}
  			container.appendChild(fill);
  			fill.color = options.fillColor || options.color;
  			fill.opacity = options.fillOpacity;

  		} else if (fill) {
  			container.removeChild(fill);
  			layer._fill = null;
  		}
  	},

  	_updateCircle: function (layer) {
  		var p = layer._point.round(),
  		    r = Math.round(layer._radius),
  		    r2 = Math.round(layer._radiusY || r);

  		this._setPath(layer, layer._empty() ? 'M0 0' :
  			'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
  	},

  	_setPath: function (layer, path) {
  		layer._path.v = path;
  	},

  	_bringToFront: function (layer) {
  		toFront(layer._container);
  	},

  	_bringToBack: function (layer) {
  		toBack(layer._container);
  	}
  };

  var create$2 = vml ? vmlCreate : svgCreate;

  /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */

  var SVG = Renderer.extend({

  	getEvents: function () {
  		var events = Renderer.prototype.getEvents.call(this);
  		events.zoomstart = this._onZoomStart;
  		return events;
  	},

  	_initContainer: function () {
  		this._container = create$2('svg');

  		// makes it possible to click through svg root; we'll reset it back in individual paths
  		this._container.setAttribute('pointer-events', 'none');

  		this._rootGroup = create$2('g');
  		this._container.appendChild(this._rootGroup);
  	},

  	_destroyContainer: function () {
  		remove(this._container);
  		off(this._container);
  		delete this._container;
  		delete this._rootGroup;
  		delete this._svgSize;
  	},

  	_onZoomStart: function () {
  		// Drag-then-pinch interactions might mess up the center and zoom.
  		// In this case, the easiest way to prevent this is re-do the renderer
  		//   bounds and padding when the zooming starts.
  		this._update();
  	},

  	_update: function () {
  		if (this._map._animatingZoom && this._bounds) { return; }

  		Renderer.prototype._update.call(this);

  		var b = this._bounds,
  		    size = b.getSize(),
  		    container = this._container;

  		// set size of svg-container if changed
  		if (!this._svgSize || !this._svgSize.equals(size)) {
  			this._svgSize = size;
  			container.setAttribute('width', size.x);
  			container.setAttribute('height', size.y);
  		}

  		// movement: update container viewBox so that we don't have to change coordinates of individual layers
  		setPosition(container, b.min);
  		container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));

  		this.fire('update');
  	},

  	// methods below are called by vector layers implementations

  	_initPath: function (layer) {
  		var path = layer._path = create$2('path');

  		// @namespace Path
  		// @option className: String = null
  		// Custom class name set on an element. Only for SVG renderer.
  		if (layer.options.className) {
  			addClass(path, layer.options.className);
  		}

  		if (layer.options.interactive) {
  			addClass(path, 'leaflet-interactive');
  		}

  		this._updateStyle(layer);
  		this._layers[stamp(layer)] = layer;
  	},

  	_addPath: function (layer) {
  		if (!this._rootGroup) { this._initContainer(); }
  		this._rootGroup.appendChild(layer._path);
  		layer.addInteractiveTarget(layer._path);
  	},

  	_removePath: function (layer) {
  		remove(layer._path);
  		layer.removeInteractiveTarget(layer._path);
  		delete this._layers[stamp(layer)];
  	},

  	_updatePath: function (layer) {
  		layer._project();
  		layer._update();
  	},

  	_updateStyle: function (layer) {
  		var path = layer._path,
  		    options = layer.options;

  		if (!path) { return; }

  		if (options.stroke) {
  			path.setAttribute('stroke', options.color);
  			path.setAttribute('stroke-opacity', options.opacity);
  			path.setAttribute('stroke-width', options.weight);
  			path.setAttribute('stroke-linecap', options.lineCap);
  			path.setAttribute('stroke-linejoin', options.lineJoin);

  			if (options.dashArray) {
  				path.setAttribute('stroke-dasharray', options.dashArray);
  			} else {
  				path.removeAttribute('stroke-dasharray');
  			}

  			if (options.dashOffset) {
  				path.setAttribute('stroke-dashoffset', options.dashOffset);
  			} else {
  				path.removeAttribute('stroke-dashoffset');
  			}
  		} else {
  			path.setAttribute('stroke', 'none');
  		}

  		if (options.fill) {
  			path.setAttribute('fill', options.fillColor || options.color);
  			path.setAttribute('fill-opacity', options.fillOpacity);
  			path.setAttribute('fill-rule', options.fillRule || 'evenodd');
  		} else {
  			path.setAttribute('fill', 'none');
  		}
  	},

  	_updatePoly: function (layer, closed) {
  		this._setPath(layer, pointsToPath(layer._parts, closed));
  	},

  	_updateCircle: function (layer) {
  		var p = layer._point,
  		    r = Math.max(Math.round(layer._radius), 1),
  		    r2 = Math.max(Math.round(layer._radiusY), 1) || r,
  		    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';

  		// drawing a circle with two half-arcs
  		var d = layer._empty() ? 'M0 0' :
  			'M' + (p.x - r) + ',' + p.y +
  			arc + (r * 2) + ',0 ' +
  			arc + (-r * 2) + ',0 ';

  		this._setPath(layer, d);
  	},

  	_setPath: function (layer, path) {
  		layer._path.setAttribute('d', path);
  	},

  	// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
  	_bringToFront: function (layer) {
  		toFront(layer._path);
  	},

  	_bringToBack: function (layer) {
  		toBack(layer._path);
  	}
  });

  if (vml) {
  	SVG.include(vmlMixin);
  }

  // @namespace SVG
  // @factory L.svg(options?: Renderer options)
  // Creates a SVG renderer with the given options.
  function svg$1(options) {
  	return svg || vml ? new SVG(options) : null;
  }

  Map.include({
  	// @namespace Map; @method getRenderer(layer: Path): Renderer
  	// Returns the instance of `Renderer` that should be used to render the given
  	// `Path`. It will ensure that the `renderer` options of the map and paths
  	// are respected, and that the renderers do exist on the map.
  	getRenderer: function (layer) {
  		// @namespace Path; @option renderer: Renderer
  		// Use this specific instance of `Renderer` for this path. Takes
  		// precedence over the map's [default renderer](#map-renderer).
  		var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;

  		if (!renderer) {
  			renderer = this._renderer = this._createRenderer();
  		}

  		if (!this.hasLayer(renderer)) {
  			this.addLayer(renderer);
  		}
  		return renderer;
  	},

  	_getPaneRenderer: function (name) {
  		if (name === 'overlayPane' || name === undefined) {
  			return false;
  		}

  		var renderer = this._paneRenderers[name];
  		if (renderer === undefined) {
  			renderer = this._createRenderer({pane: name});
  			this._paneRenderers[name] = renderer;
  		}
  		return renderer;
  	},

  	_createRenderer: function (options) {
  		// @namespace Map; @option preferCanvas: Boolean = false
  		// Whether `Path`s should be rendered on a `Canvas` renderer.
  		// By default, all `Path`s are rendered in a `SVG` renderer.
  		return (this.options.preferCanvas && canvas$1(options)) || svg$1(options);
  	}
  });

  /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */

  /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */


  var Rectangle = Polygon.extend({
  	initialize: function (latLngBounds, options) {
  		Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
  	},

  	// @method setBounds(latLngBounds: LatLngBounds): this
  	// Redraws the rectangle with the passed bounds.
  	setBounds: function (latLngBounds) {
  		return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
  	},

  	_boundsToLatLngs: function (latLngBounds) {
  		latLngBounds = toLatLngBounds(latLngBounds);
  		return [
  			latLngBounds.getSouthWest(),
  			latLngBounds.getNorthWest(),
  			latLngBounds.getNorthEast(),
  			latLngBounds.getSouthEast()
  		];
  	}
  });


  // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
  function rectangle(latLngBounds, options) {
  	return new Rectangle(latLngBounds, options);
  }

  SVG.create = create$2;
  SVG.pointsToPath = pointsToPath;

  GeoJSON.geometryToLayer = geometryToLayer;
  GeoJSON.coordsToLatLng = coordsToLatLng;
  GeoJSON.coordsToLatLngs = coordsToLatLngs;
  GeoJSON.latLngToCoords = latLngToCoords;
  GeoJSON.latLngsToCoords = latLngsToCoords;
  GeoJSON.getFeature = getFeature;
  GeoJSON.asFeature = asFeature;

  /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */

  // @namespace Map
  // @section Interaction Options
  Map.mergeOptions({
  	// @option boxZoom: Boolean = true
  	// Whether the map can be zoomed to a rectangular area specified by
  	// dragging the mouse while pressing the shift key.
  	boxZoom: true
  });

  var BoxZoom = Handler.extend({
  	initialize: function (map) {
  		this._map = map;
  		this._container = map._container;
  		this._pane = map._panes.overlayPane;
  		this._resetStateTimeout = 0;
  		map.on('unload', this._destroy, this);
  	},

  	addHooks: function () {
  		on(this._container, 'mousedown', this._onMouseDown, this);
  	},

  	removeHooks: function () {
  		off(this._container, 'mousedown', this._onMouseDown, this);
  	},

  	moved: function () {
  		return this._moved;
  	},

  	_destroy: function () {
  		remove(this._pane);
  		delete this._pane;
  	},

  	_resetState: function () {
  		this._resetStateTimeout = 0;
  		this._moved = false;
  	},

  	_clearDeferredResetState: function () {
  		if (this._resetStateTimeout !== 0) {
  			clearTimeout(this._resetStateTimeout);
  			this._resetStateTimeout = 0;
  		}
  	},

  	_onMouseDown: function (e) {
  		if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }

  		// Clear the deferred resetState if it hasn't executed yet, otherwise it
  		// will interrupt the interaction and orphan a box element in the container.
  		this._clearDeferredResetState();
  		this._resetState();

  		disableTextSelection();
  		disableImageDrag();

  		this._startPoint = this._map.mouseEventToContainerPoint(e);

  		on(document, {
  			contextmenu: stop,
  			mousemove: this._onMouseMove,
  			mouseup: this._onMouseUp,
  			keydown: this._onKeyDown
  		}, this);
  	},

  	_onMouseMove: function (e) {
  		if (!this._moved) {
  			this._moved = true;

  			this._box = create$1('div', 'leaflet-zoom-box', this._container);
  			addClass(this._container, 'leaflet-crosshair');

  			this._map.fire('boxzoomstart');
  		}

  		this._point = this._map.mouseEventToContainerPoint(e);

  		var bounds = new Bounds(this._point, this._startPoint),
  		    size = bounds.getSize();

  		setPosition(this._box, bounds.min);

  		this._box.style.width  = size.x + 'px';
  		this._box.style.height = size.y + 'px';
  	},

  	_finish: function () {
  		if (this._moved) {
  			remove(this._box);
  			removeClass(this._container, 'leaflet-crosshair');
  		}

  		enableTextSelection();
  		enableImageDrag();

  		off(document, {
  			contextmenu: stop,
  			mousemove: this._onMouseMove,
  			mouseup: this._onMouseUp,
  			keydown: this._onKeyDown
  		}, this);
  	},

  	_onMouseUp: function (e) {
  		if ((e.which !== 1) && (e.button !== 1)) { return; }

  		this._finish();

  		if (!this._moved) { return; }
  		// Postpone to next JS tick so internal click event handling
  		// still see it as "moved".
  		this._clearDeferredResetState();
  		this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);

  		var bounds = new LatLngBounds(
  		        this._map.containerPointToLatLng(this._startPoint),
  		        this._map.containerPointToLatLng(this._point));

  		this._map
  			.fitBounds(bounds)
  			.fire('boxzoomend', {boxZoomBounds: bounds});
  	},

  	_onKeyDown: function (e) {
  		if (e.keyCode === 27) {
  			this._finish();
  		}
  	}
  });

  // @section Handlers
  // @property boxZoom: Handler
  // Box (shift-drag with mouse) zoom handler.
  Map.addInitHook('addHandler', 'boxZoom', BoxZoom);

  /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */

  // @namespace Map
  // @section Interaction Options

  Map.mergeOptions({
  	// @option doubleClickZoom: Boolean|String = true
  	// Whether the map can be zoomed in by double clicking on it and
  	// zoomed out by double clicking while holding shift. If passed
  	// `'center'`, double-click zoom will zoom to the center of the
  	//  view regardless of where the mouse was.
  	doubleClickZoom: true
  });

  var DoubleClickZoom = Handler.extend({
  	addHooks: function () {
  		this._map.on('dblclick', this._onDoubleClick, this);
  	},

  	removeHooks: function () {
  		this._map.off('dblclick', this._onDoubleClick, this);
  	},

  	_onDoubleClick: function (e) {
  		var map = this._map,
  		    oldZoom = map.getZoom(),
  		    delta = map.options.zoomDelta,
  		    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;

  		if (map.options.doubleClickZoom === 'center') {
  			map.setZoom(zoom);
  		} else {
  			map.setZoomAround(e.containerPoint, zoom);
  		}
  	}
  });

  // @section Handlers
  //
  // Map properties include interaction handlers that allow you to control
  // interaction behavior in runtime, enabling or disabling certain features such
  // as dragging or touch zoom (see `Handler` methods). For example:
  //
  // ```js
  // map.doubleClickZoom.disable();
  // ```
  //
  // @property doubleClickZoom: Handler
  // Double click zoom handler.
  Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);

  /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */

  // @namespace Map
  // @section Interaction Options
  Map.mergeOptions({
  	// @option dragging: Boolean = true
  	// Whether the map be draggable with mouse/touch or not.
  	dragging: true,

  	// @section Panning Inertia Options
  	// @option inertia: Boolean = *
  	// If enabled, panning of the map will have an inertia effect where
  	// the map builds momentum while dragging and continues moving in
  	// the same direction for some time. Feels especially nice on touch
  	// devices. Enabled by default unless running on old Android devices.
  	inertia: !android23,

  	// @option inertiaDeceleration: Number = 3000
  	// The rate with which the inertial movement slows down, in pixels/second².
  	inertiaDeceleration: 3400, // px/s^2

  	// @option inertiaMaxSpeed: Number = Infinity
  	// Max speed of the inertial movement, in pixels/second.
  	inertiaMaxSpeed: Infinity, // px/s

  	// @option easeLinearity: Number = 0.2
  	easeLinearity: 0.2,

  	// TODO refactor, move to CRS
  	// @option worldCopyJump: Boolean = false
  	// With this option enabled, the map tracks when you pan to another "copy"
  	// of the world and seamlessly jumps to the original one so that all overlays
  	// like markers and vector layers are still visible.
  	worldCopyJump: false,

  	// @option maxBoundsViscosity: Number = 0.0
  	// If `maxBounds` is set, this option will control how solid the bounds
  	// are when dragging the map around. The default value of `0.0` allows the
  	// user to drag outside the bounds at normal speed, higher values will
  	// slow down map dragging outside bounds, and `1.0` makes the bounds fully
  	// solid, preventing the user from dragging outside the bounds.
  	maxBoundsViscosity: 0.0
  });

  var Drag = Handler.extend({
  	addHooks: function () {
  		if (!this._draggable) {
  			var map = this._map;

  			this._draggable = new Draggable(map._mapPane, map._container);

  			this._draggable.on({
  				dragstart: this._onDragStart,
  				drag: this._onDrag,
  				dragend: this._onDragEnd
  			}, this);

  			this._draggable.on('predrag', this._onPreDragLimit, this);
  			if (map.options.worldCopyJump) {
  				this._draggable.on('predrag', this._onPreDragWrap, this);
  				map.on('zoomend', this._onZoomEnd, this);

  				map.whenReady(this._onZoomEnd, this);
  			}
  		}
  		addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
  		this._draggable.enable();
  		this._positions = [];
  		this._times = [];
  	},

  	removeHooks: function () {
  		removeClass(this._map._container, 'leaflet-grab');
  		removeClass(this._map._container, 'leaflet-touch-drag');
  		this._draggable.disable();
  	},

  	moved: function () {
  		return this._draggable && this._draggable._moved;
  	},

  	moving: function () {
  		return this._draggable && this._draggable._moving;
  	},

  	_onDragStart: function () {
  		var map = this._map;

  		map._stop();
  		if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
  			var bounds = toLatLngBounds(this._map.options.maxBounds);

  			this._offsetLimit = toBounds(
  				this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
  				this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
  					.add(this._map.getSize()));

  			this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
  		} else {
  			this._offsetLimit = null;
  		}

  		map
  		    .fire('movestart')
  		    .fire('dragstart');

  		if (map.options.inertia) {
  			this._positions = [];
  			this._times = [];
  		}
  	},

  	_onDrag: function (e) {
  		if (this._map.options.inertia) {
  			var time = this._lastTime = +new Date(),
  			    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;

  			this._positions.push(pos);
  			this._times.push(time);

  			this._prunePositions(time);
  		}

  		this._map
  		    .fire('move', e)
  		    .fire('drag', e);
  	},

  	_prunePositions: function (time) {
  		while (this._positions.length > 1 && time - this._times[0] > 50) {
  			this._positions.shift();
  			this._times.shift();
  		}
  	},

  	_onZoomEnd: function () {
  		var pxCenter = this._map.getSize().divideBy(2),
  		    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);

  		this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
  		this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
  	},

  	_viscousLimit: function (value, threshold) {
  		return value - (value - threshold) * this._viscosity;
  	},

  	_onPreDragLimit: function () {
  		if (!this._viscosity || !this._offsetLimit) { return; }

  		var offset = this._draggable._newPos.subtract(this._draggable._startPos);

  		var limit = this._offsetLimit;
  		if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
  		if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
  		if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
  		if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }

  		this._draggable._newPos = this._draggable._startPos.add(offset);
  	},

  	_onPreDragWrap: function () {
  		// TODO refactor to be able to adjust map pane position after zoom
  		var worldWidth = this._worldWidth,
  		    halfWidth = Math.round(worldWidth / 2),
  		    dx = this._initialWorldOffset,
  		    x = this._draggable._newPos.x,
  		    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
  		    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
  		    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;

  		this._draggable._absPos = this._draggable._newPos.clone();
  		this._draggable._newPos.x = newX;
  	},

  	_onDragEnd: function (e) {
  		var map = this._map,
  		    options = map.options,

  		    noInertia = !options.inertia || this._times.length < 2;

  		map.fire('dragend', e);

  		if (noInertia) {
  			map.fire('moveend');

  		} else {
  			this._prunePositions(+new Date());

  			var direction = this._lastPos.subtract(this._positions[0]),
  			    duration = (this._lastTime - this._times[0]) / 1000,
  			    ease = options.easeLinearity,

  			    speedVector = direction.multiplyBy(ease / duration),
  			    speed = speedVector.distanceTo([0, 0]),

  			    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
  			    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),

  			    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
  			    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();

  			if (!offset.x && !offset.y) {
  				map.fire('moveend');

  			} else {
  				offset = map._limitOffset(offset, map.options.maxBounds);

  				requestAnimFrame(function () {
  					map.panBy(offset, {
  						duration: decelerationDuration,
  						easeLinearity: ease,
  						noMoveStart: true,
  						animate: true
  					});
  				});
  			}
  		}
  	}
  });

  // @section Handlers
  // @property dragging: Handler
  // Map dragging handler (by both mouse and touch).
  Map.addInitHook('addHandler', 'dragging', Drag);

  /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */

  // @namespace Map
  // @section Keyboard Navigation Options
  Map.mergeOptions({
  	// @option keyboard: Boolean = true
  	// Makes the map focusable and allows users to navigate the map with keyboard
  	// arrows and `+`/`-` keys.
  	keyboard: true,

  	// @option keyboardPanDelta: Number = 80
  	// Amount of pixels to pan when pressing an arrow key.
  	keyboardPanDelta: 80
  });

  var Keyboard = Handler.extend({

  	keyCodes: {
  		left:    [37],
  		right:   [39],
  		down:    [40],
  		up:      [38],
  		zoomIn:  [187, 107, 61, 171],
  		zoomOut: [189, 109, 54, 173]
  	},

  	initialize: function (map) {
  		this._map = map;

  		this._setPanDelta(map.options.keyboardPanDelta);
  		this._setZoomDelta(map.options.zoomDelta);
  	},

  	addHooks: function () {
  		var container = this._map._container;

  		// make the container focusable by tabbing
  		if (container.tabIndex <= 0) {
  			container.tabIndex = '0';
  		}

  		on(container, {
  			focus: this._onFocus,
  			blur: this._onBlur,
  			mousedown: this._onMouseDown
  		}, this);

  		this._map.on({
  			focus: this._addHooks,
  			blur: this._removeHooks
  		}, this);
  	},

  	removeHooks: function () {
  		this._removeHooks();

  		off(this._map._container, {
  			focus: this._onFocus,
  			blur: this._onBlur,
  			mousedown: this._onMouseDown
  		}, this);

  		this._map.off({
  			focus: this._addHooks,
  			blur: this._removeHooks
  		}, this);
  	},

  	_onMouseDown: function () {
  		if (this._focused) { return; }

  		var body = document.body,
  		    docEl = document.documentElement,
  		    top = body.scrollTop || docEl.scrollTop,
  		    left = body.scrollLeft || docEl.scrollLeft;

  		this._map._container.focus();

  		window.scrollTo(left, top);
  	},

  	_onFocus: function () {
  		this._focused = true;
  		this._map.fire('focus');
  	},

  	_onBlur: function () {
  		this._focused = false;
  		this._map.fire('blur');
  	},

  	_setPanDelta: function (panDelta) {
  		var keys = this._panKeys = {},
  		    codes = this.keyCodes,
  		    i, len;

  		for (i = 0, len = codes.left.length; i < len; i++) {
  			keys[codes.left[i]] = [-1 * panDelta, 0];
  		}
  		for (i = 0, len = codes.right.length; i < len; i++) {
  			keys[codes.right[i]] = [panDelta, 0];
  		}
  		for (i = 0, len = codes.down.length; i < len; i++) {
  			keys[codes.down[i]] = [0, panDelta];
  		}
  		for (i = 0, len = codes.up.length; i < len; i++) {
  			keys[codes.up[i]] = [0, -1 * panDelta];
  		}
  	},

  	_setZoomDelta: function (zoomDelta) {
  		var keys = this._zoomKeys = {},
  		    codes = this.keyCodes,
  		    i, len;

  		for (i = 0, len = codes.zoomIn.length; i < len; i++) {
  			keys[codes.zoomIn[i]] = zoomDelta;
  		}
  		for (i = 0, len = codes.zoomOut.length; i < len; i++) {
  			keys[codes.zoomOut[i]] = -zoomDelta;
  		}
  	},

  	_addHooks: function () {
  		on(document, 'keydown', this._onKeyDown, this);
  	},

  	_removeHooks: function () {
  		off(document, 'keydown', this._onKeyDown, this);
  	},

  	_onKeyDown: function (e) {
  		if (e.altKey || e.ctrlKey || e.metaKey) { return; }

  		var key = e.keyCode,
  		    map = this._map,
  		    offset;

  		if (key in this._panKeys) {
  			if (!map._panAnim || !map._panAnim._inProgress) {
  				offset = this._panKeys[key];
  				if (e.shiftKey) {
  					offset = toPoint(offset).multiplyBy(3);
  				}

  				map.panBy(offset);

  				if (map.options.maxBounds) {
  					map.panInsideBounds(map.options.maxBounds);
  				}
  			}
  		} else if (key in this._zoomKeys) {
  			map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);

  		} else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) {
  			map.closePopup();

  		} else {
  			return;
  		}

  		stop(e);
  	}
  });

  // @section Handlers
  // @section Handlers
  // @property keyboard: Handler
  // Keyboard navigation handler.
  Map.addInitHook('addHandler', 'keyboard', Keyboard);

  /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */

  // @namespace Map
  // @section Interaction Options
  Map.mergeOptions({
  	// @section Mouse wheel options
  	// @option scrollWheelZoom: Boolean|String = true
  	// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
  	// it will zoom to the center of the view regardless of where the mouse was.
  	scrollWheelZoom: true,

  	// @option wheelDebounceTime: Number = 40
  	// Limits the rate at which a wheel can fire (in milliseconds). By default
  	// user can't zoom via wheel more often than once per 40 ms.
  	wheelDebounceTime: 40,

  	// @option wheelPxPerZoomLevel: Number = 60
  	// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
  	// mean a change of one full zoom level. Smaller values will make wheel-zooming
  	// faster (and vice versa).
  	wheelPxPerZoomLevel: 60
  });

  var ScrollWheelZoom = Handler.extend({
  	addHooks: function () {
  		on(this._map._container, 'wheel', this._onWheelScroll, this);

  		this._delta = 0;
  	},

  	removeHooks: function () {
  		off(this._map._container, 'wheel', this._onWheelScroll, this);
  	},

  	_onWheelScroll: function (e) {
  		var delta = getWheelDelta(e);

  		var debounce = this._map.options.wheelDebounceTime;

  		this._delta += delta;
  		this._lastMousePos = this._map.mouseEventToContainerPoint(e);

  		if (!this._startTime) {
  			this._startTime = +new Date();
  		}

  		var left = Math.max(debounce - (+new Date() - this._startTime), 0);

  		clearTimeout(this._timer);
  		this._timer = setTimeout(bind(this._performZoom, this), left);

  		stop(e);
  	},

  	_performZoom: function () {
  		var map = this._map,
  		    zoom = map.getZoom(),
  		    snap = this._map.options.zoomSnap || 0;

  		map._stop(); // stop panning and fly animations if any

  		// map the delta with a sigmoid function to -4..4 range leaning on -1..1
  		var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
  		    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
  		    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
  		    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;

  		this._delta = 0;
  		this._startTime = null;

  		if (!delta) { return; }

  		if (map.options.scrollWheelZoom === 'center') {
  			map.setZoom(zoom + delta);
  		} else {
  			map.setZoomAround(this._lastMousePos, zoom + delta);
  		}
  	}
  });

  // @section Handlers
  // @property scrollWheelZoom: Handler
  // Scroll wheel zoom handler.
  Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);

  /*
   * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
   */

  // @namespace Map
  // @section Interaction Options
  Map.mergeOptions({
  	// @section Touch interaction options
  	// @option tap: Boolean = true
  	// Enables mobile hacks for supporting instant taps (fixing 200ms click
  	// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
  	tap: true,

  	// @option tapTolerance: Number = 15
  	// The max number of pixels a user can shift his finger during touch
  	// for it to be considered a valid tap.
  	tapTolerance: 15
  });

  var Tap = Handler.extend({
  	addHooks: function () {
  		on(this._map._container, 'touchstart', this._onDown, this);
  	},

  	removeHooks: function () {
  		off(this._map._container, 'touchstart', this._onDown, this);
  	},

  	_onDown: function (e) {
  		if (!e.touches) { return; }

  		preventDefault(e);

  		this._fireClick = true;

  		// don't simulate click or track longpress if more than 1 touch
  		if (e.touches.length > 1) {
  			this._fireClick = false;
  			clearTimeout(this._holdTimeout);
  			return;
  		}

  		var first = e.touches[0],
  		    el = first.target;

  		this._startPos = this._newPos = new Point(first.clientX, first.clientY);

  		// if touching a link, highlight it
  		if (el.tagName && el.tagName.toLowerCase() === 'a') {
  			addClass(el, 'leaflet-active');
  		}

  		// simulate long hold but setting a timeout
  		this._holdTimeout = setTimeout(bind(function () {
  			if (this._isTapValid()) {
  				this._fireClick = false;
  				this._onUp();
  				this._simulateEvent('contextmenu', first);
  			}
  		}, this), 1000);

  		this._simulateEvent('mousedown', first);

  		on(document, {
  			touchmove: this._onMove,
  			touchend: this._onUp
  		}, this);
  	},

  	_onUp: function (e) {
  		clearTimeout(this._holdTimeout);

  		off(document, {
  			touchmove: this._onMove,
  			touchend: this._onUp
  		}, this);

  		if (this._fireClick && e && e.changedTouches) {

  			var first = e.changedTouches[0],
  			    el = first.target;

  			if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
  				removeClass(el, 'leaflet-active');
  			}

  			this._simulateEvent('mouseup', first);

  			// simulate click if the touch didn't move too much
  			if (this._isTapValid()) {
  				this._simulateEvent('click', first);
  			}
  		}
  	},

  	_isTapValid: function () {
  		return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
  	},

  	_onMove: function (e) {
  		var first = e.touches[0];
  		this._newPos = new Point(first.clientX, first.clientY);
  		this._simulateEvent('mousemove', first);
  	},

  	_simulateEvent: function (type, e) {
  		var simulatedEvent = document.createEvent('MouseEvents');

  		simulatedEvent._simulated = true;
  		e.target._simulatedClick = true;

  		simulatedEvent.initMouseEvent(
  		        type, true, true, window, 1,
  		        e.screenX, e.screenY,
  		        e.clientX, e.clientY,
  		        false, false, false, false, 0, null);

  		e.target.dispatchEvent(simulatedEvent);
  	}
  });

  // @section Handlers
  // @property tap: Handler
  // Mobile touch hacks (quick tap and touch hold) handler.
  if (touch && (!pointer || safari)) {
  	Map.addInitHook('addHandler', 'tap', Tap);
  }

  /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */

  // @namespace Map
  // @section Interaction Options
  Map.mergeOptions({
  	// @section Touch interaction options
  	// @option touchZoom: Boolean|String = *
  	// Whether the map can be zoomed by touch-dragging with two fingers. If
  	// passed `'center'`, it will zoom to the center of the view regardless of
  	// where the touch events (fingers) were. Enabled for touch-capable web
  	// browsers except for old Androids.
  	touchZoom: touch && !android23,

  	// @option bounceAtZoomLimits: Boolean = true
  	// Set it to false if you don't want the map to zoom beyond min/max zoom
  	// and then bounce back when pinch-zooming.
  	bounceAtZoomLimits: true
  });

  var TouchZoom = Handler.extend({
  	addHooks: function () {
  		addClass(this._map._container, 'leaflet-touch-zoom');
  		on(this._map._container, 'touchstart', this._onTouchStart, this);
  	},

  	removeHooks: function () {
  		removeClass(this._map._container, 'leaflet-touch-zoom');
  		off(this._map._container, 'touchstart', this._onTouchStart, this);
  	},

  	_onTouchStart: function (e) {
  		var map = this._map;
  		if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }

  		var p1 = map.mouseEventToContainerPoint(e.touches[0]),
  		    p2 = map.mouseEventToContainerPoint(e.touches[1]);

  		this._centerPoint = map.getSize()._divideBy(2);
  		this._startLatLng = map.containerPointToLatLng(this._centerPoint);
  		if (map.options.touchZoom !== 'center') {
  			this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
  		}

  		this._startDist = p1.distanceTo(p2);
  		this._startZoom = map.getZoom();

  		this._moved = false;
  		this._zooming = true;

  		map._stop();

  		on(document, 'touchmove', this._onTouchMove, this);
  		on(document, 'touchend', this._onTouchEnd, this);

  		preventDefault(e);
  	},

  	_onTouchMove: function (e) {
  		if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }

  		var map = this._map,
  		    p1 = map.mouseEventToContainerPoint(e.touches[0]),
  		    p2 = map.mouseEventToContainerPoint(e.touches[1]),
  		    scale = p1.distanceTo(p2) / this._startDist;

  		this._zoom = map.getScaleZoom(scale, this._startZoom);

  		if (!map.options.bounceAtZoomLimits && (
  			(this._zoom < map.getMinZoom() && scale < 1) ||
  			(this._zoom > map.getMaxZoom() && scale > 1))) {
  			this._zoom = map._limitZoom(this._zoom);
  		}

  		if (map.options.touchZoom === 'center') {
  			this._center = this._startLatLng;
  			if (scale === 1) { return; }
  		} else {
  			// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
  			var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
  			if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
  			this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
  		}

  		if (!this._moved) {
  			map._moveStart(true, false);
  			this._moved = true;
  		}

  		cancelAnimFrame(this._animRequest);

  		var moveFn = bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
  		this._animRequest = requestAnimFrame(moveFn, this, true);

  		preventDefault(e);
  	},

  	_onTouchEnd: function () {
  		if (!this._moved || !this._zooming) {
  			this._zooming = false;
  			return;
  		}

  		this._zooming = false;
  		cancelAnimFrame(this._animRequest);

  		off(document, 'touchmove', this._onTouchMove, this);
  		off(document, 'touchend', this._onTouchEnd, this);

  		// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
  		if (this._map.options.zoomAnimation) {
  			this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
  		} else {
  			this._map._resetView(this._center, this._map._limitZoom(this._zoom));
  		}
  	}
  });

  // @section Handlers
  // @property touchZoom: Handler
  // Touch zoom handler.
  Map.addInitHook('addHandler', 'touchZoom', TouchZoom);

  Map.BoxZoom = BoxZoom;
  Map.DoubleClickZoom = DoubleClickZoom;
  Map.Drag = Drag;
  Map.Keyboard = Keyboard;
  Map.ScrollWheelZoom = ScrollWheelZoom;
  Map.Tap = Tap;
  Map.TouchZoom = TouchZoom;

  exports.version = version;
  exports.Control = Control;
  exports.control = control;
  exports.Browser = Browser;
  exports.Evented = Evented;
  exports.Mixin = Mixin;
  exports.Util = Util;
  exports.Class = Class;
  exports.Handler = Handler;
  exports.extend = extend;
  exports.bind = bind;
  exports.stamp = stamp;
  exports.setOptions = setOptions;
  exports.DomEvent = DomEvent;
  exports.DomUtil = DomUtil;
  exports.PosAnimation = PosAnimation;
  exports.Draggable = Draggable;
  exports.LineUtil = LineUtil;
  exports.PolyUtil = PolyUtil;
  exports.Point = Point;
  exports.point = toPoint;
  exports.Bounds = Bounds;
  exports.bounds = toBounds;
  exports.Transformation = Transformation;
  exports.transformation = toTransformation;
  exports.Projection = index;
  exports.LatLng = LatLng;
  exports.latLng = toLatLng;
  exports.LatLngBounds = LatLngBounds;
  exports.latLngBounds = toLatLngBounds;
  exports.CRS = CRS;
  exports.GeoJSON = GeoJSON;
  exports.geoJSON = geoJSON;
  exports.geoJson = geoJson;
  exports.Layer = Layer;
  exports.LayerGroup = LayerGroup;
  exports.layerGroup = layerGroup;
  exports.FeatureGroup = FeatureGroup;
  exports.featureGroup = featureGroup;
  exports.ImageOverlay = ImageOverlay;
  exports.imageOverlay = imageOverlay;
  exports.VideoOverlay = VideoOverlay;
  exports.videoOverlay = videoOverlay;
  exports.SVGOverlay = SVGOverlay;
  exports.svgOverlay = svgOverlay;
  exports.DivOverlay = DivOverlay;
  exports.Popup = Popup;
  exports.popup = popup;
  exports.Tooltip = Tooltip;
  exports.tooltip = tooltip;
  exports.Icon = Icon;
  exports.icon = icon;
  exports.DivIcon = DivIcon;
  exports.divIcon = divIcon;
  exports.Marker = Marker;
  exports.marker = marker;
  exports.TileLayer = TileLayer;
  exports.tileLayer = tileLayer;
  exports.GridLayer = GridLayer;
  exports.gridLayer = gridLayer;
  exports.SVG = SVG;
  exports.svg = svg$1;
  exports.Renderer = Renderer;
  exports.Canvas = Canvas;
  exports.canvas = canvas$1;
  exports.Path = Path;
  exports.CircleMarker = CircleMarker;
  exports.circleMarker = circleMarker;
  exports.Circle = Circle;
  exports.circle = circle;
  exports.Polyline = Polyline;
  exports.polyline = polyline;
  exports.Polygon = Polygon;
  exports.polygon = polygon;
  exports.Rectangle = Rectangle;
  exports.rectangle = rectangle;
  exports.Map = Map;
  exports.map = createMap;

  var oldL = window.L;
  exports.noConflict = function() {
  	window.L = oldL;
  	return this;
  }

  // Always export us to window global (see #2364)
  window.L = exports;

})));
//# sourceMappingURL=leaflet-src.js.map


/***/ }),

/***/ 2431:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _Payment = __webpack_require__(423);

var _Smartcard = __webpack_require__(336);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PaymentError(_ref) {
    var error = _ref.error,
        message = _ref.message,
        onRetry = _ref.onRetry,
        retryLabel = _ref.retryLabel;

    if (!message) {
        var errorMessage = void 0;
        var messageKey = void 0;
        if (error instanceof _Smartcard.ACTError) {
            messageKey = 'confirmation.externalError';
            errorMessage = (0, _I18n.translate)('confirmation.externalErrorMessage');
        } else {
            messageKey = (0, _result3.default)(_AppConstants.PaymentAuthCodes, errorMessage) ? 'payment.error.' + errorMessage : 'payment.error.UNKNOWN_ERROR';
            errorMessage = (0, _get3.default)(error, 'message');
        }
        message = (0, _I18n.translate)(messageKey, { message: errorMessage });
    }

    return _react2.default.createElement(
        'div',
        { className: 'confirmation text-center js-payment-result', 'data-error': message || error },
        _react2.default.createElement(_Icon2.default, { icon: 'clear margin-bottom--sm otrl-xl' }),
        _react2.default.createElement(
            'p',
            { className: 'alert-danger text-weight--normal' },
            (0, _I18n.translate)('confirmation.decline')
        ),
        _react2.default.createElement(
            'p',
            { className: 'text-sm margin-bottom' },
            message
        ),
        onRetry && _react2.default.createElement(
            _Button2.default,
            { bsStyle: 'default', onClick: onRetry },
            (0, _I18n.translate)(retryLabel),
            _react2.default.createElement(_Icon2.default, { className: 'pull-left otrl-rotate-180', icon: 'chevron' })
        )
    );
}

PaymentError.propTypes = {
    error: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Payment.PaymentUnauthorizedError), _propTypes2.default.instanceOf(_Smartcard.ACTError)]),
    message: _propTypes2.default.string,
    onRetry: _propTypes2.default.func,
    retryLabel: _propTypes2.default.string
};

PaymentError.defaultProps = {
    onRetry: null,
    retryLabel: 'confirmation.backToPayment'
};

exports.default = PaymentError;

/***/ }),

/***/ 2432:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _PassengersForm = __webpack_require__(2395);

var _PassengersForm2 = _interopRequireDefault(_PassengersForm);

var _SectionErrors = __webpack_require__(974);

var _SectionErrors2 = _interopRequireDefault(_SectionErrors);

var _StepperInput = __webpack_require__(2405);

var _StepperInput2 = _interopRequireDefault(_StepperInput);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PassengersSelector = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(PassengersSelector, _PureRenderComponent);

    function PassengersSelector() {
        (0, _classCallCheck3.default)(this, PassengersSelector);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    PassengersSelector.prototype.render = function render() {
        var _props = this.props,
            adults = _props.adults,
            children = _props.children,
            className = _props.className,
            hideInfo = _props.hideInfo,
            onAdultsChange = _props.onAdultsChange,
            onChildrenChange = _props.onChildrenChange,
            maxTickets = _props.maxTickets;

        var childText = (0, _I18n.translate)('booking.railcards.stepper.child', { children: children });
        var adultText = (0, _I18n.translate)('booking.railcards.stepper.adult', { adults: adults });

        var form = new this.props.Form({
            adults: adults,
            children: children
        });
        var errors = form.getValidationSummary();
        var errorArray = form.getValidationSummaryArray();

        var maxAdults = maxTickets !== -1 ? maxTickets - children : 9;
        var maxChildren = maxTickets !== -1 ? maxTickets - adults : 9;

        return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(className) },
            _react2.default.createElement(
                'div',
                { className: 'stepper-container' },
                _react2.default.createElement(_StepperInput2.default, {
                    name: 'adults',
                    label: adultText,
                    value: adults,
                    onChange: onAdultsChange,
                    error: errors.adults || errors.total || null,
                    max: maxAdults
                }),
                _react2.default.createElement(_StepperInput2.default, {
                    name: 'children',
                    label: childText,
                    value: children,
                    onChange: onChildrenChange,
                    error: errors.children || errors.total || null,
                    max: maxChildren
                })
            ),
            !hideInfo && _react2.default.createElement(
                'p',
                { className: 'text-sm text-light margin-top--sm' },
                (0, _I18n.translate)('booking.passenger.child-fare.info')
            ),
            errorArray.length > 0 && _react2.default.createElement(_SectionErrors2.default, { errors: errorArray })
        );
    };

    return PassengersSelector;
}(_PureRenderComponent3.default), _class.propTypes = {
    adults: _propTypes2.default.number.isRequired,
    children: _propTypes2.default.number.isRequired,
    onAdultsChange: _propTypes2.default.func.isRequired,
    onChildrenChange: _propTypes2.default.func.isRequired,
    className: _propTypes2.default.string,
    Form: _propTypes2.default.func,
    hideInfo: _propTypes2.default.bool,
    maxTickets: _propTypes2.default.number
}, _class.defaultProps = {
    className: '',
    Form: _PassengersForm2.default,
    hideInfo: false,
    maxTickets: -1
}, _temp);
exports.default = PassengersSelector;

/***/ }),

/***/ 2442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _Link = __webpack_require__(275);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SmartcardReplacementWarning() {
    return _react2.default.createElement(
        'div',
        { className: 'margin-top padding-bottom' },
        _react2.default.createElement(
            'div',
            { className: 'clearfix margin-top' },
            _react2.default.createElement(
                'h2',
                { className: 'text-lg text-weight--normal no-margin padding-bottom--sm alert-warning' },
                (0, _I18n.translate)('account.heading.smartcard.replacement.warning')
            ),
            _react2.default.createElement(
                'div',
                { className: 'box box--padded box--rounded box--warning' },
                _react2.default.createElement(
                    _Row2.default,
                    null,
                    _react2.default.createElement(
                        _Col2.default,
                        { sm: 12, md: 12, lg: 10 },
                        _react2.default.createElement(
                            'p',
                            { className: 'alert-warning' },
                            (0, _I18n.translate)('account.smartcard.text.replacement.warning')
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: 'no-margin' },
                            _react2.default.createElement(
                                _Link2.default,
                                { to: _AppConstants.AccountPages.SMARTCARD_REPLACEMENT },
                                (0, _I18n.translate)('account.smartcard.text.replacement.linkText')
                            )
                        )
                    )
                )
            )
        )
    );
}

exports.default = SmartcardReplacementWarning;

/***/ }),

/***/ 2443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _MomentPropTypes = __webpack_require__(230);

var _MomentPropTypes2 = _interopRequireDefault(_MomentPropTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// cannot be a functional component as a ref is used (https://reactjs.org/docs/refs-and-the-dom.html#refs-and-functional-components)

var TodayTomorrowControls = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(TodayTomorrowControls, _React$PureComponent);

    function TodayTomorrowControls() {
        (0, _classCallCheck3.default)(this, TodayTomorrowControls);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    TodayTomorrowControls.prototype.render = function render() {
        var _props = this.props,
            disabled = _props.disabled,
            onChange = _props.onChange,
            startDate = _props.startDate,
            srOnly = _props.srOnly,
            autoFocusedElt = _props.autoFocusedElt;


        var controlClass = (0, _classnames2.default)('btn-link like-link');

        var changeHandler = function changeHandler(date, type) {
            return function () {
                _TrackingActions2.default.widgetSearchClick({ name: type });
                if (startDate && !disabled) {
                    onChange(date.set({
                        hour: startDate.hour(),
                        minute: startDate.minute()
                    }));
                }
            };
        };

        return _react2.default.createElement(
            'div',
            { className: 'calendar-dropdown__controls clearfix' },
            _react2.default.createElement(
                'button',
                { className: controlClass + " pull-left",
                    disabled: disabled,
                    onClick: changeHandler((0, _TrainTime2.default)().clone(), 'today'),
                    ref: autoFocusedElt },
                srOnly && _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    srOnly
                ),
                (0, _I18n2.default)('booking.dates.todayAt')
            ),
            _react2.default.createElement(
                'button',
                { className: controlClass + " pull-right",
                    disabled: disabled,
                    onClick: changeHandler((0, _TrainTime2.default)().clone().add(1, 'day'), 'tomorrow') },
                srOnly && _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    srOnly
                ),
                (0, _I18n2.default)('booking.dates.tomorrowAt')
            )
        );
    };

    return TodayTomorrowControls;
}(_react2.default.PureComponent), _class.propTypes = {
    startDate: _MomentPropTypes2.default.isMoment,
    disabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    srOnly: _propTypes2.default.string,
    autoFocusedElt: _propTypes2.default.func
}, _class.defaultProps = {
    startDate: (0, _TrainTime2.default)(),
    disabled: false,
    onChange: _noop3.default,
    srOnly: '',
    autoFocusedElt: _noop3.default
}, _temp);
exports.default = TodayTomorrowControls;

/***/ }),

/***/ 2444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _CVVIcon = __webpack_require__(2475);

var _CVVIcon2 = _interopRequireDefault(_CVVIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardSecurityCode(props) {
    var hideValueProp = props.hideValue ? { disabled: true, value: '', hideError: true } : null;

    return _react2.default.createElement(
        'div',
        { className: 'card-security-code input-with-addon input-with-addon--right' },
        _react2.default.createElement(_ValidatedField2.default, (0, _extends3.default)({}, props, {
            type: 'tel',
            id: 'cvv',
            field: 'cv2',
            name: 'cvv',
            label: (0, _I18n.translate)('customerdetails.payment.cvv'),
            placeholder: (0, _I18n.translate)('customerdetails.payment.cvv'),
            labelClassName: 'sr-only',
            autoComplete: 'cc-csc'
        }, hideValueProp)),
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)("cvv-indicator card-security", { 'card-indicator--outside-label': props.outsideLabel }) },
            _react2.default.createElement(_CVVIcon2.default, null)
        )
    );
}

CardSecurityCode.propTypes = (0, _extends3.default)({}, (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'disabled', 'outsideLabel', 'required', 'visited', 'validation']), {
    hideValue: _propTypes2.default.bool
});

exports.default = CardSecurityCode;

/***/ }),

/***/ 2445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _AppConstants = __webpack_require__(6);

var _I18n = __webpack_require__(9);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _SeasonSearch = __webpack_require__(328);

var _SeasonSearch2 = _interopRequireDefault(_SeasonSearch);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _ViaAvoidModal = __webpack_require__(2446);

var _ViaAvoidModal2 = _interopRequireDefault(_ViaAvoidModal);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViaAvoid = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(ViaAvoid, _PureRenderComponent);

    function ViaAvoid() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ViaAvoid);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            showVia: false
        }, _this._handleViaAvoidChange = function (viaAvoid, station) {
            var current = _this._getViaAvoid();
            var search = _this.props.search.set(current, new _Station2.default()).set(viaAvoid, station);
            _this.props.onChange(search);
            _this._closeViaModal();
        }, _this._handleClick = function () {
            if (!_this._isSelected()) {
                _this._openViaModal();
            } else {
                _this._handleViaAvoidChange(_this._getViaAvoid(), new _Station2.default()); // Clear both stations
            }
        }, _this._openViaModal = function () {
            _this.setState({ showVia: true });
        }, _this._closeViaModal = function () {
            _this.setState({ showVia: false });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    ViaAvoid.prototype._getViaAvoid = function _getViaAvoid() {
        return this.props.search.avoid.nlc ? _AppConstants.StationTypes.AVOID : _AppConstants.StationTypes.VIA;
    };

    ViaAvoid.prototype._renderModal = function _renderModal() {
        if (!this.state.showVia) {
            return null;
        }

        var _props = this.props,
            search = _props.search,
            season = _props.season;


        return _react2.default.createElement(_ViaAvoidModal2.default, {
            search: search,
            show: this.state.showVia,
            season: season,
            station: search[this._getViaAvoid()],
            viaAvoid: this._getViaAvoid(),
            onCancel: this._closeViaModal,
            onSelect: this._handleViaAvoidChange
        });
    };

    ViaAvoid.prototype._getButtonText = function _getButtonText() {
        if (!this._isSelected()) {
            return (0, _I18n.translate)('booking.journey.viaAvoid');
        }

        var viaAvoid = this._getViaAvoid();
        var params = { station: this.props.search[viaAvoid].name };
        var key = 'booking.journey.' + viaAvoid + 'Station';
        return (0, _I18n.translate)(key, params);
    };

    ViaAvoid.prototype._isSelected = function _isSelected() {
        var search = this.props.search;

        return search.via.nlc || search.avoid.nlc;
    };

    ViaAvoid.prototype.render = function render() {
        var errorLabel = this.props.errorLabel;

        var viaIconClasses = (0, _classnames2.default)({
            'add': !this._isSelected(),
            'close': this._isSelected()
        });

        var viaClasses = (0, _classnames2.default)('btn-sm', 'js-via-avoid', {
            'via-avoid-active': this._isSelected(),
            'via-avoid-error': errorLabel
        });

        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                _Button2.default,
                { ref: 'button', bsStyle: 'default', className: viaClasses, onClick: this._handleClick },
                _react2.default.createElement(_Icon2.default, { icon: viaIconClasses }),
                this._getButtonText(),
                errorLabel
            ),
            this._renderModal()
        );
    };

    return ViaAvoid;
}(_PureRenderComponent3.default), _class.propTypes = {
    season: _propTypes2.default.bool,
    search: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Search2.default), _propTypes2.default.instanceOf(_SeasonSearch2.default)]).isRequired,
    onChange: _propTypes2.default.func,
    errorLabel: _propTypes2.default.node
}, _class.defaultProps = {
    season: false,
    onChange: _noop3.default,
    errorLabel: null
}, _temp2);
exports.default = ViaAvoid;

/***/ }),

/***/ 2446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _SeasonSearch = __webpack_require__(328);

var _SeasonSearch2 = _interopRequireDefault(_SeasonSearch);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _StationSelector = __webpack_require__(976);

var _StationSelector2 = _interopRequireDefault(_StationSelector);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViaAvoidModal = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(ViaAvoidModal, _PureRenderComponent);

    function ViaAvoidModal() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ViaAvoidModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            station: _this.props.station,
            viaAvoid: _this.props.viaAvoid
        }, _this._onSave = function () {
            _this.props.onSelect(_this.state.viaAvoid, _this.state.station);
        }, _this._handleViaAvoidChange = function (event) {
            _this.setState({ viaAvoid: event.target.value });
        }, _this._handleViaAvoidStationChange = function (station) {
            _this.setState({ station: station });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    ViaAvoidModal.prototype._isDirty = function _isDirty() {
        return this.props.station !== this.state.station && this.props.viaAvoid !== this.state.viaAvoid;
    };

    ViaAvoidModal.prototype._hasErrors = function _hasErrors() {
        return !this.state.station.nlc;
    };

    ViaAvoidModal.prototype.render = function render() {
        var viaAvoid = this.state.viaAvoid;
        var _props = this.props,
            search = _props.search,
            season = _props.season,
            show = _props.show,
            onCancel = _props.onCancel;

        var placeholder = viaAvoid === _AppConstants.StationTypes.VIA ? (0, _I18n.translate)('booking.journey.viaPlaceholder') : (0, _I18n.translate)('booking.journey.avoidPlaceholder');
        var label = viaAvoid === _AppConstants.StationTypes.VIA ? (0, _I18n.translate)('booking.journey.viaLabel') : (0, _I18n.translate)('booking.journey.avoidLabel');
        var modalProps = {
            show: show,
            onClose: onCancel,
            onContinue: this._onSave,
            closeText: 'button.text.cancel',
            continueText: 'button.text.select',
            disableBlur: this._isDirty(),
            disableContinue: this._hasErrors(),
            titleText: 'booking.journey.viaAvoid',
            className: 'modal--sm via-avoid-modal',
            onOpen: function onOpen() {
                _TrackingActions2.default.genericModalOpen(_AppConstants.GenericModals.TRAVEL_VIA_AVOID);
            }
        };

        var stationType = null;
        if (search.get('smartcard')) {
            stationType = _AppConstants.SmartcardStationTypes.VIAAVOID;
        } else if (season) {
            stationType = _AppConstants.SeasonStationTypes.VIAAVOID;
        } else {
            stationType = _AppConstants.StationTypes.VIAAVOID;
        }

        return _react2.default.createElement(
            _BaseModal2.default,
            modalProps,
            _react2.default.createElement(
                'section',
                { className: 'modal-body__via-avoid clearfix' },
                _react2.default.createElement(
                    _Row2.default,
                    null,
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 12, sm: 4 },
                        _react2.default.createElement(
                            'span',
                            { className: 'select-container' },
                            _react2.default.createElement(_Icon2.default, { icon: 'dropdown' }),
                            _react2.default.createElement(
                                'label',
                                { className: 'sr-only', htmlFor: 'via-avoid' },
                                (0, _I18n.translate)('booking.journey.viaAvoid')
                            ),
                            _react2.default.createElement(
                                'select',
                                {
                                    name: 'viaAvoid',
                                    id: 'via-avoid',
                                    className: 'via-avoid__select',
                                    value: viaAvoid,
                                    onChange: this._handleViaAvoidChange },
                                _react2.default.createElement(
                                    'option',
                                    { value: 'via' },
                                    (0, _I18n.translate)('booking.journey.via')
                                ),
                                _react2.default.createElement(
                                    'option',
                                    { value: 'avoid' },
                                    (0, _I18n.translate)('booking.journey.avoid')
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 12, sm: 8 },
                        _react2.default.createElement(
                            'span',
                            { className: 'input-field input-field--autocomplete' },
                            _react2.default.createElement(_StationSelector2.default, {
                                name: 'viaAvoidStation',
                                label: _react2.default.createElement(
                                    'span',
                                    { className: 'sr-only' },
                                    label
                                ),
                                station: this.state.station,
                                placeholder: placeholder,
                                onChange: this._handleViaAvoidStationChange,
                                stationType: stationType
                            })
                        )
                    )
                )
            )
        );
    };

    return ViaAvoidModal;
}(_PureRenderComponent3.default), _class.propTypes = {
    search: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Search2.default), _propTypes2.default.instanceOf(_SeasonSearch2.default)]).isRequired,
    show: _propTypes2.default.bool.isRequired,
    season: _propTypes2.default.bool,
    station: _propTypes2.default.instanceOf(_Station2.default),
    viaAvoid: _propTypes2.default.oneOf([_AppConstants.StationTypes.VIA, _AppConstants.StationTypes.AVOID]),
    onCancel: _propTypes2.default.func,
    onSelect: _propTypes2.default.func
}, _class.defaultProps = {
    season: false,
    station: null,
    viaAvoid: _AppConstants.StationTypes.VIA,
    onCancel: _noop3.default,
    onSelect: _noop3.default
}, _temp2);
exports.default = ViaAvoidModal;

/***/ }),

/***/ 2447:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.StationFinder = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _capitalize2 = __webpack_require__(623);

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _SeasonSearch = __webpack_require__(328);

var _SeasonSearch2 = _interopRequireDefault(_SeasonSearch);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _StationFinderStore = __webpack_require__(990);

var _StationFinderStore2 = _interopRequireDefault(_StationFinderStore);

var _StationFinderActions = __webpack_require__(2401);

var _StationFinderActions2 = _interopRequireDefault(_StationFinderActions);

var _NotificationActions = __webpack_require__(232);

var _NotificationActions2 = _interopRequireDefault(_NotificationActions);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Map = __webpack_require__(2407);

var _Map2 = _interopRequireDefault(_Map);

var _SearchPath = __webpack_require__(2480);

var _SearchPath2 = _interopRequireDefault(_SearchPath);

var _SearchOverlay = __webpack_require__(2481);

var _SearchOverlay2 = _interopRequireDefault(_SearchOverlay);

var _StationMarker = __webpack_require__(2483);

var _StationMarker2 = _interopRequireDefault(_StationMarker);

var _StationFinderModal = __webpack_require__(2449);

var _StationFinderModal2 = _interopRequireDefault(_StationFinderModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StationFinder = exports.StationFinder = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(StationFinder, _React$PureComponent);

    function StationFinder() {
        var _this5 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, StationFinder);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            selectedStation: null,
            showStationFinderModal: false,
            stationFinderActive: false,
            isSearchingStations: false,
            ticketOffice: null,
            loadingTicketOfficeDetails: false
        }, _this.positionSelectedMarker = null, _this._getGBoundsFromCoords = function (bounds) {
            var gBounds = new window.google.maps.LatLngBounds();
            bounds.forEach(function (latLng) {
                return gBounds.extend(latLng);
            });
            return gBounds;
        }, _this._resizeAndFitBounds = function () {
            var _this2 = _this,
                mapsHelper = _this2.mapsHelper;

            var bounds = _StationFinderStore2.default.getBounds();

            mapsHelper.resize();

            if (bounds.length > 0) {
                mapsHelper.map.fitBounds(_this._getGBoundsFromCoords(bounds));
            }
        }, _this.onSelectPosition = function (pos) {
            var _this3 = _this,
                mapsHelper = _this3.mapsHelper;


            _this.setState({ stationFinderActive: true });

            _this._removeSelectedPositionMarker();

            if (_this.props.stations.size) {
                _this._clearSuggestedStationMarkers();
            }

            var icon = {
                url: '/images/station-marker-' + _config2.default.get('brand').split('-')[0] + '.svg',
                fillOpacity: 1,
                scaledSize: new window.google.maps.Size(50, 50)
            };

            _this.positionSelectedMarker = mapsHelper.addMarker({
                position: pos,
                icon: icon,
                name: 'locationSelected',
                title: 'Your Position',
                animation: 'DROP',
                draggable: true
            });

            mapsHelper.setCenter(pos);
            _this.positionSelectedMarker.addListener('dragend', function (e) {
                _this.resetSelectedPosition(e);
            });
            _this.positionSelectedMarker.addListener('click', function () {
                _this._resizeAndFitBounds();
            });
        }, _this.resetSelectedPosition = function (e) {
            var latLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            _this.onSelectPosition(latLng);
            _this.handleSearch(latLng);
        }, _this.zoomToPosition = function (pos) {
            var _this4 = _this,
                mapsHelper = _this4.mapsHelper;

            mapsHelper.setCenter(pos);
            mapsHelper.setZoomLevel(17);
        }, _this.handleSearchClear = function () {
            _this._removeSelectedPositionMarker();
            _this.setState({ stationFinderActive: false });

            if (_this.props.stations.size > 0) {
                _this._clearSuggestedStationMarkers();
            }
        }, _this.handleSearch = function (_ref, searchInteraction) {
            var latitude = _ref.lat,
                longitude = _ref.lng;

            _this.setState({ isSearchingStations: true });
            _StationFinderActions2.default.findNearest({ latitude: latitude, longitude: longitude, searchInteraction: searchInteraction });
        }, _this.handleMapReady = function (mapsHelper) {
            _this.mapsHelper = mapsHelper;
        }, _this.handleStationSelected = function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(station) {
                var ticketOffice;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this._resizeAndFitBounds();
                                _this.setState({
                                    showStationFinderModal: true,
                                    selectedStation: station,
                                    ticketOffice: null,
                                    loadingTicketOfficeDetails: true
                                });

                                _context.prev = 2;
                                _context.next = 5;
                                return _StationFinderActions2.default.getTicketOfficeDetails(station);

                            case 5:
                                ticketOffice = _context.sent;

                                _this.setState(function (state) {
                                    return state.selectedStation === station ? { ticketOffice: ticketOffice } : {};
                                });
                                _context.next = 12;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](2);

                                console.warn('error loading opening hours', _context.t0);

                            case 12:
                                _this.setState({ loadingTicketOfficeDetails: false });

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this5, [[2, 9]]);
            }));

            return function (_x) {
                return _ref2.apply(this, arguments);
            };
        }(), _this.handleStationFinderModalClose = function () {
            _this.setState({ showStationFinderModal: false });
        }, _this._handleStationChange = function (type, value) {
            _StationFinderActions2.default.setStationSelected(type, value);

            if (_this.props.isMobile) {
                _this._clearSuggestedStationMarkers();
            }

            _this.props.onChange(type, value);

            if (_this.props.isMobile) {
                var updatedText = (0, _capitalize3.default)(type) + ' ' + (0, _I18n.translate)('stationFinder.modal.update') + ' ' + value.name;
                _NotificationActions2.default.showNotification(updatedText);
                _this.props.closeContainerModal();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    StationFinder.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        if (this.props.stations.size) {
            this._clearSuggestedStationMarkers();
        }
    };

    StationFinder.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.origin !== this.props.origin || newProps.destination !== this.props.destination) {
            this.setState({ stationFinderActive: false });
            this._clearSuggestedStationMarkers();
            this._removeSelectedPositionMarker();
            if (this.props.isExpanded) {
                _StationFinderActions2.default.setExpanded(false);
            }
        }

        if (newProps.stations.size > 0 || newProps.error) {
            this.setState({ isSearchingStations: false });
            this._resizeAndFitBounds();
        }
    };

    StationFinder.prototype._clearSuggestedStationMarkers = function _clearSuggestedStationMarkers() {
        (0, _defer3.default)(_StationFinderActions2.default.clearStations);
    };

    StationFinder.prototype._removeSelectedPositionMarker = function _removeSelectedPositionMarker() {
        if (this.positionSelectedMarker) {
            this.positionSelectedMarker.setMap(null);
            this.positionSelectedMarker = null;
        }
    };

    StationFinder.prototype._getContainerClassName = function _getContainerClassName() {
        return (0, _classnames2.default)('stationFinder__container', {
            'mobile': this.props.isMobile
        });
    };

    StationFinder.prototype.render = function render() {
        var _this6 = this;

        var _props = this.props,
            origin = _props.origin,
            destination = _props.destination,
            stations = _props.stations,
            currentSearch = _props.currentSearch;
        var _state = this.state,
            stationFinderActive = _state.stationFinderActive,
            isSearchingStations = _state.isSearchingStations,
            selectedStation = _state.selectedStation,
            ticketOffice = _state.ticketOffice,
            showStationFinderModal = _state.showStationFinderModal,
            loadingTicketOfficeDetails = _state.loadingTicketOfficeDetails;


        return _react2.default.createElement(
            'div',
            { className: this._getContainerClassName() },
            _react2.default.createElement(
                _Map2.default,
                { allowMapExpand: !this.props.isMobile, className: 'map ' + this.props.className, stationFinderActive: stationFinderActive, onReady: this.handleMapReady },
                _react2.default.createElement(_SearchOverlay2.default, {
                    error: this.props.error,
                    isExpanded: this.props.isExpanded,
                    onClear: this.handleSearchClear,
                    isMobile: this.props.isMobile,
                    onSelectPosition: this.onSelectPosition,
                    onSearch: this.handleSearch,
                    isSearchingStations: isSearchingStations }),
                _react2.default.createElement(_SearchPath2.default, { key: 'search', origin: origin, destination: destination }),
                _react2.default.createElement(_StationFinderModal2.default, {
                    selectedStation: selectedStation,
                    ticketOffice: ticketOffice,
                    show: showStationFinderModal,
                    onClose: this.handleStationFinderModalClose,
                    onContinue: this._handleStationChange,
                    loadingTicketOfficeDetails: loadingTicketOfficeDetails,
                    currentSearch: currentSearch }),
                stations && stations.map(function (station) {
                    return _react2.default.createElement(_StationMarker2.default, { key: station.nlc, station: station, onSelect: _this6.handleStationSelected });
                })
            )
        );
    };

    return StationFinder;
}(_react2.default.PureComponent), _class.propTypes = {
    className: _propTypes2.default.string,
    origin: _propTypes2.default.instanceOf(_Station2.default),
    destination: _propTypes2.default.instanceOf(_Station2.default),
    stations: _propTypes2.default.instanceOf(_immutable.List),
    error: _propTypes2.default.instanceOf(Error),
    isExpanded: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    isMobile: _propTypes2.default.bool.isRequired,
    closeContainerModal: _propTypes2.default.func,
    currentSearch: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Search2.default), _propTypes2.default.instanceOf(_SeasonSearch2.default)])
}, _temp2);


function getStateFromStores() {
    return {
        stations: _StationFinderStore2.default.get('stations'),
        error: _StationFinderStore2.default.get('error'),
        isExpanded: _StationFinderStore2.default.get('isExpanded')
    };
}

exports.default = (0, _connectToStores2.default)([_StationFinderStore2.default], getStateFromStores)(StationFinder);

/***/ }),

/***/ 2448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = SearchExpander;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SearchExpander(_ref) {
    var onExpand = _ref.onExpand,
        isSearching = _ref.isSearching,
        isExpanded = _ref.isExpanded,
        isDisabled = _ref.isDisabled;

    var expanderClassNames = (0, _classnames2.default)('input-group-btn expander', {
        'hidden': _config2.default.get('disableStationFinder')
    });
    var buttonClick = isSearching ? null : onExpand;
    var buttonIcon = isSearching ? _react2.default.createElement(_Icon2.default, { className: 'search-spin', icon: 'spinner' }) : isExpanded ? _react2.default.createElement(_Icon2.default, { icon: 'close' }) : _react2.default.createElement(_Icon2.default, { icon: 'search' });
    var buttonLabel = isExpanded ? (0, _I18n2.default)('stationFinder.shrink.buttonLabel') : (0, _I18n2.default)('stationFinder.expand.buttonLabel');

    return _react2.default.createElement(
        'span',
        { className: expanderClassNames },
        _react2.default.createElement(
            _Button2.default,
            {
                onClick: buttonClick,
                disabled: isDisabled,
                bsStyle: 'primary',
                'aria-expanded': Boolean(isExpanded),
                'aria-controls': 'stationFinder-overlay',
                'aria-label': buttonLabel
            },
            buttonIcon
        )
    );
}

SearchExpander.propTypes = {
    onExpand: _propTypes2.default.func.isRequired,
    isSearching: _propTypes2.default.bool,
    isExpanded: _propTypes2.default.bool,
    isDisabled: _propTypes2.default.bool
};

SearchExpander.defaultProps = {
    isSearching: false,
    isExpanded: false
};

/***/ }),

/***/ 2449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _get2 = __webpack_require__(61);

var _get3 = _interopRequireDefault(_get2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _AppConstants = __webpack_require__(6);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _TicketOffice = __webpack_require__(604);

var _TicketOffice2 = _interopRequireDefault(_TicketOffice);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _SeasonSearch = __webpack_require__(328);

var _SeasonSearch2 = _interopRequireDefault(_SeasonSearch);

var _OpeningHours = __webpack_require__(2484);

var _OpeningHours2 = _interopRequireDefault(_OpeningHours);

var _OpeningStatus = __webpack_require__(2485);

var _OpeningStatus2 = _interopRequireDefault(_OpeningStatus);

var _StationFacilities = __webpack_require__(2486);

var _StationFacilities2 = _interopRequireDefault(_StationFacilities);

var _AddStation = __webpack_require__(2487);

var _AddStation2 = _interopRequireDefault(_AddStation);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StationFinderModal = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(StationFinderModal, _React$PureComponent);

    function StationFinderModal() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, StationFinderModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            activeAddButton: null
        }, _this.handleAddButtonSelected = function (selected) {
            _this.setState({
                activeAddButton: selected
            });
        }, _this.handleClose = function () {
            _this.setState({
                activeAddButton: null
            });

            _this.props.onClose();
        }, _this.handleUpdateJourney = function () {
            _this.props.onContinue(_this.state.activeAddButton, _this.props.selectedStation);
            _this.handleClose();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    StationFinderModal.prototype._getSelectedStationName = function _getSelectedStationName() {
        var selectedStation = this.props.selectedStation;

        return selectedStation ? selectedStation.name : null;
    };

    StationFinderModal.prototype._getModalProps = function _getModalProps() {
        return {
            show: this.props.show,
            className: 'grid-modal modal--sm stationFinder__modal',
            onClose: this.handleClose,
            onContinue: this.handleUpdateJourney,
            onOpen: function onOpen() {
                _TrackingActions2.default.genericModalOpen(_AppConstants.GenericModals.STATION_FINDER);
            },
            titleText: this._getSelectedStationName(),
            closeText: 'button.text.cancel',
            continueText: 'button.text.apply',
            disableContinue: this.state.activeAddButton === null
        };
    };

    StationFinderModal.prototype.render = function render() {
        var _props = this.props,
            selectedStation = _props.selectedStation,
            ticketOffice = _props.ticketOffice,
            loadingTicketOfficeDetails = _props.loadingTicketOfficeDetails;

        var facilities = (0, _get3.default)(selectedStation, 'facilities');

        return _react2.default.createElement(
            _BaseModal2.default,
            this._getModalProps(),
            _react2.default.createElement(_OpeningStatus2.default, { loadingTicketOfficeDetails: loadingTicketOfficeDetails,
                ticketOffice: ticketOffice }),
            _react2.default.createElement(_AddStation2.default, {
                activeAddButton: this.state.activeAddButton,
                onSelect: this.handleAddButtonSelected
            }),
            facilities && _react2.default.createElement(_StationFacilities2.default, { facilities: facilities }),
            _react2.default.createElement(_OpeningHours2.default, { ticketOffice: ticketOffice,
                loadingTicketOfficeDetails: loadingTicketOfficeDetails })
        );
    };

    return StationFinderModal;
}(_react2.default.PureComponent), _class.propTypes = {
    show: _propTypes2.default.bool.isRequired,
    onClose: _propTypes2.default.func,
    onContinue: _propTypes2.default.func,
    selectedStation: _propTypes2.default.instanceOf(_Station2.default),
    ticketOffice: _propTypes2.default.instanceOf(_TicketOffice2.default),
    loadingTicketOfficeDetails: _propTypes2.default.bool,
    currentSearch: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Search2.default), _propTypes2.default.instanceOf(_SeasonSearch2.default)])
}, _class.defaultProps = {
    onClose: _noop3.default,
    onContinue: _noop3.default,
    selectedStation: null,
    ticketOffice: null,
    loadingTicketOfficeDetails: false
}, _temp2);
exports.default = StationFinderModal;

/***/ }),

/***/ 2450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AppConstants = __webpack_require__(6);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Fare = __webpack_require__(98);

var _Fare2 = _interopRequireDefault(_Fare);

var _Fares = __webpack_require__(605);

var _Fares2 = _interopRequireDefault(_Fares);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _ModalActions = __webpack_require__(27);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shouldShowSeatfinderButton = function shouldShowSeatfinderButton(trip) {
    if (!trip) {
        return false;
    }

    var outboundDateTime = trip.search.outboundDateTime.datetime;
    var durationHours = _TrainTime2.default.calendarDuration(outboundDateTime, (0, _TrainTime2.default)(new Date())).asHours();
    var configLimitDurationHours = _config2.default.get('seatingAvailabilityButtonShowDurationHours');

    return configLimitDurationHours >= durationHours;
};

var getCheapestFares = function getCheapestFares(trip, services, selectedService, fareClass, fareCategory, direction) {
    var size = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 3;

    var relevantServices = services.getServicesForDirection(direction).slice(0, size);

    return relevantServices.map(function (service) {
        if (service.isDisabledForTrip(trip)) {
            return new _Fare2.default();
        }

        var fare = fareCategory === _AppConstants.FareCategories.OFF_PEAK ? getCheapestOffPeakFare(trip, service, selectedService, fareClass, fareCategory, direction) : getCheapestFare(trip, service, selectedService, fareClass, fareCategory, direction);

        if (!fare) {
            return new _Fare2.default();
        }

        return fare;
    });
};

var getCheapestFare = function getCheapestFare(trip, service, selectedService, fareClass, fareCategory, direction) {
    var overAllCheapest = trip.getCheapestFareFromOverAll(fareCategory, fareClass, direction);
    if (direction === _AppConstants.JourneyDirections.OUTWARD && overAllCheapest && service.isValidWithFare(overAllCheapest) && selectedService.isValidWithFare(overAllCheapest)) {
        return overAllCheapest;
    }

    var filters = [_Fares2.default.isSingle];
    if (!trip.isReturn()) {
        if (fareCategory === _AppConstants.FareCategories.ADVANCE) {
            filters.push(_Fares2.default.isAdvance);
        }
        if (fareCategory === _AppConstants.FareCategories.ANYTIME) {
            filters.push(_Fares2.default.isAnytime);
        }
    }
    if (fareClass === _AppConstants.FareClasses.STANDARD) {
        filters.push(_Fares2.default.isStandard);
    } else {
        filters.push(_Fares2.default.isFirstClass);
    }

    return service.fares.getCheapestFare(filters);
};

var getCheapestOffPeakFare = function getCheapestOffPeakFare(trip, service, selectedService, fareClass, fareCategory, direction) {
    var overAllCheapest = trip.getCheapestFareFromOverAll(fareCategory, fareClass, direction);

    if (direction === _AppConstants.JourneyDirections.OUTWARD && overAllCheapest && service.isValidWithFare(overAllCheapest) && selectedService.isValidWithFare(overAllCheapest)) {
        return overAllCheapest;
    }

    var filters = [_Fares2.default.isOffPeak];
    if (trip.isReturn() || trip.isOpenReturn()) {
        filters.push(_Fares2.default.isReturn);
    } else if (!trip.isReturn() && !trip.search.isReturnLondonTravelcard()) {
        filters.push(_Fares2.default.isSingle);
    } else if (!trip.isReturn() && trip.search.isReturnLondonTravelcard()) {
        filters.push(_Fares2.default.isSingleOrTravelcard);
    }

    if (fareClass === _AppConstants.FareClasses.STANDARD) {
        filters.push(_Fares2.default.isStandard);
    } else {
        filters.push(_Fares2.default.isFirstClass);
    }

    if (direction === _AppConstants.JourneyDirections.OUTWARD) {
        var result = service.fares.getCheapestFare(filters);
        return result;
    } else {
        var _result = _Fares2.default.getCheapestCompatibleWithServiceFromList(getInwardServiceFareList(service, fareClass, _Fares2.default.isOffPeak), selectedService);
        return _result;
    }
};

var getInwardServiceFareList = function getInwardServiceFareList(service, fareClass, filter) {
    var fareList = service.fares.getReturnFares().filter(filter);

    if (fareClass === _AppConstants.FareClasses.STANDARD) {
        fareList = fareList.filter(_Fares2.default.isStandard);
    }

    if (fareClass === _AppConstants.FareClasses.FIRST_CLASS) {
        fareList = fareList.filter(_Fares2.default.isFirstClass);
    }

    return fareList;
};

var getCheapestAnytimeFare = function getCheapestAnytimeFare(trip, service, selectedOutwardService, fareClass, fareCategory, direction) {
    var overAllCheapest = trip.getCheapestFareFromOverAll(fareCategory, fareClass, direction);

    if (direction === _AppConstants.JourneyDirections.OUTWARD && overAllCheapest && service.isValidWithFare(overAllCheapest) && selectedOutwardService.isValidWithFare(overAllCheapest)) {
        return overAllCheapest;
    }

    var result = _Fares2.default.getCheapestCompatibleWithServiceFromList(getInwardServiceFareList(service, fareClass, _Fares2.default.isAnytime), selectedOutwardService);

    return result;
};

var getJourneyDepartureDate = function getJourneyDepartureDate(_ref) {
    var services = _ref.services,
        search = _ref.search,
        direction = _ref.direction;

    var firstService = services && services.first();
    var time = void 0;

    if (!firstService) {
        time = direction === _AppConstants.JourneyDirections.OUTWARD ? search.getOutboundDateTime() : search.getReturnDateTime();
    } else {
        time = firstService.getArrivalDateTime(false);
    }

    return time.format('ddd DD MMM YYYY');
};

var handleDifferentDaySearchResult = function handleDifferentDaySearchResult(_ref2) {
    var search = _ref2.search,
        response = _ref2.response;

    if (!response) {
        return;
    }

    var result = response.result;


    if (!result.outward.size) {
        return;
    }

    var searchTime = search.outboundDateTime.datetime.clone();
    var firstJourneyTime = result.outward.first().journey.origin.time.scheduledTime;
    var diffInDays = searchTime.startOf('day').diff(firstJourneyTime.clone().startOf('day'), 'days');

    if (!diffInDays) {
        return;
    }

    var nextRailDay = searchTime.clone().add(1, 'days').hours(_AppConstants.RailDayStart.hours).minutes(_AppConstants.RailDayStart.minutes).seconds(0);

    if (diffInDays === -1 && firstJourneyTime.isBefore(nextRailDay)) {
        return;
    }

    _ModalActions2.default.open(_AppConstants.GlobalModals.INFO, {
        type: 'warning',
        heading: 'stationFinder.nextDay.modal.heading',
        message: 'stationFinder.nextDay.modal.message'
    });
};

exports.default = {
    getCheapestFare: getCheapestFare,
    getCheapestOffPeakFare: getCheapestOffPeakFare,
    getCheapestFares: getCheapestFares,
    getCheapestAnytimeFare: getCheapestAnytimeFare,
    shouldShowSeatfinderButton: shouldShowSeatfinderButton,
    getJourneyDepartureDate: getJourneyDepartureDate,
    handleDifferentDaySearchResult: handleDifferentDaySearchResult
};

/***/ }),

/***/ 2455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _values = __webpack_require__(126);

var _values2 = _interopRequireDefault(_values);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _Checkbox = __webpack_require__(158);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _HelpIcon = __webpack_require__(335);

var _HelpIcon2 = _interopRequireDefault(_HelpIcon);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OpenReturnCheckbox = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(OpenReturnCheckbox, _PureRenderComponent);

    function OpenReturnCheckbox() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, OpenReturnCheckbox);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.toggleOpenReturn = function () {
            _TrackingActions2.default.widgetSearchClick({ name: 'open-return:' + !_this.props.search.isOpenReturn() });
            var _this$props = _this.props,
                search = _this$props.search,
                ticketTypeWhenOff = _this$props.ticketTypeWhenOff;

            var ticketType = search.isOpenReturn() ? ticketTypeWhenOff : _AppConstants.TicketTypes.OPEN_RETURN;
            _this.props.onChange(search.setTicketType(ticketType));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    OpenReturnCheckbox.prototype.render = function render() {
        var label = _react2.default.createElement(
            'span',
            null,
            (0, _I18n.translate)('booking.ticketType.openReturn'),
            _react2.default.createElement(
                _FeatureFlag2.default,
                { name: 'enableOpenReturnInfoModal' },
                _react2.default.createElement(_HelpIcon2.default, {
                    icon: 'info',
                    heading: (0, _I18n.translate)('help.openReturn.title'),
                    message: (0, _I18n.translate)('help.openReturn.message')
                })
            )
        );

        return _react2.default.createElement(_Checkbox2.default, { label: label,
            groupClassName: 'form-group open-return',
            checked: this.props.search.isOpenReturn(),
            onChange: this.toggleOpenReturn });
    };

    return OpenReturnCheckbox;
}(_PureRenderComponent3.default), _class.propTypes = {
    search: _propTypes2.default.instanceOf(_Search2.default),
    onChange: _propTypes2.default.func,
    ticketTypeWhenOff: _propTypes2.default.oneOf((0, _values2.default)(_AppConstants.TicketTypes))
}, _class.defaultProps = {
    search: new _Search2.default(),
    onChange: _noop3.default,
    ticketTypeWhenOff: _AppConstants.TicketTypes.SINGLE
}, _temp2);
exports.default = OpenReturnCheckbox;

/***/ }),

/***/ 2456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _I18n = __webpack_require__(9);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _Checkbox = __webpack_require__(158);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DepartNowCheckbox = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(DepartNowCheckbox, _React$PureComponent);

    function DepartNowCheckbox() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DepartNowCheckbox);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.toggleNow = function () {
            _TrackingActions2.default.widgetSearchClick({ name: 'depart-now:' + !_this.props.search.departNow });
            var _this$props = _this.props,
                search = _this$props.search,
                onChange = _this$props.onChange;

            onChange(search.set('departNow', !search.departNow));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    DepartNowCheckbox.prototype.render = function render() {
        return _react2.default.createElement(
            _FeatureFlag2.default,
            { name: 'enableDepartNow' },
            _react2.default.createElement(_Checkbox2.default, { id: 'departNow',
                label: (0, _I18n.translate)('booking.search.departNowLabel'),
                groupClassName: 'form-group open-return',
                checked: Boolean(this.props.search.departNow),
                onChange: this.toggleNow
            })
        );
    };

    return DepartNowCheckbox;
}(_react2.default.PureComponent), _class.propTypes = {
    search: _propTypes2.default.instanceOf(_Search2.default),
    onChange: _propTypes2.default.func
}, _class.defaultProps = {
    search: new _Search2.default(),
    onChange: _noop3.default
}, _temp2);
exports.default = DepartNowCheckbox;

/***/ }),

/***/ 2457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _omit2 = __webpack_require__(174);

var _omit3 = _interopRequireDefault(_omit2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _AppConstants = __webpack_require__(6);

var _JourneySelectorOpen = __webpack_require__(2479);

var _JourneySelectorOpen2 = _interopRequireDefault(_JourneySelectorOpen);

var _JourneySelectorClosed = __webpack_require__(2490);

var _JourneySelectorClosed2 = _interopRequireDefault(_JourneySelectorClosed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function JourneySelector(_ref) {
    var search = _ref.search,
        searchAttempted = _ref.searchAttempted,
        props = (0, _objectWithoutProperties3.default)(_ref, ['search', 'searchAttempted']);

    if (_config2.default.get('journeySelectorType') === _AppConstants.JourneySelectorTypes.OPEN) {
        return _react2.default.createElement(_JourneySelectorOpen2.default, (0, _extends3.default)({ search: search, searchAttempted: searchAttempted }, props));
    } else if (_config2.default.get('journeySelectorType') === _AppConstants.JourneySelectorTypes.CLOSED) {
        var newProps = (0, _omit3.default)(props, ['enableStationFinder']);

        var options = search.getRouteOptions();

        return _react2.default.createElement(_JourneySelectorClosed2.default, (0, _extends3.default)({ search: search,
            options: options
        }, newProps));
    }
    return null;
}

JourneySelector.propTypes = (0, _assign2.default)({}, _JourneySelectorOpen2.default.propTypes, _JourneySelectorClosed2.default.propTypes);

exports.default = JourneySelector;

/***/ }),

/***/ 2458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _Status = __webpack_require__(2493);

var _Status2 = _interopRequireDefault(_Status);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PassengerDetails(_ref) {
    var smartcard = _ref.smartcard;

    return _react2.default.createElement(
        'section',
        { className: 'booking__section booking__section--summary border--top border--bottom' },
        _react2.default.createElement(
            'header',
            null,
            _react2.default.createElement(
                'h2',
                null,
                (0, _I18n.translate)('global.passenger')
            )
        ),
        _react2.default.createElement(
            'p',
            null,
            smartcard.isChild() ? (0, _I18n.translate)('booking.smartcard.passenger.child') : (0, _I18n.translate)('booking.smartcard.passenger.adult')
        ),
        smartcard.railcard && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'header',
                null,
                _react2.default.createElement(
                    'h2',
                    null,
                    (0, _I18n.translate)('booking.smartcard.railcard')
                )
            ),
            _react2.default.createElement(
                'p',
                null,
                smartcard.railcard.name
            )
        ),
        _react2.default.createElement(_Status2.default, { smartcard: smartcard })
    );
}

PassengerDetails.propTypes = {
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default).isRequired
};

exports.default = PassengerDetails;

/***/ }),

/***/ 2459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PromoCodeActions = __webpack_require__(958);

var _PromoCodeActions2 = _interopRequireDefault(_PromoCodeActions);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _PromoCode = __webpack_require__(227);

var _PromoCode2 = _interopRequireDefault(_PromoCode);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * <PromoDiscount /> is used for 2 features, which can be toggled with the enablePromoDiscount and enableDiscountCode feature flags
 * For more information, visit https://ontrackretail.atlassian.net/wiki/spaces/RAIL/pages/2693693441/Promotional+discounts
 */

var PromoDiscount = function PromoDiscount(_ref) {
    var promoCode = _ref.promoCode,
        onChange = _ref.onChange,
        order = _ref.order;

    var _useState = (0, _react.useState)(''),
        discountCode = _useState[0],
        setDiscountCode = _useState[1];

    var _ref2 = promoCode || new _PromoCode2.default(),
        appliedPromoCode = _ref2.promoCode,
        validationError = _ref2.validationError;

    var enablePromoDiscount = _FeatureFlagStore2.default.get('enablePromoDiscount');
    var enablePromoDiscountValidation = _FeatureFlagStore2.default.get('enablePromoDiscountValidation');

    var validatePromoCode = function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : discountCode;

            var promo, _promo;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!order.checkIfThisPromoCodeHasAlreadyApplied(code)) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return', onChange(promoCode.set('validationError', (0, _I18n2.default)('booking.promoCode.theSame.discount.error'))));

                        case 2:
                            if (!(order.hasPromoCode() && !order.checkIfThisPromotionalDiscountHasAlreadyApplied(code))) {
                                _context.next = 4;
                                break;
                            }

                            return _context.abrupt('return', onChange(promoCode.set('validationError', (0, _I18n2.default)('booking.promoCode.one.discount.error'))));

                        case 4:
                            if (!(enablePromoDiscount && enablePromoDiscountValidation)) {
                                _context.next = 11;
                                break;
                            }

                            _context.next = 7;
                            return _PromoCodeActions2.default.validatePromoCode(code);

                        case 7:
                            promo = _context.sent;
                            return _context.abrupt('return', onChange(promo));

                        case 11:
                            _context.next = 13;
                            return _PromoCodeActions2.default.apply({ promoCode: code });

                        case 13:
                            _promo = code && code.length > 20 ? new _PromoCode2.default({ validationError: (0, _I18n2.default)('booking.promoCode.char.limit.error') }) : new _PromoCode2.default({ promoCode: code });
                            return _context.abrupt('return', onChange(_promo));

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function validatePromoCode() {
            return _ref3.apply(this, arguments);
        };
    }();

    (0, _react.useEffect)(function () {
        // for the case when promo code is passed as a query parameter
        if (appliedPromoCode && !discountCode) {
            setDiscountCode(appliedPromoCode);
            validatePromoCode(appliedPromoCode);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appliedPromoCode]);

    var removePromoCode = function removePromoCode() {
        setDiscountCode('');
        onChange(new _PromoCode2.default());
    };

    var onCTAClick = function onCTAClick() {
        if (appliedPromoCode) {
            return removePromoCode();
        }

        return validatePromoCode();
    };

    var onDiscountInputChange = function onDiscountInputChange(_ref4) {
        var target = _ref4.target;

        setDiscountCode(target.value);
        onChange(promoCode.set('validationError', null));
    };

    var renderCodeInput = function renderCodeInput() {
        var hasValidationError = validationError && discountCode;

        var discountInputValidationProps = hasValidationError ? { 'aria-describedby': 'promo-validation-error', 'aria-invalid': true } : { 'aria-label': (0, _I18n2.default)('booking.promoCode.input.aria') };

        if (appliedPromoCode) {
            return _react2.default.createElement(
                'div',
                { className: 'applied-code' },
                (0, _I18n2.default)('booking.promoCode.applied', {
                    promoCode: appliedPromoCode
                })
            );
        }

        return _react2.default.createElement('input', (0, _extends3.default)({
            className: 'input-field ' + (hasValidationError && 'validation-error'),
            value: discountCode,
            onChange: onDiscountInputChange,
            placeholder: '' + (0, _I18n2.default)('order.summary.discount_code')
        }, discountInputValidationProps));
    };

    var renderValidationResult = function renderValidationResult() {
        if (!discountCode) {
            return null;
        }

        if (validationError) {
            return _react2.default.createElement(
                'span',
                { className: 'alert-warning', id: 'promo-validation-error', role: 'alert' },
                validationError
            );
        }

        return _react2.default.createElement(
            'div',
            { className: 'margin-top--sm' },
            _react2.default.createElement(_FormattedHTMLMessage2.default, {
                className: 'margin-top--sm',
                message: promoCode.getParsedTerms()
            })
        );
    };

    var CTAText = (0, _I18n2.default)(appliedPromoCode ? 'railcard.list.remove' : 'button.text.apply');
    var CTAAria = CTAText + ' ' + (0, _I18n2.default)('order.summary.discount_code').toLowerCase();

    var shortDiscountCode = !discountCode || discountCode.length < 3;
    var isCTADisabled = !appliedPromoCode && shortDiscountCode;

    return _react2.default.createElement(
        'section',
        { className: 'booking__section promo-section' },
        _react2.default.createElement(
            'div',
            { className: 'promo-input-wrapper' },
            renderCodeInput(),
            _react2.default.createElement(
                'button',
                {
                    className: 'btn btn-default',
                    'aria-label': CTAAria,
                    onClick: onCTAClick,
                    disabled: isCTADisabled
                },
                CTAText
            )
        ),
        renderValidationResult()
    );
};

PromoDiscount.propTypes = {
    promoCode: _propTypes2.default.instanceOf(_PromoCode2.default).isRequired,
    onChange: _propTypes2.default.func.isRequired,
    order: _propTypes2.default.instanceOf(_Order2.default).isRequired
};

exports.default = PromoDiscount;

/***/ }),

/***/ 2466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _CardHolderName = __webpack_require__(2467);

var _CardHolderName2 = _interopRequireDefault(_CardHolderName);

var _CardNumber = __webpack_require__(2468);

var _CardNumber2 = _interopRequireDefault(_CardNumber);

var _CardExpiryMonth = __webpack_require__(2473);

var _CardExpiryMonth2 = _interopRequireDefault(_CardExpiryMonth);

var _CardExpiryYear = __webpack_require__(2474);

var _CardExpiryYear2 = _interopRequireDefault(_CardExpiryYear);

var _CardSecurityCode = __webpack_require__(2444);

var _CardSecurityCode2 = _interopRequireDefault(_CardSecurityCode);

var _Error = __webpack_require__(199);

var _Error2 = _interopRequireDefault(_Error);

var _SlashIcon = __webpack_require__(2476);

var _SlashIcon2 = _interopRequireDefault(_SlashIcon);

var _CardForm = __webpack_require__(989);

var _CardForm2 = _interopRequireDefault(_CardForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardDetails(props) {
    var isExpired = props.form.getError('isExpired');
    var Wrapper = props.isSubForm ? 'div' : 'form';
    return _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { xs: 12 },
                _react2.default.createElement(_CardHolderName2.default, (0, _extends3.default)({}, props, { required: true, outsideLabel: true }))
            )
        ),
        _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { md: 6, className: 'card-details__number' },
                _react2.default.createElement(_CardNumber2.default, (0, _extends3.default)({}, props, { required: true, outsideLabel: true, showPlaceholder: true }))
            ),
            _react2.default.createElement(
                _Col2.default,
                { md: 6, className: 'card-details__expiry-and-cvv' },
                _react2.default.createElement(
                    _Row2.default,
                    { className: 'row-padding-md' },
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 12, sm: 8 },
                        _react2.default.createElement(
                            'div',
                            { className: 'card-expiry-with-slash' },
                            _react2.default.createElement(_CardExpiryMonth2.default, (0, _extends3.default)({}, props, { required: true, outsideLabel: true })),
                            _react2.default.createElement(_SlashIcon2.default, { className: 'card-slash' }),
                            _react2.default.createElement(_CardExpiryYear2.default, (0, _extends3.default)({}, props, { required: true, outsideLabel: true }))
                        )
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 6, sm: 4 },
                        _react2.default.createElement(_CardSecurityCode2.default, (0, _extends3.default)({}, props, { required: true, outsideLabel: true }))
                    )
                ),
                isExpired && _react2.default.createElement(
                    _Row2.default,
                    null,
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: 12, className: 'card-error' },
                        _react2.default.createElement(_Error2.default, { message: isExpired })
                    )
                )
            )
        )
    );
}

CardDetails.propTypes = (0, _extends3.default)({
    isSubForm: _propTypes2.default.bool,
    showLogos: _propTypes2.default.bool,
    form: _propTypes2.default.instanceOf(_CardForm2.default).isRequired
}, (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'disabled', 'visited', 'validation']));

CardDetails.defaultProps = {
    isSubForm: false
};

exports.default = CardDetails;

/***/ }),

/***/ 2467:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardHolderName(props) {

    return _react2.default.createElement(
        'div',
        { className: 'card-holder-name' },
        _react2.default.createElement(_ValidatedField2.default, (0, _extends3.default)({}, props, {
            type: 'text',
            id: 'cardHolderName',
            name: 'cardholderName',
            field: 'cardHolderName',
            label: (0, _I18n.translate)('customerdetails.payment.cardholder'),
            placeholder: (0, _I18n.translate)('customerdetails.payment.cardholder'),
            labelClassName: 'sr-only',
            autoComplete: 'cc-name'
        }))
    );
}

CardHolderName.propTypes = (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'required', 'disabled', 'visited', 'validation']);

exports.default = CardHolderName;

/***/ }),

/***/ 2468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _slugify = __webpack_require__(626);

var _slugify2 = _interopRequireDefault(_slugify);

var _Card = __webpack_require__(2469);

var _Card2 = _interopRequireDefault(_Card);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

var _CardForm = __webpack_require__(989);

var _CardForm2 = _interopRequireDefault(_CardForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardNumber(props) {
    var _classnames;

    var cardType = _Card2.default.getType(props.form.cardNumber);
    var cardClassNames = (0, _classnames3.default)('card-indicator', (_classnames = {}, _classnames['card-' + (0, _slugify2.default)(cardType && cardType.toLowerCase())] = !!cardType, _classnames));

    return _react2.default.createElement(
        'div',
        { className: 'card-number input-with-addon input-with-addon--right' },
        _react2.default.createElement(_ValidatedField2.default, (0, _extends3.default)({}, props, {
            type: 'tel',
            id: 'cardNumber',
            field: 'cardNumber',
            name: 'cc-number',
            label: (0, _I18n.translate)('customerdetails.payment.cardnumber'),
            placeholder: (0, _I18n.translate)('customerdetails.payment.cardnumber.placeholder'),
            showPlaceholder: true,
            labelClassName: 'sr-only',
            autoComplete: 'cc-number'
        })),
        _react2.default.createElement('div', { className: cardClassNames })
    );
}

CardNumber.propTypes = (0, _extends3.default)({
    form: _propTypes2.default.instanceOf(_CardForm2.default).isRequired
}, (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'disabled', 'required', 'visited', 'validation']));

exports.default = CardNumber;

/***/ }),

/***/ 2469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _findLastKey2 = __webpack_require__(2470);

var _findLastKey3 = _interopRequireDefault(_findLastKey2);

var _immutable = __webpack_require__(5);

var _LinkMapper = __webpack_require__(8);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    token: null,
    amount: null,
    nickname: null,
    cardHolderName: null,
    startDate: null,
    expiryDate: null,
    email: null,
    phone: null,
    store: false,
    address: new _Address2.default()
};

var Card = function (_Record) {
    (0, _inherits3.default)(Card, _Record);

    function Card() {
        (0, _classCallCheck3.default)(this, Card);
        return (0, _possibleConstructorReturn3.default)(this, _Record.apply(this, arguments));
    }

    // eslint-disable-line new-cap

    Card.fromJSON = function fromJSON() {
        var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return new Card({
            token: (0, _LinkMapper.resolve)(json.token).with(String),
            amount: (0, _LinkMapper.resolve)(json.amount).with(Number),
            nickname: (0, _LinkMapper.resolve)(json.nickname).with(String),
            cardHolderName: (0, _LinkMapper.resolve)(json.cardHolderName).with(String),
            startDate: (0, _LinkMapper.resolve)(json.startDate).with(String),
            expiryDate: (0, _LinkMapper.resolve)(json.expiryDate).with(String),
            email: (0, _LinkMapper.resolve)(json.email).with(String),
            phone: (0, _LinkMapper.resolve)(json.phone).with(String),
            store: (0, _LinkMapper.resolve)(json.stored).with(Boolean),
            address: (0, _LinkMapper.resolve)(json.address).as(_Address2.default)
        });
    };

    Card.getType = function getType() {
        var pan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        return pan ? (0, _findLastKey3.default)(_AppConstants.CardTypes, function (r) {
            return pan.match(r);
        }) : null;
    };

    return Card;
}((0, _immutable.Record)(defaults));

exports.default = Card;

/***/ }),

/***/ 2470:
/***/ (function(module, exports, __webpack_require__) {

var baseFindKey = __webpack_require__(1036),
    baseForOwnRight = __webpack_require__(2471),
    baseIteratee = __webpack_require__(102);

/**
 * This method is like `_.findKey` except that it iterates over elements of
 * a collection in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findLastKey(users, function(o) { return o.age < 40; });
 * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastKey(users, { 'age': 36, 'active': true });
 * // => 'barney'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastKey(users, 'active');
 * // => 'pebbles'
 */
function findLastKey(object, predicate) {
  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwnRight);
}

module.exports = findLastKey;


/***/ }),

/***/ 2471:
/***/ (function(module, exports, __webpack_require__) {

var baseForRight = __webpack_require__(2472),
    keys = __webpack_require__(127);

/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && baseForRight(object, iteratee, keys);
}

module.exports = baseForOwnRight;


/***/ }),

/***/ 2472:
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1027);

/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = createBaseFor(true);

module.exports = baseForRight;


/***/ }),

/***/ 2473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _range2 = __webpack_require__(339);

var _range3 = _interopRequireDefault(_range2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lpad = __webpack_require__(440);

var _lpad2 = _interopRequireDefault(_lpad);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardExpiryMonth(props) {
    var monthsRange = (0, _range3.default)(1, 13).map(function (month) {
        return (0, _lpad2.default)(month, 2, '0');
    });

    return _react2.default.createElement(
        'div',
        { className: 'card-expiry-month' },
        _react2.default.createElement(
            _ValidatedField2.default,
            (0, _extends3.default)({}, props, {
                type: 'select',
                id: 'expiryMonth',
                name: 'ccmonth',
                field: 'expiryMonth',
                groupClassName: 'select-container select-container--no-margin',
                label: (0, _I18n.translate)('customerdetails.payment.expirymonth'),
                placeholder: (0, _I18n.translate)('customerdetails.payment.expirymonth'),
                labelClassName: 'sr-only',
                autoComplete: 'cc-exp-month' }),
            _react2.default.createElement(
                'option',
                null,
                (0, _I18n.translate)('customerdetails.payment.expirymonth.defaultOption')
            ),
            monthsRange.map(function (month) {
                return _react2.default.createElement(
                    'option',
                    { key: month, value: month },
                    month
                );
            })
        )
    );
}

CardExpiryMonth.propTypes = (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'required', 'disabled', 'visited', 'validation']);

exports.default = CardExpiryMonth;

/***/ }),

/***/ 2474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _range2 = __webpack_require__(339);

var _range3 = _interopRequireDefault(_range2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _I18n = __webpack_require__(9);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardExpiryYear(props) {
    var currentYear = (0, _TrainTime2.default)().year();
    var yearsRange = (0, _range3.default)(currentYear, currentYear + 11);

    return _react2.default.createElement(
        'div',
        { className: 'card-expiry-year' },
        _react2.default.createElement(
            _ValidatedField2.default,
            (0, _extends3.default)({}, props, {
                type: 'select',
                id: 'expiryYear',
                name: 'year',
                field: 'expiryYear',
                groupClassName: 'select-container select-container--no-margin',
                label: (0, _I18n.translate)('customerdetails.payment.expiryyear'),
                placeholder: (0, _I18n.translate)('customerdetails.payment.expiryyear'),
                labelClassName: 'sr-only',
                autoComplete: 'cc-exp-year' }),
            _react2.default.createElement(
                'option',
                null,
                (0, _I18n.translate)('customerdetails.payment.expiryyear.defaultOption')
            ),
            yearsRange.map(function (year) {
                return _react2.default.createElement(
                    'option',
                    { key: year, value: year },
                    year
                );
            })
        )
    );
}

CardExpiryYear.propTypes = (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'required', 'disabled', 'visited', 'validation']);

exports.default = CardExpiryYear;

/***/ }),

/***/ 2475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CVVIcon = function CVVIcon() {
    return _react2.default.createElement(
        "svg",
        { xmlns: "http://www.w3.org/2000/svg", height: "25", width: "38", viewBox: "0 0 38.28 23.868" },
        _react2.default.createElement("rect", { ry: "3.536", rx: "3.536", height: "25", width: "38", fill: "#dfdedc" }),
        _react2.default.createElement("rect", { width: "36.28", height: "23.868", x: ".86", y: ".566", rx: "3.536", ry: "3.536", fill: "#cececd" }),
        _react2.default.createElement("rect", { ry: "0", rx: "0", y: "3.995", x: ".86", height: "4.999", width: "36.28", fill: "#434244" }),
        _react2.default.createElement("rect", { width: "22.449", height: "5.031", x: "3.157", y: "12.682", rx: "0", ry: "0", fill: "#fff" }),
        _react2.default.createElement("rect", { ry: "0", rx: "0", y: "14.448", x: "5.501", height: "1.5", width: "17.762", fill: "#434244" }),
        _react2.default.createElement("rect", { ry: "0", rx: "0", y: "12.682", x: "28.907", height: "5.031", width: "4.887", fill: "#fff" }),
        _react2.default.createElement("rect", { width: "3.23", height: "1.5", x: "29.735", y: "14.448", rx: "0", ry: "0", fill: "#434244" }),
        _react2.default.createElement("path", {
            d: "M31.35 9.531c-3.077 0-5.573 2.551-5.573 5.666s2.496 5.666 5.573 5.666c3.076 0 5.574-2.55 5.574-5.666 0-3.115-2.498-5.666-5.574-5.666zm0 1.332c2.342 0 4.24 1.926 4.24 4.334 0 2.408-1.898 4.334-4.24 4.334-2.343 0-4.239-1.926-4.239-4.334 0-2.408 1.896-4.334 4.239-4.334z",
            color: "#000",
            overflow: "visible",
            fill: "#e9574c"
        })
    );
};

exports.default = CVVIcon;

/***/ }),

/***/ 2476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlashIcon = function SlashIcon(_ref) {
    var props = (0, _objectWithoutProperties3.default)(_ref, []);
    return _react2.default.createElement(
        "svg",
        (0, _extends3.default)({ xmlns: "http://www.w3.org/2000/svg", width: "7", height: "32", viewBox: "0 0 7 32" }, props),
        _react2.default.createElement("path", { fill: "none", stroke: "#979797", strokeLinecap: "square", d: "M6.5.5l-6 32" })
    );
};

exports.default = SlashIcon;

/***/ }),

/***/ 2477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _pick2 = __webpack_require__(118);

var _pick3 = _interopRequireDefault(_pick2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _I18n = __webpack_require__(9);

var _DimensionsStore = __webpack_require__(115);

var _DimensionsStore2 = _interopRequireDefault(_DimensionsStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _AddressLineOne = __webpack_require__(276);

var _AddressLineOne2 = _interopRequireDefault(_AddressLineOne);

var _AddressLineTwo = __webpack_require__(983);

var _AddressLineTwo2 = _interopRequireDefault(_AddressLineTwo);

var _AddressLineThree = __webpack_require__(984);

var _AddressLineThree2 = _interopRequireDefault(_AddressLineThree);

var _TownCity = __webpack_require__(985);

var _TownCity2 = _interopRequireDefault(_TownCity);

var _Postcode = __webpack_require__(986);

var _Postcode2 = _interopRequireDefault(_Postcode);

var _Country = __webpack_require__(987);

var _Country2 = _interopRequireDefault(_Country);

var _PostCodeLookUp = __webpack_require__(988);

var _PostCodeLookUp2 = _interopRequireDefault(_PostCodeLookUp);

var _Address = __webpack_require__(108);

var _Address2 = _interopRequireDefault(_Address);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStateFromStores = function getStateFromStores() {
    return {
        isMobile: _DimensionsStore2.default.isMobileWidth()
    };
};

var BillingAddress = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(BillingAddress, _React$PureComponent);

    function BillingAddress() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BillingAddress);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.defaultProps = {
            canUseDeliveryAddress: false,
            className: '',
            form: null,
            isSubForm: false,
            onAddressSelected: _noop3.default,
            onUseDeliveryAddress: _noop3.default
        }, _this.state = {
            showAddressFields: false
        }, _this.updateShowAddressFields = function (value) {
            _this.setState((0, _extends3.default)({}, _this.state, { showAddressFields: value }));
        }, _this.handleSelectAddress = function (address) {
            _this.updateShowAddressFields(true);

            _this.props.onAddressSelected(address);
        }, _this.handleToggleShowAddress = function () {
            _this.updateShowAddressFields(!_this.state.showAddressFields);
        }, _this.handleClearAddress = function () {
            _this.props.onAddressSelected(new _Address2.default());
        }, _this.handleOnUseDeliveryAddress = function () {
            _this.props.onUseDeliveryAddress();

            _this.updateShowAddressFields(true);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    BillingAddress.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.alwaysShowAddressFields !== this.props.alwaysShowAddressFields) {
            if (this.props.alwaysShowAddressFields) {
                this.updateShowAddressFields(true);
            }
        }
    };

    BillingAddress.prototype.render = function render() {
        var _props = this.props,
            alwaysShowAddressFields = _props.alwaysShowAddressFields,
            canUseDeliveryAddress = _props.canUseDeliveryAddress,
            className = _props.className,
            form = _props.form,
            isMobile = _props.isMobile,
            isSubForm = _props.isSubForm,
            outsideLabel = _props.outsideLabel;
        var showAddressFields = this.state.showAddressFields;


        var Wrapper = isSubForm ? 'div' : 'form';

        var displayAddressFields = showAddressFields || alwaysShowAddressFields;

        var colWidth = outsideLabel && !isMobile ? 6 : 12;

        return _react2.default.createElement(
            Wrapper,
            { className: (0, _classnames2.default)('billing-address', className) },
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12 },
                    _react2.default.createElement(
                        'h3',
                        { className: 'payment__section-header' },
                        (0, _I18n.translate)('payment.billingAddress')
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12 },
                    canUseDeliveryAddress && _react2.default.createElement(
                        _Button2.default,
                        { onClick: this.handleOnUseDeliveryAddress, className: 'margin-bottom--sm' },
                        _react2.default.createElement(_Icon2.default, { icon: 'chevron' }),
                        (0, _I18n.translate)('payment.billingAddress.useShippingAddress')
                    )
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12 },
                    _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                            _Row2.default,
                            null,
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 12, className: outsideLabel ? "billing-address--outside-label" : "" },
                                _react2.default.createElement(_PostCodeLookUp2.default, {
                                    country: form.get('country'),
                                    onSelectAddress: this.handleSelectAddress,
                                    cols: { md: 12 },
                                    outsideLabel: outsideLabel }),
                                outsideLabel && !displayAddressFields && _react2.default.createElement(
                                    'div',
                                    { className: 'manual-address-btn' },
                                    _react2.default.createElement(
                                        _Button2.default,
                                        {
                                            className: 'btn-link',
                                            onClick: this.handleToggleShowAddress
                                        },
                                        (0, _I18n.translate)("address.enterManually")
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _Row2.default,
                            { className: 'margin-bottom--sm' },
                            !outsideLabel && _react2.default.createElement(
                                _Col2.default,
                                { xs: 12, md: 6 },
                                !displayAddressFields && _react2.default.createElement(
                                    'div',
                                    { className: 'manual-address-btn' },
                                    _react2.default.createElement(
                                        _Button2.default,
                                        {
                                            className: 'btn-link',
                                            onClick: this.handleToggleShowAddress
                                        },
                                        (0, _I18n.translate)("address.enterManually")
                                    )
                                )
                            ),
                            _react2.default.createElement(
                                _Col2.default,
                                { xs: 12 },
                                displayAddressFields && _react2.default.createElement(
                                    _Button2.default,
                                    {
                                        bsStyle: 'default',
                                        className: 'btn-default pull-right',
                                        onClick: this.handleClearAddress
                                    },
                                    (0, _I18n.translate)("address.clearAddress")
                                )
                            )
                        )
                    )
                ),
                displayAddressFields && _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: colWidth },
                        _react2.default.createElement(_AddressLineOne2.default, (0, _extends3.default)({}, this.props, { required: true }))
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: colWidth },
                        _react2.default.createElement(_AddressLineTwo2.default, this.props)
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: colWidth },
                        _react2.default.createElement(_AddressLineThree2.default, this.props)
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: colWidth },
                        _react2.default.createElement(_TownCity2.default, (0, _extends3.default)({}, this.props, { required: true }))
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: colWidth },
                        _react2.default.createElement(_Postcode2.default, (0, _extends3.default)({}, this.props, { required: true }))
                    ),
                    _react2.default.createElement(
                        _Col2.default,
                        { xs: colWidth },
                        _react2.default.createElement(_Country2.default, (0, _extends3.default)({}, this.props, { required: true }))
                    )
                )
            )
        );
    };

    return BillingAddress;
}(_react2.default.PureComponent), _class.propTypes = (0, _extends3.default)({
    alwaysShowAddressFields: _propTypes2.default.bool,
    canUseDeliveryAddress: _propTypes2.default.bool,
    form: _propTypes2.default.object,
    isSubForm: _propTypes2.default.bool,
    onAddressSelected: _propTypes2.default.func,
    onUseDeliveryAddress: _propTypes2.default.func
}, (0, _pick3.default)(_ValidatedField2.default.propTypes, ['form', 'onChange', 'disabled', 'outsideLabel', 'visited', 'validation']), {
    className: _propTypes2.default.string
}), _temp2);
exports.default = (0, _connectToStores2.default)([_DimensionsStore2.default], getStateFromStores)(BillingAddress);

/***/ }),

/***/ 2478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CocsResponse = __webpack_require__(1031);

var _CocsResponse2 = _interopRequireDefault(_CocsResponse);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _APIClient = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThreeDSecure = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(ThreeDSecure, _PureRenderComponent);

    function ThreeDSecure() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ThreeDSecure);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.formRef = _react2.default.createRef(), _this._handleComplete = function (_ref) {
            var origin = _ref.origin,
                data = _ref.data;

            if (window.location.href.includes(origin.replace(/^https?:/, '')) && data === 'complete') {
                _this.props.onComplete();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    ThreeDSecure.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        window.addEventListener('message', this._handleComplete);
    };

    ThreeDSecure.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('message', this._handleComplete);
    };

    ThreeDSecure.prototype.componentDidMount = function componentDidMount() {
        // Once rendered onto the page, we submit the
        // 3DSecure form through the iframe immediately
        this.formRef.current.submit();
    };

    ThreeDSecure.prototype.render = function render() {
        var _props = this.props,
            authResponse = _props.authResponse,
            currentOrder = _props.currentOrder,
            isOrderAmendment = _props.isOrderAmendment,
            responseUrl = _props.responseUrl;

        var isThreeDSecureV2 = !!authResponse.threeDSServerTransId;

        var host = window.location.host;

        var callbackUrl = _config2.default.get('threeDSecureCallbackUrl');

        var threeDSecureTermUrl = isThreeDSecureV2 ? _config2.default.get('threeDSecureTermUrlV2Payment') : _config2.default.get('threeDSecureTermUrlV1Payment');

        var responseUrlValue = isOrderAmendment ? (0, _APIClient.makeUrl)(threeDSecureTermUrl.replace('{orderId}', currentOrder.id).replace('{paymentId}', authResponse.id).replace('{deviceToken}', this.props.deviceToken).replace('{callbackUrl}', 'https://' + host + callbackUrl)) : responseUrl;

        return _react2.default.createElement(
            'form',
            {
                className: 'embed-responsive threed-secure',
                ref: this.formRef,
                action: authResponse.redirect,
                method: 'POST',
                target: 'iframe'
            },
            _react2.default.createElement('iframe', { ref: 'iframe', name: 'iframe', className: 'js-3ds-iframe', frameBorder: '0' }),
            isThreeDSecureV2 ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement('input', {
                    type: 'hidden',
                    name: 'transactionId',
                    value: authResponse.threeDSServerTransId
                }),
                _react2.default.createElement('input', { type: 'hidden', name: 'notificationUrl', value: responseUrlValue }),
                _react2.default.createElement('input', { type: 'hidden', name: 'MD', value: authResponse.md })
            ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement('input', { type: 'hidden', name: 'PaReq', value: authResponse.pareq }),
                _react2.default.createElement('input', { type: 'hidden', name: 'MD', value: authResponse.md }),
                _react2.default.createElement('input', { type: 'hidden', name: 'TermUrl', value: responseUrlValue })
            )
        );
    };

    return ThreeDSecure;
}(_PureRenderComponent3.default), _class.propTypes = {
    authResponse: _propTypes2.default.instanceOf(_CocsResponse2.default).isRequired,
    deviceToken: _propTypes2.default.string,
    currentOrder: _propTypes2.default.instanceOf(_Order2.default),
    responseUrl: _propTypes2.default.string.isRequired,
    onComplete: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = ThreeDSecure;

/***/ }),

/***/ 2479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.unwrapped = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = __webpack_require__(5);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _SeasonSearch = __webpack_require__(328);

var _SeasonSearch2 = _interopRequireDefault(_SeasonSearch);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _PromoCodeStore = __webpack_require__(342);

var _PromoCodeStore2 = _interopRequireDefault(_PromoCodeStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _PromoCode = __webpack_require__(227);

var _PromoCode2 = _interopRequireDefault(_PromoCode);

var _StationFinderActions = __webpack_require__(2401);

var _StationFinderActions2 = _interopRequireDefault(_StationFinderActions);

var _StationFinderStore = __webpack_require__(990);

var _StationFinderStore2 = _interopRequireDefault(_StationFinderStore);

var _ResponsiveRender = __webpack_require__(982);

var _ResponsiveRender2 = _interopRequireDefault(_ResponsiveRender);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _SectionErrors = __webpack_require__(974);

var _SectionErrors2 = _interopRequireDefault(_SectionErrors);

var _StationSelector = __webpack_require__(976);

var _StationSelector2 = _interopRequireDefault(_StationSelector);

var _ViaAvoid = __webpack_require__(2445);

var _ViaAvoid2 = _interopRequireDefault(_ViaAvoid);

var _stationFinder = __webpack_require__(2447);

var _stationFinder2 = _interopRequireDefault(_stationFinder);

var _StationFinderToggle = __webpack_require__(2489);

var _StationFinderToggle2 = _interopRequireDefault(_StationFinderToggle);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Tutorial = __webpack_require__(2180);

var _Tutorial2 = _interopRequireDefault(_Tutorial);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JourneySelectorOpen = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(JourneySelectorOpen, _React$PureComponent);

    function JourneySelectorOpen() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, JourneySelectorOpen);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            showStationFinderModal: false,
            stationFieldsTouched: false,
            errors: _this._getErrors(_this.props)
        }, _this._handleStationChange = function (field, value) {
            _this.props.onChange(_this.props.search.set(field, value));
            _this.setState({ stationFieldsTouched: true });
        }, _this._handleSwapStations = function () {
            var _this$props = _this.props,
                search = _this$props.search,
                season = _this$props.season;

            var types = _AppConstants.StationTypes;
            if (search.smartcard) {
                types = _AppConstants.SmartcardStationTypes;
            } else if (season) {
                types = _AppConstants.SeasonStationTypes;
            }

            _TrackingActions2.default.widgetStationSwitch();

            var destination = search.getStationType(search.destination, types.ORIGIN);
            var origin = search.getStationType(search.origin, types.DESTINATION);
            var swappedSearch = search.set('origin', destination).set('destination', origin);
            _this.props.onChange(swappedSearch);
        }, _this._showStationFinderModal = function () {
            if (window.innerWidth <= _AppConstants.BreakPoints.TABLET_PORTRAIT_WIDTH) {
                _this.setState({
                    showStationFinderModal: true
                });
            } else {
                _StationFinderActions2.default.setExpanded(!_StationFinderStore2.default.get('isExpanded'));
            }
        }, _this._hideStationFinderModal = function () {
            _this.setState({
                showStationFinderModal: false
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    JourneySelectorOpen.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            errors: this._getErrors(nextProps)
        });
    };

    JourneySelectorOpen.prototype._getErrors = function _getErrors(_ref) {
        var search = _ref.search,
            searchAttempted = _ref.searchAttempted,
            searchErrors = _ref.searchErrors;

        var stationFieldsTouched = this.state && this.state.stationFieldsTouched;

        var errors = new _immutable.Map();
        if (searchErrors.has('validateStationsNotEqual')) {
            errors = errors.set('origin', 'booking.journey.errors.sameStation').set('destination', 'booking.journey.errors.sameStation');
        }

        if ((searchAttempted || stationFieldsTouched) && searchErrors.has('validateStationsComplete')) {
            if (!search.origin.nlc) {
                errors = errors.set('origin', 'booking.journey.errors.missingOrigin');
            }
            if (!search.destination.nlc) {
                errors = errors.set('destination', 'booking.journey.errors.missingDestination');
            }
        }

        if (_FeatureFlagStore2.default.get('enableViaAvoid') && !this.props.promoCode && !this.props.season) {
            if (search.via.nlc && [search.origin.nlc, search.destination.nlc].includes(search.via.nlc)) {
                errors = errors.set('viaAvoid', 'booking.journey.errors.viaSameStation');
            }
            if (search.avoid.nlc && [search.origin.nlc, search.destination.nlc].includes(search.avoid.nlc)) {
                errors = errors.set('viaAvoid', 'booking.journey.errors.avoidSameStation');
            }
        }

        return errors;
    };

    JourneySelectorOpen.prototype._renderStation = function _renderStation(name, type) {
        var errors = this.state.errors;

        var labelText = (0, _I18n.translate)('booking.journey.' + name + '.label');
        var placeholder = (0, _I18n.translate)('booking.journey.' + name);

        var station = this.props.search[name];
        var classes = (0, _classnames2.default)({
            'journey__station': true,
            'journey__station--selected': station.name
        });

        var error = errors.get(name);

        var label = _react2.default.createElement(
            'span',
            { className: 'sr-only' },
            error ? (0, _I18n.translate)('error.title') + ': ' + (0, _I18n.translate)(error) : labelText,
            '.',
            (0, _I18n.translate)('booking.journey.mandatoryField')
        );

        var inputClassName = (0, _classnames2.default)({ 'station--error': error });

        var focused = name === 'destination' ? errors.get('origin') ? false : error : error;

        return _react2.default.createElement(
            'div',
            { className: classes },
            _react2.default.createElement(_StationSelector2.default, {
                name: name,
                station: station,
                placeholder: placeholder,
                onChange: this._handleStationChange.bind(this, name),
                stationType: type,
                label: label,
                title: labelText,
                className: inputClassName,
                overlayResults: this.props.overlayResults,
                focused: focused,
                isInvalid: !!error,
                errorMessage: error ? (0, _I18n.translate)(error) : null,
                required: true
            })
        );
    };

    JourneySelectorOpen.prototype._getStationFinderModalProps = function _getStationFinderModalProps() {
        return {
            show: this.state.showStationFinderModal,
            className: 'grid-modal modal--sm stationFinder__container-modal',
            onClose: this._hideStationFinderModal,
            hideContinue: true,
            titleText: (0, _I18n.translate)('stationFinder.modal.title'),
            closeText: 'button.text.cancel',
            continueText: 'button.text.continue'
        };
    };

    JourneySelectorOpen.prototype.render = function render() {
        var _props = this.props,
            search = _props.search,
            season = _props.season,
            promoCode = _props.promoCode,
            onChange = _props.onChange,
            enableVia = _props.enableVia;
        var errors = this.state.errors;

        var types = _AppConstants.StationTypes;

        if (search.smartcard && season) {
            types = _AppConstants.SmartcardSeasonStationTypes;
        } else if (search.smartcard) {
            types = _AppConstants.SmartcardStationTypes;
        } else if (season) {
            types = _AppConstants.SeasonStationTypes;
        }

        var showVia = _FeatureFlagStore2.default.get('enableViaAvoid') && enableVia && !promoCode && !season;

        var viaAvoidLabel = void 0;
        var viaAvoidError = errors.get('viaAvoid');
        if (viaAvoidError) {
            viaAvoidLabel = _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                '. ',
                (0, _I18n.translate)('error.title'),
                ': ',
                (0, _I18n.translate)(viaAvoidError)
            );
        }

        return _react2.default.createElement(
            'section',
            { className: 'booking__section' },
            _react2.default.createElement(_SectionErrors2.default, { errors: errors.toSet().toList().toArray() }),
            _react2.default.createElement(
                'div',
                { className: 'margin-bottom--sm box box--rounded' },
                _react2.default.createElement(
                    'div',
                    { className: 'journey' },
                    this._renderStation('origin', types.ORIGIN),
                    _react2.default.createElement(
                        'div',
                        { className: 'journey__swap' },
                        _react2.default.createElement(
                            'button',
                            { className: 'svg-switch', onClick: this._handleSwapStations },
                            _react2.default.createElement(_Icon2.default, { icon: 'switch' }),
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                (0, _I18n.translate)('booking.journey.switch')
                            )
                        )
                    ),
                    this._renderStation('destination', types.DESTINATION)
                )
            ),
            _react2.default.createElement(
                _ResponsiveRender2.default,
                { maxWidth: _AppConstants.BreakPoints.TABLET_PORTRAIT_WIDTH },
                _react2.default.createElement(
                    _BaseModal2.default,
                    this._getStationFinderModalProps(),
                    _react2.default.createElement(_stationFinder2.default, {
                        closeContainerModal: this._hideStationFinderModal,
                        currentSearch: search,
                        className: 'mid-section',
                        isMobile: true,
                        onChange: this._handleStationChange,
                        origin: search.origin,
                        destination: search.destination })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'stationFinder' },
                showVia && _react2.default.createElement(_ViaAvoid2.default, { search: search,
                    onChange: onChange,
                    season: season,
                    errorLabel: viaAvoidLabel }),
                this.props.enableStationFinder && _react2.default.createElement(
                    'div',
                    { className: 'stationFinder__cta-group' },
                    _react2.default.createElement(_StationFinderToggle2.default, {
                        onActivate: this._showStationFinderModal }),
                    _react2.default.createElement(
                        _Tutorial2.default,
                        { name: _AppConstants.Tutorials.STATION_FINDER, notAccessible: true },
                        _react2.default.createElement(_Icon2.default, { icon: 'info' })
                    )
                )
            )
        );
    };

    return JourneySelectorOpen;
}(_react2.default.PureComponent), _class.propTypes = {
    season: _propTypes2.default.bool,
    search: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Search2.default), _propTypes2.default.instanceOf(_SeasonSearch2.default)]).isRequired,
    searchAttempted: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    promoCode: _propTypes2.default.instanceOf(_PromoCode2.default),
    searchErrors: _propTypes2.default.instanceOf(_immutable.Set),
    enableStationFinder: _propTypes2.default.bool,
    enableVia: _propTypes2.default.bool,
    overlayResults: _propTypes2.default.bool
}, _class.defaultProps = {
    season: false,
    onChange: _noop3.default,
    promoCode: null,
    searchErrors: new _immutable.Set(),
    enableStationFinder: false,
    enableVia: true,
    overlayResults: false,
    searchAttempted: false
}, _temp2);
var unwrapped = exports.unwrapped = JourneySelectorOpen;

exports.default = (0, _connectToStores2.default)([_PromoCodeStore2.default], function () {
    return { promoCode: _PromoCodeStore2.default.getActive() };
})(JourneySelectorOpen);

/***/ }),

/***/ 2480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchPath = (_temp = _class = function (_React$Component) {
    (0, _inherits3.default)(SearchPath, _React$Component);

    function SearchPath() {
        (0, _classCallCheck3.default)(this, SearchPath);
        return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
    }

    SearchPath.prototype.render = function render() {
        var _props = this.props,
            mapsHelper = _props.mapsHelper,
            origin = _props.origin,
            destination = _props.destination;


        if (mapsHelper && mapsHelper.loaded) {

            if (origin.latitude) {
                var originEl = document.createElement('div');
                originEl.className = 'map__label';
                originEl.innerHTML = (0, _I18n2.default)('global.start') + ': <strong>' + origin.name + '</strong>';
                mapsHelper.newLabel(originEl, {
                    latitude: origin.latitude,
                    longitude: origin.longitude
                });
            }

            if (destination.latitude) {
                var destinationEl = document.createElement('div');
                destinationEl.className = 'map__label';
                destinationEl.innerHTML = (0, _I18n2.default)('global.end') + ': <strong>' + destination.name + '</strong>';
                mapsHelper.newLabel(destinationEl, {
                    latitude: destination.latitude,
                    longitude: destination.longitude
                });
            }

            if (origin.latitude && destination.latitude) {
                var path = [origin.toJS(), destination.toJS()];
                mapsHelper.dashedLine(path);
            }
        }

        return null;
    };

    return SearchPath;
}(_react2.default.Component), _class.propTypes = {
    mapsHelper: _propTypes2.default.object,
    origin: _propTypes2.default.instanceOf(_Station2.default),
    destination: _propTypes2.default.instanceOf(_Station2.default)
}, _class.defaultProps = {
    mapsHelper: null,
    origin: new _Station2.default(),
    destination: new _Station2.default()
}, _temp);
exports.default = SearchPath;

/***/ }),

/***/ 2481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _delay2 = __webpack_require__(627);

var _delay3 = _interopRequireDefault(_delay2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(46);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _reactGeosuggest = __webpack_require__(2482);

var _reactGeosuggest2 = _interopRequireDefault(_reactGeosuggest);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _StationFinderActions = __webpack_require__(2401);

var _StationFinderActions2 = _interopRequireDefault(_StationFinderActions);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _GoogleMaps = __webpack_require__(2397);

var _GoogleMaps2 = _interopRequireDefault(_GoogleMaps);

var _AppConstants = __webpack_require__(6);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _SearchExpander = __webpack_require__(2448);

var _SearchExpander2 = _interopRequireDefault(_SearchExpander);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StationSearchOverlay = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(StationSearchOverlay, _React$PureComponent);

    function StationSearchOverlay() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, StationSearchOverlay);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            label: null,
            location: null,
            error: _this.props.error,
            isSearchingLocation: false
        }, _this.canGetCurrentPosition = !!navigator.geolocation, _this.handleSuggest = function (_ref) {
            var location = _ref.location,
                label = _ref.label;

            _this.setState({
                error: null
            });

            _this.clearStationSearchError();

            if (!label) {
                _this.blurGeoSuggest();
                _this.setState({ error: { message: 'stationFinder.noLabel.error' } });
                return;
            }

            if (!location) {
                _this.setState({ label: label });
                _this.focusGeoSuggest();
            } else if (location.getCurrentPosition) {
                _this.getCurrentPosition();
            } else {
                _this.props.onSelectPosition(location);
                var searchInteraction = _AppConstants.StationFinderSearchInteractions.ENTERED_LOCATION;
                _this.handleSearch(location, searchInteraction);
            }
        }, _this.handleSuggestFail = function (label) {
            _this.blurGeoSuggest();
            _this.setState({ error: { message: 'stationFinder.label.error', label: label }, label: label });
        }, _this.handleSearch = function (location, searchInteraction) {
            if (location && location.lat && location.lng) {
                _this.props.onSearch(location, searchInteraction);
            }

            _this._closeSearchOverlay();
        }, _this.handleSearchButton = function () {
            _this.refs.geoSuggest.selectSuggest(_this.refs.geoSuggest.state.activeSuggest);
        }, _this.updateLabel = function (label) {
            _this.setState({ error: null, label: label });
            _this.clearStationSearchError();
        }, _this.clearStationSearchError = function () {
            if (_this.props.error) {
                _StationFinderActions2.default.clearError();
            }
        }, _this.setCurrentPosition = function (position) {
            var location = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };

            _this.props.onSelectPosition(location);

            var searchInteraction = _AppConstants.StationFinderSearchInteractions.CURRENT_LOCATION;
            _this.handleSearch(location, searchInteraction);

            var geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ location: location }, function (results, status) {
                if (status === 'OK' && results.length) {
                    var _results$ = results[0],
                        placeId = _results$.placeId,
                        label = _results$.formatted_address;

                    if (placeId) {
                        _this.refs.geoSuggest.update(label);
                    }
                }
            });

            _this.setState({ isSearchingLocation: false });
        }, _this.setPositionError = function (error) {
            _this.setState({ label: _this.refs.geoSuggest.state.userInput });
            var isPermissionDenied = error.code === error.PERMISSION_DENIED;
            var geolocationError = 'stationFinder.geolocation.error' + (isPermissionDenied ? '.permissionDenied' : '');
            _this.setState({ error: { message: geolocationError }, isSearchingLocation: false });
            _this.blurGeoSuggest();
        }, _this.handleSearchClear = function () {
            _this._reset();
            _this.props.onClear();

            if (!_this.props.isMobile) {
                _this.focusGeoSuggest();
            }
        }, _this.toggleSearchOverlay = function () {
            if (_this.props.isExpanded) {
                _this._closeSearchOverlay();
            } else {
                _this._openSearchOverlay();
            }
        }, _this.dismissError = function () {
            _this.setState({ error: null });
            _this.clearStationSearchError();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    StationSearchOverlay.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.isExpanded && this.props.isExpanded !== newProps.isExpanded && !this.props.error) {
            this.focusGeoSuggest();
        }

        if (newProps.error && this.props.error !== newProps.error) {
            this.setState({ error: newProps.error });
        }
    };

    StationSearchOverlay.prototype.componentDidMount = function componentDidMount() {
        if (this.props.isMobile) {
            this._openSearchOverlay();
        }
    };

    StationSearchOverlay.prototype.blurGeoSuggest = function blurGeoSuggest() {
        _reactDom2.default.findDOMNode(this.refs.overlay).focus();
    };

    StationSearchOverlay.prototype.focusGeoSuggest = function focusGeoSuggest() {
        var _this2 = this;

        this.blurGeoSuggest();
        (0, _delay3.default)(function () {
            return _this2.refs.geoSuggest.focus();
        }, 40);
    };

    StationSearchOverlay.prototype.focusButton = function focusButton() {
        _reactDom2.default.findDOMNode(this.refs.button).focus();
    };

    StationSearchOverlay.prototype.getCurrentPosition = function getCurrentPosition() {
        if (this.canGetCurrentPosition) {
            this.setState({ isSearchingLocation: true });
            navigator.geolocation.getCurrentPosition(this.setCurrentPosition, this.setPositionError);
        }
    };

    StationSearchOverlay.prototype._reset = function _reset() {
        this.setState({
            label: null,
            location: null,
            error: null
        });

        this.clearStationSearchError();

        this.refs.geoSuggest.state.userInput = '';
    };

    StationSearchOverlay.prototype.getFixtures = function getFixtures() {
        var filters = [];
        if (this.canGetCurrentPosition) {
            filters.push({
                className: 'stationFinder__search-current-position otrl otrl-wifi',
                label: (0, _I18n2.default)('stationFinder.search.useCurrentPosition'),
                location: { getCurrentPosition: true }
            });
        }
        return filters;
    };

    StationSearchOverlay.prototype._closeSearchOverlay = function _closeSearchOverlay() {
        this._reset();

        _StationFinderActions2.default.setExpanded(false);
    };

    StationSearchOverlay.prototype._openSearchOverlay = function _openSearchOverlay() {
        _StationFinderActions2.default.setExpanded(true);
    };

    StationSearchOverlay.prototype._getSearchButton = function _getSearchButton() {
        var findStation = !this.state.error ? this.handleSearchButton : null;
        if (this.state.isSearchingLocation) {
            return _react2.default.createElement(
                _Button2.default,
                { ref: 'button', bsStyle: 'primary', tabIndex: '-1' },
                _react2.default.createElement(_Icon2.default, { className: 'search-spin', icon: 'spinner' })
            );
        } else {
            return _react2.default.createElement(
                _Button2.default,
                { ref: 'button', bsStyle: 'primary', onClick: findStation, tabIndex: '-1' },
                (0, _I18n2.default)('stationFinder.search.buttonText')
            );
        }
    };

    StationSearchOverlay.prototype.getStationSearchGroup = function getStationSearchGroup() {
        var isExpanded = this.props.isExpanded;

        return _react2.default.createElement(
            'div',
            {
                className: 'input-group',
                id: 'search-overlay',
                role: 'region',
                'aria-label': (0, _I18n2.default)('stationFinder.search.placeholder')
            },
            _react2.default.createElement(_SearchExpander2.default, {
                isExpanded: isExpanded,
                isSearching: this.props.isSearchingStations,
                onExpand: this.toggleSearchOverlay }),
            isExpanded && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_reactGeosuggest2.default, { ref: 'geoSuggest',
                    id: 'stationFinderSearchInput',
                    label: (0, _I18n2.default)('stationFinder.search.placeholder'),
                    placeholder: (0, _I18n2.default)('stationFinder.search.placeholder'),
                    inputClassName: 'input-field stationFinder__search-input',
                    country: 'gb',
                    ignoreTab: true,
                    autoActivateFirstSuggest: true,
                    queryDelay: 100,
                    fixtures: this.getFixtures(),
                    onSuggestSelect: this.handleSuggest,
                    onSuggestNoResults: this.handleSuggestFail,
                    onChange: this.updateLabel }),
                _react2.default.createElement(
                    'span',
                    { className: 'input-group-btn' },
                    this._getSearchButton()
                )
            )
        );
    };

    StationSearchOverlay.prototype._getSearchOverlayClassname = function _getSearchOverlayClassname() {
        return (0, _classnames2.default)('stationFinder__search-overlay', {
            expanded: this.props.isExpanded,
            mobile: this.props.isMobile
        });
    };

    StationSearchOverlay.prototype.render = function render() {
        var _this3 = this;

        var error = this.state.error;

        var shouldShowClear = this.state.label && !this.state.isSearchingLocation;

        return _react2.default.createElement(
            'div',
            {
                id: 'stationFinder-overlay',
                className: this._getSearchOverlayClassname(),
                ref: 'overlay',
                tabIndex: -1
            },
            shouldShowClear && _react2.default.createElement(
                _Button2.default,
                { className: 'stationFinder__search-clear', onClick: function onClick() {
                        return _this3.handleSearchClear();
                    } },
                _react2.default.createElement(_Icon2.default, { icon: 'clear' })
            ),
            this.getStationSearchGroup(),
            error && _react2.default.createElement(
                'div',
                { onClick: this.dismissError, className: 'stationFinder__search-error' },
                _react2.default.createElement(
                    'div',
                    { className: 'icon-margin' },
                    _react2.default.createElement(_Icon2.default, { icon: 'error' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'alert-warning' },
                    (0, _I18n2.default)(error.message),
                    error.label
                )
            )
        );
    };

    return StationSearchOverlay;
}(_react2.default.PureComponent), _class.propTypes = {
    mapsHelper: _propTypes2.default.instanceOf(_GoogleMaps2.default),
    onClear: _propTypes2.default.func.isRequired,
    onSelectPosition: _propTypes2.default.func,
    onSearch: _propTypes2.default.func,
    isMobile: _propTypes2.default.bool,
    isSearchingStations: _propTypes2.default.bool.isRequired,
    isExpanded: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.instanceOf(Error)
}, _class.defaultProps = {
    onSelectPosition: _noop3.default,
    onSearch: _noop3.default,
    isMobile: false,
    error: null
}, _temp2);
exports.default = StationSearchOverlay;

/***/ }),

/***/ 2482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce;

/* istanbul ignore next */
/* tslint:disable:no-empty */
/**
 * Default values
 */
var defaults = {
    autoActivateFirstSuggest: false,
    disabled: false,
    fixtures: [],
    getSuggestLabel: function (suggest) { return suggest.description; },
    highlightMatch: true,
    ignoreEnter: false,
    ignoreTab: false,
    initialValue: '',
    maxFixtures: 10,
    minLength: 1,
    onKeyDown: function () { },
    onKeyPress: function () { },
    placeholder: 'Search places',
    queryDelay: 250,
    skipSuggest: function () { return false; },
    style: {}
};

/**
 * Attributes allowed on input elements
 */
var allowedAttributes = [
    'autoCapitalize',
    'autoComplete',
    'autoCorrect',
    'autoFocus',
    'disabled',
    'form',
    'formAction',
    'formEncType',
    'formMethod',
    'formNoValidate',
    'formTarget',
    'height',
    'id',
    'inputMode',
    'maxLength',
    'name',
    'onClick',
    'onContextMenu',
    'onCopy',
    'onCut',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp',
    'onPaste',
    'pattern',
    'placeholder',
    'readOnly',
    'required',
    'size',
    'spellCheck',
    'tabIndex',
    'title',
    'aria-atomic',
    'aria-busy',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-dropeffect',
    'aria-errormessage',
    'aria-flowto',
    'aria-grabbed',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-live',
    'aria-owns',
    'aria-relevant',
    'aria-roledescription',
    'aria-activedescendant',
    'aria-autocomplete',
    'aria-multiline',
    'aria-placeholder',
    'aria-readonly',
    'aria-required'
];
/**
 * Filter the properties for only allowed input properties
 */
function filterInputAttributes (props) {
    var attributes = {};
    allowedAttributes.forEach(function (allowedAttribute) {
        if (props[allowedAttribute]) {
            attributes[allowedAttribute] = props[allowedAttribute];
        }
    });
    return attributes;
}

/**
 * The input field
 */
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    /**
     * The constructor.
     */
    function default_1(props) {
        var _this = _super.call(this, props) || this;
        /* tslint:enable:no-empty */
        /**
         * The reference to the input element
         */
        _this.input = null;
        _this.onChange = _this.onChange.bind(_this);
        _this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
        return _this;
    }
    /**
     * When the input got changed
     */
    default_1.prototype.onChange = function () {
        if (this.input) {
            this.props.onChange(this.input.value);
        }
    };
    /**
     * When a key gets pressed in the input
     */
    default_1.prototype.onInputKeyDown = function (event) {
        // Call props.onKeyDown if defined
        // Gives the developer a little bit more control if needed
        if (this.props.onKeyDown) {
            this.props.onKeyDown(event);
        }
        switch (event.which) {
            case 40: // DOWN
                if (!event.shiftKey) {
                    event.preventDefault();
                    this.props.onNext();
                }
                break;
            case 38: // UP
                if (!event.shiftKey) {
                    event.preventDefault();
                    this.props.onPrev();
                }
                break;
            case 13: // ENTER
                if (this.props.doNotSubmitOnEnter) {
                    event.preventDefault();
                }
                if (!this.props.ignoreEnter) {
                    this.props.onSelect();
                }
                break;
            case 9: // TAB
                if (!this.props.ignoreTab) {
                    this.props.onSelect();
                }
                break;
            case 27: // ESC
                this.props.onEscape();
                break;
            /* istanbul ignore next */
            default:
                break;
        }
    };
    /**
     * Focus the input
     */
    default_1.prototype.focus = function () {
        if (this.input) {
            this.input.focus();
        }
    };
    /**
     * Blur the input
     */
    default_1.prototype.blur = function () {
        if (this.input) {
            this.input.blur();
        }
    };
    /**
     * Render the view
     */
    default_1.prototype.render = function () {
        var _this = this;
        var attributes = filterInputAttributes(this.props);
        var classes = classnames('geosuggest__input', this.props.className);
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("input", __assign({ className: classes, ref: function (i) { return (_this.input = i); }, type: "text" }, attributes, { value: this.props.value, style: this.props.style, onKeyDown: this.onInputKeyDown, onChange: this.onChange, onKeyPress: this.props.onKeyPress, onFocus: this.props.onFocus, onBlur: this.props.onBlur })));
    };
    /* tslint:disable:no-empty */
    /**
     * Default values for the properties
     */
    default_1.defaultProps = {
        autoComplete: 'nope',
        className: '',
        onBlur: function () { },
        onChange: function () { },
        onEscape: function () { },
        onFocus: function () { },
        onKeyDown: function () { },
        onKeyPress: function () { },
        onNext: function () { },
        onPrev: function () { },
        onSelect: function () { },
        value: ''
    };
    return default_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));

/**
 * A single Geosuggest item in the list
 */
var default_1$1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    /**
     * The constructor.
     */
    function default_1(props) {
        var _this = _super.call(this, props) || this;
        /**
         * The reference to the suggest element
         */
        _this.ref = null;
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }
    /**
     * Makes a text bold
     */
    default_1.prototype.makeBold = function (element, key) {
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("b", { className: "geosuggest__item__matched-text", key: key }, element));
    };
    /**
     * Replace matched text with the same in bold
     */
    default_1.prototype.formatMatchedText = function (userInput, suggest) {
        if (!userInput || !suggest.matchedSubstrings) {
            return suggest.label;
        }
        var start = suggest.matchedSubstrings.offset;
        var length = suggest.matchedSubstrings.length;
        var end = start + length;
        var boldPart = this.makeBold(suggest.label.substring(start, end), suggest.label);
        var pre = '';
        var post = '';
        if (start > 0) {
            pre = suggest.label.slice(0, start);
        }
        if (end < suggest.label.length) {
            post = suggest.label.slice(end);
        }
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", null,
            pre,
            boldPart,
            post));
    };
    /**
     * Checking if item just became active and scrolling if needed.
     */
    default_1.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.isActive && !this.props.isActive) {
            this.scrollIfNeeded();
        }
    };
    /**
     * Scrolling current item to the center of the list if item needs scrolling.
     * Item is scrolled to the center of the list.
     */
    default_1.prototype.scrollIfNeeded = function () {
        var element = this.ref;
        var parent = element && element.parentElement;
        if (!element || !parent) {
            return;
        }
        var overTop = element.offsetTop - parent.offsetTop < parent.scrollTop;
        var overBottom = element.offsetTop - parent.offsetTop + element.clientHeight >
            parent.scrollTop + parent.clientHeight;
        if (overTop || overBottom) {
            parent.scrollTop =
                element.offsetTop -
                    parent.offsetTop -
                    parent.clientHeight / 2 +
                    element.clientHeight / 2;
        }
    };
    /**
     * When the suggest item got clicked
     */
    default_1.prototype.onClick = function (event) {
        event.preventDefault();
        this.props.onSelect(this.props.suggest);
    };
    /**
     * Render the view
     */
    default_1.prototype.render = function () {
        var _this = this;
        var _a;
        var suggest = this.props.suggest;
        var classes = classnames('geosuggest__item', this.props.className, this.props.suggestItemClassName, { 'geosuggest__item--active': this.props.isActive }, (_a = {},
            _a[this.props.activeClassName || ''] = this.props.activeClassName
                ? this.props.isActive
                : null,
            _a));
        var content = suggest.label;
        if (this.props.renderSuggestItem) {
            content = this.props.renderSuggestItem(suggest, this.props.userInput);
        }
        else if (this.props.isHighlightMatch) {
            content = this.formatMatchedText(this.props.userInput, suggest);
        }
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("li", { className: classes, ref: function (li) { return (_this.ref = li); }, style: this.props.style, onMouseDown: this.props.onMouseDown, onMouseOut: this.props.onMouseOut, onClick: this.onClick }, content));
    };
    return default_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));

/**
 * The list with suggestions.
 */
var default_1$2 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Whether or not it is hidden
     */
    default_1.prototype.isHidden = function () {
        return this.props.isHidden || this.props.suggests.length === 0;
    };
    /**
     * There are new properties available for the list
     */
    default_1.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.suggests !== this.props.suggests) {
            if (nextProps.suggests.length === 0) {
                this.props.onSuggestNoResults();
            }
        }
    };
    /**
     * Render the view
     * @return {Function} The React element to render
     */
    default_1.prototype.render = function () {
        var _this = this;
        var _a;
        var classes = classnames('geosuggest__suggests', this.props.suggestsClassName, { 'geosuggest__suggests--hidden': this.isHidden() }, (_a = {},
            _a[this.props.hiddenClassName || ''] = this.props.hiddenClassName
                ? this.isHidden()
                : null,
            _a));
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("ul", { className: classes, style: this.props.style }, this.props.suggests.map(function (suggest) {
            var isActive = _this.props.activeSuggest &&
                suggest.placeId === _this.props.activeSuggest.placeId || false;
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(default_1$1, { key: suggest.placeId, className: suggest.className || '', userInput: _this.props.userInput, isHighlightMatch: _this.props.isHighlightMatch, suggest: suggest, style: _this.props.suggestItemStyle, suggestItemClassName: _this.props.suggestItemClassName, isActive: isActive, activeClassName: _this.props.suggestItemActiveClassName, onMouseDown: _this.props.onSuggestMouseDown, onMouseOut: _this.props.onSuggestMouseOut, onSelect: _this.props.onSuggestSelect, renderSuggestItem: _this.props.renderSuggestItem }));
        })));
    };
    return default_1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));

/* global window */
// Escapes special characters in user input for regex
function escapeRegExp(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
/**
 * Entry point for the Geosuggest component
 */
var default_1$3 = /** @class */ (function (_super) {
    __extends(default_1$$1, _super);
    /**
     * The constructor. Sets the initial state.
     */
    function default_1$$1(props) {
        var _this = _super.call(this, props) || this;
        /**
         * The Google Map instance
         */
        _this.googleMaps = null;
        /**
         * The autocomple service to get suggests
         */
        _this.autocompleteService = null;
        /**
         * The places service to get place details
         */
        _this.placesService = null;
        /**
         * The sessionToken service to use session based monetization
         */
        _this.sessionToken = undefined;
        /**
         * The geocoder to get geocoded results
         */
        _this.geocoder = null;
        /**
         * The input component
         */
        _this.input = null;
        _this.state = {
            activeSuggest: null,
            ignoreBlur: false,
            isLoading: false,
            isSuggestsHidden: true,
            suggests: [],
            userInput: props.initialValue || ''
        };
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onAfterInputChange = _this.onAfterInputChange.bind(_this);
        _this.onInputFocus = _this.onInputFocus.bind(_this);
        _this.onInputBlur = _this.onInputBlur.bind(_this);
        _this.onNext = _this.onNext.bind(_this);
        _this.onPrev = _this.onPrev.bind(_this);
        _this.onSelect = _this.onSelect.bind(_this);
        _this.onSuggestMouseDown = _this.onSuggestMouseDown.bind(_this);
        _this.onSuggestMouseOut = _this.onSuggestMouseOut.bind(_this);
        _this.onSuggestNoResults = _this.onSuggestNoResults.bind(_this);
        _this.hideSuggests = _this.hideSuggests.bind(_this);
        _this.selectSuggest = _this.selectSuggest.bind(_this);
        if (props.queryDelay) {
            _this.onAfterInputChange = lodash_debounce(_this.onAfterInputChange, props.queryDelay);
        }
        return _this;
    }
    /**
     * Change inputValue if prop changes
     */
    default_1$$1.prototype.componentWillReceiveProps = function (props) {
        if (this.props.initialValue !== props.initialValue) {
            this.setState({ userInput: props.initialValue || '' });
        }
    };
    /**
     * Called on the client side after component is mounted.
     * Google api sdk object will be obtained and cached as a instance property.
     * Necessary objects of google api will also be determined and saved.
     */
    default_1$$1.prototype.componentWillMount = function () {
        if (typeof window === 'undefined') {
            return;
        }
        var googleMaps = this.props.googleMaps ||
            (window.google &&
                window.google.maps) ||
            this.googleMaps;
        /* istanbul ignore next */
        if (!googleMaps) {
            if (console) {
                // tslint:disable-next-line:no-console
                console.error('Google maps API was not found in the page.');
            }
            return;
        }
        this.googleMaps = googleMaps;
        this.autocompleteService = new googleMaps.places.AutocompleteService();
        this.placesService = new googleMaps.places.PlacesService(document.createElement('div'));
        this.sessionToken = new googleMaps.places.AutocompleteSessionToken();
        this.geocoder = new googleMaps.Geocoder();
    };
    /**
     * When the component will unmount
     */
    default_1$$1.prototype.componentWillUnmount = function () {
        clearTimeout(this.timer);
    };
    /**
     * When the input changed
     */
    default_1$$1.prototype.onInputChange = function (userInput) {
        if (!userInput) {
            if (this.props.onSuggestSelect) {
                this.props.onSuggestSelect();
            }
        }
        this.setState({ userInput: userInput }, this.onAfterInputChange);
    };
    /**
     * On After the input got changed
     */
    default_1$$1.prototype.onAfterInputChange = function () {
        this.showSuggests();
        if (this.props.onChange) {
            this.props.onChange(this.state.userInput);
        }
    };
    /**
     * When the input gets focused
     */
    default_1$$1.prototype.onInputFocus = function () {
        if (this.props.onFocus) {
            this.props.onFocus();
        }
        this.showSuggests();
    };
    /**
     * When the input gets blurred
     */
    default_1$$1.prototype.onInputBlur = function () {
        if (!this.state.ignoreBlur) {
            this.hideSuggests();
        }
    };
    default_1$$1.prototype.onNext = function () {
        this.activateSuggest('next');
    };
    default_1$$1.prototype.onPrev = function () {
        this.activateSuggest('prev');
    };
    default_1$$1.prototype.onSelect = function () {
        this.selectSuggest(this.state.activeSuggest);
    };
    default_1$$1.prototype.onSuggestMouseDown = function () {
        this.setState({ ignoreBlur: true });
    };
    default_1$$1.prototype.onSuggestMouseOut = function () {
        this.setState({ ignoreBlur: false });
    };
    default_1$$1.prototype.onSuggestNoResults = function () {
        if (this.props.onSuggestNoResults) {
            this.props.onSuggestNoResults(this.state.userInput);
        }
    };
    /**
     * Focus the input
     */
    default_1$$1.prototype.focus = function () {
        if (this.input) {
            this.input.focus();
        }
    };
    /**
     * Blur the input
     */
    default_1$$1.prototype.blur = function () {
        if (this.input) {
            this.input.blur();
        }
    };
    /**
     * Update the value of the user input
     */
    default_1$$1.prototype.update = function (userInput) {
        this.setState({ userInput: userInput });
        if (this.props.onChange) {
            this.props.onChange(userInput);
        }
    };
    /*
     * Clear the input and close the suggestion pane
     */
    default_1$$1.prototype.clear = function () {
        this.setState({ userInput: '' }, this.hideSuggests);
    };
    /**
     * Search for new suggests
     */
    default_1$$1.prototype.searchSuggests = function () {
        var _this = this;
        if (!this.state.userInput) {
            this.updateSuggests();
            return;
        }
        var options = {
            input: this.state.userInput,
            sessionToken: this.sessionToken
        };
        var inputLength = this.state.userInput.length;
        var isShorterThanMinLength = this.props.minLength && inputLength < this.props.minLength;
        if (isShorterThanMinLength) {
            return;
        }
        var _a = this.props, location = _a.location, radius = _a.radius, bounds = _a.bounds, types = _a.types, country = _a.country;
        /* tslint:disable:curly */
        if (location)
            options.location = location;
        if (radius)
            options.radius = Number(this.props.radius);
        if (bounds)
            options.bounds = bounds;
        if (types)
            options.types = types;
        if (country)
            options.componentRestrictions = { country: country };
        /* tslint:enable:curly */
        this.setState({ isLoading: true }, function () {
            if (!_this.autocompleteService) {
                _this.setState({ isLoading: false });
                return;
            }
            _this.autocompleteService.getPlacePredictions(options, function (suggestsGoogle) {
                _this.setState({ isLoading: false });
                _this.updateSuggests(suggestsGoogle || [], // can be null
                function () {
                    if (_this.props.autoActivateFirstSuggest &&
                        !_this.state.activeSuggest) {
                        _this.activateSuggest('next');
                    }
                });
            });
        });
    };
    /**
     * Update the suggests
     */
    default_1$$1.prototype.updateSuggests = function (suggestsGoogle, 
    // tslint:disable-next-line:no-empty
    callback) {
        var _this = this;
        if (suggestsGoogle === void 0) { suggestsGoogle = []; }
        if (callback === void 0) { 
        // tslint:disable-next-line:no-empty
        callback = function () { }; }
        var suggests = [];
        var userInput = this.state.userInput;
        var _a = this.props, skipSuggest = _a.skipSuggest, maxFixtures = _a.maxFixtures, fixtures = _a.fixtures;
        var regex = new RegExp(escapeRegExp(userInput), 'gim');
        var fixturesSearched = 0;
        var activeSuggest = null;
        if (fixtures) {
            fixtures.forEach(function (fixture) {
                if (maxFixtures && fixturesSearched >= maxFixtures) {
                    return;
                }
                if ((skipSuggest && !skipSuggest(fixture)) && fixture.label.match(regex)) {
                    fixturesSearched++;
                    suggests.push({
                        className: fixture.className,
                        isFixture: true,
                        label: fixture.label,
                        location: fixture.location,
                        matchedSubstrings: {
                            length: userInput.length,
                            offset: fixture.label.indexOf(userInput)
                        },
                        placeId: fixture.label
                    });
                }
            });
        }
        suggestsGoogle.forEach(function (suggest) {
            if (skipSuggest && !skipSuggest(suggest)) {
                suggests.push({
                    description: suggest.description,
                    isFixture: false,
                    label: _this.props.getSuggestLabel ? _this.props.getSuggestLabel(suggest) : '',
                    matchedSubstrings: suggest.matched_substrings[0],
                    placeId: suggest.place_id
                });
            }
        });
        activeSuggest = this.updateActiveSuggest(suggests);
        if (this.props.onUpdateSuggests) {
            this.props.onUpdateSuggests(suggests, activeSuggest);
        }
        this.setState({ suggests: suggests, activeSuggest: activeSuggest }, callback);
    };
    /**
     * Return the new activeSuggest object after suggests have been updated
     */
    default_1$$1.prototype.updateActiveSuggest = function (suggests) {
        if (suggests === void 0) { suggests = []; }
        var activeSuggest = this.state.activeSuggest;
        if (activeSuggest) {
            var newSuggest = suggests.filter(function (listedSuggest) { return activeSuggest &&
                activeSuggest.placeId === listedSuggest.placeId &&
                activeSuggest.isFixture === listedSuggest.isFixture; })[0];
            activeSuggest = newSuggest || null;
        }
        return activeSuggest;
    };
    /**
     * Show the suggestions
     */
    default_1$$1.prototype.showSuggests = function () {
        this.searchSuggests();
        this.setState({ isSuggestsHidden: false });
    };
    /**
     * Hide the suggestions
     */
    default_1$$1.prototype.hideSuggests = function () {
        var _this = this;
        if (this.props.onBlur) {
            this.props.onBlur(this.state.userInput);
        }
        this.timer = window.setTimeout(function () {
            _this.setState({
                activeSuggest: null,
                isSuggestsHidden: true
            });
        }, 100);
    };
    /**
     * Activate a new suggest
     */
    default_1$$1.prototype.activateSuggest = function (direction) {
        if (this.state.isSuggestsHidden) {
            this.showSuggests();
            return;
        }
        var suggestsCount = this.state.suggests.length - 1;
        var next = direction === 'next';
        var newActiveSuggest = null;
        var newIndex = 0;
        var i = 0;
        for (i; i <= suggestsCount; i++) {
            if (this.state.suggests[i] === this.state.activeSuggest) {
                newIndex = next ? i + 1 : i - 1;
            }
        }
        if (!this.state.activeSuggest) {
            newIndex = next ? 0 : suggestsCount;
        }
        if (newIndex >= 0 && newIndex <= suggestsCount) {
            newActiveSuggest = this.state.suggests[newIndex];
        }
        if (this.props.onActivateSuggest) {
            this.props.onActivateSuggest(newActiveSuggest);
        }
        this.setState({ activeSuggest: newActiveSuggest });
    };
    /**
     * When an item got selected
     */
    default_1$$1.prototype.selectSuggest = function (suggestToSelect) {
        var suggest = suggestToSelect || {
            isFixture: false,
            label: this.state.userInput,
            placeId: this.state.userInput
        };
        this.setState({
            isSuggestsHidden: true,
            userInput: typeof suggest.label !== 'object' ? suggest.label : (suggest.description || '')
        });
        if (suggest.location) {
            this.setState({ ignoreBlur: false });
            if (this.props.onSuggestSelect) {
                this.props.onSuggestSelect(suggest);
            }
            return;
        }
        this.geocodeSuggest(suggest);
    };
    /**
     * Geocode a suggest
     */
    default_1$$1.prototype.geocodeSuggest = function (suggestToGeocode) {
        var _this = this;
        if (!this.geocoder) {
            return;
        }
        if (suggestToGeocode.placeId && !suggestToGeocode.isFixture && this.placesService) {
            var options = {
                placeId: suggestToGeocode.placeId,
                sessionToken: this.sessionToken
            };
            if (this.props.placeDetailFields) {
                options.fields = this.props.placeDetailFields;
            }
            this.placesService.getDetails(options, function (results, status) {
                if (status === _this.googleMaps.places.PlacesServiceStatus.OK) {
                    var gmaps = results;
                    var location_1 = gmaps.geometry.location;
                    var suggest = __assign({}, suggestToGeocode, { gmaps: gmaps, location: {
                            lat: location_1.lat(),
                            lng: location_1.lng()
                        } });
                    _this.sessionToken = new google.maps.places.AutocompleteSessionToken();
                    if (_this.props.onSuggestSelect) {
                        _this.props.onSuggestSelect(suggest);
                    }
                }
            });
        }
        else {
            var options = {
                address: suggestToGeocode.label,
                bounds: this.props.bounds,
                componentRestrictions: this.props.country
                    ? { country: this.props.country }
                    : undefined,
                location: this.props.location
            };
            this.geocoder.geocode(options, function (results, status) {
                if (status === _this.googleMaps.GeocoderStatus.OK) {
                    var gmaps = results[0];
                    var location_2 = gmaps.geometry.location;
                    var suggest = __assign({}, suggestToGeocode, { gmaps: gmaps, location: {
                            lat: location_2.lat(),
                            lng: location_2.lng()
                        } });
                    if (_this.props.onSuggestSelect) {
                        _this.props.onSuggestSelect(suggest);
                    }
                }
            });
        }
    };
    /**
     * Render the view
     */
    default_1$$1.prototype.render = function () {
        var _this = this;
        var attributes = filterInputAttributes(this.props);
        var classes = classnames('geosuggest', this.props.className, {
            'geosuggest--loading': this.state.isLoading
        });
        var shouldRenderLabel = this.props.label && attributes.id;
        var input = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(default_1, __assign({ className: this.props.inputClassName, ref: function (i) { return (_this.input = i); }, value: this.state.userInput, doNotSubmitOnEnter: !this.state.isSuggestsHidden, ignoreTab: this.props.ignoreTab, ignoreEnter: this.props.ignoreEnter, style: this.props.style && this.props.style.input, onChange: this.onInputChange, onFocus: this.onInputFocus, onBlur: this.onInputBlur, onKeyDown: this.props.onKeyDown, onKeyPress: this.props.onKeyPress, onNext: this.onNext, onPrev: this.onPrev, onSelect: this.onSelect, onEscape: this.hideSuggests }, attributes)));
        var suggestionsList = (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(default_1$2, { isHidden: this.state.isSuggestsHidden, style: this.props.style && this.props.style.suggests, suggestItemStyle: this.props.style && this.props.style.suggestItem, userInput: this.state.userInput, isHighlightMatch: Boolean(this.props.highlightMatch), suggestsClassName: this.props.suggestsClassName, suggestItemClassName: this.props.suggestItemClassName, suggests: this.state.suggests, hiddenClassName: this.props.suggestsHiddenClassName, suggestItemActiveClassName: this.props.suggestItemActiveClassName, activeSuggest: this.state.activeSuggest, onSuggestNoResults: this.onSuggestNoResults, onSuggestMouseDown: this.onSuggestMouseDown, onSuggestMouseOut: this.onSuggestMouseOut, onSuggestSelect: this.selectSuggest, renderSuggestItem: this.props.renderSuggestItem }));
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: classes },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: "geosuggest__input-wrapper" },
                shouldRenderLabel && (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("label", { className: "geosuggest__label", htmlFor: attributes.id }, this.props.label)),
                input),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: "geosuggest__suggests-wrapper" }, suggestionsList)));
    };
    /**
     * Default values for the properties
     */
    default_1$$1.defaultProps = defaults;
    return default_1$$1;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/* harmony default export */ __webpack_exports__["default"] = (default_1$3);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(81)))

/***/ }),

/***/ 2483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _GoogleMaps = __webpack_require__(2397);

var _GoogleMaps2 = _interopRequireDefault(_GoogleMaps);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StationMarker = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(StationMarker, _React$PureComponent);

    function StationMarker() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, StationMarker);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.marker = null, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    StationMarker.prototype.addMarker = function addMarker() {
        var _this2 = this;

        var station = this.props.station;


        var icon = {
            url: '/images/add-station-' + _config2.default.get('brand').split('-')[0] + '.png',
            fillOpacity: 1,
            scaledSize: new window.google.maps.Size(64, 80),
            anchor: new window.google.maps.Point(26.5, 78)
        };

        this.addMarkerAsync(function () {
            _this2.marker.addListener('click', function () {
                _this2.props.onSelect(station);
            });
        }, icon, station);
    };

    StationMarker.prototype.addMarkerAsync = function addMarkerAsync(callback, icon, station) {
        var _this3 = this;

        setTimeout(function () {
            _this3.marker = _this3.props.mapsHelper.addMarker({
                position: station.getLatLng(),
                icon: icon,
                title: station.name,
                animation: 'DROP',
                optimized: false
            });
            callback();
        }, Math.random() * 0.99 * 1000);
    };

    StationMarker.prototype.removeMarker = function removeMarker() {
        if (this.marker) {
            this.marker.setMap(null);
            this.marker = null;
        }
    };

    StationMarker.prototype.componentDidMount = function componentDidMount() {
        this.addMarker();
    };

    StationMarker.prototype.componentWillUnmount = function componentWillUnmount() {
        this.removeMarker();
    };

    StationMarker.prototype.render = function render() {
        return null;
    };

    return StationMarker;
}(_react2.default.PureComponent), _class.propTypes = {
    station: _propTypes2.default.instanceOf(_Station2.default),
    mapsHelper: _propTypes2.default.instanceOf(_GoogleMaps2.default),
    onSelect: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = StationMarker;

/***/ }),

/***/ 2484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = OpeningHours;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _TicketOffice = __webpack_require__(604);

var _TicketOffice2 = _interopRequireDefault(_TicketOffice);

var _Loading = __webpack_require__(274);

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

function OpeningHours(_ref) {
    var ticketOffice = _ref.ticketOffice,
        loadingTicketOfficeDetails = _ref.loadingTicketOfficeDetails;

    var getHours = function getHours(day) {
        var timeslots = ticketOffice.openingHours.get(day);
        return timeslots.size ? timeslots.join(', ') : (0, _I18n2.default)('stationFinder.modal.openingHours.unknown');
    };

    var noHours = !loadingTicketOfficeDetails && ticketOffice ? ticketOffice.hasNoHours() : undefined;

    if (loadingTicketOfficeDetails || ticketOffice) {
        return _react2.default.createElement(
            'div',
            { className: 'stationFinder__modal-details stationFinder__modal-opening-hours' },
            _react2.default.createElement(
                'h3',
                null,
                (0, _I18n2.default)('stationFinder.modal.openingHours')
            ),
            loadingTicketOfficeDetails && _react2.default.createElement(_Loading2.default, { inline: true, message: 'stationFinder.modal.openingHoursChecking' }),
            !loadingTicketOfficeDetails && ticketOffice && noHours && _react2.default.createElement(
                'div',
                { className: 'margin-bottom--sm' },
                (0, _I18n2.default)('stationFinder.modal.openingHoursNotAvailable')
            ),
            !loadingTicketOfficeDetails && ticketOffice && !noHours && _react2.default.createElement(
                'table',
                { className: 'table margin-bottom--sm' },
                _react2.default.createElement(
                    'tbody',
                    null,
                    days.map(function (day) {
                        return _react2.default.createElement(
                            'tr',
                            { key: day },
                            _react2.default.createElement(
                                'th',
                                null,
                                day
                            ),
                            _react2.default.createElement(
                                'td',
                                null,
                                getHours(day)
                            )
                        );
                    })
                )
            )
        );
    }

    return null;
}

OpeningHours.propTypes = {
    ticketOffice: _propTypes2.default.instanceOf(_TicketOffice2.default),
    loadingTicketOfficeDetails: _propTypes2.default.bool
};

OpeningHours.defaultProps = {
    ticketOffice: null,
    loadingTicketOfficeDetails: false
};

/***/ }),

/***/ 2485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _TicketOffice = __webpack_require__(604);

var _TicketOffice2 = _interopRequireDefault(_TicketOffice);

var _AppConstants = __webpack_require__(6);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OpeningStatus = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(OpeningStatus, _React$PureComponent);

    function OpeningStatus() {
        (0, _classCallCheck3.default)(this, OpeningStatus);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    OpeningStatus.prototype._getSelectedStationOpeningTime = function _getSelectedStationOpeningTime() {
        var ticketOffice = this.props.ticketOffice;


        if (ticketOffice) {
            return ticketOffice.getOpenStatus((0, _TrainTime2.default)());
        }

        return _AppConstants.TicketOfficeHours.NO_OFFICE;
    };

    OpeningStatus.prototype.renderStationOpenStatusMessage = function renderStationOpenStatusMessage(openStatus) {
        var alertType = void 0;
        switch (openStatus) {
            case _AppConstants.TicketOfficeHours.OPEN:
                alertType = 'success';
                break;
            case _AppConstants.TicketOfficeHours.CLOSED:
                alertType = 'danger';
                break;
            case _AppConstants.TicketOfficeHours.NO_OFFICE:
                alertType = 'danger';
                break;
            default:
                alertType = 'warning';
        }

        return _react2.default.createElement(
            _BAlert2.default,
            { type: alertType, className: 'text-center' },
            _react2.default.createElement(_Icon2.default, { icon: 'clock', className: 'opening-clock' }),
            '\xA0',
            _react2.default.createElement(
                'span',
                null,
                (0, _I18n2.default)('stationFinder.status.' + openStatus)
            )
        );
    };

    OpeningStatus.prototype.render = function render() {
        if (this.props.loadingTicketOfficeDetails) {
            return _react2.default.createElement(
                'div',
                { className: 'text-center b-alert' },
                _react2.default.createElement('i', { className: 'otrl otrl-spinner otrl-spin' })
            );
        }

        var openStatus = this._getSelectedStationOpeningTime();

        return _react2.default.createElement(
            'div',
            { className: 'stationFinder__modal-opening-status' },
            this.renderStationOpenStatusMessage(openStatus)
        );
    };

    return OpeningStatus;
}(_react2.default.PureComponent), _class.propTypes = {
    loadingTicketOfficeDetails: _propTypes2.default.bool,
    ticketOffice: _propTypes2.default.instanceOf(_TicketOffice2.default)
}, _class.defaultProps = {
    loadingTicketOfficeDetails: false,
    ticketOffice: null
}, _temp);
exports.default = OpeningStatus;

/***/ }),

/***/ 2486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = StationFacilities;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapFacilities = function mapFacilities(facilities) {
    return facilities.map(function (currentFacility, index) {
        var key = 'facility-' + index;
        var currentFacilityNoCamelCase = currentFacility.replace(/([A-Z])/g, ' $1').trim();
        var facilitySplit = index !== facilities.length - 1 ? ',' : '.';

        return _react2.default.createElement(
            'li',
            { key: key },
            _react2.default.createElement(
                'div',
                { className: 'stationFinder__modal-facility' },
                currentFacilityNoCamelCase,
                facilitySplit
            )
        );
    });
};

function StationFacilities(_ref) {
    var facilities = _ref.facilities;

    return _react2.default.createElement(
        'div',
        { className: 'stationFinder__modal-details stationFinder__modal-facilities' },
        _react2.default.createElement(
            'h3',
            null,
            (0, _I18n2.default)('stationFinder.modal.facilities')
        ),
        _react2.default.createElement(
            'ul',
            null,
            mapFacilities(facilities)
        )
    );
}

StationFacilities.propTypes = {
    facilities: _propTypes2.default.array
};

StationFacilities.defaultProps = {
    facilities: []
};

/***/ }),

/***/ 2487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = AddStation;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _AppConstants = __webpack_require__(6);

var _AddStationButton = __webpack_require__(2488);

var _AddStationButton2 = _interopRequireDefault(_AddStationButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AddStation(_ref) {
    var activeAddButton = _ref.activeAddButton,
        onSelect = _ref.onSelect;

    return _react2.default.createElement(
        'div',
        { className: 'stationFinder__modal-add-station' },
        _react2.default.createElement(
            'div',
            { className: 'stationFinder__modal-text' },
            (0, _I18n2.default)('stationFinder.modal.mainText')
        ),
        _react2.default.createElement(_AddStationButton2.default, { type: _AppConstants.StationTypes.ORIGIN,
            activeAddButton: activeAddButton,
            onSelect: onSelect
        }),
        _react2.default.createElement(_AddStationButton2.default, { type: _AppConstants.StationTypes.DESTINATION,
            activeAddButton: activeAddButton,
            onSelect: onSelect
        })
    );
}

AddStation.propTypes = {
    activeAddButton: _propTypes2.default.string,
    onSelect: _propTypes2.default.func.isRequired,
    disableOrigin: _propTypes2.default.bool,
    disableDestination: _propTypes2.default.bool
};

AddStation.defaultProps = {
    activeAddButton: null,
    disableOrigin: false,
    disableDestination: false
};

/***/ }),

/***/ 2488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = AddStationButton;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AddStationButton(_ref) {
    var type = _ref.type,
        onSelect = _ref.onSelect,
        activeAddButton = _ref.activeAddButton,
        disabled = _ref.disabled;

    var addButtonClassNames = (0, _classnames2.default)('btn-box btn-add', {
        selected: activeAddButton === type
    });

    return _react2.default.createElement(
        'div',
        { className: 'stationFinder__modal-button' },
        _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                    return onSelect(type);
                }, className: addButtonClassNames, disabled: disabled },
            _react2.default.createElement(_Icon2.default, { className: 'box-icon', icon: 'add' }),
            _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'stationFinder.modal.' + type }),
            activeAddButton === type && _react2.default.createElement(_Icon2.default, { icon: 'selected', className: 'selected-icon' })
        )
    );
}

AddStationButton.propTypes = {
    type: _propTypes2.default.string.isRequired,
    onSelect: _propTypes2.default.func.isRequired,
    activeAddButton: _propTypes2.default.string,
    disabled: _propTypes2.default.bool
};

AddStationButton.defaultProps = {
    activeAddButton: null,
    disabled: false
};

/***/ }),

/***/ 2489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = StationFinderToggle;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StationFinderToggle(_ref) {
    var onActivate = _ref.onActivate;

    return _react2.default.createElement(
        'button',
        { onClick: onActivate, className: 'btn btn-default stationFinder__open' },
        _react2.default.createElement(_Icon2.default, { icon: 'search' }),
        (0, _I18n.translate)('stationFinder.modal.link')
    );
}

StationFinderToggle.propTypes = {
    onActivate: _propTypes2.default.func.isRequired
};

/***/ }),

/***/ 2490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(53);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _compact2 = __webpack_require__(155);

var _compact3 = _interopRequireDefault(_compact2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _SeasonSearch = __webpack_require__(328);

var _SeasonSearch2 = _interopRequireDefault(_SeasonSearch);

var _I18n = __webpack_require__(9);

var _Immutable = __webpack_require__(54);

var _StationStore = __webpack_require__(429);

var _StationStore2 = _interopRequireDefault(_StationStore);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _Select = __webpack_require__(425);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JourneySelectorClosed = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(JourneySelectorClosed, _PureRenderComponent);

    function JourneySelectorClosed() {
        var _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, JourneySelectorClosed);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            journeys: new _immutable.List()
        }, _this.updateJourneys = function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(options) {
                var stationCrsCodes, stationPromises, stations, byCRS, updatedJourneys;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                // Find out the stations CRS codes we need to fetch and ask the store for them
                                stationCrsCodes = (0, _Immutable.unique)(options.flatten(true), function (crs) {
                                    return crs;
                                });
                                stationPromises = stationCrsCodes.map(function (crs) {
                                    return _StationStore2.default.get(crs);
                                });
                                _context.next = 4;
                                return _promise2.default.all(stationPromises.toArray());

                            case 4:
                                stations = _context.sent;

                                // Once we have the stations, we need to construct the given journey options
                                // again - but using the actual station records we have been given back rather
                                // than just the CRS codes since we need more detail information about the stations
                                byCRS = function byCRS(crs) {
                                    return stations.find(function (station) {
                                        return station.get('crs') === crs;
                                    });
                                };

                                updatedJourneys = options.map(function (option) {
                                    return option.map(byCRS);
                                });

                                _this.setState({ journeys: updatedJourneys });

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }(), _this._handleChange = function (event) {
            var _this$props = _this.props,
                search = _this$props.search,
                onChange = _this$props.onChange;

            var _this$state$journeys$ = _this.state.journeys.get(event.target.selectedIndex - 1).toArray(),
                origin = _this$state$journeys$[0],
                destination = _this$state$journeys$[1];

            _TrackingActions2.default.widgetSearchClick({ name: 'direction:' + event.target.value.toLowerCase() });

            return onChange(search.set('origin', origin).set('destination', destination));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    JourneySelectorClosed.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        var options = this.props.options;

        if (options && options.size > 0) {
            this.updateJourneys(options);
        }
    };

    JourneySelectorClosed.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.options && this.props.search.showAdditionalRoutes !== nextProps.search.showAdditionalRoutes) {
            this.updateJourneys(nextProps.options);
        }
    };

    JourneySelectorClosed.prototype.render = function render() {
        var value = (0, _compact3.default)([this.props.search.origin.get('crs'), this.props.search.destination.get('crs')]).join('-');

        return _react2.default.createElement(
            'section',
            { className: 'booking__section' },
            _react2.default.createElement(
                'div',
                { className: 'form-field journey-selector__closed' },
                _react2.default.createElement(
                    _Select2.default,
                    {
                        id: 'journey',
                        type: 'select',
                        value: value,
                        labelClassName: 'sr-only',
                        className: 'journey-selector',
                        onChange: this._handleChange,
                        groupClassName: 'select-container',
                        label: (0, _I18n.translate)('booking.journey.chooseAJourney') },
                    _react2.default.createElement(
                        'option',
                        { value: '', disabled: true },
                        (0, _I18n.translate)('booking.journey.chooseAJourney') + '...'
                    ),
                    this.state.journeys.map(function (option, key) {
                        var _option$toArray = option.toArray(),
                            origin = _option$toArray[0],
                            destination = _option$toArray[1];

                        return _react2.default.createElement(
                            'option',
                            {
                                key: key,
                                value: origin.get('crs') + '-' + destination.get('crs') },
                            origin.getName(),
                            ' ',
                            (0, _I18n.translate)('global.to'),
                            ' ',
                            destination.getName()
                        );
                    })
                )
            )
        );
    };

    return JourneySelectorClosed;
}(_PureRenderComponent3.default), _class.propTypes = {
    search: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Search2.default), _propTypes2.default.instanceOf(_SeasonSearch2.default)]).isRequired,
    onChange: _propTypes2.default.func,
    options: _propTypes2.default.instanceOf(_immutable.List),
    showAdditionalRoutes: _propTypes2.default.bool
}, _class.defaultProps = {
    showAdditionalRoutes: false
}, _temp2);
exports.default = JourneySelectorClosed;

/***/ }),

/***/ 2491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Immutable = __webpack_require__(54);

var _I18n = __webpack_require__(9);

var _PassengersForm = __webpack_require__(2395);

var _PassengersForm2 = _interopRequireDefault(_PassengersForm);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _PassengersModal = __webpack_require__(2492);

var _PassengersModal2 = _interopRequireDefault(_PassengersModal);

var _SectionErrors = __webpack_require__(974);

var _SectionErrors2 = _interopRequireDefault(_SectionErrors);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _RailcardsStore = __webpack_require__(608);

var _RailcardsStore2 = _interopRequireDefault(_RailcardsStore);

var _RailcardsActions = __webpack_require__(2402);

var _RailcardsActions2 = _interopRequireDefault(_RailcardsActions);

var _PassengerRailcard = __webpack_require__(269);

var _PassengerRailcard2 = _interopRequireDefault(_PassengerRailcard);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getStateFromStores = function _getStateFromStores() {
    return {
        favouriteDRC: _RailcardsStore2.default.getFavouriteDRC(),
        user: _UserStore2.default.getCurrent()
    };
};

var PassengersSummary = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(PassengersSummary, _PureRenderComponent);

    function PassengersSummary() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PassengersSummary);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            modalOpen: false
        }, _this.componentDidMount = function () {
            var enableDigitalRailcards = _FeatureFlagStore2.default.get('enableDigitalRailcards');

            if (enableDigitalRailcards) {
                _this._preselectDRC(_this.props, {});
            }
        }, _this.componentDidUpdate = function (prevProps) {
            var enableDigitalRailcards = _FeatureFlagStore2.default.get('enableDigitalRailcards');

            if (enableDigitalRailcards) {
                _this._preselectDRC(_this.props, prevProps);
            }
        }, _this._preselectDRC = function (currentProps, prevProps) {
            var enableDigitalRailcards = _FeatureFlagStore2.default.get('enableDigitalRailcards');

            var user = currentProps.user,
                favouriteDRC = currentProps.favouriteDRC,
                railcards = currentProps.railcards;

            var hasJustLoggedIn = !(prevProps.user && prevProps.user.id) && user.id;

            if (enableDigitalRailcards && hasJustLoggedIn) {
                (0, _defer3.default)(function () {
                    return _RailcardsActions2.default.loadAccountDRC(user.id);
                });
            }

            var isRailcardNotSelected = railcards.size === 0;
            var hasJustFetchedFavourite = favouriteDRC && (prevProps.favouriteDRC && prevProps.favouriteDRC.id || null) !== favouriteDRC.id;

            if (hasJustFetchedFavourite && isRailcardNotSelected) {
                _this._setFavouriteDRC(favouriteDRC);
            }
        }, _this._setFavouriteDRC = function (_ref) {
            var code = _ref.railcardCode;
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                adults = _this$props.adults,
                children = _this$props.children;

            var railcard = new _PassengerRailcard2.default({ quantity: 1, code: code });

            (0, _defer3.default)(function () {
                return onChange(adults, children, new _immutable.List([railcard]));
            });
        }, _this._toggleModal = function () {
            _this.setState({ modalOpen: !_this.state.modalOpen });
        }, _this._handleChange = function (adults, children, railcards) {
            _this._toggleModal();
            _this.props.onChange(adults, children, railcards);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    PassengersSummary.prototype._renderModal = function _renderModal() {
        if (!this.state.modalOpen) {
            return null;
        }

        return _react2.default.createElement(_PassengersModal2.default, {
            show: this.state.modalOpen,
            adults: this.props.adults,
            children: this.props.children,
            railcards: this.props.railcards,
            onCancel: this._toggleModal,
            onSelect: this._handleChange,
            Form: this.props.Form,
            hideRailcards: this.props.hideRailcards,
            hideFareInfo: this.props.hideFareInfo
        });
    };

    PassengersSummary.prototype._validate = function _validate() {
        var _props = this.props,
            railcards = _props.railcards,
            adults = _props.adults,
            children = _props.children;

        var form = new this.props.Form({ railcards: railcards, adults: adults, children: children });
        var errors = form.getValidationSummaryArray();
        return errors;
    };

    PassengersSummary.prototype._renderErrors = function _renderErrors() {
        var errors = this._validate();
        return errors.length > 0 ? _react2.default.createElement(_SectionErrors2.default, { errors: errors }) : null;
    };

    PassengersSummary.prototype.render = function render() {
        var _props2 = this.props,
            adults = _props2.adults,
            children = _props2.children,
            hideRailcards = _props2.hideRailcards,
            railcards = _props2.railcards;


        var railcardsText = '';

        if (railcards && !hideRailcards) {
            railcardsText = ' - ' + (0, _I18n.translate)('booking.railcards.summary', { railcards: (0, _Immutable.sum)(railcards, 'quantity') });
        }

        return _react2.default.createElement(
            'section',
            { className: 'booking__section passengers' },
            this._renderModal(),
            _react2.default.createElement(
                'button',
                { ref: 'button', className: 'btn-box', type: 'button', onClick: this._toggleModal },
                (0, _I18n.translate)('booking.passengers.summary.text', { adults: adults, children: children }),
                railcardsText + ' ',
                _react2.default.createElement(_Icon2.default, {
                    className: (0, _classnames2.default)('pull-right', 'box__icon', 'icon-top-right-absolute', { hideRailcards: hideRailcards }),
                    icon: 'passengers',
                    srOnly: (0, _I18n.translate)('ariaLabel.passengerInfo')
                })
            ),
            this._renderErrors()
        );
    };

    return PassengersSummary;
}(_PureRenderComponent3.default), _class.propTypes = {
    adults: _propTypes2.default.number.isRequired,
    children: _propTypes2.default.number.isRequired,
    railcards: _propTypes2.default.instanceOf(_immutable.List),
    onChange: _propTypes2.default.func,
    Form: _propTypes2.default.func,
    hideRailcards: _propTypes2.default.bool
}, _class.defaultProps = {
    railcards: null,
    onChange: _noop3.default,
    Form: _PassengersForm2.default,
    hideRailcards: false
}, _temp2);
exports.default = (0, _connectToStores2.default)([_RailcardsStore2.default, _UserStore2.default], _getStateFromStores)(PassengersSummary);

/***/ }),

/***/ 2492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _AppConstants = __webpack_require__(6);

var _PassengersForm = __webpack_require__(2395);

var _PassengersForm2 = _interopRequireDefault(_PassengersForm);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Railcards = __webpack_require__(2424);

var _Railcards2 = _interopRequireDefault(_Railcards);

var _PassengersSelector = __webpack_require__(2432);

var _PassengersSelector2 = _interopRequireDefault(_PassengersSelector);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PassengersModal = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(PassengersModal, _PureRenderComponent);

    function PassengersModal() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, PassengersModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            railcards: _this.props.railcards,
            adults: _this.props.adults,
            children: _this.props.children
        }, _this._handleChangeFor = function (key) {
            return function (value) {
                var _this$setState;

                _this.setState((_this$setState = {}, _this$setState[key] = value, _this$setState));
            };
        }, _this._onSave = function () {
            var railcards = _this.state.railcards ? _this.state.railcards.filter(function (railcard) {
                return railcard.code;
            }) : null;

            if (!_this._hasErrors()) {
                _this.props.onSelect(_this.state.adults, _this.state.children, railcards);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    PassengersModal.prototype._hasErrors = function _hasErrors() {
        var form = new this.props.Form(this.state);

        return !form.isComplete();
    };

    PassengersModal.prototype._isDirty = function _isDirty() {
        return this.props.children !== this.state.children || this.props.adults !== this.state.adults || this.props.railcards !== this.state.railcards;
    };

    PassengersModal.prototype.render = function render() {
        var _state = this.state,
            adults = _state.adults,
            children = _state.children,
            railcards = _state.railcards;
        var hideRailcards = this.props.hideRailcards;


        var modalProps = {
            show: this.props.show,
            onClose: this.props.onCancel,
            onContinue: this._onSave,
            closeText: 'button.text.cancel',
            continueText: 'button.text.select',
            disableBlur: this._isDirty(),
            disableContinue: this._hasErrors(),
            titleText: 'booking.passengers.modal.title' + (railcards ? '.withRailcards' : ''),
            className: 'modal--sm',
            onOpen: function onOpen() {
                _TrackingActions2.default.genericModalOpen(_AppConstants.GenericModals.PASSENGERS_RAILCARDS);
            }
        };

        return _react2.default.createElement(
            _BaseModal2.default,
            modalProps,
            _react2.default.createElement(
                'section',
                { className: 'modal-body__passengers' },
                _react2.default.createElement(_PassengersSelector2.default, {
                    adults: adults,
                    children: children,
                    onAdultsChange: this._handleChangeFor('adults'),
                    onChildrenChange: this._handleChangeFor('children'),
                    Form: this.props.Form,
                    hideInfo: this.props.hideFareInfo
                }),
                railcards && !hideRailcards && _react2.default.createElement(_Railcards2.default, {
                    adults: adults,
                    children: children,
                    railcards: railcards,
                    onRailcardsChange: this._handleChangeFor('railcards'),
                    Form: this.props.Form
                })
            )
        );
    };

    return PassengersModal;
}(_PureRenderComponent3.default), _class.propTypes = {
    show: _propTypes2.default.bool.isRequired,
    railcards: _propTypes2.default.instanceOf(_immutable.List),
    adults: _propTypes2.default.number.isRequired,
    children: _propTypes2.default.number.isRequired,
    onCancel: _propTypes2.default.func,
    onSelect: _propTypes2.default.func,
    Form: _propTypes2.default.func,
    hideRailcards: _propTypes2.default.bool,
    hideFareInfo: _propTypes2.default.bool
}, _class.defaultProps = {
    railcards: null,
    onCancel: _noop3.default,
    onSelect: _noop3.default,
    Form: _PassengersForm2.default,
    hideRailcards: false,
    hideFareInfo: false
}, _temp2);
exports.default = PassengersModal;

/***/ }),

/***/ 2493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _AppConstants = __webpack_require__(6);

var _Link = __webpack_require__(275);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getStatusText(smartcard) {
    if (smartcard.isActive() && smartcard.isFull()) {
        return (0, _I18n2.default)('account.smartcard.status.full');
    }
    if (smartcard.isAwaitingProduct()) {
        return '';
    }
    return smartcard.getStatus();
}

function SmartcardStatus(_ref) {
    var smartcard = _ref.smartcard;

    var classNames = (0, _classnames2.default)({
        'alert-success': smartcard.canLoadProduct(),
        'alert-warning': !smartcard.canLoadProduct()
    }, 'text-weight--normal', 'text-upper', 'no-margin');

    return _react2.default.createElement(
        'p',
        { className: classNames },
        _getStatusText(smartcard) + ' ',
        !smartcard.canLoadProduct() && _react2.default.createElement(
            _Link2.default,
            { className: 'alert-warning text-sm text-capitalise', to: _AppConstants.AccountPages.SMARTCARD_TICKETS },
            (0, _I18n2.default)('booking.smartcard.moreInformation')
        )
    );
}

SmartcardStatus.propTypes = {
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default).isRequired
};

exports.default = SmartcardStatus;

/***/ }),

/***/ 2516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ThreeDSecureType = undefined;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keymirror = __webpack_require__(176);

var _keymirror2 = _interopRequireDefault(_keymirror);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _OrderActions = __webpack_require__(157);

var _OrderActions2 = _interopRequireDefault(_OrderActions);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _PaymentStore = __webpack_require__(418);

var _PaymentStore2 = _interopRequireDefault(_PaymentStore);

var _ThreeDSecure = __webpack_require__(2478);

var _ThreeDSecure2 = _interopRequireDefault(_ThreeDSecure);

var _TokenStore = __webpack_require__(281);

var _TokenStore2 = _interopRequireDefault(_TokenStore);

var _APIClient = __webpack_require__(52);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThreeDSecureType = exports.ThreeDSecureType = (0, _keymirror2.default)({
    Payment: null,
    Authorization: null
});

var with3DSecure = function with3DSecure(type) {
    return function (WrappedComponent) {
        var _dec, _class, _class2, _temp2;

        var _getStateFromStores = function _getStateFromStores() {
            return {
                currentOrder: _OrderStore2.default.getCurrent(),
                is3DSecure: _PaymentStore2.default.is3DSecure()
            };
        };

        var With3DSecure = (_dec = (0, _connectToStores2.default)([_OrderStore2.default, _PaymentStore2.default], _getStateFromStores), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
            (0, _inherits3.default)(With3DSecure, _React$PureComponent);

            function With3DSecure() {
                var _temp, _this, _ret;

                (0, _classCallCheck3.default)(this, With3DSecure);

                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._handle3DSComplete = function (handlePaymentComplete, options) {
                    return function () {
                        if (options) {
                            // handle keyGo here
                            if (options.isKeyGo) {
                                handlePaymentComplete({ justReset3D: true });
                            }
                            if (options.isKeyGoRegistration) {
                                _CustomerActions2.default.registerKeyGoResume(options.user, options.threeDSecureAuthResponse.cocs.id);
                            } else {
                                // can only be registration or update
                                _CustomerActions2.default.updateKeyGoResume(options.user, options.threeDSecureAuthResponse.cocs.id);
                            }
                            if (options && options.successCallback) {
                                options.successCallback();
                            }
                        } else {
                            _OrderActions2.default.refresh(_this.props.currentOrder).then(handlePaymentComplete);
                        }
                    };
                }, _this._getThreeDSecureProps = function (authResponse, handler, opts) {
                    var host = window.location.host;

                    var callbackUrl = _config2.default.get('threeDSecureCallbackUrl');
                    var threeDSecureTermUrl = _config2.default.get('threeDSecureTermUrl' + (authResponse.cocs.threeDSServerTransId ? 'V2' : 'V1') + type);

                    switch (type) {
                        case ThreeDSecureType.Payment:
                            {
                                return {
                                    authResponse: authResponse.cocs,
                                    onComplete: _this._handle3DSComplete(handler, opts),
                                    responseUrl: (0, _APIClient.makeUrl)(threeDSecureTermUrl.replace('{orderId}', _this.props.currentOrder.id).replace('{paymentId}', authResponse.id).replace('{deviceToken}', _TokenStore2.default.getDevice()).replace('{callbackUrl}', 'https://' + host + callbackUrl))
                                };
                            }

                        case ThreeDSecureType.Authorization:
                            {
                                return {
                                    authResponse: authResponse.cocs,
                                    onComplete: _this._handle3DSComplete(handler, opts),
                                    responseUrl: (0, _APIClient.makeUrl)(threeDSecureTermUrl.replace('{paymentId}', authResponse.id).replace('{callbackUrl}', 'https://' + host + callbackUrl))
                                };
                            }

                        default:
                            {
                                return null;
                            }
                    }
                }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
            }

            With3DSecure.prototype.render = function render() {
                var _this2 = this;

                var injectedProps = {
                    handle3DSComplete: this._handle3DSComplete,
                    renderThreeDSecure: function renderThreeDSecure() {
                        return _react2.default.createElement(_ThreeDSecure2.default, _this2._getThreeDSecureProps.apply(_this2, arguments));
                    }
                };

                return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({}, injectedProps, this.props));
            };

            return With3DSecure;
        }(_react2.default.PureComponent), _class2.propTypes = {
            currentOrder: _propTypes2.default.instanceOf(_Order2.default).isRequired
        }, _temp2)) || _class);


        With3DSecure.displayName = 'With3DSecure(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')';

        return With3DSecure;
    };
};

exports.default = with3DSecure;

/***/ }),

/***/ 2524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _immutable = __webpack_require__(5);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _ConfigService = __webpack_require__(630);

var _ConfigService2 = _interopRequireDefault(_ConfigService);

var _AppConstants = __webpack_require__(6);

var _JourneyNotificationStore = __webpack_require__(1000);

var _JourneyNotificationStore2 = _interopRequireDefault(_JourneyNotificationStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JourneyNotificationActions = {
    fetchMessages: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(search) {
            var messages;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            messages = void 0;
                            _context.prev = 1;
                            _context.next = 4;
                            return _ConfigService2.default.loadJourneyNotifications(search.getJsonForJourneyNotification());

                        case 4:
                            messages = _context.sent;

                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.JOURNEY_NOTIFICATIONS_LOADED,
                                search: search,
                                messages: messages
                            });
                            _context.next = 12;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](1);

                            console.error('Failed to load journey notifications', _context.t0);
                            messages = new _immutable.List();

                        case 12:
                            return _context.abrupt('return', { messages: messages.filter(function (message) {
                                    return !_JourneyNotificationStore2.default.isJourneyNotificationDismissed(message.id);
                                }) });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 8]]);
        }));

        function fetchMessages(_x) {
            return _ref.apply(this, arguments);
        }

        return fetchMessages;
    }(),
    dismissMessages: function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({
                                actionType: _AppConstants.ActionTypes.JOURNEY_NOTIFICATIONS_DISMISSED
                            });

                        case 1:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function dismissMessages() {
            return _ref2.apply(this, arguments);
        }

        return dismissMessages;
    }()
};

exports.default = JourneyNotificationActions;

/***/ }),

/***/ 2525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _uniqueId2 = __webpack_require__(146);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Timeband = __webpack_require__(337);

var _Timeband2 = _interopRequireDefault(_Timeband);

var _MomentPropTypes = __webpack_require__(230);

var _MomentPropTypes2 = _interopRequireDefault(_MomentPropTypes);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _AppConstants = __webpack_require__(6);

var _TimeSelector = __webpack_require__(979);

var _TimeSelector2 = _interopRequireDefault(_TimeSelector);

var _DateSelector = __webpack_require__(2396);

var _DateSelector2 = _interopRequireDefault(_DateSelector);

var _TodayTomorrowControls = __webpack_require__(2443);

var _TodayTomorrowControls2 = _interopRequireDefault(_TodayTomorrowControls);

var _ArriveDepart = __webpack_require__(2415);

var _ArriveDepart2 = _interopRequireDefault(_ArriveDepart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OutboundDateSelector(_ref) {
    var className = _ref.className,
        timeband = _ref.timeband,
        min = _ref.min,
        max = _ref.max,
        disabled = _ref.disabled,
        onChange = _ref.onChange,
        id = _ref.id,
        disableTodayTomorrow = _ref.disableTodayTomorrow,
        autoFocusedElt = _ref.autoFocusedElt;


    var handleChangeFor = function handleChangeFor(field, trackingEvent) {
        return function (value) {
            if (trackingEvent === _AppConstants.widgetSearchElements.timeSelector) {
                _TrackingActions2.default.widgetSearchClick({ name: 'outbound-time', value: value });
            } else if (trackingEvent === _AppConstants.widgetSearchElements.arriveDepart) {
                _TrackingActions2.default.widgetSearchClick({ name: 'outbound-arrive-depart', value: value });
            } else if (trackingEvent === _AppConstants.widgetSearchElements.dateSelector) {
                _TrackingActions2.default.widgetDaySelect({ date: value, type: 'outbound' });
            }
            onChange(timeband.set(field, value));
        };
    };

    var datetime = timeband.datetime,
        arriveDepart = timeband.arriveDepart;


    return _react2.default.createElement(
        'div',
        { className: className + ' timeband-selector',
            id: id },
        _react2.default.createElement(_TodayTomorrowControls2.default, {
            startDate: (0, _TrainTime2.default)().set({ hour: datetime.hour(), minute: datetime.minute() }),
            onChange: handleChangeFor('datetime'),
            disabled: disabled || disableTodayTomorrow,
            srOnly: (0, _I18n2.default)('ariaLabel.setFieldDescription', { field: (0, _I18n2.default)('ariaLabel.outboundDateField') }),
            autoFocusedElt: autoFocusedElt }),
        _react2.default.createElement(_DateSelector2.default, { datetime: datetime,
            min: min,
            max: max,
            onChange: handleChangeFor('datetime', _AppConstants.widgetSearchElements.dateSelector),
            disabled: disabled,
            srOnly: (0, _I18n2.default)('ariaLabel.fieldDescription', { field: (0, _I18n2.default)('ariaLabel.outboundDateField') }) }),
        _react2.default.createElement(_ArriveDepart2.default, { arriveDepart: arriveDepart,
            onChange: handleChangeFor('arriveDepart', _AppConstants.widgetSearchElements.arriveDepart),
            direction: _AppConstants.JourneyDirections.OUTWARD,
            disabled: disabled }),
        _react2.default.createElement(_TimeSelector2.default, { datetime: datetime,
            min: min,
            max: max,
            onChange: handleChangeFor('datetime', _AppConstants.widgetSearchElements.timeSelector),
            disabled: disabled })
    );
}

OutboundDateSelector.propTypes = {
    className: _propTypes2.default.string,
    timeband: _propTypes2.default.instanceOf(_Timeband2.default),
    onChange: _propTypes2.default.func,
    min: _MomentPropTypes2.default.isMoment,
    max: _MomentPropTypes2.default.isMoment,
    disabled: _propTypes2.default.bool,
    id: _propTypes2.default.string,
    disableTodayTomorrow: _propTypes2.default.bool,
    autoFocusedElt: _propTypes2.default.func
};

OutboundDateSelector.defaultProps = {
    timeband: new _Timeband2.default(),
    className: '',
    onChange: _noop3.default,
    min: null,
    max: null,
    disabled: false,
    id: (0, _uniqueId3.default)('outbound-timeband-selector'),
    disableTodayTomorrow: false,
    autoFocusedElt: _noop3.default
};

exports.default = OutboundDateSelector;

/***/ }),

/***/ 2526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _uniqueId2 = __webpack_require__(146);

var _uniqueId3 = _interopRequireDefault(_uniqueId2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Timeband = __webpack_require__(337);

var _Timeband2 = _interopRequireDefault(_Timeband);

var _MomentPropTypes = __webpack_require__(230);

var _MomentPropTypes2 = _interopRequireDefault(_MomentPropTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _AppConstants = __webpack_require__(6);

var _TimeSelector = __webpack_require__(979);

var _TimeSelector2 = _interopRequireDefault(_TimeSelector);

var _DateSelector = __webpack_require__(2396);

var _DateSelector2 = _interopRequireDefault(_DateSelector);

var _SameNextDayControls = __webpack_require__(2527);

var _SameNextDayControls2 = _interopRequireDefault(_SameNextDayControls);

var _ArriveDepart = __webpack_require__(2415);

var _ArriveDepart2 = _interopRequireDefault(_ArriveDepart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ReturnDateSelector(_ref) {
    var className = _ref.className,
        timeband = _ref.timeband,
        min = _ref.min,
        max = _ref.max,
        disabled = _ref.disabled,
        onChange = _ref.onChange,
        id = _ref.id;


    var handleChangeFor = function handleChangeFor(field, trackingEvent) {
        return function (value) {
            if (trackingEvent === _AppConstants.widgetSearchElements.timeSelector) {
                _TrackingActions2.default.widgetSearchClick({ name: 'return-time', value: value });
            } else if (trackingEvent === _AppConstants.widgetSearchElements.arriveDepart) {
                _TrackingActions2.default.widgetSearchClick({ name: 'return-arrive-depart', value: value });
            } else if (trackingEvent === _AppConstants.widgetSearchElements.dateSelector) {
                _TrackingActions2.default.widgetDaySelect({ date: value, type: 'return' });
            }
            onChange(timeband.set(field, value));
        };
    };

    var datetime = timeband.datetime,
        arriveDepart = timeband.arriveDepart;


    return _react2.default.createElement(
        'div',
        { className: className + ' timeband-selector',
            id: id },
        _react2.default.createElement(_SameNextDayControls2.default, { disabled: disabled,
            datetime: datetime,
            startDate: min,
            onChange: handleChangeFor('datetime'),
            max: max,
            srOnly: (0, _I18n2.default)('ariaLabel.setFieldDescription', { field: (0, _I18n2.default)('ariaLabel.returnDateField') }) }),
        _react2.default.createElement(_DateSelector2.default, { datetime: datetime,
            min: min,
            max: max,
            dropdownPosition: _DateSelector2.default.dropdownPositions.RIGHT,
            onChange: handleChangeFor('datetime', _AppConstants.widgetSearchElements.dateSelector),
            disabled: disabled,
            srOnly: (0, _I18n2.default)('ariaLabel.fieldDescription', { field: (0, _I18n2.default)('ariaLabel.returnDateField') }) }),
        _react2.default.createElement(_ArriveDepart2.default, { arriveDepart: arriveDepart,
            onChange: handleChangeFor('arriveDepart', _AppConstants.widgetSearchElements.arriveDepart),
            direction: _AppConstants.JourneyDirections.INWARD,
            disabled: disabled }),
        _react2.default.createElement(_TimeSelector2.default, { datetime: datetime,
            min: min,
            max: max,
            onChange: handleChangeFor('datetime', _AppConstants.widgetSearchElements.timeSelector),
            disabled: disabled })
    );
}

ReturnDateSelector.propTypes = {
    className: _propTypes2.default.string,
    timeband: _propTypes2.default.instanceOf(_Timeband2.default),
    onChange: _propTypes2.default.func,
    min: _MomentPropTypes2.default.isMoment,
    max: _MomentPropTypes2.default.isMoment,
    disabled: _propTypes2.default.bool,
    id: _propTypes2.default.string
};

ReturnDateSelector.defaultProps = {
    timeband: new _Timeband2.default(),
    className: '',
    onChange: _noop3.default,
    min: null,
    max: null,
    disabled: false,
    id: (0, _uniqueId3.default)('return-timeband-selector')
};

exports.default = ReturnDateSelector;

/***/ }),

/***/ 2527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _MomentPropTypes = __webpack_require__(230);

var _MomentPropTypes2 = _interopRequireDefault(_MomentPropTypes);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SameNextDayControls(_ref) {
    var datetime = _ref.datetime,
        startDate = _ref.startDate,
        disabled = _ref.disabled,
        onChange = _ref.onChange,
        max = _ref.max,
        srOnly = _ref.srOnly;

    var controlClass = (0, _classnames2.default)('btn-link like-link');

    var changeHandler = function changeHandler(date, type) {
        return function () {
            _TrackingActions2.default.widgetSearchClick({ name: type });
            if (!disabled) {
                onChange(date.set({
                    hour: datetime.hour(),
                    minute: datetime.minute()
                }));
            }
        };
    };

    var nextDay = startDate.clone().add(1, 'day');

    return _react2.default.createElement(
        'div',
        { className: 'calendar-dropdown__controls clearfix' },
        _react2.default.createElement(
            'button',
            { className: controlClass + " pull-left",
                disabled: disabled,
                onClick: changeHandler(startDate.clone(), 'same-day') },
            srOnly && _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                srOnly
            ),
            (0, _I18n2.default)('booking.dates.sameDay')
        ),
        _react2.default.createElement(
            'button',
            { className: controlClass + " pull-right",
                disabled: disabled || startDate.isSame(max, 'day'),
                onClick: changeHandler(nextDay, 'next-day') },
            srOnly && _react2.default.createElement(
                'span',
                { className: 'sr-only' },
                srOnly
            ),
            (0, _I18n2.default)('booking.dates.nextDay')
        )
    );
}

SameNextDayControls.propTypes = {
    datetime: _MomentPropTypes2.default.isMoment,
    max: _MomentPropTypes2.default.isMoment,
    startDate: _MomentPropTypes2.default.isMoment,
    disabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func,
    srOnly: _propTypes2.default.string
};

SameNextDayControls.defaultProps = {
    datetime: (0, _TrainTime2.default)(),
    max: null,
    startDate: (0, _TrainTime2.default)(),
    disabled: false,
    onChange: _noop3.default,
    srOnly: ''
};

exports.default = SameNextDayControls;

/***/ }),

/***/ 2528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _class2, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _JourneyNotificationStore = __webpack_require__(1000);

var _JourneyNotificationStore2 = _interopRequireDefault(_JourneyNotificationStore);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getPropsFromStores() {
    return {
        messages: _JourneyNotificationStore2.default.get('latestMessages')
    };
}

var JourneyNotificationsModal = (_dec = (0, _connectToStores2.default)([_JourneyNotificationStore2.default], _getPropsFromStores), _dec(_class = (_temp = _class2 = function (_PureRenderComponent) {
    (0, _inherits3.default)(JourneyNotificationsModal, _PureRenderComponent);

    function JourneyNotificationsModal() {
        (0, _classCallCheck3.default)(this, JourneyNotificationsModal);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    JourneyNotificationsModal.prototype.render = function render() {
        var messages = this.props.messages;


        var modalProps = {
            show: this.props.show,
            onClose: this.props.onClose,
            onContinue: this.props.onContinue,
            closeText: 'button.text.close',
            continueText: 'button.text.continue',
            titleText: 'booking.search.journey-notification.modal.title',
            className: 'modal--sm'
        };

        var messageElements = messages.map(function (jnf) {
            return _react2.default.createElement(
                'li',
                { key: jnf.id },
                jnf.message
            );
        });

        return _react2.default.createElement(
            _BaseModal2.default,
            modalProps,
            _react2.default.createElement(
                'section',
                { className: 'text-center' },
                _react2.default.createElement(_Icon2.default, { icon: 'warning', className: 'journey-notification__icon' }),
                _react2.default.createElement(
                    'div',
                    { className: 'text-justify' },
                    _react2.default.createElement(
                        'ul',
                        { className: 'journey-notification__details' },
                        messageElements
                    )
                )
            )
        );
    };

    return JourneyNotificationsModal;
}(_PureRenderComponent3.default), _class2.propTypes = {
    show: _propTypes2.default.bool,
    messages: _propTypes2.default.instanceOf(_immutable.List),
    onClose: _propTypes2.default.func,
    onContinue: _propTypes2.default.func
}, _class2.defaultProps = {
    messages: new _immutable.List(),
    show: false,
    onClose: _noop3.default,
    onContinue: _noop3.default
}, _temp)) || _class);
exports.default = JourneyNotificationsModal;

/***/ }),

/***/ 2557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _KeyGoForm = __webpack_require__(978);

var _KeyGoForm2 = _interopRequireDefault(_KeyGoForm);

var _I18n = __webpack_require__(9);

var _CardDetails = __webpack_require__(2466);

var _CardDetails2 = _interopRequireDefault(_CardDetails);

var _BillingAddress = __webpack_require__(2477);

var _BillingAddress2 = _interopRequireDefault(_BillingAddress);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _CollectionStation = __webpack_require__(2572);

var _CollectionStation2 = _interopRequireDefault(_CollectionStation);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _SignupTAndCs = __webpack_require__(594);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SmartcardPayment = function SmartcardPayment(_ref) {
    var form = _ref.form,
        validation = _ref.validation,
        visited = _ref.visited,
        onChange = _ref.onChange,
        onAddressSelected = _ref.onAddressSelected,
        isUpdate = _ref.isUpdate,
        collectionLocationRequired = _ref.collectionLocationRequired;
    return _react2.default.createElement(
        'div',
        { className: 'payment-form keygo-card-details' },
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { md: 7, lg: 8, className: 'margin-bottom--sm' },
                    _react2.default.createElement(_FormattedHTMLMessage2.default, {
                        message: 'account.smartcard.keygo.cardTypes',
                        keygobrand: _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.text.keygo' })
                    })
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { md: 5, lg: 4 },
                    _react2.default.createElement(
                        'ul',
                        { className: 'card-type-list text-center' },
                        _react2.default.createElement(
                            'li',
                            { className: 'card-type--visa' },
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                (0, _I18n.translate)('payment.cardType.visa')
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'card-type--mastercard' },
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                (0, _I18n.translate)('payment.cardType.mastercard')
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'card-type--amex' },
                            _react2.default.createElement(
                                'span',
                                { className: 'sr-only' },
                                (0, _I18n.translate)('payment.cardType.amex')
                            )
                        )
                    )
                )
            )
        ),
        isUpdate && _react2.default.createElement(
            'h4',
            { className: 'text-weight--normal text-primary' },
            (0, _I18n.translate)('account.smartcard.keygo.updatePayment')
        ),
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: 'account.smartcard.keygo.details.' + (isUpdate ? 'reminder' : '1'),
            splitParagraphs: true
        }),
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: 'account.smartcard.keygo.details.2',
            tagName: 'ul',
            className: 'list-styled',
            splitParagraphs: true,
            paragraphTagName: 'li'
        }),
        _react2.default.createElement(
            'div',
            { className: 'alert-required margin-top' },
            _react2.default.createElement(_Icon2.default, { icon: 'mandatory' }),
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n.translate)('required.fields')
            )
        ),
        collectionLocationRequired && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement('br', null),
            _react2.default.createElement(_CollectionStation2.default, {
                form: form,
                validation: validation,
                visited: visited,
                onChange: onChange,
                isKeyGo: true,
                required: true
            })
        ),
        _react2.default.createElement(
            'h3',
            { className: 'payment__section-header' },
            (0, _I18n.translate)('account.smartcard.keygo.cardDetails')
        ),
        _react2.default.createElement(_CardDetails2.default, {
            form: form,
            validation: validation,
            visited: visited,
            onChange: onChange
        }),
        _react2.default.createElement(_BillingAddress2.default, {
            className: 'border--bottom',
            form: form,
            validation: validation,
            visited: visited,
            onChange: onChange,
            onAddressSelected: onAddressSelected,
            alwaysShowAddressFields: visited,
            outsideLabel: true
        }),
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: 'account.smartcard.keygo.byContinuingYouAccept',
            termsAndConditions: _react2.default.createElement(_SignupTAndCs.TermsAndConditionsLink, {
                message: (0, _I18n.translate)('form.keyGoTermsAndConditions'),
                url: _config2.default.get('keyGoTermsAndConditionsUrl')
            })
        })
    );
};

SmartcardPayment.propTypes = {
    form: _propTypes2.default.instanceOf(_KeyGoForm2.default).isRequired,
    validation: _propTypes2.default.object.isRequired,
    visited: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onAddressSelected: _propTypes2.default.func.isRequired,
    isUpdate: _propTypes2.default.bool,
    collectionLocationRequired: _propTypes2.default.bool
};

SmartcardPayment.defaultProps = {
    visited: false,
    isUpdate: false,
    collectionLocationRequired: false
};

exports.default = SmartcardPayment;

/***/ }),

/***/ 2558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = JourneyDetailsVerticalRenderer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function JourneyDetailsVerticalRenderer(_ref) {
    var journeySelector = _ref.journeySelector,
        tocSpecificSelector = _ref.tocSpecificSelector,
        dateTimePicker = _ref.dateTimePicker,
        passengers = _ref.passengers,
        smartcardInfo = _ref.smartcardInfo,
        smartcardMaintenance = _ref.smartcardMaintenance,
        smartcardDetails = _ref.smartcardDetails,
        promoDiscount = _ref.promoDiscount;

    return _react2.default.createElement(
        'div',
        null,
        smartcardInfo,
        smartcardMaintenance,
        journeySelector,
        tocSpecificSelector,
        dateTimePicker,
        passengers,
        promoDiscount,
        smartcardDetails
    );
}

JourneyDetailsVerticalRenderer.propTypes = {
    journeySelector: _propTypes2.default.node,
    tocSpecificSelector: _propTypes2.default.node,
    dateTimePicker: _propTypes2.default.node,
    passengers: _propTypes2.default.node,
    smartcardMaintenance: _propTypes2.default.node,
    smartcardDetails: _propTypes2.default.node,
    smartcardInfo: _propTypes2.default.node,
    promoDiscount: _propTypes2.default.node
};

/***/ }),

/***/ 2567:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _Loading = __webpack_require__(274);

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LeftColumn(_ref) {
    var loading = _ref.loading,
        children = _ref.children,
        className = _ref.className;

    if (loading) {
        return _react2.default.createElement(_Loading2.default, { message: (0, _I18n.translate)('booking.loading.results') });
    }

    return _react2.default.createElement(
        'div',
        { className: 'left-col ' + className },
        children
    );
}

LeftColumn.propTypes = {
    loading: _propTypes2.default.bool,
    children: _propTypes2.default.any,
    className: _propTypes2.default.string
};

exports.default = LeftColumn;

/***/ }),

/***/ 2568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _KeyGoForm = __webpack_require__(978);

var _KeyGoForm2 = _interopRequireDefault(_KeyGoForm);

var _Payment = __webpack_require__(423);

var _Smartcard3 = __webpack_require__(336);

var _Breadcrumb = __webpack_require__(2179);

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _FormWrapper = __webpack_require__(613);

var _FormWrapper2 = _interopRequireDefault(_FormWrapper);

var _Error = __webpack_require__(2569);

var _Error2 = _interopRequireDefault(_Error);

var _Success = __webpack_require__(2570);

var _Success2 = _interopRequireDefault(_Success);

var _Form = __webpack_require__(2571);

var _Form2 = _interopRequireDefault(_Form);

var _with3DSecure = __webpack_require__(2516);

var _with3DSecure2 = _interopRequireDefault(_with3DSecure);

var _AuthResponse = __webpack_require__(607);

var _AuthResponse2 = _interopRequireDefault(_AuthResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyGoRegistration = (_temp = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(KeyGoRegistration, _PureRenderComponent);

    function KeyGoRegistration() {
        (0, _classCallCheck3.default)(this, KeyGoRegistration);
        return (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.apply(this, arguments));
    }

    KeyGoRegistration.prototype.render = function render() {
        var _props = this.props,
            error = _props.error,
            paymentSucceeded = _props.paymentSucceeded,
            smartcard = _props.smartcard,
            form = _props.form,
            validation = _props.validation,
            hasSmartcardInSingleStep = _props.hasSmartcardInSingleStep,
            isReplacementPending = _props.isReplacementPending,
            isSingleStepSmartcardRegistration = _props.isSingleStepSmartcardRegistration,
            formInvalid = _props.formInvalid,
            handleFormChange = _props.handleFormChange,
            handleRetry = _props.handleRetry,
            enableSameAsDeliveryAddress = _props.enableSameAsDeliveryAddress,
            onChangeUseDeliveryAddress = _props.onChangeUseDeliveryAddress,
            submitted = _props.submitted,
            renderThreeDSecure = _props.renderThreeDSecure,
            threeDSecureAuthResponse = _props.threeDSecureAuthResponse,
            handleRegisterKeyGo = _props.handleRegisterKeyGo,
            user = _props.user;


        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                _Row2.default,
                null,
                !isSingleStepSmartcardRegistration && _react2.default.createElement(_Breadcrumb2.default, { pageName: (0, _I18n.translate)('account.nav.smartcard.keygoaccount') }),
                _react2.default.createElement(
                    _Col2.default,
                    {
                        md: isSingleStepSmartcardRegistration ? 12 : 10,
                        mdOffset: isSingleStepSmartcardRegistration ? 0 : 1,
                        lg: isSingleStepSmartcardRegistration ? 12 : 10,
                        lgOffset: isSingleStepSmartcardRegistration ? 0 : 1,
                        className: (0, _classnames2.default)('account', {
                            'margin-bottom': !isSingleStepSmartcardRegistration
                        })
                    },
                    error && _react2.default.createElement(_Error2.default, { error: error, handleRetry: handleRetry }),
                    paymentSucceeded && _react2.default.createElement(_Success2.default, null),
                    !error && !paymentSucceeded && _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            _FormWrapper2.default,
                            { submitted: submitted },
                            _react2.default.createElement(_Form2.default, {
                                smartcard: smartcard,
                                form: form,
                                validation: validation,
                                hasSmartcardInSingleStep: hasSmartcardInSingleStep,
                                isReplacementPending: isReplacementPending,
                                isSingleStepSmartcardRegistration: isSingleStepSmartcardRegistration,
                                formInvalid: formInvalid,
                                handleFormChange: handleFormChange,
                                enableSameAsDeliveryAddress: enableSameAsDeliveryAddress,
                                onChangeUseDeliveryAddress: onChangeUseDeliveryAddress
                            })
                        )
                    )
                )
            ),
            _react2.default.createElement(
                _Row2.default,
                null,
                threeDSecureAuthResponse && _react2.default.createElement(
                    _Col2.default,
                    {
                        md: isSingleStepSmartcardRegistration ? 12 : 10,
                        mdOffset: isSingleStepSmartcardRegistration ? 0 : 1,
                        lg: isSingleStepSmartcardRegistration ? 12 : 10,
                        lgOffset: isSingleStepSmartcardRegistration ? 0 : 1,
                        className: 'margin-bottom'
                    },
                    renderThreeDSecure(threeDSecureAuthResponse, handleRegisterKeyGo, {
                        isKeyGo: true,
                        isKeyGoRegistration: true,
                        isKeyGoUpdate: false,
                        user: user,
                        threeDSecureAuthResponse: threeDSecureAuthResponse
                    })
                )
            )
        );
    };

    return KeyGoRegistration;
}(_PureRenderComponent3.default), _class.propTypes = {
    error: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Payment.PaymentUnauthorizedError), _propTypes2.default.instanceOf(_Smartcard3.ACTError)]),
    paymentSucceeded: _propTypes2.default.bool,
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default).isRequired,
    form: _propTypes2.default.instanceOf(_KeyGoForm2.default).isRequired,
    validation: _propTypes2.default.object.isRequired,
    isReplacementPending: _propTypes2.default.bool,
    isSingleStepSmartcardRegistration: _propTypes2.default.bool,
    hasSmartcardInSingleStep: _propTypes2.default.bool,
    formInvalid: _propTypes2.default.bool,
    handleFormChange: _propTypes2.default.func.isRequired,
    handleRetry: _propTypes2.default.func.isRequired,
    enableSameAsDeliveryAddress: _propTypes2.default.bool,
    onChangeUseDeliveryAddress: _propTypes2.default.func,
    submitted: _propTypes2.default.bool,
    renderThreeDSecure: _propTypes2.default.func.isRequired,
    handleRegisterKeyGo: _propTypes2.default.func.isRequired,
    threeDSecureAuthResponse: _propTypes2.default.instanceOf(_AuthResponse2.default)
}, _temp);
exports.default = (0, _with3DSecure2.default)(_with3DSecure.ThreeDSecureType.Authorization)(KeyGoRegistration);

/***/ }),

/***/ 2569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Payment = __webpack_require__(423);

var _Smartcard = __webpack_require__(336);

var _PaymentError = __webpack_require__(2431);

var _PaymentError2 = _interopRequireDefault(_PaymentError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Error(_ref) {
    var error = _ref.error,
        handleRetry = _ref.handleRetry;

    return _react2.default.createElement(
        _Row2.default,
        null,
        _react2.default.createElement(
            _Col2.default,
            { md: 6, mdOffset: 3 },
            _react2.default.createElement(
                'div',
                { className: 'margin-top margin-bottom' },
                _react2.default.createElement(_PaymentError2.default, {
                    error: error,
                    onRetry: handleRetry
                })
            )
        )
    );
}

Error.propTypes = {
    error: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Payment.PaymentUnauthorizedError), _propTypes2.default.instanceOf(_Smartcard.ACTError)]),
    handleRetry: _propTypes2.default.func.isRequired
};

exports.default = Error;

/***/ }),

/***/ 2570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _CollectionStationsStore = __webpack_require__(1008);

var _CollectionStationsStore2 = _interopRequireDefault(_CollectionStationsStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getStateFromStores() {
    return {
        location: _CollectionStationsStore2.default.getSelectedLocationName()
    };
}

function Success(_ref) {
    var location = _ref.location;

    return _react2.default.createElement(
        'div',
        { className: 'padding-top padding-bottom' },
        _react2.default.createElement(
            'div',
            { className: 'confirmation text-center' },
            _react2.default.createElement(_Icon2.default, { icon: 'selected margin-bottom--sm otrl-xl' }),
            _react2.default.createElement(
                'p',
                { className: 'text-weight--normal alert-success' },
                (0, _I18n.translate)('confirmation.keygo.success')
            ),
            location && _react2.default.createElement(
                'p',
                { className: 'text-center text-weight--normal' },
                _react2.default.createElement(_FormattedHTMLMessage2.default, {
                    message: 'account.smartcard.keygo.ready',
                    location: location,
                    keygobrand: _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.text.keygo' })
                })
            ),
            !location && _react2.default.createElement(
                _FeatureFlag2.default,
                { name: 'enableKeyGoCollectionInfo' },
                _react2.default.createElement(
                    'p',
                    { className: 'text-center text-weight--normal' },
                    _react2.default.createElement(_FormattedHTMLMessage2.default, {
                        message: 'account.smartcard.keygo.collect.info',
                        keygobrand: _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.text.keygo' })
                    })
                ),
                _react2.default.createElement(
                    'p',
                    { className: 'text-center text-weight--normal' },
                    _react2.default.createElement(_ExternalLink2.default, {
                        message: (0, _I18n.translate)('account.smartcard.keygo.collect.map', {
                            keygobrand: (0, _I18n.translate)('account.smartcard.text.keygo')
                        }),
                        href: _config2.default.get('keyGoCollectionMapUrl')
                    })
                )
            )
        )
    );
}

Success.propTypes = {
    location: _propTypes2.default.string
};

Success.defaultProps = {
    location: null
};

exports.default = (0, _connectToStores2.default)([_CollectionStationsStore2.default], _getStateFromStores)(Success);

/***/ }),

/***/ 2571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _KeyGoForm = __webpack_require__(978);

var _KeyGoForm2 = _interopRequireDefault(_KeyGoForm);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _SmartcardPayment = __webpack_require__(2557);

var _SmartcardPayment2 = _interopRequireDefault(_SmartcardPayment);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _SmartcardReplacementWarning = __webpack_require__(2442);

var _SmartcardReplacementWarning2 = _interopRequireDefault(_SmartcardReplacementWarning);

var _KeyGoInformation = __webpack_require__(2574);

var _KeyGoInformation2 = _interopRequireDefault(_KeyGoInformation);

var _KeyGoNotAvailable = __webpack_require__(2575);

var _KeyGoNotAvailable2 = _interopRequireDefault(_KeyGoNotAvailable);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Form(props) {
    var smartcard = props.smartcard,
        form = props.form,
        validation = props.validation,
        isReplacementPending = props.isReplacementPending,
        formInvalid = props.formInvalid,
        handleFormChange = props.handleFormChange,
        enableKeyGoMinTopup = props.enableKeyGoMinTopup,
        isSingleStepSmartcardRegistration = props.isSingleStepSmartcardRegistration,
        enableSameAsDeliveryAddress = props.enableSameAsDeliveryAddress,
        onChangeUseDeliveryAddress = props.onChangeUseDeliveryAddress,
        hasSmartcardInSingleStep = props.hasSmartcardInSingleStep;


    if (isReplacementPending) {
        return _react2.default.createElement(_SmartcardReplacementWarning2.default, null);
    }

    if (!isSingleStepSmartcardRegistration && !smartcard.canLoadProduct()) {
        return _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { xs: 12 },
                _react2.default.createElement(
                    _KeyGoInformation2.default,
                    null,
                    _react2.default.createElement(_KeyGoNotAvailable2.default, { smartcard: smartcard })
                )
            )
        );
    }

    return _react2.default.createElement(
        'div',
        null,
        !isSingleStepSmartcardRegistration && _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { xs: 12 },
                _react2.default.createElement(_KeyGoInformation2.default, { enableKeyGoMinTopup: enableKeyGoMinTopup })
            )
        ),
        _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
                _Col2.default,
                { xs: 12 },
                _react2.default.createElement(
                    'div',
                    { className: 'margin-top--sm padding-bottom--sm' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'text-weight--normal keygo-registration__title' },
                        _react2.default.createElement(_FormattedHTMLMessage2.default, {
                            message: 'account.smartcard.keygo.add',
                            keygobrand: _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.text.keygo' })
                        })
                    ),
                    _react2.default.createElement(
                        'h4',
                        { className: 'text-weight--normal text-primary' },
                        (0, _I18n.translate)('account.smartcard.keygo.' + (enableKeyGoMinTopup ? 'minimumTopup' : 'noTopup'))
                    ),
                    _react2.default.createElement(_SmartcardPayment2.default, {
                        form: form,
                        onChange: handleFormChange,
                        validation: validation,
                        visited: formInvalid,
                        onAddressSelected: _CustomerActions2.default.keyGoFormAddressSelected,
                        collectionLocationRequired: (!isSingleStepSmartcardRegistration || hasSmartcardInSingleStep) && !smartcard.isAwaitingProduct(),
                        enableSameAsDeliveryAddress: enableSameAsDeliveryAddress,
                        onChangeUseDeliveryAddress: onChangeUseDeliveryAddress })
                )
            )
        )
    );
}

Form.propTypes = {
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default).isRequired,
    form: _propTypes2.default.instanceOf(_KeyGoForm2.default),
    validation: _propTypes2.default.object,
    isReplacementPending: _propTypes2.default.bool,
    formInvalid: _propTypes2.default.bool,
    handleFormChange: _propTypes2.default.func.isRequired,
    enableKeyGoMinTopup: _propTypes2.default.bool,
    hasSmartcardInSingleStep: _propTypes2.default.bool,
    isSingleStepSmartcardRegistration: _propTypes2.default.bool,
    enableSameAsDeliveryAddress: _propTypes2.default.bool,
    onChangeUseDeliveryAddress: _propTypes2.default.func
};

function getStateFromStores() {
    return {
        enableKeyGoMinTopup: _FeatureFlagStore2.default.get('enableKeyGoMinTopup')
    };
}

exports.default = (0, _connectToStores2.default)([_FeatureFlagStore2.default], getStateFromStores)(Form);

/***/ }),

/***/ 2572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _immutable = __webpack_require__(5);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _CollectionStationsStore = __webpack_require__(1008);

var _CollectionStationsStore2 = _interopRequireDefault(_CollectionStationsStore);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _CollectionStationsActions = __webpack_require__(2573);

var _CollectionStationsActions2 = _interopRequireDefault(_CollectionStationsActions);

var _I18n = __webpack_require__(9);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _ValidatedField = __webpack_require__(84);

var _ValidatedField2 = _interopRequireDefault(_ValidatedField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getStateFromStores() {
    return {
        collectionStations: _CollectionStationsStore2.default.get('stations'),
        isLoading: _CollectionStationsStore2.default.get('loading')
    };
}

var CollectionStation = (_dec = (0, _connectToStores2.default)([_CollectionStationsStore2.default], _getStateFromStores), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(CollectionStation, _React$PureComponent);

    function CollectionStation() {
        (0, _classCallCheck3.default)(this, CollectionStation);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    CollectionStation.prototype.componentDidMount = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _CollectionStationsActions2.default.get();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function componentDidMount() {
            return _ref.apply(this, arguments);
        }

        return componentDidMount;
    }();

    CollectionStation.prototype.render = function render() {
        var _props = this.props,
            isKeyGo = _props.isKeyGo,
            isSubForm = _props.isSubForm,
            form = _props.form,
            onChange = _props.onChange,
            disabled = _props.disabled,
            visited = _props.visited,
            validation = _props.validation,
            collectionStations = _props.collectionStations,
            required = _props.required;

        var Wrapper = isSubForm ? 'div' : 'form';
        var outsideLabelProp = isKeyGo ? { outsideLabel: true } : null;

        return _react2.default.createElement(
            Wrapper,
            { className: 'collection-location' },
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12 },
                    _react2.default.createElement(
                        _ValidatedField2.default,
                        (0, _extends3.default)({ form: form, onChange: onChange, disabled: disabled, visited: visited, validation: validation, required: required }, {
                            type: 'select',
                            id: 'collectionLocation',
                            field: 'collectionLocation',
                            groupClassName: 'select-container margin-bottom--sm',
                            label: (0, _I18n.translate)('account.register.loadingStation.fieldLabel'),
                            placeholder: (0, _I18n.translate)('account.register.loadingStation.fieldLabel'),
                            labelClassName: 'sr-only'
                        }, outsideLabelProp),
                        _react2.default.createElement(
                            'option',
                            { value: '' },
                            (0, _I18n.translate)('account.register.loadingStation.fieldPlaceholder')
                        ),
                        collectionStations.map(function (station) {
                            return _react2.default.createElement(
                                'option',
                                { key: station.nlc, value: station.nlc },
                                station.get('name')
                            );
                        })
                    )
                )
            ),
            _react2.default.createElement(
                'p',
                { className: isKeyGo ? 'border--bottom margin-bottom padding-bottom--sm' : '' },
                isKeyGo ? _react2.default.createElement(_FormattedHTMLMessage2.default, {
                    className: 'text-size--normal text-weight--bold',
                    message: 'account.smartcard.keygo.loadingStation',
                    findMoreLink: _react2.default.createElement(_ExternalLink2.default, {
                        message: (0, _I18n.translate)('account.smartcard.keygo.loadingStation.findMore'),
                        href: _config2.default.get('keyGoInformationUrl')
                    })
                }) : (0, _I18n.translate)('account.register.loadingStation.fieldDescription')
            )
        );
    };

    return CollectionStation;
}(_react2.default.PureComponent), _class2.propTypes = {
    isSubForm: _propTypes2.default.bool,
    required: _propTypes2.default.bool,
    isLoading: _propTypes2.default.bool,
    collectionStations: _propTypes2.default.instanceOf(_immutable.List),
    visited: _propTypes2.default.bool,
    validation: _propTypes2.default.object,
    form: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_immutable.Record), _propTypes2.default.object]).isRequired,
    onChange: _propTypes2.default.func.isRequired,
    disabled: _propTypes2.default.bool,
    isKeyGo: _propTypes2.default.bool
}, _class2.defaultProps = {
    isLoading: false,
    collectionStations: new _immutable.List(),
    isSubForm: false,
    required: false,
    visited: false,
    disabled: false,
    validation: {}
}, _temp)) || _class);
exports.default = CollectionStation;

/***/ }),

/***/ 2573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _AppDispatcher = __webpack_require__(37);

var _AppDispatcher2 = _interopRequireDefault(_AppDispatcher);

var _AppConstants = __webpack_require__(6);

var _KeyGoService = __webpack_require__(1020);

var _KeyGoService2 = _interopRequireDefault(_KeyGoService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionStationsActions = {
    get: function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var stations;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.GET_COLLECTION_STATIONS_STARTED });
                            _context.prev = 1;
                            _context.next = 4;
                            return _KeyGoService2.default.getCollectionLocations();

                        case 4:
                            stations = _context.sent;

                            _AppDispatcher2.default.dispatch({
                                stations: stations,
                                actionType: _AppConstants.ActionTypes.GET_COLLECTION_STATIONS_ENDED
                            });
                            return _context.abrupt('return', stations);

                        case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](1);

                            _AppDispatcher2.default.dispatch({ actionType: _AppConstants.ActionTypes.GET_COLLECTION_STATIONS_FAILED, error: _context.t0 });
                            throw _context.t0;

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[1, 9]]);
        }));

        function get() {
            return _ref.apply(this, arguments);
        }

        return get;
    }()
};

exports.default = CollectionStationsActions;

/***/ }),

/***/ 2574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function KeyGoInformation(_ref) {
    var enableKeyGoMinTopup = _ref.enableKeyGoMinTopup,
        children = _ref.children;

    var topUpMessage = enableKeyGoMinTopup ? _react2.default.createElement(
        'p',
        null,
        (0, _I18n.translate)('account.smartcard.keygo.routes')
    ) : _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            'p',
            null,
            (0, _I18n.translate)('account.smartcard.keygo.details')
        ),
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: 'account.smartcard.keygo.moreDetails',
            learnMoreLink: _react2.default.createElement(_ExternalLink2.default, {
                message: (0, _I18n.translate)('account.smartcard.keygo.moreDetails.link'),
                href: _config2.default.get('keyGoInformationUrl')
            })
        })
    );

    return _react2.default.createElement(
        'div',
        { className: 'margin-top' },
        _react2.default.createElement(
            'div',
            { className: 'padding-bottom--sm border--bottom' },
            children,
            topUpMessage
        )
    );
}

KeyGoInformation.propTypes = {
    children: _propTypes2.default.any,
    enableKeyGoMinTopup: _propTypes2.default.bool
};

exports.default = KeyGoInformation;

/***/ }),

/***/ 2575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _I18n = __webpack_require__(9);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function KeyGoNotAvailable(_ref) {
    var smartcard = _ref.smartcard;

    var message = smartcard.productAvailability === 0 ? (0, _I18n.translate)('account.smartcard.keygo.cardFull') : (0, _I18n.translate)('account.smartcard.keygo.cardBusy');
    return _react2.default.createElement(
        'p',
        { className: 'alert-danger' },
        _react2.default.createElement(_Icon2.default, { icon: 'error', className: 'otrl-inline' }),
        ' ',
        _react2.default.createElement(
            'span',
            { className: 'text-weight--normal' },
            (0, _I18n.translate)('account.smartcard.keygo.notAvailable')
        ),
        ' ',
        message
    );
}

KeyGoNotAvailable.propTypes = {
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default).isRequired
};

exports.default = KeyGoNotAvailable;

/***/ }),

/***/ 2576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.JourneyDetailsForm = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _TocOnlyStore = __webpack_require__(1014);

var _TocOnlyStore2 = _interopRequireDefault(_TocOnlyStore);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _Order = __webpack_require__(50);

var _Order2 = _interopRequireDefault(_Order);

var _DateTimeSummary = __webpack_require__(2577);

var _DateTimeSummary2 = _interopRequireDefault(_DateTimeSummary);

var _JourneySelector = __webpack_require__(2457);

var _JourneySelector2 = _interopRequireDefault(_JourneySelector);

var _PassengersSummary = __webpack_require__(2491);

var _PassengersSummary2 = _interopRequireDefault(_PassengersSummary);

var _Railcard = __webpack_require__(2582);

var _Railcard2 = _interopRequireDefault(_Railcard);

var _PassengerDetails = __webpack_require__(2458);

var _PassengerDetails2 = _interopRequireDefault(_PassengerDetails);

var _TocSpecificSelector = __webpack_require__(2583);

var _TocSpecificSelector2 = _interopRequireDefault(_TocSpecificSelector);

var _JourneyDetailsVerticalRenderer = __webpack_require__(2558);

var _JourneyDetailsVerticalRenderer2 = _interopRequireDefault(_JourneyDetailsVerticalRenderer);

var _PromoDiscount = __webpack_require__(2459);

var _PromoDiscount2 = _interopRequireDefault(_PromoDiscount);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getStateFromStores() {
    var enableSmartcardMaintenance = _FeatureFlagStore2.default.get('enableSmartcardMaintenance'),
        shouldGetSmartcard = _SmartcardStore2.default.shouldGetSmartcard(),
        smartcard = _SmartcardStore2.default.get('smartcard'),
        smartcardFailure = _SmartcardStore2.default.get('smartcardFailure') ? true : false,
        order = _OrderStore2.default.getCurrent();

    return {
        enableSmartcardMaintenance: enableSmartcardMaintenance,
        shouldGetSmartcard: shouldGetSmartcard,
        smartcard: smartcard,
        smartcardFailure: smartcardFailure,
        order: order
    };
}

var JourneyDetailsForm = exports.JourneyDetailsForm = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(JourneyDetailsForm, _React$PureComponent);

    function JourneyDetailsForm() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, JourneyDetailsForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            search: _this.props.search
        }, _this._handleChangeFor = function (key) {
            return function (value) {
                _this.props.handleSearchChange(_this.state.search.set(key, value));
            };
        }, _this._handlePassengersChange = function (adults, children, railcards) {
            var search = _this.state.search.set('adults', adults).set('children', children).set('railcards', railcards);
            _this.props.handleSearchChange(search);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    JourneyDetailsForm.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
        var enableSmartcardMaintenance = nextProps.enableSmartcardMaintenance,
            smartcardFailure = nextProps.smartcardFailure,
            user = nextProps.user;
        var search = nextProps.search;

        if (!user.isLoggedIn() && enableSmartcardMaintenance || smartcardFailure) {
            search = search.set('smartcard', false);
        }

        this.setState({
            search: search
        });
    };

    JourneyDetailsForm.prototype.componentDidMount = function componentDidMount() {
        if (!this._smartcardDisabled()) {
            _CustomerActions2.default.getSmartcard(this.props.user);
        }
    };

    JourneyDetailsForm.prototype._smartcardDisabled = function _smartcardDisabled() {
        return this.props.enableSmartcardMaintenance || !this.props.shouldGetSmartcard;
    };

    JourneyDetailsForm.prototype._isViewingSmartcardFares = function _isViewingSmartcardFares() {
        var _props = this.props,
            smartcard = _props.smartcard,
            search = _props.search;

        return smartcard && smartcard.canSearchForProducts() && search.smartcard;
    };

    JourneyDetailsForm.prototype._renderPassengersSummary = function _renderPassengersSummary() {
        var search = this.props.search;


        if (this._isViewingSmartcardFares()) {
            return _react2.default.createElement(_Railcard2.default, {
                search: search,
                onChange: this._handleChangeFor('railcards') });
        }

        return _react2.default.createElement(_PassengersSummary2.default, {
            railcards: search.railcards,
            adults: search.adults,
            children: search.children,
            onChange: this._handlePassengersChange,
            hideRailcards: this.props.hideRailcards,
            hideFareInfo: this.props.hideFareInfo
        });
    };

    JourneyDetailsForm.prototype._renderSmartcardDetails = function _renderSmartcardDetails() {
        return !this._smartcardDisabled() && this._isViewingSmartcardFares() && _react2.default.createElement(_PassengerDetails2.default, { smartcard: this.props.smartcard });
    };

    JourneyDetailsForm.prototype._renderPromoDiscount = function _renderPromoDiscount() {
        return _react2.default.createElement(
            _FeatureFlag2.default,
            { name: 'enablePromoDiscount' },
            _react2.default.createElement(_PromoDiscount2.default, { promoCode: this.props.search.promoCode, onChange: this._handleChangeFor('promoCode'), order: this.props.order })
        );
    };

    JourneyDetailsForm.prototype.render = function render() {
        var _props2 = this.props,
            smartcard = _props2.smartcard,
            enableStationFinder = _props2.enableStationFinder,
            tocSpecificSelectorVisible = _props2.tocSpecificSelectorVisible,
            handleSearchChange = _props2.handleSearchChange,
            overlayStationResults = _props2.overlayStationResults,
            FormRenderer = _props2.renderer,
            search = this.state.search,
            isAwaitingProduct = (0, _result3.default)(smartcard, 'isAwaitingProduct');

        var showTocSpecificSelector = search.origin.id && search.destination.id && tocSpecificSelectorVisible;

        var searchAttempted = this.props.searchAttempted;


        return _react2.default.createElement(FormRenderer, {
            journeySelector: _react2.default.createElement(_JourneySelector2.default, {
                searchErrors: search.getValidationErrors(),
                search: search,
                searchAttempted: searchAttempted,
                enableStationFinder: enableStationFinder,
                onChange: handleSearchChange,
                overlayResults: overlayStationResults
            }),
            tocSpecificSelector: showTocSpecificSelector && _react2.default.createElement(_TocSpecificSelector2.default, {
                search: search,
                onChange: handleSearchChange }),
            dateTimePicker: _react2.default.createElement(_DateTimeSummary2.default, {
                searchErrors: search.getValidationErrors(),
                search: search,
                smartcard: smartcard,
                onChange: handleSearchChange,
                disableTodayTomorrow: isAwaitingProduct }),
            passengers: this._renderPassengersSummary(),
            smartcardDetails: this._renderSmartcardDetails(),
            promoDiscount: this._renderPromoDiscount()
        });
    };

    return JourneyDetailsForm;
}(_react2.default.PureComponent), _class.propTypes = {
    search: _propTypes2.default.instanceOf(_Search2.default).isRequired,
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    handleSearchChange: _propTypes2.default.func,
    enableSmartcardMaintenance: _propTypes2.default.bool.isRequired,
    shouldGetSmartcard: _propTypes2.default.bool.isRequired,
    smartcardFailure: _propTypes2.default.bool.isRequired,
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default),
    enableStationFinder: _propTypes2.default.bool,
    tocSpecificSelectorVisible: _propTypes2.default.bool,
    hideSmartcardInfo: _propTypes2.default.bool,
    order: _propTypes2.default.instanceOf(_Order2.default),
    overlayStationResults: _propTypes2.default.bool,
    renderer: _propTypes2.default.func,
    searchAttempted: _propTypes2.default.bool,
    hideRailcards: _propTypes2.default.bool
}, _class.defaultProps = {
    order: null,
    smartcard: null,
    handleSearchChange: _noop3.default,
    enableStationFinder: false,
    tocSpecificSelectorVisible: false,
    overlayStationResults: false,
    renderer: _JourneyDetailsVerticalRenderer2.default,
    searchAttempted: false,
    hideRailcards: false
}, _temp2);
exports.default = (0, _connectToStores2.default)([_FeatureFlagStore2.default, _SmartcardStore2.default, _TocOnlyStore2.default, _OrderStore2.default], _getStateFromStores)(JourneyDetailsForm);

/***/ }),

/***/ 2577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _immutable2 = _interopRequireDefault(_immutable);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _AppConstants = __webpack_require__(6);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _ResponsiveRender = __webpack_require__(982);

var _ResponsiveRender2 = _interopRequireDefault(_ResponsiveRender);

var _DateTimeSummaryCompact = __webpack_require__(2578);

var _DateTimeSummaryCompact2 = _interopRequireDefault(_DateTimeSummaryCompact);

var _DateTimeSummarySideBySide = __webpack_require__(2581);

var _DateTimeSummarySideBySide2 = _interopRequireDefault(_DateTimeSummarySideBySide);

var _FormComponent2 = __webpack_require__(417);

var _FormComponent3 = _interopRequireDefault(_FormComponent2);

var _SectionErrors = __webpack_require__(974);

var _SectionErrors2 = _interopRequireDefault(_SectionErrors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateTimeSummary = (_temp2 = _class = function (_FormComponent) {
    (0, _inherits3.default)(DateTimeSummary, _FormComponent);

    function DateTimeSummary() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DateTimeSummary);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _FormComponent.call.apply(_FormComponent, [this].concat(args))), _this), _this.handleChange = function (search) {
            _this.props.onChange(search.slideAfterChange());
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    DateTimeSummary.prototype._shouldFocus = function _shouldFocus(prevProps) {
        var prevErrors = prevProps.searchErrors;
        var searchErrors = this.props.searchErrors;
        return this.getErrors(searchErrors).join('') !== this.getErrors(prevErrors).join('');
    };

    DateTimeSummary.prototype.getErrors = function getErrors(searchErrors) {
        var errors = [];

        if (searchErrors.has('validateDepartBeforeArrive')) {
            errors.push('booking.dates.errors.departAfterArrive');
        }

        if (searchErrors.has('validateDatesComplete')) {
            errors.push('booking.dates.errors.invalidDate');
        }

        if (searchErrors.has('validateDatesInFuture')) {
            errors.push('booking.dates.errors.pastDate');
        }

        if (searchErrors.has('validateSmartcardPeriodReturn')) {
            errors.push('booking.dates.errors.smartcardPeriodReturn');
        }

        if (searchErrors.has('validateDatesBeforeMax')) {
            errors.push((0, _I18n2.default)('booking.dates.errors.datesAfterMax', { maxOutboundDays: _config2.default.get('maxOutboundDays') }));
        }

        return errors;
    };

    DateTimeSummary.prototype.render = function render() {
        var _props = this.props,
            search = _props.search,
            smartcard = _props.smartcard,
            searchErrors = _props.searchErrors,
            disableTodayTomorrow = _props.disableTodayTomorrow;

        var props = { search: search, smartcard: smartcard, onChange: this.handleChange, disableTodayTomorrow: disableTodayTomorrow };
        return _react2.default.createElement(
            'section',
            { className: 'booking__section datetime', ref: this.captureFormRef },
            _react2.default.createElement(
                _ResponsiveRender2.default,
                { maxWidth: _AppConstants.BreakPoints.MOBILE_WIDTH },
                _react2.default.createElement(_DateTimeSummaryCompact2.default, props)
            ),
            _react2.default.createElement(
                _ResponsiveRender2.default,
                { minWidth: _AppConstants.BreakPoints.MOBILE_WIDTH + 1 },
                _react2.default.createElement(_DateTimeSummarySideBySide2.default, props)
            ),
            _react2.default.createElement(_SectionErrors2.default, { errors: this.getErrors(searchErrors) })
        );
    };

    return DateTimeSummary;
}(_FormComponent3.default), _class.propTypes = {
    search: _propTypes2.default.instanceOf(_Search2.default),
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default),
    onChange: _propTypes2.default.func,
    searchErrors: _propTypes2.default.instanceOf(_immutable2.default.Set),
    disableTodayTomorrow: _propTypes2.default.bool
}, _class.defaultProps = {
    search: new _Search2.default(),
    onChange: _noop3.default,
    searchErrors: new _immutable2.default.Set(),
    disableTodayTomorrow: false
}, _temp2);
exports.default = DateTimeSummary;

/***/ }),

/***/ 2578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _TimebandModal = __webpack_require__(2579);

var _TimebandModal2 = _interopRequireDefault(_TimebandModal);

var _OpenReturnCheckbox = __webpack_require__(2455);

var _OpenReturnCheckbox2 = _interopRequireDefault(_OpenReturnCheckbox);

var _DepartNowCheckbox = __webpack_require__(2456);

var _DepartNowCheckbox2 = _interopRequireDefault(_DepartNowCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DateTime summary that uses modals to capture dates and times,
 * used on small screens.
 */

var DateTimeSummaryCompact = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(DateTimeSummaryCompact, _React$PureComponent);

    function DateTimeSummaryCompact() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DateTimeSummaryCompact);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            modal: null
        }, _this._closeModal = function () {
            _this.setState({ modal: null });
        }, _this._handleChange = function (search) {
            _this.props.onChange(search);
            // This solves an IOS issue where the native select drawers
            // were popping up randomly after modal would close
            setTimeout(function () {
                return _this._closeModal();
            }, 1);
        }, _this._hideDepartNow = function () {
            var _this$props = _this.props,
                search = _this$props.search,
                disableTodayTomorrow = _this$props.disableTodayTomorrow;

            return search.smartcard && disableTodayTomorrow;
        }, _this.handleAddReturn = function () {
            _TrackingActions2.default.widgetSearchClick({ name: 'add-return' });
            _this.setState({ modal: _AppConstants.JourneyDirections.INWARD });
            _this.props.onChange(_this.props.search.setTicketType(_AppConstants.TicketTypes.RETURN));
        }, _this.handleRemoveReturn = function () {
            _TrackingActions2.default.widgetSearchClick({ name: 'remove-return' });
            _this.props.onChange(_this.props.search.setTicketType(_AppConstants.TicketTypes.SINGLE));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    DateTimeSummaryCompact.prototype._getDateText = function _getDateText(dt, labelText) {
        var m = dt.datetime;
        var arriveDepartText = dt.arriveDepart === _AppConstants.TimeTypes.ARRIVE ? 'booking.dates.arriving' : 'booking.dates.departing';
        var arriveDepartTextShort = arriveDepartText + '.short';

        var day = m.calendar(null, {
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: 'ddd DD MMM',
            sameElse: 'ddd DD MMM'
        });
        var time = m.format('HH:mm');

        return _react2.default.createElement(
            'time',
            { className: 'clearfix', dateTime: m.format() },
            _react2.default.createElement(
                'div',
                { className: 'pull-left' },
                _react2.default.createElement(
                    'div',
                    { className: 'text-light datetime__fixed-width' },
                    labelText
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    day
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'pull-right' },
                _react2.default.createElement(
                    'div',
                    { className: 'text-light', 'aria-hidden': 'true' },
                    (0, _I18n.translate)(arriveDepartTextShort)
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'sr-only' },
                    (0, _I18n.translate)(arriveDepartText)
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    time
                )
            )
        );
    };

    DateTimeSummaryCompact.prototype._renderButton = function _renderButton(dateTimeDirection, dateText) {
        var _this2 = this;

        var buttonProps = {
            className: 'btn-box',
            disabled: dateTimeDirection === _AppConstants.JourneyDirections.OUTWARD && this.props.search.departNow,
            onClick: function onClick() {
                return _this2.setState({ modal: dateTimeDirection });
            }
        };

        return _react2.default.createElement(
            'button',
            buttonProps,
            _react2.default.createElement(
                'span',
                { className: 'datetime__selected-date pull-left' },
                dateText
            ),
            _react2.default.createElement(_Icon2.default, { className: 'pull-right box__icon', icon: 'calendar' })
        );
    };

    DateTimeSummaryCompact.prototype.renderRemoveReturn = function renderRemoveReturn() {
        if (!this.props.search.isReturn()) {
            return null;
        }
        return _react2.default.createElement(
            'button',
            { className: 'remove-return', onClick: this.handleRemoveReturn, title: 'No Return' },
            _react2.default.createElement(_Icon2.default, { icon: 'close' })
        );
    };

    DateTimeSummaryCompact.prototype._renderModal = function _renderModal() {
        // This is required otherwise the DateTimeModal is
        // initialised with an old search record and retains
        // this in its state, meaning it resets the form back
        // to the default state with exception to the date picked
        if (!this.state.modal) {
            return null;
        }

        return _react2.default.createElement(_TimebandModal2.default, {
            show: !!this.state.modal,
            search: this.props.search,
            smartcard: this.props.smartcard,
            type: this.state.modal,
            onCancel: this._closeModal,
            onSelect: this._handleChange
        });
    };

    DateTimeSummaryCompact.prototype._renderOutboundDateTimeButton = function _renderOutboundDateTimeButton() {
        var datetime = this.props.search.get('outboundDateTime');
        var outboundText = this._getDateText(datetime, (0, _I18n.translate)('booking.dates.outbound'));
        return this._renderButton(_AppConstants.JourneyDirections.OUTWARD, outboundText);
    };

    DateTimeSummaryCompact.prototype._renderReturnDateTimeButton = function _renderReturnDateTimeButton() {
        if (this.props.search.isReturn()) {
            var datetime = this.props.search.get('returnDateTime');
            var outboundText = this._getDateText(datetime, (0, _I18n.translate)('booking.dates.return'));
            return this._renderButton(_AppConstants.JourneyDirections.INWARD, outboundText, this.handleRemoveReturn);
        } else {
            return _react2.default.createElement(
                'button',
                {
                    className: 'btn-box btn-add-return',
                    onClick: this.handleAddReturn },
                _react2.default.createElement(
                    'span',
                    { className: 'pull-left text-light' },
                    (0, _I18n.translate)('booking.dates.addReturn')
                ),
                _react2.default.createElement(_Icon2.default, { className: 'pull-right box__icon', icon: 'add' })
            );
        }
    };

    DateTimeSummaryCompact.prototype._getSummaryClasses = function _getSummaryClasses() {
        return (0, _classnames2.default)('datetime__summary', 'margin-bottom--sm', {
            'datetime__summary--no-time': !_FeatureFlagStore2.default.get('enableTimeSelect')
        });
    };

    DateTimeSummaryCompact.prototype.render = function render() {
        var search = this.props.search;


        return _react2.default.createElement(
            'div',
            { className: 'datetime__summary-compact' },
            this._renderModal(),
            _react2.default.createElement(
                'div',
                { className: this._getSummaryClasses() },
                _react2.default.createElement(
                    'div',
                    { className: 'btn-box-group' },
                    this._renderOutboundDateTimeButton(),
                    this._renderReturnDateTimeButton()
                ),
                this.renderRemoveReturn()
            ),
            !this._hideDepartNow() && _react2.default.createElement(_DepartNowCheckbox2.default, { search: search, onChange: this._handleChange }),
            _react2.default.createElement(_OpenReturnCheckbox2.default, { search: search, onChange: this._handleChange })
        );
    };

    return DateTimeSummaryCompact;
}(_react2.default.PureComponent), _class.propTypes = {
    search: _propTypes2.default.instanceOf(_Search2.default),
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default),
    onChange: _propTypes2.default.func,
    disableTodayTomorrow: _propTypes2.default.bool
}, _class.defaultProps = {
    search: new _Search2.default(),
    onChange: _noop3.default,
    disableTodayTomorrow: false
}, _temp2);
exports.default = DateTimeSummaryCompact;

/***/ }),

/***/ 2579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _AppConstants = __webpack_require__(6);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _TimebandSelector = __webpack_require__(2580);

var _TimebandSelector2 = _interopRequireDefault(_TimebandSelector);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimebandModal = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(TimebandModal, _PureRenderComponent);

    function TimebandModal() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, TimebandModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            search: _this.props.search
        }, _this._handleChange = function (value) {
            var search = _this.state.search.set(_this._getKey(), value);
            _this.setState({ search: search });
        }, _this._onSelect = function () {
            _this.props.onSelect(_this.state.search);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    TimebandModal.prototype._getKey = function _getKey() {
        return this.props.type === _AppConstants.JourneyDirections.INWARD ? 'returnDateTime' : 'outboundDateTime';
    };

    TimebandModal.prototype._isDirty = function _isDirty() {
        return this.props.search !== this.state.search;
    };

    TimebandModal.prototype.render = function render() {
        var search = this.state.search;
        var _props = this.props,
            smartcard = _props.smartcard,
            type = _props.type,
            show = _props.show,
            onCancel = _props.onCancel;

        var timeband = search.get(this._getKey());

        var min = search.smartcard && smartcard && smartcard.isAwaitingProduct() ? (0, _TrainTime2.default)().addWorkingDays(_config2.default.get('minAwaitingSmartcardProductDays')) : search.getMinDate(type);

        return _react2.default.createElement(
            _BaseModal2.default,
            {
                show: show,
                onClose: onCancel,
                onContinue: this._onSelect,
                closeText: 'button.text.cancel',
                continueText: 'button.text.select',
                disableBlur: this._isDirty(),
                titleText: 'booking.dates.modal.title.' + type + '.' + timeband.arriveDepart,
                className: 'datetime__modal modal--md' },
            _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(_TimebandSelector2.default, { name: type,
                    min: min,
                    max: search.getMaxDate(type),
                    timeband: timeband,
                    onChange: this._handleChange })
            )
        );
    };

    return TimebandModal;
}(_PureRenderComponent3.default), _class.propTypes = {
    show: _propTypes2.default.bool,
    search: _propTypes2.default.instanceOf(_Search2.default),
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default),
    type: _propTypes2.default.oneOf([_AppConstants.JourneyDirections.OUTWARD, _AppConstants.JourneyDirections.INWARD]),
    onCancel: _propTypes2.default.func,
    onSelect: _propTypes2.default.func
}, _class.defaultProps = {
    search: new _Search2.default(),
    show: false,
    onCancel: _noop3.default,
    onSelect: _noop3.default,
    type: null
}, _temp2);
exports.default = TimebandModal;

/***/ }),

/***/ 2580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _MomentPropTypes = __webpack_require__(230);

var _MomentPropTypes2 = _interopRequireDefault(_MomentPropTypes);

var _Timeband = __webpack_require__(337);

var _Timeband2 = _interopRequireDefault(_Timeband);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _AppConstants = __webpack_require__(6);

var _Calendar = __webpack_require__(975);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _TimeSelector = __webpack_require__(979);

var _TimeSelector2 = _interopRequireDefault(_TimeSelector);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _ArriveDepart = __webpack_require__(2415);

var _ArriveDepart2 = _interopRequireDefault(_ArriveDepart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimebandSelector = (_temp2 = _class = function (_PureRenderComponent) {
    (0, _inherits3.default)(TimebandSelector, _PureRenderComponent);

    function TimebandSelector() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, TimebandSelector);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.handleChangeFor = function (field, trackingEvent) {
            return function (value) {
                var _this$props = _this.props,
                    onChange = _this$props.onChange,
                    timeband = _this$props.timeband,
                    name = _this$props.name;

                if (trackingEvent === _AppConstants.widgetSearchElements.timeSelector) {
                    _TrackingActions2.default.widgetSearchClick({ name: name === _AppConstants.JourneyDirections.OUTWARD ? 'outbound-time' : 'return-time', value: value });
                } else if (trackingEvent === _AppConstants.widgetSearchElements.arriveDepart) {
                    _TrackingActions2.default.widgetSearchClick({ name: name === _AppConstants.JourneyDirections.OUTWARD ? 'outbound-arrive-depart' : 'return-arrive-depart', value: value });
                }
                onChange(timeband.set(field, value));
            };
        }, _this.handleDateChange = function (date) {
            var _this$props2 = _this.props,
                timeband = _this$props2.timeband,
                name = _this$props2.name;

            var covertedDate = (0, _TrainTime2.default)(date.format('YYYY-MM-DD'));

            _TrackingActions2.default.widgetDaySelect({ date: date, type: name === _AppConstants.JourneyDirections.OUTWARD ? 'outbound' : 'return' });

            var datetime = covertedDate.clone().set({
                hour: timeband.datetime.hour(),
                minute: timeband.datetime.minute()
            });

            _this.handleChangeFor('datetime')(datetime);
        }, _this.handleArriveDepartChange = function (arriveDepart) {
            _this.props.onChange(_this.props.timeband.set('arriveDepart', arriveDepart));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    TimebandSelector.prototype.render = function render() {
        var _props = this.props,
            name = _props.name,
            min = _props.min,
            max = _props.max,
            timeband = _props.timeband;
        var datetime = timeband.datetime,
            arriveDepart = timeband.arriveDepart;


        return _react2.default.createElement(
            'div',
            { className: 'clearfix timeband' },
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12, sm: 6, className: 'margin-bottom' },
                    _react2.default.createElement(_Calendar2.default, { id: name + '-date',
                        selected: datetime,
                        onChange: this.handleDateChange,
                        min: min,
                        max: max,
                        className: 'timeband__calendar' })
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 6 },
                    _react2.default.createElement(_ArriveDepart2.default, { arriveDepart: arriveDepart,
                        onChange: this.handleChangeFor('arriveDepart', _AppConstants.widgetSearchElements.arriveDepart),
                        direction: name,
                        className: 'margin-bottom--sm' })
                ),
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 6 },
                    _react2.default.createElement(_TimeSelector2.default, { className: 'timeband__time',
                        datetime: datetime,
                        onChange: this.handleChangeFor('datetime', _AppConstants.widgetSearchElements.timeSelector) })
                )
            )
        );
    };

    return TimebandSelector;
}(_PureRenderComponent3.default), _class.propTypes = {
    name: _propTypes2.default.string,
    timeband: _propTypes2.default.instanceOf(_Timeband2.default),
    min: _MomentPropTypes2.default.isMoment,
    max: _MomentPropTypes2.default.isMoment,
    onChange: _propTypes2.default.func
}, _class.defaultProps = {
    name: 'timeband',
    timeband: new _Timeband2.default(),
    onChange: _noop3.default
}, _temp2);
exports.default = TimebandSelector;

/***/ }),

/***/ 2581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(67);

var _moment2 = _interopRequireDefault(_moment);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _AppConstants = __webpack_require__(6);

var _TrackingActions = __webpack_require__(117);

var _TrackingActions2 = _interopRequireDefault(_TrackingActions);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _OpenReturnCheckbox = __webpack_require__(2455);

var _OpenReturnCheckbox2 = _interopRequireDefault(_OpenReturnCheckbox);

var _OutboundDateSelector = __webpack_require__(2525);

var _OutboundDateSelector2 = _interopRequireDefault(_OutboundDateSelector);

var _ReturnDateSelector = __webpack_require__(2526);

var _ReturnDateSelector2 = _interopRequireDefault(_ReturnDateSelector);

var _DepartNowCheckbox = __webpack_require__(2456);

var _DepartNowCheckbox2 = _interopRequireDefault(_DepartNowCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Datetime summary for larger screens, doesnt use modals, all entry is in place
 */

var DateTimeSummarySideBySide = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(DateTimeSummarySideBySide, _React$PureComponent);

    function DateTimeSummarySideBySide() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DateTimeSummarySideBySide);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._hideDepartNow = function () {
            var _this$props = _this.props,
                search = _this$props.search,
                disableTodayTomorrow = _this$props.disableTodayTomorrow;

            return search.smartcard && disableTodayTomorrow;
        }, _this.handleTimebandChangeFor = function (field) {
            return function (value) {
                var search = _this.props.search.set(field, value);
                _this.props.onChange(search);
            };
        }, _this.handleAddReturn = function () {
            _TrackingActions2.default.widgetSearchClick({ name: 'add-return' });
            var returnTitle = document.getElementById('departNow');
            if (returnTitle) {
                returnTitle.focus();
            }
            _this.props.onChange(_this.props.search.setTicketType(_AppConstants.TicketTypes.RETURN));
        }, _this.handleRemoveReturn = function () {
            _TrackingActions2.default.widgetSearchClick({ name: 'remove-return' });
            _this.props.onChange(_this.props.search.setTicketType(_AppConstants.TicketTypes.SINGLE));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    DateTimeSummarySideBySide.prototype.renderAddReturn = function renderAddReturn() {
        return _react2.default.createElement(
            'button',
            { className: 'btn-box btn-add-return',
                onClick: this.handleAddReturn },
            _react2.default.createElement(_Icon2.default, { icon: 'add' }),
            _react2.default.createElement('br', null),
            (0, _I18n2.default)('booking.dates.addReturn')
        );
    };

    DateTimeSummarySideBySide.prototype.renderReturn = function renderReturn(max) {
        var _props = this.props,
            search = _props.search,
            onChange = _props.onChange;

        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_ReturnDateSelector2.default, { id: 'return-timeband-selector',
                timeband: search.returnDateTime,
                disabled: search.isOpenReturn(),
                onChange: this.handleTimebandChangeFor('returnDateTime'),
                min: search.outboundDateTime.datetime,
                max: max }),
            _react2.default.createElement(_OpenReturnCheckbox2.default, { search: search, onChange: onChange, ticketTypeWhenOff: _AppConstants.TicketTypes.RETURN })
        );
    };

    DateTimeSummarySideBySide.prototype.render = function render() {
        var _props2 = this.props,
            search = _props2.search,
            smartcard = _props2.smartcard,
            onChange = _props2.onChange;

        var brand = _config2.default.get('brand');
        var isTrainhugger = brand === 'trainhugger';

        var min = search.smartcard && smartcard && smartcard.isAwaitingProduct() ? (0, _TrainTime2.default)().addWorkingDays(_config2.default.get('minAwaitingSmartcardProductDays')) : (0, _TrainTime2.default)();
        var max = isTrainhugger ? (0, _moment2.default)('2023-01-24').endOf('day') : (0, _TrainTime2.default)().endOf('day').add(_config2.default.get('maxOutboundDays'), 'days');

        //For smartcard tickets, they are only day return so set the return date max to the outbound date
        var outboundDateTime = search.outboundDateTime.datetime.clone();
        var returnMax = search.smartcard ? outboundDateTime.endOf('day') : max;

        return _react2.default.createElement(
            _Row2.default,
            { className: 'datetime__summary-side-by-side' },
            _react2.default.createElement(
                _Col2.default,
                { xs: 6 },
                _react2.default.createElement(
                    'span',
                    { className: 'label' },
                    (0, _I18n2.default)('booking.dates.outbound')
                ),
                _react2.default.createElement(_OutboundDateSelector2.default, { id: 'outbound-timeband-selector',
                    timeband: search.outboundDateTime,
                    onChange: this.handleTimebandChangeFor('outboundDateTime'),
                    disabled: search.departNow,
                    disableTodayTomorrow: this._hideDepartNow(),
                    min: min,
                    max: max }),
                !this._hideDepartNow() && _react2.default.createElement(_DepartNowCheckbox2.default, { search: search, onChange: onChange })
            ),
            _react2.default.createElement(
                _Col2.default,
                { xs: 6, className: 'timeband-selector--return' },
                _react2.default.createElement(
                    'span',
                    { className: 'label', id: 'returnSelectorTitle' },
                    (0, _I18n2.default)('booking.dates.return')
                ),
                !search.isSingle() && _react2.default.createElement(
                    'button',
                    { className: 'btn otrl-inline btn-link like-link no-return pull-right text-sm',
                        onClick: this.handleRemoveReturn },
                    (0, _I18n2.default)('booking.ticketType.remove-return')
                ),
                search.isSingle() ? this.renderAddReturn() : this.renderReturn(returnMax)
            )
        );
    };

    return DateTimeSummarySideBySide;
}(_react2.default.PureComponent), _class.propTypes = {
    search: _propTypes2.default.instanceOf(_Search2.default),
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default),
    onChange: _propTypes2.default.func,
    disableTodayTomorrow: _propTypes2.default.bool
}, _class.defaultProps = {
    search: new _Search2.default(),
    onChange: _noop3.default,
    disableTodayTomorrow: false
}, _temp2);
exports.default = DateTimeSummarySideBySide;

/***/ }),

/***/ 2582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _PassengerRailcard = __webpack_require__(269);

var _PassengerRailcard2 = _interopRequireDefault(_PassengerRailcard);

var _RailcardTypes = __webpack_require__(2406);

var _RailcardTypes2 = _interopRequireDefault(_RailcardTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Railcard(_ref) {
    var search = _ref.search,
        onChange = _ref.onChange;

    var _updateRailcards = function _updateRailcards(railcard) {
        var railcards = new _immutable.List();

        if (railcard && railcard.get('code')) {
            railcards = railcards.push(new _PassengerRailcard2.default({
                code: railcard.get('code'),
                quantity: 1
            }));
        }

        onChange(railcards);
    };

    return _react2.default.createElement(
        'section',
        { className: 'booking__section' },
        _react2.default.createElement(_RailcardTypes2.default, {
            smartcard: false /* BUG-FIX */,
            value: search.getIn(['railcards', 0, 'code'], ''),
            onChange: _updateRailcards
        })
    );
}

Railcard.propTypes = {
    search: _propTypes2.default.instanceOf(_Search2.default).isRequired,
    onChange: _propTypes2.default.func
};

Railcard.defaultProps = {
    onChange: _noop3.default
};

exports.default = Railcard;

/***/ }),

/***/ 2583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _noop2 = __webpack_require__(24);

var _noop3 = _interopRequireDefault(_noop2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Row = __webpack_require__(41);

var _Row2 = _interopRequireDefault(_Row);

var _Col = __webpack_require__(33);

var _Col2 = _interopRequireDefault(_Col);

var _FormGroup = __webpack_require__(611);

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _FeatureFlag = __webpack_require__(59);

var _FeatureFlag2 = _interopRequireDefault(_FeatureFlag);

var _Radio = __webpack_require__(231);

var _Radio2 = _interopRequireDefault(_Radio);

var _HelpIcon = __webpack_require__(335);

var _HelpIcon2 = _interopRequireDefault(_HelpIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TocSpecificSelector(_ref) {
    var search = _ref.search,
        onChange = _ref.onChange;


    var label = _react2.default.createElement(
        'div',
        null,
        (0, _I18n2.default)('booking.operator.specifictoc', { toc: (0, _I18n2.default)('app.owner.short') }),
        _react2.default.createElement(_HelpIcon2.default, { icon: 'info',
            heading: (0, _I18n2.default)('help.tocSpecific.title', { toc: (0, _I18n2.default)('app.owner.short') }),
            message: (0, _I18n2.default)('help.tocSpecific.message', { toc: (0, _I18n2.default)('app.owner.short') }) })
    );

    var tocOnly = search.tocSpecific;

    var _handleTocSpecificChange = function _handleTocSpecificChange(value) {
        return function () {
            onChange(search.set('tocSpecific', !!value));
        };
    };

    return _react2.default.createElement(
        _FeatureFlag2.default,
        { name: 'enableTocOnlySearch' },
        _react2.default.createElement(
            'section',
            { className: 'booking__section' },
            _react2.default.createElement(
                _Row2.default,
                null,
                _react2.default.createElement(
                    _Col2.default,
                    { xs: 12 },
                    _react2.default.createElement(
                        _FormGroup2.default,
                        { className: 'toc-specific-radio radio-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-option' },
                            _react2.default.createElement(_Radio2.default, {
                                radioClass: 'regular-radio',
                                className: 'radio-booking-operator-all',
                                name: 'service-operator',
                                label: (0, _I18n2.default)('booking.operator.all'),
                                checked: !tocOnly,
                                onChange: _handleTocSpecificChange(false)
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-option' },
                            _react2.default.createElement(_Radio2.default, {
                                radioClass: 'regular-radio',
                                className: 'radio-booking-operator-specific',
                                name: 'service-operator',
                                label: label,
                                checked: tocOnly,
                                onChange: _handleTocSpecificChange(true)
                            })
                        )
                    )
                )
            )
        )
    );
}

TocSpecificSelector.propTypes = {
    search: _propTypes2.default.instanceOf(_Search2.default).isRequired,
    onChange: _propTypes2.default.func
};

TocSpecificSelector.defaultProps = {
    onChange: _noop3.default
};

exports.default = TocSpecificSelector;

/***/ }),

/***/ 2584:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _uuid = __webpack_require__(270);

var _uuid2 = _interopRequireDefault(_uuid);

var _MapContext = __webpack_require__(2408);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBoundedMapElement = function useBoundedMapElement(openStreetMapsObj, isBounded) {
    var _useMap = (0, _MapContext.useMap)(),
        boundedElementsDispatch = _useMap.boundedElementsDispatch;

    (0, _react.useEffect)(function () {
        if (isBounded) {
            var uid = _uuid2.default.v1();
            boundedElementsDispatch({ type: _MapContext.BoundedElementsReducerActions.ADD_ITEM, uid: uid, coords: openStreetMapsObj.getLatLng() });
            return function () {
                boundedElementsDispatch({ type: _MapContext.BoundedElementsReducerActions.REMOVE_ITEM, uid: uid });
            };
        }
        return undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return undefined;
};

exports.default = useBoundedMapElement;

/***/ }),

/***/ 2585:
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(119),
    unescapeHtmlChar = __webpack_require__(2586);

/** Used to match HTML entities and HTML characters. */
var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
    reHasEscapedHtml = RegExp(reEscapedHtml.source);

/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */
function unescape(string) {
  string = toString(string);
  return (string && reHasEscapedHtml.test(string))
    ? string.replace(reEscapedHtml, unescapeHtmlChar)
    : string;
}

module.exports = unescape;


/***/ }),

/***/ 2586:
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(639);

/** Used to map HTML entities to characters. */
var htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};

/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */
var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

module.exports = unescapeHtmlChar;


/***/ }),

/***/ 2616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2, _initialiseProps;

exports.getStateFromStores = getStateFromStores;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _KeyGoStore = __webpack_require__(1004);

var _KeyGoStore2 = _interopRequireDefault(_KeyGoStore);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _KeyGoForm = __webpack_require__(978);

var _KeyGoForm2 = _interopRequireDefault(_KeyGoForm);

var _Payment = __webpack_require__(423);

var _Smartcard3 = __webpack_require__(336);

var _FormComponent2 = __webpack_require__(417);

var _FormComponent3 = _interopRequireDefault(_FormComponent2);

var _TimeDelayedModal = __webpack_require__(2617);

var _TimeDelayedModal2 = _interopRequireDefault(_TimeDelayedModal);

var _Warning = __webpack_require__(2619);

var _Warning2 = _interopRequireDefault(_Warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getStateFromStores() {
    return {
        form: _KeyGoStore2.default.get('form'),
        validation: _KeyGoStore2.default.get('validation'),
        error: _KeyGoStore2.default.get('error'),
        paymentSucceeded: _KeyGoStore2.default.get('paymentSucceeded'),
        enableKeyGoRegistrationWarning: _FeatureFlagStore2.default.get('enableKeyGoRegistrationWarning')
    };
}

var KeyGoRegistration = (_temp2 = _class = function (_FormComponent) {
    (0, _inherits3.default)(KeyGoRegistration, _FormComponent);

    function KeyGoRegistration() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, KeyGoRegistration);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _FormComponent.call.apply(_FormComponent, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    KeyGoRegistration.prototype.handleRetry = function handleRetry() {
        _CustomerActions2.default.retryKeyGoForm();
    };

    KeyGoRegistration.prototype.renderRegistrationWarning = function renderRegistrationWarning() {
        if (!this.state.showRegistrationWarning) {
            return false;
        }
        return _react2.default.createElement(
            _TimeDelayedModal2.default,
            { delay: 10,
                onClose: this.handleCloseWarning,
                onContinue: this.handleConfirmWarning,
                disableClose: false,
                disableEscape: false,
                continueText: 'account.smartcard.keygo.registrationWarning.confirm',
                closeText: 'button.text.cancel',
                titleText: 'account.smartcard.keygo.registrationWarning.title',
                className: 'modal--med' },
            _react2.default.createElement(_Warning2.default, null)
        );
    };

    (0, _createClass3.default)(KeyGoRegistration, [{
        key: 'isButtonDisabled',
        get: function get() {
            var _state = this.state,
                loading = _state.loading,
                formInvalid = _state.formInvalid;


            return loading || formInvalid;
        }
    }, {
        key: 'keyGoRegistrationProps',
        get: function get() {
            var formInvalid = this.state.formInvalid;
            var _props = this.props,
                error = _props.error,
                paymentSucceeded = _props.paymentSucceeded,
                smartcard = _props.smartcard,
                form = _props.form,
                validation = _props.validation,
                isReplacementPending = _props.isReplacementPending,
                user = _props.user;


            return {
                error: error,
                paymentSucceeded: paymentSucceeded,
                smartcard: smartcard,
                validation: validation,
                form: form,
                isReplacementPending: isReplacementPending,
                formInvalid: formInvalid,
                threeDSecureAuthResponse: this.state.threeDSecureAuthResponse,
                handleFormChange: this.handleFormChange,
                handleRetry: this.handleRetry,
                handleRegisterKeyGo: this.handleRegisterFinishedKeyGo,
                user: user
            };
        }
    }]);
    return KeyGoRegistration;
}(_FormComponent3.default), _class.propTypes = {
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default).isRequired,
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    isReplacementPending: _propTypes2.default.bool,
    form: _propTypes2.default.instanceOf(_KeyGoForm2.default),
    validation: _propTypes2.default.object,
    error: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Payment.PaymentUnauthorizedError), _propTypes2.default.instanceOf(_Smartcard3.ACTError)]),
    paymentSucceeded: _propTypes2.default.bool,
    enableKeyGoRegistrationWarning: _propTypes2.default.bool
}, _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.state = {
        loading: false,
        formInvalid: false,
        showRegistrationWarning: false,
        threeDSecureAuthResponse: null
    };

    this.checkFormFold = function (someCb) {
        var noneCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
            _this2.setState({ submitted: true, formInvalid: true });
        };
        var form = _this2.props.form;

        if (form.isComplete()) {
            someCb(form);
        } else {
            noneCb();
        }
    };

    this.handleKeyGoPay = function () {
        return _this2.checkFormFold(function () {
            var enableKeyGoRegistrationWarning = _this2.props.enableKeyGoRegistrationWarning;
            // submitted is used by FormComponent to handle scrolling

            _this2.setState({ submitted: true });

            if (enableKeyGoRegistrationWarning) {
                _this2.setState({
                    showRegistrationWarning: true
                });
            } else {
                _this2.handleRegisterKeyGo();
            }
        });
    };

    this.handleCloseWarning = function () {
        _this2.setState({ showRegistrationWarning: false });
    };

    this.handleConfirmWarning = function () {
        _this2.handleCloseWarning();
        _this2.handleRegisterKeyGo();
    };

    this.handleRegisterKeyGo = function () {
        return _this2.checkFormFold(function (form) {
            _this2.setState({ threeDSecureAuthResponse: null });
            var user = _this2.props.user;


            _this2.setState({ loading: true });
            _CustomerActions2.default.registerKeyGo(user, form).then(function (threeDSecureAuthResponse) {
                if (threeDSecureAuthResponse) {
                    _this2.setState({ threeDSecureAuthResponse: threeDSecureAuthResponse });
                }
            }).finally(function () {
                return _this2.setState({ loading: false });
            });
        });
    };

    this.handleRegisterFinishedKeyGo = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            justReset3D = _ref2.justReset3D;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!justReset3D) {
                            _CustomerActions2.default.registrationKeyGoFormComplete();
                        }

                        _this2.setState({ threeDSecureAuthResponse: null });

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this2);
    }));

    this.handleFormChange = function () {
        _this2.setState({ submitted: false, formInvalid: false });
        _CustomerActions2.default.changeKeyGoForm.apply(_CustomerActions2.default, arguments);
    };
}, _temp2);
exports.default = KeyGoRegistration;

/***/ }),

/***/ 2617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(65);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Countdown = __webpack_require__(2618);

var _Countdown2 = _interopRequireDefault(_Countdown);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _ProgressBar = __webpack_require__(641);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TimeDelayedModal = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(TimeDelayedModal, _React$PureComponent);

    function TimeDelayedModal() {
        (0, _classCallCheck3.default)(this, TimeDelayedModal);
        return (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.apply(this, arguments));
    }

    TimeDelayedModal.prototype.render = function render() {
        var _props = this.props,
            show = _props.show,
            delay = _props.delay,
            children = _props.children,
            FooterLoader = _props.footerLoader,
            modalProps = (0, _objectWithoutProperties3.default)(_props, ['show', 'delay', 'children', 'footerLoader']);

        if (!show) {
            return null;
        }

        return _react2.default.createElement(
            _Countdown2.default,
            { start: delay },
            function (_ref) {
                var timeRemaining = _ref.counter,
                    isCounting = _ref.isCounting;
                return _react2.default.createElement(
                    _BaseModal2.default,
                    (0, _extends3.default)({
                        disableClose: isCounting,
                        disableContinue: isCounting,
                        disableEscape: isCounting,
                        footerContent: isCounting ? _react2.default.createElement(FooterLoader, { completed: delay - timeRemaining, total: delay }) : null
                    }, modalProps),
                    children
                );
            }
        );
    };

    return TimeDelayedModal;
}(_react2.default.PureComponent), _class.propTypes = {
    delay: _propTypes2.default.number.isRequired,
    footerLoader: _propTypes2.default.func,
    children: _propTypes2.default.any,
    show: _propTypes2.default.bool
}, _class.defaultProps = {
    show: true,
    footerLoader: function footerLoader(_ref2) {
        var completed = _ref2.completed,
            total = _ref2.total;
        return _react2.default.createElement(
            'div',
            { className: 'countdown-progressbar margin-top--sm' },
            _react2.default.createElement(_ProgressBar2.default, { completed: completed, total: total })
        );
    }
}, _temp);
exports.default = TimeDelayedModal;

/***/ }),

/***/ 2618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Countdown = (_temp2 = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(Countdown, _React$PureComponent);

    function Countdown() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Countdown);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
            counter: _this.props.start
        }, _this.timer = undefined, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    Countdown.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        this.startCountdown();
    };

    Countdown.prototype.componentWillUnmount = function componentWillUnmount() {
        this.stopCountdown();
    };

    Countdown.prototype.startCountdown = function startCountdown() {
        var _this2 = this;

        var counter = Math.floor(this.props.start);
        var countdown = function countdown() {
            _this2.setState({ counter: counter });
            if (counter > Math.floor(_this2.props.end)) {
                --counter;
                _this2.timer = setTimeout(countdown, 1000);
            } else {
                _this2.timer = undefined;
            }
        };

        countdown();
    };

    Countdown.prototype.stopCountdown = function stopCountdown() {
        this.timer = clearTimeout(this.timer);
        this.timer = undefined;
    };

    Countdown.prototype.render = function render() {
        var ChildComponent = this.props.children;
        var counter = this.state.counter;

        var isCounting = !!this.timer && counter > Math.floor(this.props.end);
        return _react2.default.createElement(ChildComponent, { counter: counter, isCounting: isCounting });
    };

    return Countdown;
}(_react2.default.PureComponent), _class.propTypes = {
    start: _propTypes2.default.number,
    end: _propTypes2.default.number,
    children: _propTypes2.default.func.isRequired
}, _class.defaultProps = {
    start: 3,
    end: 0
}, _temp2);
exports.default = Countdown;

/***/ }),

/***/ 2619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = KeyGoRegistrationWarning;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _ExternalLink = __webpack_require__(172);

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _BAlert = __webpack_require__(101);

var _BAlert2 = _interopRequireDefault(_BAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function KeyGoRegistrationWarning() {
    var keygoBrand = _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.text.keygo' });
    return _react2.default.createElement(
        'div',
        { className: 'padding-top padding-bottom' },
        _react2.default.createElement(
            'div',
            { className: 'confirmation' },
            _react2.default.createElement(_Icon2.default, { icon: 'warning margin-bottom--sm otrl-xl text-center' }),
            _react2.default.createElement(
                'p',
                { className: 'text-weight--normal alert-warning' },
                (0, _I18n2.default)('account.smartcard.keygo.registrationWarning.title')
            ),
            _react2.default.createElement(
                _BAlert2.default,
                { type: _BAlert.bAlertType.WARNING, className: 'text-center' },
                _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.keygo.registrationWarning.alert',
                    keygobrand: keygoBrand
                })
            ),
            _react2.default.createElement(_FormattedHTMLMessage2.default, {
                splitParagraphs: true,
                paragraphTagName: 'li',
                tagName: 'ul',
                className: 'list-styled text-left text-weight--normal margin-top--sm',
                message: 'account.smartcard.keygo.registrationWarning.list',
                keygobrand: keygoBrand,
                moreDetails: _react2.default.createElement(_ExternalLink2.default, {
                    href: _config2.default.get('keyGoInformationUrl'),
                    message: 'global.here' }) })
        )
    );
}

/***/ }),

/***/ 2620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _leaflet = __webpack_require__(2427);

var _leaflet2 = _interopRequireDefault(_leaflet);

var _keys = __webpack_require__(127);

var _keys2 = _interopRequireDefault(_keys);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _MapContext = __webpack_require__(2408);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OpenMap = function OpenMap(_ref) {
    var className = _ref.className,
        children = _ref.children,
        _ref$centerCoords = _ref.centerCoords,
        centerCoords = _ref$centerCoords === undefined ? _config2.default.get('defaultMapCenter') : _ref$centerCoords;

    var classes = (0, _classnames2.default)(className);
    var mapRef = (0, _react.useRef)(null);

    var _useState = (0, _react.useState)(null),
        map = _useState[0],
        setMap = _useState[1];

    var _useReducer = (0, _react.useReducer)(_MapContext.boundedElementsReducer, {}),
        boundedElements = _useReducer[0],
        boundedElementsDispatch = _useReducer[1];

    //Setting up the map


    (0, _react.useEffect)(function () {
        if (mapRef.current !== null && map === null) {
            var mapInstance = new _leaflet2.default.Map(mapRef.current);
            mapInstance.setView(centerCoords, 13);
            mapInstance.zoomControl.setPosition('bottomright');
            _leaflet2.default.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            }).addTo(mapInstance);
            setMap(mapInstance);
        }
    }, [mapRef, map, centerCoords]);

    (0, _react.useEffect)(function () {
        var bounds = (0, _keys2.default)(boundedElements).reduce(function (array, key) {
            array.push(boundedElements[key]);
            return array;
        }, []);
        if (bounds.length > 0) {
            map.fitBounds(bounds, { padding: [50, 50] });
        }
    }, [boundedElements, map]);

    return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
            'div',
            { style: { width: '100%', height: '100%' }, ref: mapRef },
            _react2.default.createElement(
                _MapContext.MapContext.Provider,
                { value: { map: map, boundedElementsDispatch: boundedElementsDispatch } },
                children
            )
        )
    );
};

OpenMap.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.any,
    centerCoords: _propTypes2.default.objectOf({
        lat: _propTypes2.default.number.isRequired,
        lng: _propTypes2.default.number.isRequired
    })
};

exports.default = OpenMap;

/***/ }),

/***/ 2621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leaflet = __webpack_require__(2427);

var _leaflet2 = _interopRequireDefault(_leaflet);

var _usePopUp = __webpack_require__(2622);

var _usePopUp2 = _interopRequireDefault(_usePopUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LabelPopup = function LabelPopup(_ref) {
    var coords = _ref.coords,
        label = _ref.label,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        isAutoPan = _ref.isAutoPan;

    var popUp = new _leaflet2.default.Popup({
        className: className,
        closeButton: false,
        autoClose: false,
        closeOnEscapeKey: false,
        autoPan: isAutoPan
    }).setLatLng(coords).setContent(label);

    (0, _usePopUp2.default)(popUp, true);
    return undefined;
};

LabelPopup.propTypes = {
    coords: _propTypes2.default.objectOf({
        lat: _propTypes2.default.number,
        lng: _propTypes2.default.number
    }).isRequired,
    label: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string,
    isAutoPan: _propTypes2.default.bool
};

exports.default = _react2.default.memo(LabelPopup);

/***/ }),

/***/ 2622:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _MapContext = __webpack_require__(2408);

var _useBoundedMapElement = __webpack_require__(2584);

var _useBoundedMapElement2 = _interopRequireDefault(_useBoundedMapElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usePopUp = function usePopUp(openStreetMapsObj) {
    var isBounded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _useMap = (0, _MapContext.useMap)(),
        map = _useMap.map;

    (0, _react.useEffect)(function () {
        if (map) {
            openStreetMapsObj.openOn(map);

            return function () {
                openStreetMapsObj.removeFrom(map);
            };
        }
        return undefined;
    }, [map, openStreetMapsObj]);

    (0, _useBoundedMapElement2.default)(openStreetMapsObj, isBounded);
    return undefined;
};

exports.default = usePopUp;

/***/ }),

/***/ 2623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leaflet = __webpack_require__(2427);

var _leaflet2 = _interopRequireDefault(_leaflet);

var _isArray = __webpack_require__(68);

var _isArray2 = _interopRequireDefault(_isArray);

var _MapContext = __webpack_require__(2408);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinePath = function LinePath(_ref) {
    var pathArray = _ref.pathArray,
        _ref$styles = _ref.styles,
        styles = _ref$styles === undefined ? {
        weight: 4
    } : _ref$styles;

    var _useMap = (0, _MapContext.useMap)(),
        map = _useMap.map;

    (0, _react.useEffect)(function () {
        if (map && (0, _isArray2.default)(pathArray) && pathArray.length > 1) {
            var line = new _leaflet2.default.Polyline(pathArray, styles).addTo(map);

            return function () {
                line.removeFrom(map);
            };
        }
        return undefined;
    }, [pathArray, map, styles]);
    return null;
};

LinePath.propTypes = {
    pathArray: _propTypes2.default.arrayOf(_propTypes2.default.object),
    map: _propTypes2.default.object,
    styles: _propTypes2.default.object
};

exports.default = _react2.default.memo(LinePath);

/***/ }),

/***/ 2624:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _unescape2 = __webpack_require__(2585);

var _unescape3 = _interopRequireDefault(_unescape2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PropTypes = __webpack_require__(85);

var _urijs = __webpack_require__(283);

var _urijs2 = _interopRequireDefault(_urijs);

var _OrderActions = __webpack_require__(157);

var _OrderActions2 = _interopRequireDefault(_OrderActions);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _Handoff = __webpack_require__(1060);

var _Handoff2 = _interopRequireDefault(_Handoff);

var _LinkMapper = __webpack_require__(8);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getStateFromStores = function _getStateFromStores() {
    return {
        handoffDetails: _OrderStore2.default.getHandoffDetails(),
        isHandoffReported: _OrderStore2.default.getHandoffReferralReported()
    };
};

var NREReferralFrame = function (_Component) {
    (0, _inherits3.default)(NREReferralFrame, _Component);

    function NREReferralFrame() {
        (0, _classCallCheck3.default)(this, NREReferralFrame);
        return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
    }

    NREReferralFrame.prototype.componentDidMount = function componentDidMount() {
        var search = this.props.location.search;

        /**
         * Booking Engine does some parsing to query string before it's accessible in location object.
         * Because of that, there are 3 steps needed to decode query and turn it into usable object.
         * 1. JS .decodeURIComponent() decodes characters like %3b => ;
         * 2. lodash .unescape() that turns &amp; into &
         * 3. first argument has broken and unnecesary symbol ?amp; - .replace() takes care of that
         */

        var query = _urijs2.default.parseQuery((0, _unescape3.default)(decodeURIComponent(search)).replace('amp;', ''));
        var orderHandoff = (0, _LinkMapper.resolve)(query).as(_Handoff2.default);

        if (orderHandoff.handoffid) {
            _OrderActions2.default.updateHandoffDetails(orderHandoff);
        }
    };

    NREReferralFrame.prototype.componentWillUnmount = function componentWillUnmount() {
        _OrderActions2.default.updateHandoffReferralReported(true);
    };

    NREReferralFrame.prototype.render = function render() {
        var _props = this.props,
            handoffDetails = _props.handoffDetails,
            isHandoffReported = _props.isHandoffReported;


        if (isHandoffReported === true || !handoffDetails || !handoffDetails.handoffid) {
            return null;
        }

        var isProd = _config2.default.get('environment') === 'prod';
        var baseUrl = _config2.default.get(isProd ? 'journeyPlannerNREUrl' : 'journeyPlannerNREStagingUrl');
        var queryString = '?' + handoffDetails.getReferralQueryString();
        var url = baseUrl + '/service/iframe/error' + queryString;

        return _react2.default.createElement('iframe', { src: url, width: 1, height: 1, frameBorder: 0, style: { display: 'none' } });
    };

    return NREReferralFrame;
}(_react.Component);

NREReferralFrame.propTypes = {
    location: _PropTypes.locationShape,
    handoffDetails: _propTypes2.default.instanceOf(_Handoff2.default),
    isHandoffReported: _propTypes2.default.bool
};

exports.default = (0, _connectToStores2.default)([_OrderStore2.default], _getStateFromStores)(NREReferralFrame);

/***/ }),

/***/ 2699:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _LeftColumn = __webpack_require__(2567);

var _LeftColumn2 = _interopRequireDefault(_LeftColumn);

var _SearchTabs = __webpack_require__(2700);

var _SearchTabs2 = _interopRequireDefault(_SearchTabs);

var _SmartcardCTA = __webpack_require__(2701);

var _SmartcardCTA2 = _interopRequireDefault(_SmartcardCTA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchLeftColumn = function SearchLeftColumn(_ref) {
    var children = _ref.children,
        _ref$className = _ref.className,
        className = _ref$className === undefined ? null : _ref$className,
        loading = _ref.loading,
        title = _ref.title;

    var baseClass = 'booking';
    return _react2.default.createElement(
        _LeftColumn2.default,
        { className: (0, _classnames2.default)(baseClass, className), loading: loading },
        _react2.default.createElement(_SmartcardCTA2.default, null),
        title && _react2.default.createElement(
            'h1',
            { className: (0, _classnames2.default)(baseClass + '__title', 'sr-only') },
            title
        ),
        _react2.default.createElement(_SearchTabs2.default, null),
        children
    );
};

SearchLeftColumn.propTypes = {
    children: _propTypes2.default.any,
    className: _propTypes2.default.string,
    loading: _propTypes2.default.bool,
    title: _propTypes2.default.string
};

exports.default = SearchLeftColumn;

/***/ }),

/***/ 2700:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _immutable = __webpack_require__(5);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _I18n = __webpack_require__(9);

var _AppConstants = __webpack_require__(6);

var _Link = __webpack_require__(275);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SearchTabs() {

    function _getTabs() {
        var classNames = 'pull-left text-center text-sm';

        var tabs = new _immutable.List();
        tabs = tabs.push(_react2.default.createElement(
            _Link2.default,
            { key: 'point',
                to: _AppConstants.PointStages.SEARCH,
                className: classNames,
                srOnly: (0, _I18n.translate)('global.searchFor') },
            (0, _I18n.translate)('nav.pointTickets')
        ));
        if (_FeatureFlagStore2.default.get('enableSeasonTickets')) {
            tabs = tabs.push(_react2.default.createElement(
                _Link2.default,
                { key: 'season',
                    to: _AppConstants.SeasonStages.SEARCH,
                    className: classNames,
                    srOnly: (0, _I18n.translate)('global.searchFor') },
                (0, _I18n.translate)('nav.seasonTickets')
            ));
        }
        if (_FeatureFlagStore2.default.get('enableOtherTickets')) {
            tabs = tabs.push(_react2.default.createElement(
                _Link2.default,
                { key: 'other',
                    to: _AppConstants.OtherTicketStages.SEARCH,
                    className: classNames,
                    srOnly: (0, _I18n.translate)('global.searchFor') },
                (0, _I18n.translate)('nav.otherTickets')
            ));
        }
        return tabs;
    }

    var tabs = _getTabs();

    var tabsClasses = (0, _classnames2.default)('search-tabs', {
        'search-tabs--thirds': tabs.size === 3
    });

    return _react2.default.createElement(
        'div',
        { className: tabsClasses },
        tabs.size > 1 ? _react2.default.createElement(
            'nav',
            { role: 'navigation', className: 'clearfix' },
            tabs
        ) : _react2.default.createElement(
            'h2',
            { className: 'text-center border--bottom' },
            (0, _I18n.translate)('nav.heading')
        )
    );
}

exports.default = SearchTabs;

/***/ }),

/***/ 2701:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(47);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _result2 = __webpack_require__(70);

var _result3 = _interopRequireDefault(_result2);

var _dec, _class, _class2, _temp2;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _UserStore = __webpack_require__(32);

var _UserStore2 = _interopRequireDefault(_UserStore);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _SmartcardStore = __webpack_require__(129);

var _SmartcardStore2 = _interopRequireDefault(_SmartcardStore);

var _Smartcard = __webpack_require__(332);

var _Smartcard2 = _interopRequireDefault(_Smartcard);

var _CustomerActions = __webpack_require__(99);

var _CustomerActions2 = _interopRequireDefault(_CustomerActions);

var _SmartcardCTAStore = __webpack_require__(1081);

var _SmartcardCTAStore2 = _interopRequireDefault(_SmartcardCTAStore);

var _ModalActions = __webpack_require__(27);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _AppConstants = __webpack_require__(6);

var _I18n = __webpack_require__(9);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _PureRenderComponent2 = __webpack_require__(44);

var _PureRenderComponent3 = _interopRequireDefault(_PureRenderComponent2);

var _SmartcardModal = __webpack_require__(1072);

var _SmartcardModal2 = _interopRequireDefault(_SmartcardModal);

var _FormattedHTMLMessage = __webpack_require__(30);

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _KeyGoRegistrationModal = __webpack_require__(2702);

var _KeyGoRegistrationModal2 = _interopRequireDefault(_KeyGoRegistrationModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _handleDismiss = function _handleDismiss() {
    _CustomerActions2.default.dismissSmartcardCTA();
};

var _handleRegisterUser = function _handleRegisterUser() {
    _ModalActions2.default.open(_AppConstants.GlobalModals.REGISTER, { forceSmartcardSignup: true });
};

var SmartcardCTA = (_dec = (0, _connectToStores2.default)([_FeatureFlagStore2.default, _UserStore2.default, _SmartcardStore2.default, _SmartcardCTAStore2.default], function () {
    return {
        smartcard: _SmartcardStore2.default.getCurrent(),
        user: _UserStore2.default.getCurrent(),
        enableSmartcardCTA: _FeatureFlagStore2.default.get('enableSmartcardCTA'),
        enableKeyGoCTA: _FeatureFlagStore2.default.get('enableKeyGoCTA'),
        enableSmartcard: _FeatureFlagStore2.default.get('enableSmartcard'),
        dismissed: _SmartcardCTAStore2.default.get('dismissed'),
        showSmartcardModal: false
    };
}), _dec(_class = (_temp2 = _class2 = function (_PureRenderComponent) {
    (0, _inherits3.default)(SmartcardCTA, _PureRenderComponent);

    function SmartcardCTA() {
        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SmartcardCTA);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _PureRenderComponent.call.apply(_PureRenderComponent, [this].concat(args))), _this), _this.state = {
            showModal: false
        }, _this._handleCancelled = function () {
            _this.setState({ showModal: false });
        }, _this._handleRegisterSmartcard = function () {
            _this.setState({ showModal: true });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    SmartcardCTA.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        if (!this.props.enableSmartcardCTA) {
            return;
        }

        if (_SmartcardStore2.default.shouldGetSmartcard()) {
            _CustomerActions2.default.getSmartcard(this.props.user);
        }
    };

    SmartcardCTA.prototype._canRegisterKeyGo = function _canRegisterKeyGo() {
        var _props = this.props,
            smartcard = _props.smartcard,
            enableKeyGoCTA = _props.enableKeyGoCTA;

        return smartcard && enableKeyGoCTA && smartcard.canSearchForProducts() && smartcard.canRegisterKeyGo();
    };

    SmartcardCTA.prototype.render = function render() {
        var _props2 = this.props,
            className = _props2.className,
            enableSmartcardCTA = _props2.enableSmartcardCTA,
            dismissed = _props2.dismissed,
            smartcard = _props2.smartcard,
            user = _props2.user,
            enableSmartcard = _props2.enableSmartcard;

        var canRegisterKeyGo = this._canRegisterKeyGo();

        if (!enableSmartcardCTA || dismissed || !enableSmartcard || smartcard && !canRegisterKeyGo) {
            return null;
        }

        var registrationHandler = (0, _result3.default)(user, 'isLoggedIn') ? this._handleRegisterSmartcard : _handleRegisterUser;
        var Modal = canRegisterKeyGo ? _KeyGoRegistrationModal2.default : _SmartcardModal2.default;

        return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('smartcard-cta', className), role: 'dialog',
                'aria-modal': 'false',
                'aria-describedby': 'cta__description' },
            this.state.showModal && _react2.default.createElement(Modal, {
                user: user,
                smartcard: smartcard,
                hideSmartcardCheckbox: true,
                onCancel: this._handleCancelled }),
            _react2.default.createElement(
                'p',
                { id: 'cta__description' },
                canRegisterKeyGo ? this._keyGoMessage : (0, _I18n.translate)('smartcardCTA.message.smartcard')
            ),
            _react2.default.createElement(
                _Button2.default,
                { bsStyle: 'default',
                    className: 'text-sm btn btn-dismiss',
                    onClick: _handleDismiss },
                (0, _I18n.translate)('global.banner.dismiss')
            ),
            _react2.default.createElement(
                _Button2.default,
                { bsStyle: 'primary',
                    className: 'text-sm btn btn-register',
                    onClick: registrationHandler },
                (0, _I18n.translate)(canRegisterKeyGo ? 'smartcardCTA.button.submit.keyGo' : 'smartcardCTA.button.submit.smartcard')
            )
        );
    };

    (0, _createClass3.default)(SmartcardCTA, [{
        key: '_keyGoMessage',
        get: function get() {
            return _react2.default.createElement(_FormattedHTMLMessage2.default, {
                message: 'smartcardCTA.message.keyGo',
                br: _react2.default.createElement('br', null),
                keygobrand: _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'account.smartcard.text.keygo' })
            });
        }
    }]);
    return SmartcardCTA;
}(_PureRenderComponent3.default), _class2.propTypes = {
    smartcard: _propTypes2.default.instanceOf(_Smartcard2.default),
    enableSmartcardCTA: _propTypes2.default.bool.isRequired,
    enableKeyGoCTA: _propTypes2.default.bool.isRequired,
    user: _propTypes2.default.instanceOf(_User2.default),
    dismissed: _propTypes2.default.bool.isRequired,
    className: _propTypes2.default.string
}, _class2.defaultProps = {
    className: ''
}, _temp2)) || _class);
exports.default = SmartcardCTA;

/***/ }),

/***/ 2702:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _KeyGoStore = __webpack_require__(1004);

var _KeyGoStore2 = _interopRequireDefault(_KeyGoStore);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _AbstractKeyGoRegistration = __webpack_require__(2616);

var _AbstractKeyGoRegistration2 = _interopRequireDefault(_AbstractKeyGoRegistration);

var _KeyGoRegistration = __webpack_require__(2568);

var _KeyGoRegistration2 = _interopRequireDefault(_KeyGoRegistration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KeyGoRegistrationModal = (_dec = (0, _connectToStores2.default)([_KeyGoStore2.default], _AbstractKeyGoRegistration.getStateFromStores), _dec(_class = (_temp = _class2 = function (_AbstractKeyGoRegistr) {
    (0, _inherits3.default)(KeyGoRegistrationModal, _AbstractKeyGoRegistr);

    function KeyGoRegistrationModal() {
        (0, _classCallCheck3.default)(this, KeyGoRegistrationModal);
        return (0, _possibleConstructorReturn3.default)(this, _AbstractKeyGoRegistr.apply(this, arguments));
    }

    KeyGoRegistrationModal.prototype.render = function render() {
        var onCancel = this.props.onCancel;


        return _react2.default.createElement(
            _BaseModal2.default,
            {
                onClose: onCancel,
                hideClose: this.props.paymentSucceeded,
                onContinue: this.props.paymentSucceeded ? onCancel : this.handleKeyGoPay,
                continueText: this.props.paymentSucceeded ? 'button.text.close' : 'account.smartcard.keygo.signupButton',
                closeText: 'button.text.cancel',
                disableContinue: this.isButtonDisabled,
                titleText: 'smartcardCTA.message.signup.keyGo',
                className: 'modal--med' },
            _react2.default.createElement(_KeyGoRegistration2.default, this.keyGoRegistrationProps),
            this.renderRegistrationWarning()
        );
    };

    return KeyGoRegistrationModal;
}(_AbstractKeyGoRegistration2.default), _class2.propTypes = {
    onCancel: _propTypes2.default.func
}, _temp)) || _class);
exports.default = KeyGoRegistrationModal;

/***/ }),

/***/ 2703:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _MapContext = __webpack_require__(2408);

var _useBoundedMapElement = __webpack_require__(2584);

var _useBoundedMapElement2 = _interopRequireDefault(_useBoundedMapElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useMarker = function useMarker(openStreetMapsObj) {
    var isBounded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _useMap = (0, _MapContext.useMap)(),
        map = _useMap.map;

    (0, _react.useEffect)(function () {
        if (map) {
            openStreetMapsObj.addTo(map);

            return function () {
                openStreetMapsObj.removeFrom(map);
            };
        }
        return undefined;
    }, [map, openStreetMapsObj]);

    (0, _useBoundedMapElement2.default)(openStreetMapsObj, isBounded);
    return undefined;
};

exports.default = useMarker;

/***/ }),

/***/ 2704:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(13);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AppConstants = __webpack_require__(6);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _useLoadJPWidget2 = __webpack_require__(2705);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JPWidget = function JPWidget(_ref) {
    var params = _ref.params,
        userId = _ref.userId;

    var _useLoadJPWidget = (0, _useLoadJPWidget2.useLoadJPWidget)(),
        isWidgetBundleLoaded = _useLoadJPWidget.isWidgetBundleLoaded;

    var widgetRef = (0, _react.useRef)(false);

    var _useState = (0, _react.useState)(false),
        shouldJPWidgetBeRerendered = _useState[0],
        setShouldJPWidgetBeRerendered = _useState[1];

    (0, _react.useEffect)(function () {
        var initJPWidget = function initJPWidget() {
            try {
                if (!window.OtrlJPWidget) {
                    return;
                }
                var init = window.OtrlJPWidget.init;

                if (widgetRef.current && init) {
                    init((0, _extends3.default)({
                        id: widgetRef.current.id,
                        dataLayerName: _config2.default.get("gtmDataLayer"),
                        enableModalHeightResize: true
                    }, params));
                }
            } catch (error) {
                console.error("Error initializing JPWidget:", error);
            }
        };

        setShouldJPWidgetBeRerendered(true);
        setTimeout(function () {
            setShouldJPWidgetBeRerendered(false);
            initJPWidget();
        }, 0);

        /*eslint-disable */
    }, [userId, isWidgetBundleLoaded]);

    if (shouldJPWidgetBeRerendered) {
        return null;
    }

    return _react2.default.createElement(
        "div",
        {
            ref: widgetRef,
            className: "otrl-jpWidget-external-component",
            id: _AppConstants.JPWidgetConf.ID
        },
        _react2.default.createElement("span", { className: "otrl circle-spinner" })
    );
};

JPWidget.propTypes = {
    params: _propTypes2.default.object,
    userId: _propTypes2.default.number
};

exports.default = JPWidget;

/***/ }),

/***/ 2705:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.useLoadJPWidget = undefined;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = __webpack_require__(0);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _ExternalScript = __webpack_require__(1016);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useLoadJPWidget = exports.useLoadJPWidget = function useLoadJPWidget() {
    var _useState = (0, _react.useState)(false),
        isWidgetBundleLoaded = _useState[0],
        setIsWidgetBundleLoaded = _useState[1];

    var jpWidgetBundleUrl = _config2.default.get('jpWidgetBundleUrl');

    (0, _react.useEffect)(function () {
        var getJPWidgetScript = function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return (0, _ExternalScript.loadScript)(jpWidgetBundleUrl);

                            case 2:
                                setIsWidgetBundleLoaded(true);

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            return function getJPWidgetScript() {
                return _ref.apply(this, arguments);
            };
        }();

        getJPWidgetScript();
    }, [jpWidgetBundleUrl]);

    return { isWidgetBundleLoaded: isWidgetBundleLoaded };
};

/***/ }),

/***/ 2820:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _capitalize2 = __webpack_require__(623);

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _defer2 = __webpack_require__(39);

var _defer3 = _interopRequireDefault(_defer2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _SeasonSearch = __webpack_require__(328);

var _SeasonSearch2 = _interopRequireDefault(_SeasonSearch);

var _StationFinderStore = __webpack_require__(990);

var _StationFinderStore2 = _interopRequireDefault(_StationFinderStore);

var _StationFinderActions = __webpack_require__(2401);

var _StationFinderActions2 = _interopRequireDefault(_StationFinderActions);

var _NotificationActions = __webpack_require__(232);

var _NotificationActions2 = _interopRequireDefault(_NotificationActions);

var _connectToStores = __webpack_require__(35);

var _connectToStores2 = _interopRequireDefault(_connectToStores);

var _SearchOverlay = __webpack_require__(2821);

var _SearchOverlay2 = _interopRequireDefault(_SearchOverlay);

var _StationFinderModal = __webpack_require__(2449);

var _StationFinderModal2 = _interopRequireDefault(_StationFinderModal);

var _openMap = __webpack_require__(2620);

var _openMap2 = _interopRequireDefault(_openMap);

var _LabelPopup = __webpack_require__(2621);

var _LabelPopup2 = _interopRequireDefault(_LabelPopup);

var _LinePath = __webpack_require__(2623);

var _LinePath2 = _interopRequireDefault(_LinePath);

var _StationGroup = __webpack_require__(2823);

var _StationGroup2 = _interopRequireDefault(_StationGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StationFinder = function StationFinder(_ref) {
    var className = _ref.className,
        origin = _ref.origin,
        destination = _ref.destination,
        stations = _ref.stations,
        error = _ref.error,
        isExpanded = _ref.isExpanded,
        onChange = _ref.onChange,
        isMobile = _ref.isMobile,
        closeContainerModal = _ref.closeContainerModal,
        currentSearch = _ref.currentSearch;

    var _useState = (0, _react.useState)(null),
        selectedStation = _useState[0],
        setSelectedStation = _useState[1];

    var _useState2 = (0, _react.useState)(false),
        showStationFinderModal = _useState2[0],
        setShowStationFinderModal = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        isSearchingStations = _useState3[0],
        setIsSearchingStations = _useState3[1];

    var _useState4 = (0, _react.useState)(null),
        ticketOffice = _useState4[0],
        setTicketOffice = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        loadingTicketOfficeDetails = _useState5[0],
        setLoadingTicketOfficeDetails = _useState5[1];

    var _useState6 = (0, _react.useState)(null),
        positionMarkerCoords = _useState6[0],
        setPositionMarkerCoords = _useState6[1];

    (0, _react.useEffect)(function () {
        if (stations.size) {
            (0, _defer3.default)(_StationFinderActions2.default.clearStations);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    (0, _react.useEffect)(function () {
        (0, _defer3.default)(_StationFinderActions2.default.clearStations);
        setPositionMarkerCoords(null);
        if (isExpanded) {
            _StationFinderActions2.default.setExpanded(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [origin, destination]);

    (0, _react.useEffect)(function () {
        if (stations.size > 0 || error) {
            setIsSearchingStations(false);
        }
    }, [stations, error]);

    var onSelectPosition = function onSelectPosition(coords) {
        setPositionMarkerCoords(coords);
    };

    var handleSearchClear = function handleSearchClear() {
        setPositionMarkerCoords(null);
    };

    var handleSearch = function handleSearch(_ref2, searchInteraction) {
        var latitude = _ref2.lat,
            longitude = _ref2.lng;

        setIsSearchingStations(true);
        _StationFinderActions2.default.findNearest({ latitude: latitude, longitude: longitude, searchInteraction: searchInteraction });
    };

    var handleStationSelected = function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(station) {
            var fetchedTicketOffice;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            setShowStationFinderModal(true);
                            setSelectedStation(station);
                            setTicketOffice(null);
                            setLoadingTicketOfficeDetails(true);

                            _context.prev = 4;
                            _context.next = 7;
                            return _StationFinderActions2.default.getTicketOfficeDetails(station);

                        case 7:
                            fetchedTicketOffice = _context.sent;

                            setTicketOffice(fetchedTicketOffice);
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](4);

                            console.warn('error loading opening hours', _context.t0);

                        case 14:
                            setLoadingTicketOfficeDetails(false);

                        case 15:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[4, 11]]);
        }));

        return function handleStationSelected(_x) {
            return _ref3.apply(this, arguments);
        };
    }();

    var handleStationFinderModalClose = function handleStationFinderModalClose() {
        setShowStationFinderModal(false);
    };

    var handleStationChange = function handleStationChange(type, value) {
        _StationFinderActions2.default.setStationSelected(type, value);

        if (isMobile) {
            (0, _defer3.default)(_StationFinderActions2.default.clearStations);
        }

        onChange(type, value);

        if (isMobile) {
            var updatedText = (0, _capitalize3.default)(type) + ' ' + (0, _I18n.translate)('stationFinder.modal.update') + ' ' + value.name;
            _NotificationActions2.default.showNotification(updatedText);
            closeContainerModal();
        }
    };

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('stationFinder__container', {
                'mobile': isMobile
            }) },
        _react2.default.createElement(
            _openMap2.default,
            { className: 'map ' + className },
            origin.latitude && _react2.default.createElement(_LabelPopup2.default, {
                coords: origin.getLatLng(),
                className: 'search-station-popup',
                label: (0, _I18n.translate)('global.start') + ': <strong>' + origin.name + '</strong>',
                isAutoPan: origin.latitude && destination.latitude
            }),
            destination.latitude && _react2.default.createElement(_LabelPopup2.default, {
                coords: destination.getLatLng(),
                className: 'search-station-popup',
                label: (0, _I18n.translate)('global.end') + ': <strong>' + destination.name + '</strong>',
                isAutoPan: origin.latitude && destination.latitude
            }),
            origin.latitude && destination.latitude && _react2.default.createElement(_LinePath2.default, { styles: { dashArray: '5, 10' }, pathArray: [origin.getLatLng(), destination.getLatLng()] }),
            _react2.default.createElement(_SearchOverlay2.default, {
                error: error,
                isExpanded: isExpanded,
                onClear: handleSearchClear,
                isMobile: isMobile,
                onSelectPosition: onSelectPosition,
                onSearch: handleSearch,
                positionMarkerCoords: positionMarkerCoords,
                setPositionMarkerCoords: onSelectPosition,
                setShowStationFinderModal: setShowStationFinderModal,
                isSearchingStations: isSearchingStations }),
            _react2.default.createElement(_StationFinderModal2.default, {
                selectedStation: selectedStation,
                ticketOffice: ticketOffice,
                show: showStationFinderModal,
                onClose: handleStationFinderModalClose,
                onContinue: handleStationChange,
                loadingTicketOfficeDetails: loadingTicketOfficeDetails,
                currentSearch: currentSearch }),
            _react2.default.createElement(_StationGroup2.default, { stations: stations, onSelect: handleStationSelected })
        )
    );
};

StationFinder.propTypes = {
    className: _propTypes2.default.string,
    origin: _propTypes2.default.instanceOf(_Station2.default),
    destination: _propTypes2.default.instanceOf(_Station2.default),
    stations: _propTypes2.default.instanceOf(_immutable.List),
    error: _propTypes2.default.instanceOf(Error),
    isExpanded: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    isMobile: _propTypes2.default.bool.isRequired,
    closeContainerModal: _propTypes2.default.func,
    currentSearch: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_Search2.default), _propTypes2.default.instanceOf(_SeasonSearch2.default)])
};

function getStateFromStores() {
    return {
        stations: _StationFinderStore2.default.get('stations'),
        error: _StationFinderStore2.default.get('error'),
        isExpanded: _StationFinderStore2.default.get('isExpanded')
    };
}

exports.default = (0, _connectToStores2.default)([_StationFinderStore2.default], getStateFromStores)(StationFinder);

/***/ }),

/***/ 2821:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = __webpack_require__(23);

var _Icon2 = _interopRequireDefault(_Icon);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _SearchExpander = __webpack_require__(2448);

var _SearchExpander2 = _interopRequireDefault(_SearchExpander);

var _CurrentPositionMarker = __webpack_require__(2822);

var _CurrentPositionMarker2 = _interopRequireDefault(_CurrentPositionMarker);

var _StationFinderActions = __webpack_require__(2401);

var _StationFinderActions2 = _interopRequireDefault(_StationFinderActions);

var _AppConstants = __webpack_require__(6);

var _MapContext = __webpack_require__(2408);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _ExternalScript = __webpack_require__(1016);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchOverlay = function SearchOverlay(_ref) {
    var isExpanded = _ref.isExpanded,
        isSearchingStations = _ref.isSearchingStations,
        isMobile = _ref.isMobile,
        onClear = _ref.onClear,
        onSelectPosition = _ref.onSelectPosition,
        onSearch = _ref.onSearch,
        error = _ref.error,
        positionMarkerCoords = _ref.positionMarkerCoords,
        setPositionMarkerCoords = _ref.setPositionMarkerCoords;

    var _useState = (0, _react.useState)(null),
        labelState = _useState[0],
        setLabelState = _useState[1];

    var _useState2 = (0, _react.useState)(false),
        isLocating = _useState2[0],
        setIsLocating = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        isLeafletGeolocationLoaded = _useState3[0],
        setIsLeafletGeolocationLoaded = _useState3[1];

    var leafletGeolocationUrl = _config2.default.get('leafletGeolocationUrl');

    (0, _react.useEffect)(function () {
        var getLeafleftMapScript = function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return (0, _ExternalScript.loadScript)(leafletGeolocationUrl);

                            case 2:
                                setIsLeafletGeolocationLoaded(true);

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            return function getLeafleftMapScript() {
                return _ref2.apply(this, arguments);
            };
        }();

        getLeafleftMapScript();
    }, [leafletGeolocationUrl]);

    var _useMap = (0, _MapContext.useMap)(),
        map = _useMap.map;

    var LeafletgeoSearch = function LeafletgeoSearch() {
        // eslint-disable-next-line
        var provider = new GeoSearch.OpenStreetMapProvider({
            params: {
                'accept-language': "en",
                countrycodes: "gb",
                addressdetails: 1
            }
        });

        // eslint-disable-next-line
        var searchControl = new GeoSearch.GeoSearchControl({
            provider: provider,
            showMarker: false,
            searchLabel: (0, _I18n2.default)('stationFinder.search.placeholder'),
            resultFormat: function resultFormat(_ref3) {
                var result = _ref3.result;

                return result.label;
            }
        });

        map.addControl(searchControl);

        map.on('geosearch/showlocation', function (e) {
            var _e$location = e.location,
                y = _e$location.y,
                x = _e$location.x;

            setPositionMarkerCoords({ lat: y, lng: x });

            var errorBlock = document.querySelector('.stationFinder__search-error');

            if (errorBlock) {
                errorBlock.classList.add("hide");
            }
        });

        (0, _react.useEffect)(function () {
            return function () {
                return map.removeControl(searchControl);
            };
        }, []);

        return null;
    };

    var onSearchClear = function onSearchClear() {
        onClear();
        setLabelState(null);
        setPositionMarkerCoords(null);
        _StationFinderActions2.default.clearStations();
        if (error) {
            _StationFinderActions2.default.clearError();
        }
    };

    var setCurrentPosition = function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(location) {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            setPositionMarkerCoords(location);
                            onSelectPosition(location);
                            _context2.next = 4;
                            return onSearch(location, _AppConstants.StationFinderSearchInteractions.CURRENT_LOCATION);

                        case 4:
                            dismissOverlay();
                            setIsLocating(false);

                        case 6:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, undefined);
        }));

        return function setCurrentPosition(_x) {
            return _ref4.apply(this, arguments);
        };
    }();

    var dismissError = function dismissError() {
        _StationFinderActions2.default.clearError();
    };

    var dismissOverlay = function dismissOverlay() {
        setLabelState(null);
        _StationFinderActions2.default.setExpanded(false);
    };

    var errorBlock = document.querySelector('.stationFinder__search-error');
    var errorText = document.querySelector('.stationFinder__search-error .alert-warning');

    if (isExpanded) {
        setTimeout(function () {
            var geosearch = document.querySelector('.geosearch');

            if (geosearch) {
                var input = geosearch.querySelector('input');

                input.addEventListener("keydown", function () {
                    errorBlock.classList.remove("hide");

                    setTimeout(function () {
                        var results = document.querySelector('.geosearch .results');

                        if (!errorBlock.classList.contains('hide') && input.value && results.childNodes.length === 0) {
                            errorBlock.style.display = 'block';
                            if (errorText) {
                                errorText.innerHTML = 'No results for ' + input.value;
                            }
                        } else {
                            errorBlock.style.display = 'none';
                            if (errorText) {
                                errorText.innerHTML = '';
                            }
                        }
                    }, 1000);
                });
            }
        }, 1000);
    } else {
        if (errorBlock) {
            errorBlock.style.display = 'none';
        }
    }

    return _react2.default.createElement(
        'div',
        {
            id: 'stationFinder-overlay',
            className: (0, _classnames2.default)('stationFinder__search-overlay', {
                expanded: isExpanded,
                mobile: isMobile
            }),
            tabIndex: -1
        },
        labelState && !isLocating && _react2.default.createElement(
            _Button2.default,
            { className: 'stationFinder__search-clear', onClick: onSearchClear },
            _react2.default.createElement(_Icon2.default, { icon: 'clear' })
        ),
        _react2.default.createElement(
            'div',
            {
                className: 'input-group',
                id: 'search-overlay',
                role: 'region',
                'aria-label': (0, _I18n2.default)('stationFinder.search.placeholder')
            },
            _react2.default.createElement(_SearchExpander2.default, {
                isExpanded: isExpanded,
                isSearching: isSearchingStations,
                onExpand: function onExpand() {
                    return _StationFinderActions2.default.setExpanded(!isExpanded);
                },
                isDisabled: !isLeafletGeolocationLoaded }),
            map && isExpanded && _react2.default.createElement(LeafletgeoSearch, null)
        ),
        _react2.default.createElement(
            'div',
            { style: { display: 'none' }, onClick: dismissError, className: 'stationFinder__search-error' },
            _react2.default.createElement(
                'div',
                { className: 'icon-margin' },
                _react2.default.createElement(_Icon2.default, { icon: 'error' })
            ),
            _react2.default.createElement('div', { className: 'alert-warning' })
        ),
        positionMarkerCoords && _react2.default.createElement(_CurrentPositionMarker2.default, {
            coords: positionMarkerCoords,
            onMove: setCurrentPosition
        })
    );
};

SearchOverlay.propTypes = {
    isExpanded: _propTypes2.default.bool.isRequired,
    isSearchingStations: _propTypes2.default.bool.isRequired,
    isMobile: _propTypes2.default.bool.isRequired,
    onClear: _propTypes2.default.func.isRequired,
    onSelectPosition: _propTypes2.default.func.isRequired,
    onSearch: _propTypes2.default.func.isRequired,
    error: _propTypes2.default.instanceOf(Error),
    positionMarkerCoords: _propTypes2.default.objectOf({
        lat: _propTypes2.default.number.isRequired,
        lng: _propTypes2.default.number.isRequired
    }),
    setPositionMarkerCoords: _propTypes2.default.func.isRequired
};

exports.default = _react2.default.memo(SearchOverlay);

/***/ }),

/***/ 2822:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _leaflet = __webpack_require__(2427);

var _leaflet2 = _interopRequireDefault(_leaflet);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _useMarker = __webpack_require__(2703);

var _useMarker2 = _interopRequireDefault(_useMarker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CurrentPositionMarker = function CurrentPositionMarker(_ref) {
    var coords = _ref.coords,
        onMove = _ref.onMove;

    var marker = new _leaflet2.default.Marker(coords, {
        icon: _leaflet2.default.icon({
            iconUrl: '/images/station-marker-' + _config2.default.get('brand').split('-')[0] + '.svg',
            iconSize: [50, 50],
            iconAnchor: [25, 50]
        }),
        draggable: true
    }).on('dragend', function (e) {
        return onMove(e.target.getLatLng());
    });

    (0, _useMarker2.default)(marker);
    return undefined;
};

CurrentPositionMarker.propTypes = {
    coords: _propTypes2.default.objectOf({
        lat: _propTypes2.default.number.isRequired,
        lng: _propTypes2.default.number.isRequired
    }),
    onMove: _propTypes2.default.func.isRequired
};

exports.default = (0, _react.memo)(CurrentPositionMarker);

/***/ }),

/***/ 2823:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _immutable = __webpack_require__(5);

var _defer = __webpack_require__(39);

var _defer2 = _interopRequireDefault(_defer);

var _StationMarker = __webpack_require__(2824);

var _StationMarker2 = _interopRequireDefault(_StationMarker);

var _MapContext = __webpack_require__(2408);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StationGroup = function StationGroup(_ref) {
    var stations = _ref.stations,
        onSelect = _ref.onSelect;

    var _useMap = (0, _MapContext.useMap)(),
        map = _useMap.map;

    (0, _react.useEffect)(function () {
        if (stations.size && map) {
            (0, _defer2.default)(function () {
                return map.fitBounds(stations.map(function (s) {
                    return s.getLatLng();
                }).toArray(), { padding: [10, 10] });
            });
        }
    }, [stations, map]);

    return _react2.default.createElement(
        _react.Fragment,
        null,
        stations && stations.map(function (station) {
            return _react2.default.createElement(_StationMarker2.default, { key: station.nlc, station: station, onSelect: onSelect });
        })
    );
};

StationGroup.propTypes = {
    stations: _propTypes2.default.instanceOf(_immutable.List).isRequired,
    onSelect: _propTypes2.default.func.isRequired
};

exports.default = (0, _react.memo)(StationGroup);

/***/ }),

/***/ 2824:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _leaflet = __webpack_require__(2427);

var _leaflet2 = _interopRequireDefault(_leaflet);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _useMarker = __webpack_require__(2703);

var _useMarker2 = _interopRequireDefault(_useMarker);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StationMarker = function StationMarker(_ref) {
    var station = _ref.station,
        onSelect = _ref.onSelect;

    var marker = new _leaflet2.default.Marker(station.getLatLng(), {
        icon: _leaflet2.default.icon({
            iconUrl: '/images/add-station-' + _config2.default.get('brand').split('-')[0] + '.png',
            iconSize: [64, 80],
            iconAnchor: [26.5, 78]
        })
    }).on('mouseup', function () {
        return onSelect(station);
    });

    (0, _useMarker2.default)(marker);
    return undefined;
};

StationMarker.propTypes = {
    station: _propTypes2.default.instanceOf(_Station2.default).isRequired,
    onSelect: _propTypes2.default.func.isRequired
};

exports.default = _react2.default.memo(StationMarker);

/***/ }),

/***/ 2825:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SearchFooter(_ref) {
    var disabled = _ref.disabled,
        onSearch = _ref.onSearch,
        type = _ref.type,
        hasFooterPoweredByOn = _ref.hasFooterPoweredByOn;

    return _react2.default.createElement(
        'footer',
        {
            className: (0, _classnames2.default)("booking__footer clearfix", {
                "booking__footer--with-powered-by-on": hasFooterPoweredByOn
            })
        },
        _react2.default.createElement(
            _Button2.default,
            { bsStyle: 'primary',
                className: 'btn-lg pull-right',
                disabled: disabled,
                onClick: onSearch },
            (0, _I18n.translate)('booking.search.' + type)
        )
    );
}

SearchFooter.propTypes = {
    disabled: _propTypes2.default.bool,
    onSearch: _propTypes2.default.func.isRequired,
    type: _propTypes2.default.string.isRequired,
    hasFooterPoweredByOn: _propTypes2.default.bool
};

SearchFooter.defaultProps = {
    disabled: false,
    hasFooterPoweredByOn: false
};

exports.default = SearchFooter;

/***/ }),

/***/ 3073:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _JPWidget = __webpack_require__(2704);

var _JPWidget2 = _interopRequireDefault(_JPWidget);

var _TranspennineRoverCTA = __webpack_require__(3074);

var _TranspennineRoverCTA2 = _interopRequireDefault(_TranspennineRoverCTA);

var _config = __webpack_require__(11);

var _config2 = _interopRequireDefault(_config);

var _FeatureFlagStore = __webpack_require__(29);

var _FeatureFlagStore2 = _interopRequireDefault(_FeatureFlagStore);

var _FamilyVerificationStore = __webpack_require__(638);

var _FamilyVerificationStore2 = _interopRequireDefault(_FamilyVerificationStore);

var _useStoreState = __webpack_require__(145);

var _useStoreState2 = _interopRequireDefault(_useStoreState);

var _User = __webpack_require__(75);

var _User2 = _interopRequireDefault(_User);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchWithoutMap = function SearchWithoutMap(_ref) {
    var user = _ref.user,
        performSearch = _ref.performSearch;

    var _useState = (0, _react.useState)(false),
        showJPWidget = _useState[0],
        setShowJPWidget = _useState[1];

    var enableTPEStaffRover = _FeatureFlagStore2.default.get('enableTPEStaffRover');

    var isVerified = (0, _useStoreState2.default)(_FamilyVerificationStore2.default, 'isVerified');

    var showTranspennineRoverCTA = enableTPEStaffRover && isVerified;

    var handleShowJPWidget = function handleShowJPWidget() {
        setShowJPWidget(true);
    };

    return _react2.default.createElement(
        'div',
        { className: 'se-main-page' },
        showTranspennineRoverCTA && !showJPWidget && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'h1',
                null,
                (0, _I18n2.default)('promotion.tocFamily.rover.header')
            ),
            _react2.default.createElement(_TranspennineRoverCTA2.default, null),
            _react2.default.createElement(
                'div',
                { className: 'toc-family-search-other-journeys' },
                _react2.default.createElement(
                    'a',
                    { href: '#', onClick: handleShowJPWidget },
                    (0, _I18n2.default)('promotion.tocFamily.rover.searchOtherJourneys')
                )
            )
        ),
        (!showTranspennineRoverCTA || showJPWidget) && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'h1',
                null,
                (0, _I18n2.default)('pageTitles.se.main.page')
            ),
            _react2.default.createElement(_JPWidget2.default, {
                params: {
                    brand: _config2.default.get('tocCode'),
                    apiUrl: 'https://' + _config2.default.get('apiHost'),
                    stylesheetUrl: _config2.default.get('jpWidgetStylesheetUrl'),
                    vertical: false,
                    hideNavigation: false,
                    disableBackground: false,
                    hidePromotionalText: false,
                    enableDaySave: _FeatureFlagStore2.default.get('enableDaySave') && !_FeatureFlagStore2.default.get('enableHiddenDaySave'),
                    enableRoversRangers: _FeatureFlagStore2.default.get('enableRoversRangers'),
                    enableTPERover: _FeatureFlagStore2.default.get('enableTPERover'),
                    enableSmartCarnet: _FeatureFlagStore2.default.get('enableSmartCarnet'),
                    disabledTabs: '',
                    searchCallBack: typeof performSearch === 'function' ? performSearch : function () {},
                    enableKentRover: _FeatureFlagStore2.default.get('enableKentRover'),
                    enableBestFareFinderAndRecentOrders: _config2.default.get('enableBestFareFinderAndRecentOrdersJPWidget'),
                    context: 'BOOKING_ENGINE',
                    enablePromoDiscount: _FeatureFlagStore2.default.get('enablePromoDiscount') || _FeatureFlagStore2.default.get('enableDiscountCode')
                },
                userId: user && user.id
            })
        )
    );
};

SearchWithoutMap.propTypes = {
    user: _propTypes2.default.instanceOf(_User2.default).isRequired,
    performSearch: _propTypes2.default.func.isRequired
};

SearchWithoutMap.defaultProps = {
    user: {},
    performSearch: function performSearch() {}
};

exports.default = SearchWithoutMap;

/***/ }),

/***/ 3074:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _regenerator = __webpack_require__(15);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(16);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(645);

var _PropTypes = __webpack_require__(85);

var _DateSelector = __webpack_require__(2396);

var _DateSelector2 = _interopRequireDefault(_DateSelector);

var _TrainTime = __webpack_require__(19);

var _TrainTime2 = _interopRequireDefault(_TrainTime);

var _I18n = __webpack_require__(9);

var _I18n2 = _interopRequireDefault(_I18n);

var _Search = __webpack_require__(156);

var _Search2 = _interopRequireDefault(_Search);

var _Station = __webpack_require__(38);

var _Station2 = _interopRequireDefault(_Station);

var _PointFlow = __webpack_require__(980);

var _PointFlow2 = _interopRequireDefault(_PointFlow);

var _AppConstants = __webpack_require__(6);

var _Timeband = __webpack_require__(337);

var _Timeband2 = _interopRequireDefault(_Timeband);

var _PassengersSelector = __webpack_require__(2432);

var _PassengersSelector2 = _interopRequireDefault(_PassengersSelector);

var _FamilyVerificationStore = __webpack_require__(638);

var _FamilyVerificationStore2 = _interopRequireDefault(_FamilyVerificationStore);

var _useStoreState = __webpack_require__(145);

var _useStoreState2 = _interopRequireDefault(_useStoreState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TranspennineRoverCTA = function TranspennineRoverCTA(_ref) {
    var router = _ref.router;

    var getStartDate = function getStartDate() {
        return (0, _TrainTime2.default)();
    };

    var _useState = (0, _react.useState)(getStartDate()),
        selectedDate = _useState[0],
        setSelectedDate = _useState[1];

    var _useState2 = (0, _react.useState)(1),
        adults = _useState2[0],
        setAdults = _useState2[1];

    var _useState3 = (0, _react.useState)(0),
        children = _useState3[0],
        setChildren = _useState3[1];

    var availableTickets = (0, _useStoreState2.default)(_FamilyVerificationStore2.default, 'availableTickets');
    var isExceeded = adults + children > availableTickets;

    var handleDateChange = function handleDateChange(date) {
        setSelectedDate(date);
    };

    var handleSearch = function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
            var origin, destination, email, searchDate, search;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            e.preventDefault();

                            origin = new _Station2.default({ nlc: 'Z031' });
                            destination = new _Station2.default({ nlc: 'Z032' });
                            email = _FamilyVerificationStore2.default.getEmail();
                            searchDate = selectedDate.clone().hour(11).minute(30).second(0);
                            search = new _Search2.default({
                                origin: origin,
                                destination: destination,
                                adults: adults,
                                children: children,
                                outboundDateTime: new _Timeband2.default({
                                    datetime: searchDate,
                                    arriveDepart: 'Depart',
                                    windowLength: 8
                                }),
                                targetLayout: _AppConstants.JourneyPlannerLayout.LIST,
                                numJourneys: 8,
                                email: email
                            });


                            _PointFlow2.default.moveToNext(_AppConstants.PointStages.SEARCH, { search: search }, router);

                        case 7:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function handleSearch(_x) {
            return _ref2.apply(this, arguments);
        };
    }();

    return _react2.default.createElement(
        'div',
        { className: 'transpennine-rover-cta' },
        _react2.default.createElement(
            'div',
            { className: 'transpennine-rover-cta__header' },
            _react2.default.createElement(
                'div',
                { className: 'transpennine-rover-cta__header-content' },
                _react2.default.createElement(
                    'h2',
                    null,
                    (0, _I18n2.default)('promotion.tocFamily.rover.title')
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'transpennine-rover-cta__content' },
            _react2.default.createElement(
                'p',
                null,
                (0, _I18n2.default)('promotion.tocFamily.rover.description')
            ),
            _react2.default.createElement(
                'div',
                { className: 'transpennine-rover-cta__form' },
                _react2.default.createElement(
                    'div',
                    { className: 'transpennine-rover-cta__field' },
                    _react2.default.createElement(_DateSelector2.default, {
                        datetime: selectedDate,
                        min: getStartDate(),
                        max: (0, _TrainTime2.default)().add(30, 'days'),
                        onChange: handleDateChange,
                        srOnly: (0, _I18n2.default)('ariaLabel.fieldDescription', {
                            field: (0, _I18n2.default)('promotion.tocFamily.rover.dateField')
                        })
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'transpennine-rover-cta__field transpennine-rover-cta__field--passengers' },
                    _react2.default.createElement(_PassengersSelector2.default, {
                        adults: adults,
                        children: children,
                        onAdultsChange: setAdults,
                        onChildrenChange: setChildren,
                        maxTickets: availableTickets ? availableTickets + 1 : -1,
                        hideInfo: true
                    }),
                    isExceeded && _react2.default.createElement(
                        'div',
                        { className: 'transpennine-rover-cta__error' },
                        (0, _I18n2.default)('promotion.tocFamily.rover.error', {
                            tickets: availableTickets
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'transpennine-rover-cta__field' },
                    _react2.default.createElement(
                        'button',
                        {
                            onClick: handleSearch,
                            className: 'btn btn-primary',
                            type: 'button',
                            disabled: isExceeded
                        },
                        (0, _I18n2.default)('promotion.tocFamily.rover.buttonText')
                    )
                )
            )
        )
    );
};

TranspennineRoverCTA.propTypes = {
    router: _PropTypes.routerShape.isRequired
};

exports.default = (0, _reactRouter.withRouter)(TranspennineRoverCTA);

/***/ })

});


// WEBPACK FOOTER //
// js/pages/point-search.417b25cead8fd529b740.js